webpackJsonp([0],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var appSingleton;
function storeAppSingleton(theApp) {
    if (appSingleton) {
        throw Error("Error - attempting to reinitialize the global app.");
    }
    appSingleton = theApp;
}
exports.storeAppSingleton = storeAppSingleton;
function app() {
    return appSingleton;
}
exports.app = app;


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var Util = __webpack_require__(8);
function createWebServiceDataSource(readURL, model, customParameters, onError) {
    if (customParameters === void 0) { customParameters = null; }
    if (onError === void 0) { onError = null; }
    var app = Global.app();
    var dataSource = new kendo.data.DataSource({
        transport: {
            read: {
                url: app.webServiceBaseURL + readURL,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                type: "POST",
                beforeSend: function (req) {
                    if (app.userSession != null && app.authenticationToken != null) {
                        req.setRequestHeader("Authorization", "token " + app.authenticationToken);
                    }
                },
            },
            parameterMap: function (data, operation) {
                if (customParameters !== null) {
                    customParameters(data);
                }
                return JSON.stringify(data);
            },
        },
        serverPaging: true,
        serverSorting: true,
        serverFiltering: true,
        pageSize: 100,
        schema: {
            data: "Payload.Data",
            total: "Payload.Total",
            model: model,
        },
        error: function (e) {
            var status = 0;
            if (e != null && e.xhr != null) {
                status = e.xhr.status;
                Util.handleAjaxError(e.xhr);
            }
            else {
                UI.showErrorMessage([Constants.PHRASE_GENERALACTIONFAILURE]);
            }
            if (onError !== null) {
                onError(status);
            }
        },
        requestEnd: function (e) {
            var response;
            if (e != null && e.response != null) {
                response = e.response;
                if (response.Success) {
                    if (response.RotateAuthenticationToken) {
                        Global.app().setAuthenticationToken(response.AuthenticationToken);
                    }
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                }
            }
        },
    });
    return dataSource;
}
exports.createWebServiceDataSource = createWebServiceDataSource;
function createAutocompleteDataSource(readURL, customParameters) {
    var app = Global.app();
    var dataSource = new kendo.data.DataSource({
        transport: {
            read: {
                url: app.webServiceBaseURL + readURL,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                type: "POST",
                beforeSend: function (req) {
                    if (app.userSession != null && app.authenticationToken != null) {
                        req.setRequestHeader("Authorization", "token " + app.authenticationToken);
                    }
                },
            },
            parameterMap: function (data, operation) {
                var parameters = {
                    SearchText: "",
                    MaxRecords: 50,
                };
                if (operation === "read") {
                    parameters.SearchText = data.filter.filters[0].value;
                }
                if (customParameters !== null) {
                    customParameters(parameters);
                }
                return JSON.stringify(parameters);
            },
        },
        serverFiltering: true,
        schema: {
            data: "Payload",
        },
        error: function (e) {
            if (e != null && e.xhr != null) {
                Util.handleAjaxError(e.xhr);
            }
            else {
                UI.showErrorMessage([Constants.PHRASE_GENERALACTIONFAILURE]);
            }
        },
        requestEnd: function (e) {
            if (e == null || e.response == null) {
                UI.showErrorMessage([Constants.PHRASE_GENERALACTIONFAILURE]);
            }
            else if (e.response.Success) {
                if (e.response.RotateAuthenticationToken) {
                    Global.app().setAuthenticationToken(e.response.AuthenticationToken);
                }
            }
            else {
                UI.showErrorMessage(e.response.Messages);
            }
        },
    });
    return dataSource;
}
exports.createAutocompleteDataSource = createAutocompleteDataSource;


/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_ROUTECHANGE = "routeChange";
exports.EVENT_ROUTECLOSE = "routeClose";
exports.EVENT_TARGETTEMPLATECHANGE = "targetTemplateChange";


/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function AddCustomer(request) {
    return Util.callWebService("/api/Customer/Add", "POST", request);
}
exports.AddCustomer = AddCustomer;
function GetCustomer(customerID) {
    return Util.callWebService("/api/Customer/Get/" + customerID, "GET");
}
exports.GetCustomer = GetCustomer;
function SaveCustomer(request) {
    return Util.callWebService("/api/Customer/Save", "POST", request);
}
exports.SaveCustomer = SaveCustomer;
function ChangeIsActive(request) {
    return Util.callWebService("/api/Customer/ChangeIsActive", "POST", request);
}
exports.ChangeIsActive = ChangeIsActive;


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(267);
var ko = __webpack_require__(4);
var _ = __webpack_require__(9);
var UI = __webpack_require__(3);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var Util = __webpack_require__(8);
exports.GRIDFILTERCONTROL_HEIGHT = 96;
var GridFilterControl = (function () {
    function GridFilterControl(container, settings) {
        this.viewModel = {};
        var me = this;
        var app = Global.app();
        this.settings = settings;
        this.container = container;
        app.templates().render("gridfiltercontrol", "template_gridfiltercontrol", this.container)
            .done(function () {
            me.viewModel = {
                showTextSearch: settings.showTextSearch != null ? settings.showTextSearch : false,
                showRefresh: settings.showRefresh != null ? settings.showRefresh : false,
                showFilters: settings.showFilters != null ? settings.showFilters : false,
                filters: me.createFilterObservableArray(settings.filters ? settings.filters : []),
                showExportToExcel: settings.showExportToExcel != null ? settings.showExportToExcel : false,
                buttons: settings.buttons != null ? settings.buttons : [],
                searchText: ko.observable(""),
                showSearchAllFields: ko.observable(settings.showSearchAllFields),
                searchAllFields: ko.observable(false),
                search: function () {
                    me.refreshGrid();
                },
                filterChange: function () {
                    me.refreshGrid();
                    return true;
                },
                refresh: function () {
                    me.refreshGrid();
                },
                exportClick: function () {
                    if (me.settings.grid != null) {
                        me.settings.grid.saveAsExcel();
                    }
                },
            };
            ko.applyBindings(me.viewModel, container[0]);
            me.container.find("ul[data-id='filterMenu']").kendoMenu();
            me.container.find("ul[data-id='buttons']").kendoMenu();
            me.container.find("input[data-id='filterSearchText']").on("keydown", function (event) {
                return me.searchKeyDown(event);
            });
        });
    }
    GridFilterControl.prototype.getValues = function () {
        var filterValues = {};
        if (this.viewModel.searchText != null) {
            filterValues.searchText = this.viewModel.searchText();
        }
        if (this.viewModel.filters != null) {
            filterValues.filters = ko.toJS(this.viewModel.filters);
        }
        if (this.viewModel.searchAllFields != null) {
            filterValues.searchAllFields = this.viewModel.searchAllFields();
        }
        return filterValues;
    };
    GridFilterControl.prototype.setDataFilter = function (data) {
        var values;
        data.IncludeActive = true;
        data.IncludeInactive = false;
        values = this.getValues();
        data.SearchText = values.searchText;
        if (values.filters) {
            values.filters.forEach(function (filter) {
                switch (filter.name) {
                    case Constants.PHRASE_FILTER_SHOWACTIVE:
                        data.IncludeActive = filter.checked;
                        break;
                    case Constants.PHRASE_FILTER_SHOWINACTIVE:
                        data.IncludeInactive = filter.checked;
                        break;
                }
            });
        }
    };
    GridFilterControl.prototype.searchKeyDown = function (event) {
        var me = this;
        var keyCode = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
        if (keyCode === 13) {
            me.refreshGrid();
            return false;
        }
        else {
            if (me.searchTimeoutID != null) {
                window.clearTimeout(me.searchTimeoutID);
            }
            me.searchTimeoutID = window.setTimeout(function () {
                me.refreshGrid();
            }, 500);
            return true;
        }
    };
    GridFilterControl.prototype.createFilterObservableArray = function (filters) {
        var filterObservable = ko.observableArray([]);
        if (filters != null) {
            filters.forEach(function (filter) {
                filterObservable.push({
                    name: ko.observable(filter.name),
                    checked: ko.observable(filter.checked),
                });
            });
        }
        return filterObservable;
    };
    GridFilterControl.prototype.refreshGrid = function () {
        if (this.settings.grid != null) {
            this.settings.grid.dataSource.read();
            this.settings.grid.dataSource.page(1);
        }
    };
    return GridFilterControl;
}());
exports.GridFilterControl = GridFilterControl;
exports.RESULT_SCHEME_COLUMN_TYPE_STRING = "string";
exports.RESULT_SCHEME_COLUMN_TYPE_NUMBER = "number";
exports.RESULT_SCHEME_COLUMN_TYPE_BOOLEAN = "boolean";
exports.RESULT_SCHEME_COLUMN_TYPE_DATE = "date";
exports.RESULT_SCHEME_COLUMN_FORMAT_DATE = "date";
exports.RESULT_SCHEME_COLUMN_FORMAT_DATE_TIME = "date-time";
exports.RESULT_SCHEME_COLUMN_FORMAT_TIME = "time";
function createDataSourceModel(resultScheme) {
    var model = {
        id: resultScheme.ID,
        fields: {},
    };
    resultScheme.Columns.forEach(function (column) {
        column.Title = _.escape(column.Title);
        model.fields[column.Field] = {
            type: column.Type,
        };
    });
    return model;
}
exports.createDataSourceModel = createDataSourceModel;
function createColumnsModel(resultScheme) {
    var gridColumns = [];
    var app = Global.app();
    var customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
    var dateFormat = UI.GetCustomerSetting(customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT);
    var timeFormat = UI.GetCustomerSetting(customerSettings, Constants.SETTING_KEY_TIMEFORMAT, Constants.DEFAULT_TIME_FORMAT);
    for (var _i = 0, _a = resultScheme.Columns; _i < _a.length; _i++) {
        var column = _a[_i];
        if (column.ShowInGrid) {
            var gridColumn = {
                title: column.Title,
                field: column.Field,
            };
            if (!Util.isNullOrEmpty(column.TemplateHTML)) {
                gridColumn.template = kendo.template(column.TemplateHTML ? column.TemplateHTML : "");
            }
            else {
                switch (column.Format) {
                    case exports.RESULT_SCHEME_COLUMN_FORMAT_DATE:
                        gridColumn.template =
                            "#= " + column.Field + " ? kendo.toString(" + column.Field + ", \"" + UI.getKendoDateFormat(dateFormat) + "\") : \"\"#";
                        break;
                    case exports.RESULT_SCHEME_COLUMN_FORMAT_DATE_TIME:
                        gridColumn.template =
                            "#= " + column.Field + " ? kendo.toString(" + column.Field + ", \"" + UI.getKendoDateFormat(dateFormat) + " " + UI.getKendoTimeFormat(timeFormat) + "\") : \"\"#";
                        break;
                    case exports.RESULT_SCHEME_COLUMN_FORMAT_TIME:
                        gridColumn.template =
                            "#= " + column.Field + " ? kendo.toString(new Date(\"2000-01-01T\" + " + column.Field + "), \"" + UI.getKendoTimeFormat(timeFormat) + "\") : \"\"#";
                        gridColumn.filterable = false;
                        break;
                }
                if (column.Type === exports.RESULT_SCHEME_COLUMN_TYPE_DATE) {
                    gridColumn.filterable = {
                        ui: function (element) {
                            element.kendoDatePicker({
                                format: UI.getKendoDateFormat(dateFormat),
                            });
                        },
                    };
                }
            }
            gridColumns.push(gridColumn);
        }
    }
    return gridColumns;
}
exports.createColumnsModel = createColumnsModel;


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(420);
__webpack_require__(421);
var _ = __webpack_require__(9);
var moment = __webpack_require__(0);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var Util = __webpack_require__(8);
function showErrorMessage(messages) {
    if (!messages) {
        return;
    }
    var message = "";
    var i;
    var max;
    max = messages.length;
    for (i = 0; i < max; i++) {
        message += messages[i];
    }
    $("#master_errorMessageDialog_Message").text(message);
    $("#master_errorMessageDialog").modal("show");
}
exports.showErrorMessage = showErrorMessage;
var confirmDialogIsCreated = false;
var confirmDialogOnYes = null;
var confirmDialogOnNo = null;
function showConfirmDialog(message, onYes, onNo) {
    if (!confirmDialogIsCreated) {
        $("#master_confirmDialog_Yes").click(function () {
            $("#master_confirmDialog").modal("hide");
            if (confirmDialogOnYes != null) {
                confirmDialogOnYes();
            }
        });
        $("#master_confirmDialog_No").click(function () {
            $("#master_confirmDialog").modal("hide");
            if (confirmDialogOnNo != null) {
                confirmDialogOnNo();
            }
        });
        confirmDialogIsCreated = true;
    }
    confirmDialogOnYes = onYes;
    confirmDialogOnNo = onNo;
    $("#master_confirmDialog_Message").text(message);
    $("#master_confirmDialog").modal("show");
}
exports.showConfirmDialog = showConfirmDialog;
var sessionTimeoutWarningDialogIsCreated = false;
var sessionTimeoutWarningDialogTimer = null;
var sessionTimeoutWarningDialogExpirationDateTime = null;
function showSessionTimeWarningDialog() {
    var app = Global.app();
    var clearTimer = function () {
        if (sessionTimeoutWarningDialogTimer) {
            clearInterval(sessionTimeoutWarningDialogTimer);
        }
    };
    if (!sessionTimeoutWarningDialogIsCreated) {
        $("#master_sessionExpirationWarningDialog_ContinueWorking").click(function () {
            clearTimer();
            Util.callWebService("/api/App/SessionKeepAlive", "GET").done(function (response) {
                if (response.Success) {
                    $("#master_sessionExpirationWarningDialog").modal("hide");
                }
                else {
                    showErrorMessage(response.ErrorMessages);
                }
            });
        });
        $("#master_sessionExpirationWarningDialog_Logout").click(function () {
            clearTimer();
            app.pageManager().logout();
        });
        sessionTimeoutWarningDialogIsCreated = true;
    }
    sessionTimeoutWarningDialogExpirationDateTime = moment().add(app.global.SessionTimeoutWarningMinutes, "minutes").subtract(20, "seconds");
    var showTimeToExpiration = function () {
        if (sessionTimeoutWarningDialogExpirationDateTime) {
            $("#master_sessionExpirationWarningDialog_TimeToLogout").text(sessionTimeoutWarningDialogExpirationDateTime.fromNow());
        }
    };
    sessionTimeoutWarningDialogTimer = window.setInterval(function () {
        if (sessionTimeoutWarningDialogExpirationDateTime && sessionTimeoutWarningDialogExpirationDateTime.isBefore()) {
            clearTimer();
            app.pageManager().logout();
        }
        else {
            showTimeToExpiration();
        }
    }, 5000);
    showTimeToExpiration();
    $("#master_sessionExpirationWarningDialog").modal("show");
}
exports.showSessionTimeWarningDialog = showSessionTimeWarningDialog;
function showWaitIndicator(targetContainer) {
    var position = targetContainer.offset();
    var left = position ? position.left : 0;
    var top = position ? position.top : 0;
    var targetWidth = _.defaultTo(targetContainer.width(), 0);
    var targetHeight = _.defaultTo(targetContainer.height(), 0);
    targetContainer.css({ opacity: "0.5" });
    return $("<div class='three-quarters'></div>").css({
        position: "absolute",
        left: left + (targetWidth / 2),
        top: top + (targetHeight / 2),
    }).appendTo("body");
}
exports.showWaitIndicator = showWaitIndicator;
function hideWaitIndicator(targetContainer, waitContainer) {
    targetContainer.css({ opacity: "1" });
    $(waitContainer).remove();
}
exports.hideWaitIndicator = hideWaitIndicator;
function setRequiredStringError(value, errorMessageName, viewModel) {
    var isValid = true;
    if (value == null || value === "") {
        isValid = false;
    }
    viewModel[errorMessageName](!isValid);
    return isValid;
}
exports.setRequiredStringError = setRequiredStringError;
function GetCustomerSetting(customerSettings, settingKey, defaultValue) {
    var setting = customerSettings.filter(function (x) { return x.SettingKey === settingKey; });
    var settingValue = defaultValue;
    if (setting && setting.length > 0) {
        settingValue = setting[0].Value;
    }
    return settingValue;
}
exports.GetCustomerSetting = GetCustomerSetting;
function getKendoDateFormat(dateSetting) {
    return Constants.KENDO_DATE_FORMAT_MAP[dateSetting];
}
exports.getKendoDateFormat = getKendoDateFormat;
function getKendoTimeFormat(timeSetting) {
    return Constants.KENDO_TIME_FORMAT_MAP[timeSetting];
}
exports.getKendoTimeFormat = getKendoTimeFormat;
function getMomentDateFormat(dateSetting) {
    return Constants.MOMENT_DATE_FORMAT_MAP[dateSetting];
}
exports.getMomentDateFormat = getMomentDateFormat;
function getMomentTimeFormat(timeSetting) {
    return Constants.MOMENT_TIME_FORMAT_MAP[timeSetting];
}
exports.getMomentTimeFormat = getMomentTimeFormat;
function getKendoNumericFormat(mask, numberOfDecimals) {
    var format = mask;
    if (!format) {
        format = "#";
    }
    if (numberOfDecimals > 0) {
        format = format + ".";
        for (var i = 0; i < numberOfDecimals; i++) {
            format = format + "0";
        }
    }
    return format;
}
exports.getKendoNumericFormat = getKendoNumericFormat;
function formatValueFromControlType(value, controlTypeID) {
    var returnValue = value;
    if (value &&
        (controlTypeID === Constants.QuestionType.DATE ||
            controlTypeID === Constants.QuestionType.DATETIME ||
            controlTypeID === Constants.QuestionType.TIME)) {
        var app = Global.app();
        var customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
        var dateFormat = GetCustomerSetting(customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT);
        var timeFormat = GetCustomerSetting(customerSettings, Constants.SETTING_KEY_TIMEFORMAT, Constants.DEFAULT_TIME_FORMAT);
        if (controlTypeID === Constants.QuestionType.DATE) {
            returnValue = kendo.toString(new Date(value + "T00:00:00"), getKendoDateFormat(dateFormat));
        }
        else if (controlTypeID === Constants.QuestionType.DATETIME) {
            returnValue = kendo.toString(new Date(value), getKendoDateFormat(dateFormat) + " " + getKendoTimeFormat(timeFormat)).toString();
        }
        else if (controlTypeID === Constants.QuestionType.TIME) {
            returnValue = kendo.toString(new Date("2000-01-01T" + value), getKendoTimeFormat(timeFormat)).toString();
        }
    }
    return returnValue;
}
exports.formatValueFromControlType = formatValueFromControlType;
function setRequiredString(value, errorFlag) {
    var isValid = !Util.isNullOrEmpty(value());
    errorFlag(!isValid);
    return isValid;
}
exports.setRequiredString = setRequiredString;
function setRequiredNumber(value, errorFlag, mustBeGreaterThenZero) {
    if (mustBeGreaterThenZero === void 0) { mustBeGreaterThenZero = false; }
    var isValid = true;
    if (value() == null) {
        isValid = false;
    }
    else if (mustBeGreaterThenZero && value() <= 0) {
        isValid = false;
    }
    errorFlag(!isValid);
    return isValid;
}
exports.setRequiredNumber = setRequiredNumber;
function validateMinMaxNumericValues(minEntry, maxEntry, allowNegative, errorFlag) {
    var isValid = true;
    var min = parseInt(minEntry(), 10);
    var max = parseInt(maxEntry(), 10);
    if (!isNaN(min) && !allowNegative && min < 0) {
        isValid = false;
    }
    else if (!isNaN(max) && !allowNegative && max < 0) {
        isValid = false;
    }
    else if (!isNaN(min) && !isNaN(max) && max < min) {
        isValid = false;
    }
    errorFlag(!isValid);
    return isValid;
}
exports.validateMinMaxNumericValues = validateMinMaxNumericValues;
var messageTypeValues;
(function (messageTypeValues) {
    messageTypeValues[messageTypeValues["success"] = 0] = "success";
    messageTypeValues[messageTypeValues["error"] = 1] = "error";
    messageTypeValues[messageTypeValues["info"] = 2] = "info";
})(messageTypeValues = exports.messageTypeValues || (exports.messageTypeValues = {}));
var notificationMessage;
function showNotificationMessage(message, messageType) {
    if (!notificationMessage) {
        notificationMessage = $("#master_notificationMessage").kendoNotification({
            width: 400,
            position: {
                bottom: 20,
                right: 80,
            },
        }).data("kendoNotification");
    }
    var className = "";
    switch (messageType) {
        case messageTypeValues.success:
            className = "success";
            break;
        case messageTypeValues.error:
            className = "error";
            break;
        case messageTypeValues.info:
            className = "info";
            break;
    }
    notificationMessage.show(message, className);
}
exports.showNotificationMessage = showNotificationMessage;
function resizeGrid(gridContainer, height) {
    var dataArea = gridContainer.find(".k-grid-content");
    var newHeight = height - 8;
    var gridInnerHeight = _.defaultTo(gridContainer.innerHeight(), 0);
    var dataInnerHeight = _.defaultTo(dataArea.innerHeight(), 0);
    var diff = gridInnerHeight - dataInnerHeight;
    gridContainer.height(newHeight);
    dataArea.height(newHeight - diff);
}
exports.resizeGrid = resizeGrid;
function isDateTimeValid(date, time, dateTime, dateFormat, timeFormat) {
    var momentDateFormat = getMomentDateFormat(dateFormat);
    var momentTimeFormat = getMomentTimeFormat(timeFormat);
    var dateTimeString = dateTime ? dateTime : (date ? date : moment().format(momentDateFormat)) + " " + (time ? time : moment().format(momentTimeFormat));
    var dateTimeMoment = moment(dateTimeString, momentDateFormat + " " + momentTimeFormat, true);
    return dateTimeMoment.isValid();
}
exports.isDateTimeValid = isDateTimeValid;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function AuthenticateUser(request) {
    return Util.callWebService("/api/Authentication/AuthenticateUser", "POST", request);
}
exports.AuthenticateUser = AuthenticateUser;
function AuthenticateJWT(request) {
    return Util.callWebService("/api/Authentication/AuthenticateJWT", "POST", request);
}
exports.AuthenticateJWT = AuthenticateJWT;
function AuthenticateUserWithToken(request) {
    return Util.callWebService("/api/Authentication/AuthenticateUserWithToken", "POST", request);
}
exports.AuthenticateUserWithToken = AuthenticateUserWithToken;
function AuthenticateUserWithExternalToken(request) {
    return Util.callWebService("/api/Authentication/AuthenticateUserWithExternalToken", "POST", request);
}
exports.AuthenticateUserWithExternalToken = AuthenticateUserWithExternalToken;
function EmailPasswordReset(request) {
    return Util.callWebService("/api/Authentication/EmailPasswordReset", "POST", request);
}
exports.EmailPasswordReset = EmailPasswordReset;
function ValidateResetPasswordKey(request) {
    return Util.callWebService("/api/Authentication/ValidateResetPasswordKey", "POST", request);
}
exports.ValidateResetPasswordKey = ValidateResetPasswordKey;
function ResetPassword(request) {
    return Util.callWebService("/api/Authentication/ResetPassword", "POST", request);
}
exports.ResetPassword = ResetPassword;
function Logout() {
    return Util.callWebService("/api/Authentication/Logout", "POST", null, false);
}
exports.Logout = Logout;


/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var AuthenticationData = __webpack_require__(32);
var LoginControl = (function () {
    function LoginControl() {
        var me = this;
        var app = Global.app();
        this.viewModel = {
            UserName: ko.observable(""),
            Password: ko.observable(""),
            UserNameMissing: ko.observable(false),
            PasswordMissing: ko.observable(false),
            LoginInvalid: ko.observable(false),
            AccountLocked: ko.observable(false),
            AccountLockedLength: ko.observable(0),
            LoginHelp: ko.observable(""),
            CookiesEnabled: ko.observable(this.checkCookiesEnabled()),
            selfRegistrationAllowed: app.global.SelfRegistrationAllowed,
            onSelfRegistration: function () {
                app.router().navigate("/SelfRegistration", true);
            },
            onLogin: function () {
                me.processLoginRequest();
            },
            onForgotPassword: function () {
                app.router().navigate("/ForgotPassword", true);
            },
            viewTOC: function () {
                me.tocModal.modal("show");
            },
            hideTOC: function () {
                me.tocModal.modal("hide");
            },
        };
    }
    LoginControl.prototype.render = function (container) {
        var _this = this;
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        this.container = container;
        app.templates().render("logincontrol", "template_logincontrol", this.container)
            .done(function () {
            _this.tocModal = container.find("#tocModal");
            ko.applyBindings(_this.viewModel, container[0]);
            _this.container.find("input[data-id='loginField']").keypress(function (e) {
                if (e.which === 13) {
                    $(e.target).blur();
                    me.processLoginRequest();
                }
            });
            _this.setFocusToUserNameField();
            deferred.resolve();
        });
        return deferred.promise();
    };
    LoginControl.prototype.checkCookiesEnabled = function () {
        if (Global.app().webServiceBaseDomain === "localhost") {
            return true;
        }
        try {
            document.cookie = "cookietest=1;";
            var ret = document.cookie.indexOf("cookietest=") !== -1;
            document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT; SameSite=None; Secure;";
            return ret;
        }
        catch (e) {
            return false;
        }
    };
    LoginControl.prototype.processLoginRequest = function () {
        var me = this;
        var app = Global.app();
        var waitContainer;
        var targetContainer;
        var request;
        if (!this.validateLogin()) {
            me.setFocusToUserNameField();
            return;
        }
        targetContainer = this.container.find(".login_panel_body");
        waitContainer = UI.showWaitIndicator(targetContainer);
        request = {
            UserName: this.viewModel.UserName(),
            Password: this.viewModel.Password(),
        };
        AuthenticationData.AuthenticateUser(request)
            .done(function (response) {
            if (response.Success) {
                if (response.Payload.IsAuthenticated) {
                    me.viewModel.LoginInvalid(false);
                    me.viewModel.AccountLocked(false);
                    app.loginUser(response.Payload.AuthenticationToken, response.Payload.UserSession, response.Payload.ReportToken);
                    if (app.pageManager().redirectURL) {
                        window.location.href = app.pageManager().redirectURL;
                    }
                    else {
                        app.pageManager().closeAllAndGotoDefaultPage();
                    }
                }
                else {
                    if (response.Payload.MustChangePassword) {
                        app.router().navigate("/ResetPassword/Expired/" + response.Payload.PasswordResetToken, true);
                    }
                    else if (response.Payload.ExceededMaximumAttempts) {
                        me.viewModel.LoginInvalid(false);
                        me.viewModel.AccountLocked(true);
                        me.viewModel.AccountLockedLength(response.Payload.AccountLockedLength);
                    }
                    else {
                        me.setFocusToUserNameField();
                        me.viewModel.LoginInvalid(true);
                        me.viewModel.AccountLocked(false);
                    }
                }
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(targetContainer, waitContainer);
        });
    };
    LoginControl.prototype.validateLogin = function () {
        var isValid = true;
        isValid = UI.setRequiredStringError(this.viewModel.UserName(), "UserNameMissing", this.viewModel) ? isValid : false;
        isValid = UI.setRequiredStringError(this.viewModel.Password(), "PasswordMissing", this.viewModel) ? isValid : false;
        return isValid;
    };
    LoginControl.prototype.setFocusToUserNameField = function () {
        this.container.find("input[data-id='loginField']").first().focus();
    };
    return LoginControl;
}());
exports.LoginControl = LoginControl;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var moment = __webpack_require__(0);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var TargetData = __webpack_require__(45);
var TargetEditControl = (function () {
    function TargetEditControl() {
        var _this = this;
        this.fieldsOnLoad = "";
        this.targetTemplateURLName = "";
        var me = this;
        var app = Global.app();
        var customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
        this.viewModel = {
            ID: ko.observable(0),
            IsActive: ko.observable(true),
            HasAddressFields: ko.observable(false),
            HasCustomFields: ko.observable(false),
            AddressFormItems: ko.observableArray(),
            FormItems: ko.observableArray(),
            StateID: ko.observable(0),
            AppointmentLabel: ko.observable(Constants.LABEL_APPOINTMENT),
            States: ko.observableArray(),
            AllCustomerDocuments: ko.observableArray(),
            LinkedCustomerDocuments: ko.observableArray(),
            CustomerDocumentDownloadUrl: ko.observable(app.webServiceBaseURL + "/api/DocumentLibrary/Download/"),
            SelectedCustomerDocument: ko.observable(),
            URL: Global.app().webServiceBaseURL,
            PictureURL: ko.observable(null),
            TemplatePhraseID: ko.observable(0),
            TemplatePhrases: ko.observableArray(),
            ListValues: ko.observableArray(),
            DateFormat: UI.GetCustomerSetting(customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT),
            TimeFormat: UI.GetCustomerSetting(customerSettings, Constants.SETTING_KEY_TIMEFORMAT, Constants.DEFAULT_TIME_FORMAT),
            toggleIsActive: function () {
                var message;
                if (this.IsActive()) {
                    message = "Are you sure you want to make this target inactive?";
                }
                else {
                    message = "Are you sure you want to make this target active?";
                }
                UI.showConfirmDialog(message, function () {
                    me.toggleIsActive();
                });
            },
            addAppointment: function () {
                Global.app().router().navigate("/TaskAdd?targetID=" + me.viewModel.ID(), true);
            },
            linkDocument: function () {
                if (_this.viewModel.SelectedCustomerDocument()) {
                    var doc = _this.viewModel.SelectedCustomerDocument();
                    var linkedDoc = {
                        TargetCustomerDocumentID: ko.observable(0),
                        CustomerDocumentID: ko.observable(doc.ID()),
                        Description: ko.observable(doc.Description()),
                        FileName: ko.observable(doc.FileName()),
                        IsActive: ko.observable(doc.IsActive()),
                        StorageKey: ko.observable(doc.StorageKey()),
                    };
                    _this.viewModel.LinkedCustomerDocuments.push(linkedDoc);
                    _this.viewModel.SelectedCustomerDocument(null);
                }
            },
            removeLinkedDocument: function (doc) {
                UI.showConfirmDialog("Are you sure you want to remove this document?", function () {
                    if (doc.TargetCustomerDocumentID() > 0) {
                        doc.IsActive(false);
                    }
                    else {
                        _this.viewModel.LinkedCustomerDocuments.remove(doc);
                    }
                });
            },
            UnselectedCustomerDocuments: ko.pureComputed(function () {
                var selectedDocumentIDs = _this.viewModel.LinkedCustomerDocuments().map(function (doc) { return doc.CustomerDocumentID(); });
                return _this.viewModel.AllCustomerDocuments().filter(function (doc) {
                    return selectedDocumentIDs.indexOf(doc.ID()) < 0;
                });
            }),
            closeUploadImageModal: function () {
                me.container.find("div[data-id='uploadImageDialog']").modal("hide");
            },
            showUploadImageModal: function (formItemIndex) {
                me.currentUploadFormItem = me.viewModel.FormItems()[formItemIndex];
                me.uploadControl.clearAllFiles();
                me.container.find("div[data-id='uploadImageDialog']").modal("show");
                me.container.find(".k-upload-status-total").remove();
            },
            removeImage: function (formItemIndex) {
                var formItem = me.viewModel.FormItems()[formItemIndex];
                formItem.Value(null);
                formItem.TempFileKey(null);
                formItem.TempFileExtension(null);
                formItem.TempFileName(null);
            },
            closeViewImageModal: function () {
                me.container.find("div[data-id='viewImageFormDialog']").modal("hide");
            },
            openViewImageModal: function (formItemIndex) {
                me.viewModel.PictureURL(me.viewModel.getImageURL(formItemIndex));
                me.container.find("div[data-id='viewImageFormDialog']").modal("show");
            },
            getImageURL: function (formItemIndex) {
                var formItem = me.viewModel.FormItems()[formItemIndex];
                var cacheBuster = "?v=" + (new Date()).getTime().toString();
                if (formItem.TempFileKey() && formItem.TempFileExtension()) {
                    return Global.app().webServiceBaseURL + "/api/Target/GetTempImage/" + formItem.TempFileName() + "/" + formItem.TempFileExtension() + cacheBuster;
                }
                else if (formItem.Value()) {
                    return Global.app().webServiceBaseURL + "/api/Target/GetImage/" + formItem.ID + cacheBuster;
                }
                else {
                    return null;
                }
            },
        };
    }
    TargetEditControl.prototype.render = function (container) {
        var _this = this;
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        me.container = container;
        app.templates().render("targeteditcontrol", "template_target_edit_control", this.container).done(function () {
            _this.uploadControl = _this.container.find("input[data-id='uploadImageControl']").kendoUpload({
                async: {
                    saveUrl: "save",
                    removeUrl: "remove",
                    autoUpload: true,
                },
                validation: {
                    allowedExtensions: [".jpg", ".jpeg", ".png"],
                },
                upload: _this.onImageUpload.bind(_this),
                success: _this.onUploadSuccess.bind(_this),
                multiple: false,
            }).data("kendoUpload");
            ko.applyBindings(_this.viewModel, container[0]);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TargetEditControl.prototype.load = function (targetTemplateURLName, targetID) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        if (!targetTemplateURLName) {
            deferred.reject();
            return deferred.promise();
        }
        this.targetTemplateURLName = targetTemplateURLName;
        if (targetID) {
            this.viewModel.ID(targetID);
        }
        else {
            this.viewModel.ID(null);
        }
        TargetData.GetTargetMaster(this.targetTemplateURLName, this.viewModel.ID())
            .done(function (response) {
            if (response.Success) {
                me.updateViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TargetEditControl.prototype.haveFieldsChanged = function () {
        var fieldValues = JSON.stringify(this.getTargetMasterFromViewModel());
        return fieldValues !== this.fieldsOnLoad;
    };
    TargetEditControl.prototype.subTitle = function () {
        if (this.viewModel.HasAddressFields()) {
            return this.viewModel.AddressFormItems()[0].Value();
        }
        else if (this.viewModel.HasCustomFields()) {
            return this.viewModel.FormItems()[0].Value();
        }
        else {
            return "";
        }
    };
    TargetEditControl.prototype.save = function () {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer;
        if (me.viewModel.AddressFormItems()) {
            me.viewModel.AddressFormItems().forEach(function (formItem) {
                if (formItem.FormText === "State") {
                    formItem.Value(me.getStateName());
                }
            });
        }
        if (this.isValid()) {
            waitContainer = UI.showWaitIndicator(this.container);
            TargetData.Save(this.getTargetMasterFromViewModel())
                .done(function (response) {
                if (response.Success) {
                    UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                    me.updateViewModel(response.Payload);
                    deferred.resolve(response.Payload);
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                    deferred.reject();
                }
            })
                .fail(function () {
                deferred.reject();
            })
                .always(function () {
                UI.hideWaitIndicator(me.container, waitContainer);
            });
        }
        else {
            deferred.reject();
        }
        return deferred.promise();
    };
    TargetEditControl.prototype.getStateName = function () {
        var me = this;
        var name = "";
        me.viewModel.States().forEach(function (state) {
            if (state.ID() === me.viewModel.StateID()) {
                name = state.Name();
            }
        });
        return name;
    };
    TargetEditControl.prototype.setStateID = function (stateName, states) {
        var me = this;
        states.forEach(function (state) {
            if (state.Name === stateName) {
                me.viewModel.StateID(state.ID);
            }
        });
    };
    TargetEditControl.prototype.updateViewModel = function (targetMaster) {
        var _this = this;
        var me = this;
        this.viewModel.ID(targetMaster.ID);
        this.viewModel.IsActive(targetMaster.IsActive);
        this.viewModel.HasAddressFields(targetMaster.HasAddressFields);
        this.viewModel.HasCustomFields(targetMaster.HasCustomFields);
        this.viewModel.States([]);
        me.viewModel.AddressFormItems.removeAll();
        me.viewModel.FormItems.removeAll();
        targetMaster.FormItems.forEach(function (formItem) {
            me.viewModel.FormItems.push(me.createFormItemObservable(formItem));
        });
        if (targetMaster.States) {
            targetMaster.States.forEach(function (state) {
                var dropdownState = {
                    ID: ko.observable(state.ID),
                    Name: ko.observable(state.Name),
                };
                me.viewModel.States.push(dropdownState);
            });
        }
        targetMaster.AddressFormItems.forEach(function (formItem) {
            me.viewModel.AddressFormItems.push(me.createFormItemObservable(formItem));
            if (formItem.FormText === "State") {
                me.setStateID(formItem.Value, targetMaster.States);
            }
        });
        this.viewModel.LinkedCustomerDocuments.removeAll();
        targetMaster.LinkedCustomerDocuments.forEach(function (doc) {
            _this.viewModel.LinkedCustomerDocuments.push(_this.createLinkedCustomerDocumentObservable(doc));
        });
        this.viewModel.AllCustomerDocuments.removeAll();
        targetMaster.AllCustomerDocuments.forEach(function (doc) {
            _this.viewModel.AllCustomerDocuments.push(_this.createCustomerDocumentObservable(doc));
        });
        this.fieldsOnLoad = JSON.stringify(this.getTargetMasterFromViewModel());
    };
    TargetEditControl.prototype.createCustomerDocumentObservable = function (doc) {
        return {
            ID: ko.observable(doc.ID),
            Description: ko.observable(doc.Description),
            FileName: ko.observable(doc.FileName),
            IsActive: ko.observable(doc.IsActive),
            StorageKey: ko.observable(doc.StorageKey),
            TempFileKey: ko.observable(doc.TempFileKey),
        };
    };
    TargetEditControl.prototype.createLinkedCustomerDocumentObservable = function (doc) {
        return {
            TargetCustomerDocumentID: ko.observable(doc.TargetCustomerDocumentID),
            CustomerDocumentID: ko.observable(doc.CustomerDocumentID),
            Description: ko.observable(doc.Description),
            FileName: ko.observable(doc.FileName),
            IsActive: ko.observable(doc.IsActive),
            StorageKey: ko.observable(doc.StorageKey),
        };
    };
    TargetEditControl.prototype.createFormItemObservable = function (formItem) {
        var observable = {
            ID: formItem.ID,
            Value: ko.observable(this.convertValueForLocalDisplay(formItem.Value, formItem.ControlTypeID)),
            TargetTemplateFormItemID: formItem.TargetTemplateFormItemID,
            ControlTypeID: formItem.ControlTypeID,
            FormText: formItem.FormText,
            IsRequired: formItem.IsRequired,
            MaxLength: formItem.MaxLength,
            TempFileKey: ko.observable(null),
            TempFileName: ko.observable(null),
            TempFileExtension: ko.observable(null),
            ShowTextField: formItem.ControlTypeID !== Constants.QuestionType.PICTURE,
            ShowPictureUpload: formItem.ControlTypeID === Constants.QuestionType.PICTURE,
            IsFieldMissing: ko.observable(false),
            InvalidDateTimeFormat: ko.observable(false),
            TemplateName: this.getTemplateNameFromControlTypeID(formItem.ControlTypeID),
            TemplatePhraseID: formItem.TemplatePhraseID,
            ListValues: ko.observableArray(formItem.ListValues),
            TemplatePhrases: ko.observableArray(formItem.TemplatePhrases),
        };
        return observable;
    };
    TargetEditControl.prototype.isValid = function () {
        var validDateFormat = true;
        var isValid = true;
        var formItems = this.viewModel.HasCustomFields() ? this.viewModel.FormItems() : this.viewModel.AddressFormItems();
        var app = Global.app();
        var customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
        var dateFormat = UI.GetCustomerSetting(customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT);
        var timeFormat = UI.GetCustomerSetting(customerSettings, Constants.SETTING_KEY_TIMEFORMAT, Constants.DEFAULT_TIME_FORMAT);
        for (var _i = 0, formItems_1 = formItems; _i < formItems_1.length; _i++) {
            var formItem = formItems_1[_i];
            if (formItem.IsRequired) {
                if (formItem.ShowPictureUpload) {
                    if (!formItem.Value() && !formItem.TempFileKey()) {
                        isValid = false;
                        formItem.IsFieldMissing(true);
                    }
                    else {
                        formItem.IsFieldMissing(false);
                    }
                }
                else {
                    isValid = UI.setRequiredString(formItem.Value, formItem.IsFieldMissing) ? isValid : false;
                }
            }
            switch (formItem.ControlTypeID) {
                case Constants.QuestionType.DATE:
                    validDateFormat = UI.isDateTimeValid(formItem.Value(), null, null, dateFormat, timeFormat);
                    isValid = validDateFormat ? isValid : false;
                    formItem.InvalidDateTimeFormat(!validDateFormat);
                    break;
                case Constants.QuestionType.DATETIME:
                    validDateFormat = UI.isDateTimeValid(null, null, formItem.Value(), dateFormat, timeFormat);
                    isValid = validDateFormat ? isValid : false;
                    formItem.InvalidDateTimeFormat(!validDateFormat);
                    break;
                case Constants.QuestionType.TIME:
                    validDateFormat = UI.isDateTimeValid(null, formItem.Value(), null, dateFormat, timeFormat);
                    isValid = validDateFormat ? isValid : false;
                    formItem.InvalidDateTimeFormat(!validDateFormat);
                    break;
            }
        }
        if (!isValid) {
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
        }
        return isValid;
    };
    TargetEditControl.prototype.toggleIsActive = function () {
        var _this = this;
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        var newIsActive = !this.viewModel.IsActive();
        var request = {
            TargetID: this.viewModel.ID(),
            IsActive: newIsActive,
        };
        TargetData.SetIsActive(request)
            .done(function (response) {
            if (response.Success) {
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                me.viewModel.IsActive(newIsActive);
                _this.fieldsOnLoad = JSON.stringify(_this.getTargetMasterFromViewModel());
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve(true);
        });
        return deferred.promise();
    };
    TargetEditControl.prototype.onImageUpload = function (e) {
        var url = Global.app().webServiceBaseURL;
        if (this.uploadControl.options.async) {
            this.uploadControl.options.async.saveUrl = url + "/api/Target/UploadImage";
        }
    };
    TargetEditControl.prototype.onUploadSuccess = function (e) {
        if (this.currentUploadFormItem != null) {
            this.currentUploadFormItem.TempFileKey(e.response.TempFileKey);
            this.currentUploadFormItem.TempFileName(e.response.TempFileName);
            this.currentUploadFormItem.TempFileExtension(e.response.TempFileExtension);
        }
    };
    TargetEditControl.prototype.getTargetMasterFromViewModel = function () {
        var targetMaster = {
            ID: this.viewModel.ID(),
            TargetTemplateURLName: this.targetTemplateURLName,
            AddressFormItems: this.getTargetMasterFormItemsFromObservable(this.viewModel.AddressFormItems),
            FormItems: this.getTargetMasterFormItemsFromObservable(this.viewModel.FormItems),
            LinkedCustomerDocuments: this.getTargetLinkedCustomDocumentsFromObservable(this.viewModel.LinkedCustomerDocuments),
            States: [],
            AllCustomerDocuments: [],
            IsActive: this.viewModel.IsActive(),
            HasAddressFields: this.viewModel.HasAddressFields(),
            HasCustomFields: this.viewModel.HasCustomFields(),
        };
        return targetMaster;
    };
    TargetEditControl.prototype.getTargetMasterFormItemsFromObservable = function (formItemsObservable) {
        var formItems = [];
        for (var _i = 0, _a = formItemsObservable(); _i < _a.length; _i++) {
            var formItemObservable = _a[_i];
            formItems.push({
                ID: formItemObservable.ID,
                Value: this.convertValueForSave(formItemObservable.Value(), formItemObservable.ControlTypeID),
                TargetTemplateFormItemID: formItemObservable.TargetTemplateFormItemID,
                TempFileKey: formItemObservable.TempFileKey(),
                ControlTypeID: formItemObservable.ControlTypeID,
                FormText: formItemObservable.FormText,
                IsRequired: formItemObservable.IsRequired,
                MaxLength: formItemObservable.MaxLength,
                TemplatePhraseID: formItemObservable.TemplatePhraseID,
                ListValues: [],
                TemplatePhrases: [],
            });
        }
        return formItems;
    };
    TargetEditControl.prototype.getTargetLinkedCustomDocumentsFromObservable = function (linkedDocumentsObservable) {
        var documents = [];
        for (var _i = 0, _a = linkedDocumentsObservable(); _i < _a.length; _i++) {
            var linkedDocumentObservable = _a[_i];
            documents.push({
                TargetCustomerDocumentID: linkedDocumentObservable.TargetCustomerDocumentID(),
                CustomerDocumentID: linkedDocumentObservable.CustomerDocumentID(),
                StorageKey: linkedDocumentObservable.StorageKey(),
                IsActive: linkedDocumentObservable.IsActive(),
                Description: linkedDocumentObservable.Description(),
                FileName: linkedDocumentObservable.FileName(),
            });
        }
        return documents;
    };
    TargetEditControl.prototype.getTemplateNameFromControlTypeID = function (controlTypeID) {
        switch (controlTypeID) {
            case Constants.QuestionType.PICTURE:
                return "target_edit_control_picture";
            case Constants.QuestionType.DATE:
                return "target_edit_control_date";
            case Constants.QuestionType.DATETIME:
                return "target_edit_control_date_time";
            case Constants.QuestionType.TIME:
                return "target_edit_control_time";
            case Constants.QuestionType.TEXTAREA:
                return "target_edit_control_text_area";
            case Constants.QuestionType.EMAIL:
                return "target_edit_control_email";
            case Constants.QuestionType.PHONE:
                return "target_edit_control_phone";
            case Constants.QuestionType.ADDRESS:
                return "target_edit_control_address";
            case Constants.QuestionType.RADIOBUTTONLIST:
                return "target_edit_control_radio_button_list";
            case Constants.QuestionType.DROPDOWN:
                return "target_edit_control_dropdown";
            default:
                return "target_edit_control_text_box";
        }
    };
    TargetEditControl.prototype.convertValueForLocalDisplay = function (value, controlTypeID) {
        var timeFormat = UI.getMomentTimeFormat(this.viewModel.TimeFormat);
        var dateFormat = UI.getMomentDateFormat(this.viewModel.DateFormat);
        var finalValue = value;
        if (value) {
            switch (controlTypeID) {
                case Constants.QuestionType.TIME:
                    finalValue = moment(value, Constants.MOMENT_FORMAT_TIME_STANDARDIZED).format(timeFormat);
                    break;
                case Constants.QuestionType.DATE:
                    finalValue = moment(value, Constants.MOMENT_FORMAT_DATE_STANDARDIZED).format(dateFormat);
                    break;
                case Constants.QuestionType.DATETIME:
                    finalValue = moment(value).local().format(dateFormat + " " + timeFormat);
                    break;
            }
        }
        return finalValue;
    };
    TargetEditControl.prototype.convertValueForSave = function (value, controlTypeID) {
        var finalValue = value;
        if (value) {
            var timeFormat = UI.getMomentTimeFormat(this.viewModel.TimeFormat);
            var dateFormat = UI.getMomentDateFormat(this.viewModel.DateFormat);
            switch (controlTypeID) {
                case Constants.QuestionType.TIME:
                    finalValue = moment(value, timeFormat).format(Constants.MOMENT_FORMAT_TIME_STANDARDIZED);
                    break;
                case Constants.QuestionType.DATE:
                    finalValue = moment(value, dateFormat).format(Constants.MOMENT_FORMAT_DATE_STANDARDIZED);
                    break;
                case Constants.QuestionType.DATETIME:
                    finalValue = moment(value, dateFormat + " " + timeFormat).utc()
                        .format(Constants.MOMENT_FORMAT_DATE_STANDARDIZED + "[T]" + Constants.MOMENT_FORMAT_TIME_STANDARDIZED + "[Z]");
                    break;
            }
        }
        return finalValue;
    };
    return TargetEditControl;
}());
exports.TargetEditControl = TargetEditControl;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var _ = __webpack_require__(9);
var UI = __webpack_require__(3);
var AddFormDialog = (function () {
    function AddFormDialog() {
        var me = this;
        this.viewModel = {
            ListName: ko.observable(),
            TemplateFormID: ko.observable(),
            ID: ko.observable(),
            ListItems: ko.observableArray(),
            MultipleTemplateFormIDs: ko.observable(false),
            ListNameMissing: ko.observable(false),
            TemplateFormIDMissing: ko.observable(false),
            TemplateFormListName: ko.observable(),
            onAddForm: function () {
                if (me.isValid()) {
                    me.container.modal("hide");
                    me.onAddForm(me.viewModel.ListName(), me.viewModel.TemplateFormID(), me.viewModel.ID());
                }
            },
        };
        this.viewModel.ID.subscribe(function (data) {
            if (me.viewModel.ListItems().length > 0) {
                var match = ko.utils.arrayFirst(me.viewModel.ListItems(), function (item) {
                    return item.ID === data;
                });
                me.viewModel.TemplateFormID(match.TemplateFormID);
            }
        });
    }
    AddFormDialog.prototype.render = function (container) {
        this.container = container.find("div[data-id='newFormDialog']");
        ko.applyBindings(this.viewModel, this.container[0]);
    };
    AddFormDialog.prototype.show = function (listItems, onAddForm) {
        var me = this;
        if (listItems.length === 0) {
            UI.showErrorMessage(["No forms can be added under this item."]);
            return;
        }
        this.onAddForm = onAddForm;
        this.viewModel.ListItems.removeAll();
        _.forEach(listItems, function (listItem) {
            me.viewModel.ListItems.push(listItem);
        });
        if (listItems.length === 1) {
            this.viewModel.MultipleTemplateFormIDs(false);
            this.viewModel.TemplateFormID(listItems[0].TemplateFormID);
            this.viewModel.TemplateFormListName(listItems[0].ListItemName);
        }
        else {
            this.viewModel.MultipleTemplateFormIDs(true);
            this.viewModel.ListItems.unshift({
                ID: 0,
                TemplateFormID: 0,
                ParentID: 0,
                ListItemName: "(select form template)",
                SortOrder: 0,
            });
        }
        this.viewModel.ListName("");
        this.viewModel.ListNameMissing(false);
        this.viewModel.TemplateFormIDMissing(false);
        this.container.modal("show");
    };
    AddFormDialog.prototype.isValid = function () {
        var isValid = true;
        isValid = UI.setRequiredString(this.viewModel.ListName, this.viewModel.ListNameMissing) ? isValid : false;
        isValid = UI.setRequiredNumber(this.viewModel.ID, this.viewModel.TemplateFormIDMissing, true) ? isValid : false;
        return isValid;
    };
    return AddFormDialog;
}());
exports.AddFormDialog = AddFormDialog;


/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var L = __webpack_require__(139);
var Global = __webpack_require__(2);
function getMapTileLayer() {
    return L.tileLayer("https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}", {
        attribution: "© <a href='https: //www.mapbox.com/about/maps/'>Mapbox</a> © <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a> " +
            "<strong><a href='https://www.mapbox.com/map-feedback/' target='_blank'>Improve this map</a></strong>",
        tileSize: 512,
        maxZoom: 18,
        zoomOffset: -1,
        id: "mapbox/streets-v11",
        accessToken: Global.app().global.MapboxAccessToken,
    });
}
exports.getMapTileLayer = getMapTileLayer;


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(22);
__webpack_require__(80);
var autosize = __webpack_require__(849);
var ko = __webpack_require__(4);
var _ = __webpack_require__(9);
var moment = __webpack_require__(0);
var AppointmentData = __webpack_require__(58);
var Constants = __webpack_require__(5);
var constants_1 = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var Util = __webpack_require__(8);
var FormDataEntryControl = (function () {
    function FormDataEntryControl(options) {
        this.options = options;
        var app = Global.app();
        var me = this;
        this.customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
        this.viewModel = {
            FormItems: ko.observableArray(),
            allowedFileTypes: ko.observable(),
            uploadMaxFileSizeWarning: ko.observable(),
            uploadedFormItemIndex: ko.observable(),
            uploadedCommentIndex: ko.observable(),
            uploadedDocumentIndex: ko.observable(),
            uploadedGuid: ko.observable(""),
            uploadSignature: ko.observable(),
            PictureURL: ko.observable(),
            DateFormat: UI.GetCustomerSetting(this.customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT),
            TimeFormat: UI.GetCustomerSetting(this.customerSettings, Constants.SETTING_KEY_TIMEFORMAT, Constants.DEFAULT_TIME_FORMAT),
            closeUploadModal: function () {
                me.container.find("div[data-id='uploadDialog']").modal("hide");
            },
            closeUploadDocumentModal: function () {
                me.container.find("div[data-id='uploadDocumentDialog']").modal("hide");
            },
            closePictureModal: function () {
                me.container.find("div[data-id='pictureFormDialog']").modal("hide");
                me.viewModel.PictureURL("");
            },
            CustomerDocumentDownloadUrl: app.webServiceBaseURL + "/api/DocumentLibrary/Download/",
            LanguageID: ko.observable(),
        };
        this.viewModel.errors = ko.validation.group(this.viewModel.FormItems, { deep: true });
    }
    FormDataEntryControl.prototype.render = function (container) {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        this.container = container;
        container.hide();
        app.templates().render("formdataentrycontrol", "template_formdataentrycontrol", this.container)
            .done(function () {
            me.container.find("input[data-id='uploadControl']").kendoUpload({
                async: {
                    saveUrl: "save",
                    removeUrl: "remove",
                    autoUpload: true,
                },
                validation: {
                    allowedExtensions: [".jpg", ".jpeg", ".png"],
                },
                upload: me.onUpload.bind(me),
                complete: me.onComplete.bind(me),
                success: me.onSuccess.bind(me),
                multiple: false,
            });
            me.documentUploadControl = me.container.find("input[data-id='uploadDocumentControl']").kendoUpload({
                async: {
                    saveUrl: "save",
                    removeUrl: "remove",
                    autoUpload: true,
                },
                upload: me.onUpload.bind(me),
                complete: me.onCompleteDocument.bind(me),
                success: me.onSuccess.bind(me),
                multiple: false,
            }).data("kendoUpload");
            autosize(me.container.find("textarea"));
            ko.applyBindings(me.viewModel, me.container[0]);
            deferred.resolve();
        });
        return deferred.promise();
    };
    FormDataEntryControl.prototype.load = function (loadParams) {
        var me = this;
        this.viewModel.FormItems.removeAll();
        this.ConvertDateTimeFormatsForFormItems(loadParams.FormItems);
        loadParams.FormItems.forEach(function (formItem) {
            me.viewModel.FormItems.push(me.createFormItemObservable(formItem));
        });
        this.fieldsOnLoad = ko.toJSON(this.getFormItems());
        me.viewModel.errors.showAllMessages(false);
        me.viewModel.uploadSignature(false);
        me.viewModel.LanguageID(loadParams.LanguageID);
    };
    FormDataEntryControl.prototype.changeLocation = function (formItemViewModel, position) {
        var me = this;
        formItemViewModel.Latitude(position.coords.latitude);
        formItemViewModel.Longitude(position.coords.longitude);
        formItemViewModel.ItemHasValue(true);
        formItemViewModel.selected(JSON.stringify(me.getLocationObject("", formItemViewModel.Latitude(), formItemViewModel.Longitude())));
    };
    FormDataEntryControl.prototype.getLocationObject = function (formItemAnswer, latitude, longitude) {
        var existingGeoLoc = formItemAnswer ? JSON.parse(formItemAnswer) : null;
        if (existingGeoLoc != null && existingGeoLoc.Latitude === latitude && existingGeoLoc.Longitude === longitude) {
            return existingGeoLoc;
        }
        else {
            var locationObject = {
                Latitude: latitude,
                Longitude: longitude,
                Speed: 0,
                Altitude: 0,
                Bearing: 0,
                RadiusOfUncertainty: 0,
                RecordedDateTime: moment().utc().format(),
            };
            return locationObject;
        }
    };
    FormDataEntryControl.prototype.getFormItems = function () {
        var _this = this;
        var formItems = [];
        this.viewModel.FormItems().forEach(function (formItem) {
            var newFormItem = {
                ID: formItem.ID(),
                AdditionalTemplateFormID: formItem.AdditionalTemplateFormID(),
                TemplateFormItemID: formItem.TemplateFormItemID(),
                AppointmentID: formItem.AppointmentID(),
                FormAnswer: formItem.FormAnswer(),
                ControlTypeID: formItem.ControlTypeID(),
                selected: formItem.ControlTypeID() === Constants.QuestionType.GEOLOCAITON ? _this.currentValues(formItem) : formItem.selected(),
                selectedArray: formItem.selectedArray(),
                dropdownselected: formItem.dropdownselected(),
                Comments: formItem.Comments(),
                Documents: formItem.Documents(),
                IsRequired: formItem.IsRequired(),
                IsReadOnly: formItem.IsReadOnly(),
                IsVisible: formItem.IsVisible(),
                AdditionalFormItems: formItem.AdditionalFormItems(),
                AppointmentFormItemDocumentTypesAllowed: formItem.AppointmentFormItemDocumentTypesAllowed(),
                MultipleAdditionalForms: formItem.MultipleAdditionalForms(),
                Targets: [],
            };
            formItems.push(newFormItem);
        });
        var saveFormItems = {
            FormItems: formItems,
            errors: this.viewModel.errors,
        };
        return saveFormItems;
    };
    FormDataEntryControl.prototype.isValid = function () {
        var _this = this;
        var isValid = true;
        if (this.viewModel.errors && this.viewModel.errors().length > 0) {
            this.viewModel.errors.showAllMessages(true);
            isValid = false;
        }
        this.viewModel.FormItems().forEach(function (formItem) {
            formItem.ItemHasValue(_this.FormItemHasValue(formItem));
            formItem.LatLongMissing(_this.LatLongMissing(formItem));
            isValid = formItem.ItemHasValue() ? isValid : false;
            isValid = !formItem.LatLongMissing() ? isValid : false;
            isValid = formItem.ValidLat() && formItem.ValidLong() ? isValid : false;
        });
        return isValid;
    };
    FormDataEntryControl.prototype.getFormItemsForSave = function () {
        var _this = this;
        var me = this;
        var formItems = [];
        this.viewModel.FormItems().forEach(function (formItem) {
            var selectedValue = formItem.selected();
            if (selectedValue) {
                var timeFormat = UI.getMomentTimeFormat(me.viewModel.TimeFormat);
                var dateFormat = UI.getMomentDateFormat(me.viewModel.DateFormat);
                switch (formItem.ControlTypeID()) {
                    case Constants.QuestionType.TIME:
                        selectedValue = moment(selectedValue, timeFormat).format(Constants.MOMENT_FORMAT_TIME_STANDARDIZED);
                        break;
                    case Constants.QuestionType.DATE:
                        selectedValue = moment(selectedValue, dateFormat).format(Constants.MOMENT_FORMAT_DATE_STANDARDIZED);
                        break;
                    case Constants.QuestionType.DATETIME:
                        selectedValue = moment(selectedValue, dateFormat + " " + timeFormat).utc()
                            .format(Constants.MOMENT_FORMAT_DATE_STANDARDIZED + "[T]" + Constants.MOMENT_FORMAT_TIME_STANDARDIZED + "[Z]");
                        break;
                }
            }
            if (formItem.ControlTypeID() === Constants.QuestionType.GEOLOCAITON) {
                selectedValue = _this.currentValues(formItem);
            }
            var newFormItem = {
                ID: formItem.ID(),
                TemplateFormItemID: formItem.TemplateFormItemID(),
                AppointmentID: formItem.AppointmentID(),
                FormAnswer: formItem.FormAnswer(),
                ControlTypeID: formItem.ControlTypeID(),
                selected: selectedValue,
                selectedArray: formItem.selectedArray(),
                dropdownselected: formItem.dropdownselected(),
                Comments: formItem.Comments(),
                Documents: formItem.Documents(),
                IsRequired: formItem.IsRequired(),
                IsReadOnly: formItem.IsReadOnly(),
                IsVisible: formItem.IsVisible(),
                AdditionalFormItems: formItem.AdditionalFormItems(),
                AppointmentFormItemDocumentTypesAllowed: formItem.AppointmentFormItemDocumentTypesAllowed(),
                MultipleAdditionalForms: formItem.MultipleAdditionalForms(),
                Targets: [],
            };
            formItems.push(newFormItem);
        });
        return ko.toJS(formItems);
    };
    FormDataEntryControl.prototype.show = function () {
        this.container.show();
    };
    FormDataEntryControl.prototype.hide = function () {
        this.container.hide();
    };
    FormDataEntryControl.prototype.haveFieldsChanged = function () {
        var fieldValues = ko.toJSON(this.getFormItems());
        if (this.fieldsOnLoad === undefined) {
            return false;
        }
        else {
            return fieldValues !== this.fieldsOnLoad;
        }
    };
    FormDataEntryControl.prototype.currentValues = function (formItem) {
        var selectedValue = "";
        if (this.latLongAreNumbers(formItem) && this.latLongAreNotNull(formItem)) {
            var lat = Number(formItem.Latitude());
            var long = Number(formItem.Longitude());
            selectedValue = JSON.stringify(this.getLocationObject(formItem.selected(), lat, long));
        }
        return selectedValue;
    };
    FormDataEntryControl.prototype.latLongAreNumbers = function (formItem) {
        return (!_.isNaN(formItem.Latitude()) && !_.isNaN(formItem.Longitude())) ? true : false;
    };
    FormDataEntryControl.prototype.latLongAreNotNull = function (formItem) {
        return (!_.isNil(formItem.Latitude()) && !_.isNil(formItem.Longitude())) ? true : false;
    };
    FormDataEntryControl.prototype.createFormItemObservable = function (formItem) {
        var _this = this;
        var me = this;
        var app = Global.app();
        var url = app.webServiceBaseURL;
        if (formItem.IsAdditionalForm === undefined) {
            formItem.IsAdditionalForm = false;
        }
        var targetsForControl = this.getTargetListForControl(formItem.Targets);
        var controlTypeAttributes = formItem.AppointmentControlTypeAttribute;
        if (!controlTypeAttributes) {
            controlTypeAttributes = {
                ID: 0,
                MinVal: "",
                MaxVal: "",
                Format: "",
                MinLength: 0,
                MaxLength: 0,
                Mask: "",
                NumDecimals: 0,
                NumericDefaultValue: 0,
                Interval: 1,
            };
        }
        var formItemViewModel = {
            ID: ko.observable(formItem ? formItem.ID : 0),
            TemplateFormID: ko.observable(0),
            TemplateFormItemID: ko.observable(formItem ? formItem.TemplateFormItemID : 0),
            AppointmentID: ko.observable(formItem ? formItem.AppointmentID : 0),
            ControlTypeID: ko.observable(formItem ? formItem.ControlTypeID : 0),
            FormText: ko.pureComputed(function () {
                if (formItemViewModel.FormTextTranslations) {
                    var translations = formItemViewModel.FormTextTranslations
                        .filter(function (formTextTranslations) { return formTextTranslations.LanguageID === me.viewModel.LanguageID(); });
                    if (translations && translations.length > 0 && translations[0].TranslatedText) {
                        return translations[0].TranslatedText;
                    }
                    else {
                        return formItemViewModel.FormTextDefault();
                    }
                }
                else {
                    return formItemViewModel.FormTextDefault();
                }
            }),
            FormTextDefault: ko.observable(formItem ? formItem.FormText : ""),
            FormTextTranslations: formItem.FormTextTranslations,
            IsRequired: ko.observable(formItem ? formItem.IsRequired : false),
            SortOrder: ko.observable(formItem ? formItem.SortOrder : 0),
            IsReadOnly: ko.observable(formItem ? formItem.IsReadOnly : false),
            IsVisible: ko.observable(formItem ? formItem.IsVisible : true),
            IsActive: ko.observable(true),
            ItemHasValue: ko.observable(true),
            ValidLatLong: ko.observable(true),
            AdditionalTemplateFormID: ko.observable(formItem ? formItem.AdditionalTemplateFormID : 0),
            Fields: ko.observableArray(),
            AppointmentControlTypeAttribute: ko.observable(controlTypeAttributes),
            AppointmentFormItemDocumentTypesAllowed: ko.observableArray(),
            AdditionalFormItems: ko.observableArray(),
            FormAnswer: ko.observableArray(),
            Comments: ko.observableArray(),
            Documents: ko.observableArray(),
            TemplatePhrases: ko.observableArray(),
            url: ko.observable(url),
            IsAdditionalForm: ko.observable(formItem ? formItem.IsAdditionalForm : false),
            TemplatePhraseID: ko.observable(formItem ? formItem.TemplatePhraseID : 0),
            SelectedPhrase: ko.observable(""),
            SelectedCommentPhrase: ko.observable(""),
            newFieldText: ko.observable(""),
            MaskValue: ko.observable(controlTypeAttributes.Mask),
            MaxVal: ko.observable(controlTypeAttributes.MaxVal),
            MinVal: ko.observable(controlTypeAttributes.MinVal),
            MinLength: ko.observable(controlTypeAttributes.MinLength),
            MaxLength: ko.observable(controlTypeAttributes.MaxLength),
            NumberOfDecimals: ko.observable(controlTypeAttributes.NumDecimals),
            NumericDefaultValue: ko.observable(controlTypeAttributes.NumericDefaultValue),
            Interval: ko.observable(controlTypeAttributes.Interval),
            PictureURL: ko.observable(""),
            isSelected: ko.observable(false),
            SignatureUploaded: ko.observable(false),
            displayTemplateName: ko.observable(me.GetTemplateName(formItem && formItem.ControlTypeID ? formItem.ControlTypeID : 1)),
            AppointmentFormItemLinkedCustomerDocuments: ko.observableArray(formItem.AppointmentFormItemLinkedCustomerDocuments),
            MultipleAdditionalForms: ko.observable(formItem.MultipleAdditionalForms),
            AvailableAdditionalForm: ko.observable(0),
            Latitude: ko.observable(null),
            Longitude: ko.observable(null),
            ValidLat: ko.observable(true),
            ValidLong: ko.observable(true),
            LatLongMissing: ko.observable(false),
            SingleCheckboxSelected: ko.observable(formItem.FormAnswer ? this.answerChecked(formItem.FormAnswer[0].Value) : false),
            buttonFormItemClick: function (e) {
                formItemViewModel.showAdditionalForm(e);
            },
            SelectedTargetValues: ko.pureComputed(function () {
                var selectedTargetID = formItemViewModel.selected().toString();
                if (!Util.isNullOrEmpty(formItem.Targets)) {
                    for (var _i = 0, _a = formItem.Targets; _i < _a.length; _i++) {
                        var target = _a[_i];
                        if (target.ID.toString() === selectedTargetID) {
                            return me.getTargetValues(target);
                        }
                    }
                }
                return null;
            }),
            TargetOptions: ko.pureComputed(function () {
                return targetsForControl;
            }),
        };
        formItemViewModel.selected = ko.observable(formItem.FormAnswer ? formItem.FormAnswer[0].Value : "").extend({
            required: {
                message: "This field is required.",
                params: true,
                onlyIf: function () {
                    return (!(formItem && formItem.IsReadOnly ? true : false)
                        && (formItem && formItem.IsRequired ? true : false)
                        && (formItem && formItem.IsVisible ? true : false)
                        && (formItem.ControlTypeID === Constants.QuestionType.TEXTAREA
                            || formItem.ControlTypeID === Constants.QuestionType.TEXTBOX
                            || formItem.ControlTypeID === Constants.QuestionType.EMAIL
                            || formItem.ControlTypeID === Constants.QuestionType.NUMERIC
                            || formItem.ControlTypeID === Constants.QuestionType.DATE
                            || formItem.ControlTypeID === Constants.QuestionType.TIME
                            || formItem.ControlTypeID === Constants.QuestionType.DATETIME
                            || formItem.ControlTypeID === Constants.QuestionType.BARCODE
                            || formItem.ControlTypeID === Constants.QuestionType.SIGNATURE
                            || formItem.ControlTypeID === Constants.QuestionType.PHONE
                            || formItem.ControlTypeID === Constants.QuestionType.RADIOBUTTONLIST
                            || formItem.ControlTypeID === Constants.QuestionType.TARGET
                            || formItem.ControlTypeID === Constants.QuestionType.ADDRESS
                            || formItem.ControlTypeID === Constants.QuestionType.SLIDER));
                },
            },
            maxLength: {
                onlyIf: function () {
                    if (formItem.AppointmentControlTypeAttribute == null) {
                        return false;
                    }
                    else {
                        if (formItem.ControlTypeID === Constants.QuestionType.TEXTBOX &&
                            formItem.AppointmentControlTypeAttribute.MaxLength > 0) {
                            return true;
                        }
                        else if (formItem.ControlTypeID === Constants.QuestionType.TEXTAREA
                            && formItem.AppointmentControlTypeAttribute.MaxLength > 0) {
                            return true;
                        }
                        else if (formItem.ControlTypeID === Constants.QuestionType.BARCODE &&
                            formItem.AppointmentControlTypeAttribute.MaxLength > 0) {
                            return true;
                        }
                        else if (formItem.ControlTypeID === Constants.QuestionType.ADDRESS &&
                            formItem.AppointmentControlTypeAttribute.MaxLength > 0) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                },
                params: formItemViewModel.MaxLength(),
            },
            minLength: {
                onlyIf: function () {
                    if (formItem.AppointmentControlTypeAttribute == null) {
                        return false;
                    }
                    else {
                        if (formItem.ControlTypeID === Constants.QuestionType.TEXTBOX &&
                            formItem.AppointmentControlTypeAttribute.MinLength > 0) {
                            return true;
                        }
                        else if (formItem.ControlTypeID === Constants.QuestionType.TEXTAREA
                            && formItem.AppointmentControlTypeAttribute.MinLength > 0) {
                            return true;
                        }
                        else if (formItem.ControlTypeID === Constants.QuestionType.BARCODE
                            && formItem.AppointmentControlTypeAttribute.MinLength > 0) {
                            return true;
                        }
                        else if (formItem.ControlTypeID === Constants.QuestionType.ADDRESS
                            && formItem.AppointmentControlTypeAttribute.MinLength > 0) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                },
                params: formItemViewModel.MinLength(),
            },
            max: {
                onlyIf: function () {
                    if (formItemViewModel.MaxVal() === "") {
                        return false;
                    }
                    else if (formItem.AppointmentControlTypeAttribute == null) {
                        return false;
                    }
                    else {
                        if (formItem.ControlTypeID === Constants.QuestionType.NUMERIC &&
                            !Util.isNullOrEmpty(formItem.AppointmentControlTypeAttribute.MaxVal)) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                },
                params: formItemViewModel.MaxVal(),
            },
            min: {
                onlyIf: function () {
                    if (formItemViewModel.MinVal() === "") {
                        return false;
                    }
                    else if (formItem.AppointmentControlTypeAttribute == null) {
                        return false;
                    }
                    else {
                        if (formItem.ControlTypeID === Constants.QuestionType.NUMERIC &&
                            !Util.isNullOrEmpty(formItem.AppointmentControlTypeAttribute.MinVal)) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                },
                params: formItemViewModel.MinVal(),
            },
            email: {
                onlyIf: function () {
                    if (formItem.ControlTypeID === Constants.QuestionType.EMAIL) {
                        return true;
                    }
                    else {
                        return false;
                    }
                },
            },
            dateValid: {
                onlyIf: function () {
                    if (formItem.ControlTypeID === Constants.QuestionType.DATE) {
                        return true;
                    }
                    else {
                        return false;
                    }
                },
            },
            timeValid: {
                onlyIf: function () {
                    if (formItem.ControlTypeID === Constants.QuestionType.TIME) {
                        return true;
                    }
                    else {
                        return false;
                    }
                },
            },
            dateTimeValid: {
                onlyIf: function () {
                    if (formItem.ControlTypeID === Constants.QuestionType.DATETIME) {
                        return true;
                    }
                    else {
                        return false;
                    }
                },
            },
        });
        if (formItemViewModel.ControlTypeID() === Constants.QuestionType.GEOLOCAITON && formItemViewModel.selected()) {
            var geoLocation = JSON.parse(formItemViewModel.selected());
            if (geoLocation) {
                formItemViewModel.Latitude(geoLocation.Latitude);
                formItemViewModel.Longitude(geoLocation.Longitude);
            }
        }
        formItemViewModel.dropdownselected = ko.observable(formItem.FormAnswer ? formItem.FormAnswer[0].Value : "").extend({
            required: {
                message: "This field is required.",
                params: true,
                onlyIf: function () {
                    return (!(formItem && formItem.IsReadOnly ? true : false)
                        && formItem && formItem.IsRequired ? true :  false ? true : false)
                        && formItem.ControlTypeID === Constants.QuestionType.DROPDOWN;
                },
            },
        });
        formItemViewModel.removeField = function (comment) {
            formItemViewModel.Comments.remove(comment);
            formItemViewModel.ItemHasValue(me.FormItemHasValue(formItemViewModel));
        };
        formItemViewModel.addField = function (newfield) {
            var comment = {
                ID: 0,
                Comment: newfield.newFieldText(),
            };
            formItemViewModel.Comments.push(me.Comments(comment));
            formItemViewModel.ItemHasValue(me.FormItemHasValue(formItemViewModel));
            newfield.newFieldText("");
        };
        formItemViewModel.currentLocation = function () {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(positionSuccess, positionNotFound);
            }
            else {
                updateItemHasValueFlag();
            }
            function positionSuccess(position) {
                if (formItemViewModel.Latitude() !== null && formItemViewModel.Longitude() !== null) {
                    UI.showConfirmDialog("Are you sure you want to change the location?", function () {
                        me.changeLocation(formItemViewModel, position);
                    });
                }
                else {
                    me.changeLocation(formItemViewModel, position);
                }
            }
            function positionNotFound() {
                UI.showErrorMessage(["The location could be not obtained from the browser. You may need to enable geolocation permissions for this web site."]);
            }
            function updateItemHasValueFlag() {
                if (!formItemViewModel.IsReadOnly() && formItemViewModel.IsRequired() && formItemViewModel.IsVisible()) {
                    formItemViewModel.ItemHasValue(_.isNaN(formItemViewModel.Latitude()) || _.isNaN(formItemViewModel.Longitude()) ?
                        false : true);
                }
                else {
                    formItemViewModel.ItemHasValue(true);
                }
            }
        };
        formItemViewModel.addDocument = function (formItemIndex) {
            me.viewModel.uploadedFormItemIndex(formItemIndex());
            var allowedExtensions = formItemViewModel.AppointmentFormItemDocumentTypesAllowed().map(function (x) { return x.DocumentTypeExtension(); });
            me.viewModel.allowedFileTypes(allowedExtensions.join(", "));
            var options = {
                validation: {
                    allowedExtensions: allowedExtensions,
                },
            };
            var maxFileSizeInBytes = Global.app().global.MaximumUploadFileSizeInBytes;
            if (maxFileSizeInBytes > 0) {
                options.validation.maxFileSize = maxFileSizeInBytes;
            }
            me.viewModel.uploadMaxFileSizeWarning(_this.getMaxUploadFileSizeMessage(maxFileSizeInBytes));
            me.documentUploadControl.setOptions(options);
            me.container.find("div[data-id='uploadDocumentDialog']").modal("show");
            me.container.find(".k-upload-status-total").remove();
        };
        formItemViewModel.selectedArray = ko.observableArray().extend({
            required: {
                message: "This field is required.",
                params: true,
                onlyIf: function () {
                    return (formItem && formItem.IsRequired ? true : false) && formItem.ControlTypeID === Constants.QuestionType.CHECKBOXLIST;
                },
            },
        });
        formItemViewModel.dropdownselected.subscribe(function (data, context) {
            if (!data) {
                return;
            }
            for (var _i = 0, _a = me.viewModel.FormItems(); _i < _a.length; _i++) {
                var item = _a[_i];
                item.isSelected(false);
            }
            var selectedField = ko.utils.arrayFirst(formItemViewModel.Fields(), function (item) {
                return item.FieldValue() === data;
            });
            formItemViewModel.selected(data);
            var additionalFormID = formItemViewModel.AdditionalTemplateFormID();
            if (formItemViewModel.MultipleAdditionalForms()) {
                additionalFormID = selectedField.TemplateFormID() ? selectedField.TemplateFormID() : 0;
            }
            if (selectedField != null && selectedField.HasExceptionForm() || (formItemViewModel.MultipleAdditionalForms() && additionalFormID > 0)) {
                formItemViewModel.isSelected(true);
                var index = me.viewModel.FormItems().indexOf(formItemViewModel);
                if (me.options.openAdditionalForm) {
                    me.options.openAdditionalForm(index, true, additionalFormID);
                }
            }
        });
        formItemViewModel.SelectedPhrase.subscribe(function (phrase) {
            if (phrase != null) {
                var text = formItemViewModel.selected() + phrase;
                formItemViewModel.selected(text);
            }
        });
        formItemViewModel.SelectedCommentPhrase.subscribe(function (phrase) {
            if (phrase != null) {
                var text = formItemViewModel.newFieldText() + phrase;
                formItemViewModel.newFieldText(text);
            }
        });
        formItemViewModel.showAddSignatureButton = ko.pureComputed(function () {
            return formItemViewModel.selected() === "";
        });
        formItemViewModel.typeIsTextbox = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.TEXTBOX;
        });
        formItemViewModel.typeIsNumeric = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.NUMERIC;
        });
        formItemViewModel.typeIsTextArea = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.TEXTAREA;
        });
        formItemViewModel.typeIsDate = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.DATE;
        });
        formItemViewModel.typeIsDateTime = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.DATETIME;
        });
        formItemViewModel.typeIsTime = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.TIME;
        });
        formItemViewModel.typeIsRadio = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.RADIOBUTTONLIST;
        });
        formItemViewModel.typeIsDropdown = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.DROPDOWN;
        });
        formItemViewModel.typeIsCheckbox = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.CHECKBOXLIST;
        });
        formItemViewModel.typeIsSection = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.SECTION;
        });
        formItemViewModel.typeIsButton = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.BUTTON;
        });
        formItemViewModel.typeIsTextDesc = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.TEXTDESCRIPTION;
        });
        formItemViewModel.typeIsBarcode = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID === Constants.QuestionType.BARCODE;
        });
        formItemViewModel.typeIsDocuments = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID === Constants.QuestionType.DOCUMENTS;
        });
        formItemViewModel.typeIsSingleCheckbox = ko.pureComputed(function () {
            return formItemViewModel.ControlTypeID() === Constants.QuestionType.SINGLECHECKBOX;
        });
        $(formItem.FormAnswer).each(function (index, formAnswers) {
            formItemViewModel.FormAnswer.push(me.FormAnswers(formAnswers));
            formItemViewModel.selectedArray.push(formAnswers.Value);
        });
        $(formItem.Fields).each(function (index, fields) {
            formItemViewModel.Fields.push(me.Fields(fields));
        });
        $(formItem.AppointmentFormItemDocumentTypesAllowed).each(function (index, appointmentFormItemDocumentTypesAllowed) {
            formItemViewModel.AppointmentFormItemDocumentTypesAllowed.push(me.FormItemDocumentFileTypeAllowed(appointmentFormItemDocumentTypesAllowed));
        });
        $(formItem.Comments).each(function (index, comments) {
            formItemViewModel.Comments.push(me.Comments(comments));
        });
        $(formItem.Documents).each(function (index, documents) {
            formItemViewModel.Documents.push(me.Documents(documents));
        });
        $(formItem.TemplatePhrases).each(function (index, phrases) {
            formItemViewModel.TemplatePhrases.push(me.TemplatePhrases(phrases));
        });
        $(formItem.AdditionalFormItems).each(function (index, additionalformitems) {
            formItemViewModel.AdditionalFormItems.push(me.AdditionalFormItems(additionalformitems));
        });
        formItemViewModel.showAdditionalForm = function (formitem) {
            if (me.options.openAdditionalForm && formitem.AvailableAdditionalForm()) {
                for (var _i = 0, _a = me.viewModel.FormItems(); _i < _a.length; _i++) {
                    var item = _a[_i];
                    item.isSelected(false);
                }
                formitem.isSelected(true);
                var index = me.viewModel.FormItems().indexOf(formitem);
                me.options.openAdditionalForm(index, false, formitem.AvailableAdditionalForm());
            }
        };
        formItemViewModel.deleteSignature = function (data, parent) {
            if (formItemViewModel.IsReadOnly()) {
                UI.showErrorMessage([Constants.PHRASE_CANNOTDELETEREADONLYIMAGE]);
            }
            else {
                me.deletePicture("Signature", formItemViewModel.FormAnswer()[0].ID()).then(function () {
                    formItemViewModel.selected("");
                    formItemViewModel.FormAnswer()[0].Value("");
                    formItemViewModel.SignatureUploaded(false);
                })
                    .catch(function () {
                    UI.showErrorMessage([constants_1.PHRASE_GENERALACTIONFAILURE]);
                });
            }
        };
        formItemViewModel.deleteSignatureAdditional = function (data, parent) {
            if (formItemViewModel.IsReadOnly()) {
                UI.showErrorMessage([Constants.PHRASE_CANNOTDELETEREADONLYIMAGE]);
            }
            else {
                me.deletePicture("AdditionalSignature", formItemViewModel.FormAnswer()[0].ID()).then(function () {
                    formItemViewModel.selected("");
                    formItemViewModel.FormAnswer()[0].Value("");
                    formItemViewModel.SignatureUploaded(false);
                })
                    .catch(function () {
                    UI.showErrorMessage([constants_1.PHRASE_GENERALACTIONFAILURE]);
                });
            }
        };
        formItemViewModel.deleteSignatureUpload = function (data, parent) {
            me.deletePicture("UploadPicture", data.selected()).then(function () {
                data.selected("");
                data.FormAnswer()[0].Value("");
                data.SignatureUploaded(false);
            })
                .catch(function () {
                UI.showErrorMessage([constants_1.PHRASE_GENERALACTIONFAILURE]);
            });
        };
        formItemViewModel.openUploadSignatureModal = function (formitem, formItemIndex) {
            me.viewModel.uploadSignature(true);
            me.viewModel.uploadedFormItemIndex(formItemIndex());
            me.container.find("div[data-id='uploadDialog']").modal("show");
            me.container.find(".k-upload-status-total").remove();
        };
        formItemViewModel.openUploadSignature = function (formitem) {
            me.viewModel.PictureURL(url + "/api/AppointmentPicture/UploadPicture/" + formitem.selected());
            me.container.find("div[data-id='pictureFormDialog']").modal("show");
        };
        formItemViewModel.openWindow = function (formitem) {
            me.viewModel.PictureURL(formitem.url() + "/api/AppointmentPicture/Signature/" + formitem.FormAnswer()[0].ID());
            me.container.find("div[data-id='pictureFormDialog']").modal("show");
        };
        formItemViewModel.openAdditionalWindow = function (formitem) {
            me.viewModel.PictureURL(formitem.url() + "/api/AppointmentPicture/AdditionalSignature/" + formitem.FormAnswer()[0].ID());
            me.container.find("div[data-id='pictureFormDialog']").modal("show");
        };
        formItemViewModel.fieldShowAdditionalForm = function (field, formitem, index) {
            for (var _i = 0, _a = me.viewModel.FormItems(); _i < _a.length; _i++) {
                var item = _a[_i];
                item.isSelected(false);
            }
            var additionalFormID = formitem.AdditionalTemplateFormID();
            if (formitem.MultipleAdditionalForms()) {
                additionalFormID = field.TemplateFormID() ? field.TemplateFormID() : 0;
            }
            if (field.HasExceptionForm() || (formitem.MultipleAdditionalForms() && additionalFormID > 0)) {
                formitem.isSelected(true);
                if (me.options.openAdditionalForm) {
                    me.options.openAdditionalForm(index(), true, additionalFormID, field);
                }
            }
        };
        formItemViewModel.AvailableAdditionalForm = ko.computed(function () {
            var id = 0;
            if (formItemViewModel.MultipleAdditionalForms()) {
                var selected_1 = formItemViewModel.selected();
                var selectedFields = formItemViewModel.Fields().filter(function (field) { return field.FieldValue() === selected_1; });
                if (selectedFields.length > 0 && selectedFields[0].TemplateFormID() > 0) {
                    id = selectedFields[0].TemplateFormID();
                }
            }
            else if (formItemViewModel.AdditionalTemplateFormID()) {
                id = formItemViewModel.AdditionalTemplateFormID();
            }
            return id;
        });
        return formItemViewModel;
    };
    FormDataEntryControl.prototype.getTargetValues = function (target) {
        var fields = [];
        if (target.HasAddressFields) {
            for (var _i = 0, _a = target.AddressFormItems; _i < _a.length; _i++) {
                var field = _a[_i];
                if (field.Value) {
                    fields.push({
                        ID: field.FormText,
                        Name: field.Value,
                    });
                }
            }
        }
        if (target.HasCustomFields) {
            for (var _b = 0, _c = target.FormItems; _b < _c.length; _b++) {
                var field = _c[_b];
                if (field.Value) {
                    fields.push({
                        ID: field.FormText,
                        Name: UI.formatValueFromControlType(field.Value, field.ControlTypeID),
                    });
                }
            }
        }
        if (fields.length === 0) {
            fields.push({
                ID: "No Data, Target ID",
                Name: target.ID.toString(),
            });
        }
        return fields;
    };
    FormDataEntryControl.prototype.getTargetListForControl = function (targets) {
        var results = [];
        if (!targets || targets.length === 0) {
            return results;
        }
        for (var _i = 0, targets_1 = targets; _i < targets_1.length; _i++) {
            var target = targets_1[_i];
            var fields = [];
            for (var _a = 0, _b = this.getTargetValues(target); _a < _b.length; _a++) {
                var value = _b[_a];
                fields.push(value.ID + ": " + value.Name);
            }
            results.push({ ID: target.ID, Name: fields.join(", ") });
        }
        return results;
    };
    FormDataEntryControl.prototype.onUpload = function (e) {
        var me = this;
        var app = Global.app();
        var url = app.webServiceBaseURL;
        e.sender.options.async.saveUrl = url + "/api/FileUploadApi/Save/" + me.viewModel.FormItems()[0].AppointmentID();
    };
    FormDataEntryControl.prototype.onComplete = function (e) {
        var me = this;
        if (me.viewModel.uploadedGuid() !== "") {
            AppointmentData.GetUploadedFile(me.viewModel.uploadedGuid())
                .done(function (response) {
                var fileParts;
                var extension = "";
                if (response.Success) {
                    if (me.viewModel.uploadSignature()) {
                        fileParts = response.Payload.StorageKey.split(".");
                        if (fileParts.length > 1) {
                            extension = "." + fileParts[fileParts.length - 1];
                        }
                        me.viewModel.FormItems()[me.viewModel.uploadedFormItemIndex()].SignatureUploaded(true);
                        if (me.viewModel.FormItems()[me.viewModel.uploadedFormItemIndex()].FormAnswer().length > 0) {
                            var answer = me.viewModel.FormItems()[me.viewModel.uploadedFormItemIndex()].FormAnswer()[0];
                            answer.Value(response.Payload.FileUniqueKey + extension);
                        }
                        else {
                            me.viewModel.FormItems()[me.viewModel.uploadedFormItemIndex()].FormAnswer.push(me.FormAnswers({ ID: 0, Value: response.Payload.FileUniqueKey + extension }));
                        }
                        me.viewModel.FormItems()[me.viewModel.uploadedFormItemIndex()].selected(response.Payload.ID.toString());
                        me.viewModel.closeUploadModal();
                    }
                    else {
                        me.viewModel.FormItems()[me.viewModel.uploadedFormItemIndex()]
                            .Comments()[me.viewModel.uploadedCommentIndex()].Pictures.push(me.Pictures({
                            ID: 0, TempID: response.Payload.ID, PictureID: response.Payload.FileUniqueKey,
                            StorageKey: response.Payload.StorageKey, IsUpload: true,
                        }));
                    }
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                }
            });
        }
        me.container.find(".k-upload-files").remove();
        me.viewModel.uploadedGuid("");
    };
    FormDataEntryControl.prototype.onSuccess = function (e) {
        this.viewModel.uploadedGuid(e.response);
    };
    FormDataEntryControl.prototype.onCompleteDocument = function (e) {
        var me = this;
        if (me.viewModel.uploadedGuid() !== "") {
            AppointmentData.GetUploadedFile(me.viewModel.uploadedGuid())
                .done(function (response) {
                if (response.Success) {
                    me.viewModel.FormItems()[me.viewModel.uploadedFormItemIndex()]
                        .Documents.push(me.Documents({
                        ID: 0,
                        TempID: response.Payload.ID,
                        FileUniqueKey: response.Payload.FileUniqueKey,
                        StorageKey: response.Payload.StorageKey,
                        Description: "",
                        FileName: response.Payload.FileName,
                        IsUpload: true,
                    }));
                    if (me.viewModel.FormItems()[me.viewModel.uploadedFormItemIndex()].IsRequired()) {
                        me.viewModel.FormItems()[me.viewModel.uploadedFormItemIndex()].ItemHasValue(true);
                    }
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                }
            });
        }
        me.container.find(".k-upload-files").remove();
        me.viewModel.uploadedGuid("");
    };
    FormDataEntryControl.prototype.Fields = function (fields) {
        var vmField = {
            ID: ko.observable(fields ? fields.ID : 0),
            FieldText: ko.observable(fields ? fields.FieldText : ""),
            FieldValue: ko.observable(fields ? fields.FieldValue : ""),
            SortOrder: ko.observable(fields ? fields.SortOrder : 0),
            HasException: ko.observable(fields ? fields.HasException : false),
            HasExceptionForm: ko.observable(fields ? fields.HasExceptionForm : false),
            IsActive: ko.observable(fields ? fields.IsActive : true),
            TemplateFormID: ko.observable(fields ? fields.TemplateFormID : null),
            AppointmentFormItemID: ko.observable(),
        };
        return vmField;
    };
    FormDataEntryControl.prototype.FormItemDocumentFileTypeAllowed = function (allowedFileType) {
        var vmDocumentFileTypeAllowed = {
            ID: ko.observable(allowedFileType ? allowedFileType.ID : 0),
            AppointmentID: ko.observable(allowedFileType ? allowedFileType.AppointmentID : 0),
            AppointmentFormItemID: ko.observable(allowedFileType ? allowedFileType.AppointmentFormItemID : 0),
            DocumentTypeExtension: ko.observable(allowedFileType ? allowedFileType.DocumentTypeExtension : ""),
            DocumentFileTypeAllowedID: ko.observable(allowedFileType ? allowedFileType.DocumentFileTypeAllowedID : 0),
        };
        return vmDocumentFileTypeAllowed;
    };
    FormDataEntryControl.prototype.Documents = function (theDocument) {
        var me = this;
        var app = Global.app();
        var vmDocuments = {
            ID: ko.observable(theDocument ? theDocument.ID : 0),
            FileName: ko.observable(theDocument ? theDocument.FileName : ""),
            TempID: ko.observable(theDocument ? theDocument.TempID : 0),
            Description: ko.observable(theDocument ? theDocument.Description : ""),
            FileUniqueKey: ko.observable(theDocument ? theDocument.FileUniqueKey : ""),
            PictureURL: ko.observable(""),
            StorageKey: ko.observable(theDocument ? theDocument.StorageKey : ""),
            IsUpload: ko.observable(theDocument ? theDocument.IsUpload : false),
            url: ko.observable(app.webServiceBaseURL),
        };
        vmDocuments.deleteDocument = function (document, parent) {
            UI.showConfirmDialog("Are you sure you want to delete the file \"" + document.FileName() + "\"?", function () {
                me.deletePicture("Document", document.ID());
                parent.Documents.remove(document);
                parent.ItemHasValue(me.FormItemHasValue(parent));
            });
        };
        vmDocuments.deleteAdditionalDocument = function (document, parent) {
            UI.showConfirmDialog("Are you sure you want to delete the file \"" + document.FileName() + "\"?", function () {
                me.deletePicture("AdditionalDocument", document.ID());
                parent.Documents.remove(document);
                parent.ItemHasValue(me.FormItemHasValue(parent));
            });
        };
        vmDocuments.deleteUploadDocument = function (document, parent) {
            UI.showConfirmDialog("Are you sure you want to delete the file \"" + document.FileName() + "\"?", function () {
                me.deletePicture("UploadPicture", document.TempID());
                parent.Documents.remove(document);
                parent.ItemHasValue(me.FormItemHasValue(parent));
            });
        };
        return vmDocuments;
    };
    FormDataEntryControl.prototype.Comments = function (comments) {
        var me = this;
        var vmComments = {
            ID: ko.observable(comments ? comments.ID : 0),
            Comment: ko.observable(comments ? comments.Comment : ""),
            Pictures: ko.observableArray(),
        };
        $(comments.Pictures).each(function (index, pictures) {
            vmComments.Pictures.push(me.Pictures(pictures));
        });
        vmComments.uploadImage = function (comment, formItem, commentindex, formItemIndex) {
            me.viewModel.uploadedCommentIndex(commentindex());
            me.viewModel.uploadedFormItemIndex(formItemIndex());
            me.viewModel.uploadSignature(false);
            me.container.find("div[data-id='uploadDialog']").modal("show");
            me.container.find(".k-upload-status-total").remove();
        };
        return vmComments;
    };
    FormDataEntryControl.prototype.TemplatePhrases = function (phrases) {
        var vmPhrases = {
            ID: ko.observable(phrases ? phrases.ID : 0),
            Phrase: ko.observable(phrases ? phrases.Phrase : ""),
            SortOrder: ko.observable(phrases ? phrases.SortOrder : 0),
        };
        return vmPhrases;
    };
    FormDataEntryControl.prototype.Pictures = function (thePicture) {
        var me = this;
        var app = Global.app();
        var vmPictures = {
            ID: ko.observable(thePicture ? thePicture.ID : 0),
            TempID: ko.observable(thePicture ? thePicture.TempID : 0),
            PictureID: ko.observable(thePicture ? thePicture.PictureID : ""),
            StorageKey: ko.observable(thePicture ? thePicture.StorageKey : ""),
            PictureURL: ko.observable(""),
            IsUpload: ko.observable(thePicture ? thePicture.IsUpload : false),
            url: ko.observable(app.webServiceBaseURL),
        };
        vmPictures.openPicture = function (picture, formitem) {
            me.viewModel.PictureURL(picture.url() + "/api/AppointmentPicture/Picture/" + picture.ID());
            me.container.find("div[data-id='pictureFormDialog']").modal("show");
        };
        vmPictures.openAdditionalPicture = function (picture, formitem) {
            me.viewModel.PictureURL(picture.url() + "/api/AppointmentPicture/AdditionalPicture/" + picture.ID());
            me.container.find("div[data-id='pictureFormDialog']").modal("show");
        };
        vmPictures.openUploadPicture = function (picture, formitem) {
            me.viewModel.PictureURL(picture.url() + "/api/AppointmentPicture/UploadPicture/" + picture.TempID());
            me.container.find("div[data-id='pictureFormDialog']").modal("show");
        };
        vmPictures.deletePicture = function (picture, formitem, parent) {
            if (formitem.IsReadOnly()) {
                UI.showErrorMessage([Constants.PHRASE_CANNOTDELETEREADONLYIMAGE]);
            }
            else {
                me.deletePicture("Picture", picture.ID());
                parent.Pictures.remove(picture);
            }
        };
        vmPictures.deleteAdditionalPicture = function (picture, formitem, parent) {
            if (formitem.IsReadOnly()) {
                UI.showErrorMessage([Constants.PHRASE_CANNOTDELETEREADONLYIMAGE]);
            }
            else {
                me.deletePicture("AdditionalPicture", picture.ID());
                parent.Pictures.remove(picture);
            }
        };
        vmPictures.deleteUploadPicture = function (picture, formitem, parent) {
            me.deletePicture("UploadPicture", picture.TempID());
            parent.Pictures.remove(picture);
        };
        return vmPictures;
    };
    FormDataEntryControl.prototype.deletePicture = function (pictureType, PictureID) {
        var deferred = $.Deferred();
        return AppointmentData.DeletePictures(pictureType, PictureID)
            .done(function (response) {
            if (response.Success) {
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        }).promise();
    };
    FormDataEntryControl.prototype.AdditionalFormItems = function (additionalformitems) {
        var vmAdditionalFormItem = {
            TemplateFormItemID: ko.observable(additionalformitems ? additionalformitems.TemplateFormItemID : 0),
            Answers: ko.observableArray(additionalformitems.Answers ? additionalformitems.Answers : ""),
            Comments: ko.observableArray(additionalformitems.Comments ? additionalformitems.Comments : ""),
            Documents: ko.observableArray(additionalformitems.Documents ? additionalformitems.Documents : ""),
        };
        return vmAdditionalFormItem;
    };
    FormDataEntryControl.prototype.FormAnswers = function (formAnswers) {
        var vmFormAnswer = {
            ID: ko.observable(formAnswers ? formAnswers.ID : 0),
            Value: ko.observable(formAnswers ? formAnswers.Value : ""),
        };
        return vmFormAnswer;
    };
    FormDataEntryControl.prototype.LatLongMissing = function (formItem) {
        var isMissing = false;
        if (formItem.ControlTypeID() === Constants.QuestionType.GEOLOCAITON &&
            !formItem.IsReadOnly()) {
            if ((!formItem.Latitude() && !formItem.Longitude()) ||
                (formItem.Latitude() && formItem.Longitude())) {
                isMissing = false;
            }
            else {
                isMissing = true;
            }
        }
        return isMissing;
    };
    FormDataEntryControl.prototype.FormItemHasValue = function (formItem) {
        var isValid = true;
        if ((!formItem.IsReadOnly()) && formItem.IsRequired() && formItem.IsVisible()) {
            switch (formItem.ControlTypeID()) {
                case Constants.QuestionType.MULTIPLECOMMENTS:
                case Constants.QuestionType.MULTIPLECOMMENTSPICS:
                    isValid = formItem.Comments().length > 0;
                    break;
                case Constants.QuestionType.DOCUMENTS:
                    isValid = formItem.Documents().length > 0;
                    break;
                case Constants.QuestionType.GEOLOCAITON:
                    isValid = (formItem.Latitude() && formItem.Longitude()) ? isValid : false;
                    break;
            }
        }
        return isValid;
    };
    FormDataEntryControl.prototype.GetTemplateName = function (controlType) {
        if (controlType === Constants.QuestionType.TEXTBOX) {
            return "template_text-template";
        }
        else if (controlType === Constants.QuestionType.DROPDOWN) {
            return "template_select-template";
        }
        else if (controlType === Constants.QuestionType.RADIOBUTTONLIST) {
            return "template_radio-template";
        }
        else if (controlType === Constants.QuestionType.CHECKBOXLIST) {
            return "template_checkbox-template";
        }
        else if (controlType === Constants.QuestionType.DATE) {
            return "template_date-template";
        }
        else if (controlType === Constants.QuestionType.TEXTAREA) {
            return "template_textarea-template";
        }
        else if (controlType === Constants.QuestionType.NUMERIC) {
            return "template_numeric-template";
        }
        else if (controlType === Constants.QuestionType.SECTION) {
            return "template_section-template";
        }
        else if (controlType === Constants.QuestionType.TEXTDESCRIPTION) {
            return "template_textdescription-template";
        }
        else if (controlType === Constants.QuestionType.BUTTON) {
            return "template_button-template";
        }
        else if (controlType === Constants.QuestionType.SIGNATURE) {
            return "template_signature-template";
        }
        else if (controlType === Constants.QuestionType.MULTIPLECOMMENTS) {
            return "template_multiplecomments-template";
        }
        else if (controlType === Constants.QuestionType.MULTIPLECOMMENTSPICS) {
            return "template_multiplecommentspics-template";
        }
        else if (controlType === Constants.QuestionType.BARCODE) {
            return "template_text-template";
        }
        else if (controlType === Constants.QuestionType.DOCUMENTS) {
            return "template_documents-template";
        }
        else if (controlType === Constants.QuestionType.DATETIME) {
            return "template_datetime-template";
        }
        else if (controlType === Constants.QuestionType.TIME) {
            return "template_time-template";
        }
        else if (controlType === Constants.QuestionType.EMAIL) {
            return "template_email-template";
        }
        else if (controlType === Constants.QuestionType.PHONE) {
            return "template_phone-template";
        }
        else if (controlType === Constants.QuestionType.LINKEDDOCUMENTS) {
            return "template_linkeddocuments-template";
        }
        else if (controlType === Constants.QuestionType.TARGET) {
            return "template_target-template";
        }
        else if (controlType === Constants.QuestionType.ADDRESS) {
            return "template_address-template";
        }
        else if (controlType === Constants.QuestionType.GEOLOCAITON) {
            return "template_geolocation-template";
        }
        else if (controlType === Constants.QuestionType.SLIDER) {
            return "template_slider-template";
        }
        else if (controlType === Constants.QuestionType.SINGLECHECKBOX) {
            return "template_singlecheckbox-template";
        }
        else {
            return "";
        }
    };
    FormDataEntryControl.prototype.ConvertDateTimeFormatsForFormItems = function (formItems) {
        var timeFormat = UI.getMomentTimeFormat(this.viewModel.TimeFormat);
        var dateFormat = UI.getMomentDateFormat(this.viewModel.DateFormat);
        for (var _i = 0, formItems_1 = formItems; _i < formItems_1.length; _i++) {
            var formItem = formItems_1[_i];
            if (formItem.FormAnswer && formItem.FormAnswer.length > 0 && formItem.FormAnswer[0].Value) {
                var currentDate = formItem.FormAnswer[0].Value;
                switch (formItem.ControlTypeID) {
                    case Constants.QuestionType.TIME:
                        formItem.FormAnswer[0].Value = moment(currentDate, Constants.MOMENT_FORMAT_TIME_STANDARDIZED).format(timeFormat);
                        break;
                    case Constants.QuestionType.DATE:
                        formItem.FormAnswer[0].Value = moment(currentDate, Constants.MOMENT_FORMAT_DATE_STANDARDIZED).format(dateFormat);
                        break;
                    case Constants.QuestionType.DATETIME:
                        formItem.FormAnswer[0].Value = moment(currentDate).local().format(dateFormat + " " + timeFormat);
                        break;
                }
            }
        }
    };
    FormDataEntryControl.prototype.answerChecked = function (answer) {
        return answer === Constants.SINGLECHECKBOX_ANSWER_TRUE;
    };
    FormDataEntryControl.prototype.getMaxUploadFileSizeMessage = function (maxFileSizeInBytes) {
        var BYTES_PER_KB = 1000;
        var BYTES_PER_MB = 1000000;
        if (maxFileSizeInBytes >= BYTES_PER_MB) {
            return "Maximum file size is " + Math.round(maxFileSizeInBytes / BYTES_PER_KB) + " KB/" + Math.round(maxFileSizeInBytes / BYTES_PER_MB) + " MB.";
        }
        else if (maxFileSizeInBytes >= BYTES_PER_KB) {
            return "Maximum file size is " + Math.round(maxFileSizeInBytes / BYTES_PER_KB) + " KB.";
        }
        else if (maxFileSizeInBytes > 0) {
            return "Maximum file size is " + maxFileSizeInBytes + " bytes.";
        }
        else {
            return "";
        }
    };
    return FormDataEntryControl;
}());
exports.FormDataEntryControl = FormDataEntryControl;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var data_1 = __webpack_require__(23);
var Util = __webpack_require__(8);
function getAppointmentLookupData(request) {
    return Util.callWebService("/api/AppointmentAdd/GetAppointmentLookupData", "POST", request);
}
exports.getAppointmentLookupData = getAppointmentLookupData;
function getTargetTemplate(templateID) {
    return Util.callWebService("/api/AppointmentAdd/GetTargetTemplate", "POST", templateID);
}
exports.getTargetTemplate = getTargetTemplate;
function getTargetAutocompleteData(customParameters) {
    if (!customParameters) {
        return null;
    }
    return data_1.createAutocompleteDataSource("/api/AppointmentAdd/GetTargetAutocompleteData", customParameters);
}
exports.getTargetAutocompleteData = getTargetAutocompleteData;
function createAppointment(request) {
    return Util.callWebService("/api/Appointment/CreateAppointment", "POST", request);
}
exports.createAppointment = createAppointment;
function createDefaultAppointment(request) {
    return Util.callWebService("/api/AppointmentAdd/TaskAutoAdd", "POST", request);
}
exports.createDefaultAppointment = createDefaultAppointment;


/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function GetAll() {
    return Util.callWebService("/api/TemplateAccessRole/GetAll", "GET");
}
exports.GetAll = GetAll;
function Save(role) {
    return Util.callWebService("/api/TemplateAccessRole/Save", "POST", role);
}
exports.Save = Save;
function GetByID(id) {
    return Util.callWebService("/api/TemplateAccessRole/GetByID/" + id, "GET");
}
exports.GetByID = GetByID;
function Delete(id) {
    return Util.callWebService("/api/TemplateAccessRole/Delete/" + id, "POST");
}
exports.Delete = Delete;


/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function GetTemplateForm(request) {
    return Util.callWebService("/api/TemplateForm/GetTemplateForm", "POST", request);
}
exports.GetTemplateForm = GetTemplateForm;
function SaveTemplateForm(templateForm) {
    return Util.callWebService("/api/TemplateForm/SaveTemplateForm", "POST", templateForm);
}
exports.SaveTemplateForm = SaveTemplateForm;
function CopyForm(ID) {
    return Util.callWebService("/api/TemplateForm/CopyForm", "POST", {
        ID: ID,
    });
}
exports.CopyForm = CopyForm;
function ChangeFormStatus(templateFormID, isActive) {
    return Util.callWebService("/api/TemplateForm/ChangeFormStatus", "POST", {
        ID: templateFormID,
        IsActive: isActive,
    });
}
exports.ChangeFormStatus = ChangeFormStatus;


/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(370);
__webpack_require__(19);
__webpack_require__(22);
__webpack_require__(914);
__webpack_require__(389);
__webpack_require__(915);
__webpack_require__(13);
__webpack_require__(82);
__webpack_require__(916);
__webpack_require__(917);
__webpack_require__(368);
__webpack_require__(39);
var ko = __webpack_require__(4);
__webpack_require__(918);
__webpack_require__(919);
var ReportData = __webpack_require__(81);
__webpack_require__(920);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var ReportViewer = (function () {
    function ReportViewer() {
        var _this = this;
        this.emailReportCommand = {
            enabled: function () {
                return _this.viewModel.canEmailReport();
            },
            checked: function () { return false; },
            exec: function () {
                _this.emailReportModal.modal("show");
            },
        };
        this.viewModel = {
            emailAddress: ko.observable("").extend({ required: true, email: true }),
            emailAddresses: ko.observableArray(),
            canEmailReport: ko.observable(false),
            addEmail: function () {
                if (_this.viewModel.errors && _this.viewModel.errors().length > 0) {
                    _this.viewModel.errors.showAllMessages();
                    return;
                }
                for (var _i = 0, _a = _this.viewModel.emailAddresses(); _i < _a.length; _i++) {
                    var email = _a[_i];
                    if (email.toLowerCase() === _this.viewModel.emailAddress().toLowerCase()) {
                        return;
                    }
                }
                _this.viewModel.emailAddresses.push(_this.viewModel.emailAddress());
                _this.viewModel.emailAddress("");
                _this.viewModel.emailAddress.isModified(false);
            },
            removeEmail: function (email) {
                _this.viewModel.emailAddresses.remove(email);
            },
            closeEmailModal: function () {
                _this.emailReportModal.modal("hide");
                _this.viewModel.emailAddress("");
                _this.viewModel.emailAddress.isModified(false);
                _this.viewModel.emailAddresses([]);
            },
            emailReport: function () {
                if (_this.viewModel.emailAddresses().length === 0) {
                    return;
                }
                var reportSource = _this.telerikReportViewer.reportSource();
                var request = {
                    EmailAddresses: _this.viewModel.emailAddresses(),
                    ReportID: reportSource.report,
                    Parameters: [],
                };
                for (var key in reportSource.parameters) {
                    if (reportSource.parameters.hasOwnProperty(key)) {
                        request.Parameters.push({ Name: key, Value: reportSource.parameters[key] });
                    }
                }
                var waitIndicator = UI.showWaitIndicator(_this.container);
                ReportData.EmailReport(request)
                    .done(function (response) {
                    if (response.Success) {
                        _this.emailReportModal.modal("hide");
                        _this.viewModel.emailAddress("");
                        _this.viewModel.emailAddresses([]);
                        _this.viewModel.emailAddress.isModified(false);
                        UI.showNotificationMessage("Report Emailed", UI.messageTypeValues.success);
                    }
                    else {
                        UI.showErrorMessage(response.ErrorMessages);
                    }
                })
                    .always(function () {
                    UI.hideWaitIndicator(_this.container, waitIndicator);
                });
            },
        };
        this.viewModel.errors = ko.validation.group(this.viewModel, { deep: true });
    }
    ReportViewer.prototype.render = function (container) {
        var _this = this;
        var deferred = $.Deferred();
        var app = Global.app();
        this.container = container;
        app.templates().render("reportviewer", "template_reportviewer", this.container)
            .done(function () {
            ko.applyBindings(_this.viewModel, _this.container[0]);
            _this.emailReportModal = $(".emailReportModal");
            _this.telerikReportViewer = _this.container.find(".telerikReportViewer").telerik_ReportViewer({
                authenticationToken: app.reportToken,
                scaleMode: "FIT_PAGE_WIDTH",
                serviceUrl: app.reportingWebServiceBaseURL + "/api/telerikreports",
                templateUrl: "/templates/telerikreportviewer.html",
                renderingBegin: function () {
                    $("#emailReportItem").addClass("k-state-disabled");
                    _this.viewModel.canEmailReport(false);
                },
                pageReady: function () {
                    $("#emailReportItem").removeClass("k-state-disabled");
                    _this.viewModel.canEmailReport(true);
                },
            }).data("telerik_ReportViewer");
            _this.telerikReportViewer.commands.emailReport = _this.emailReportCommand;
            deferred.resolve();
        });
        return deferred;
    };
    ReportViewer.prototype.loadReport = function (reportID, params) {
        this.telerikReportViewer.reportSource({
            report: reportID,
            parameters: params,
        });
    };
    return ReportViewer;
}());
exports.ReportViewer = ReportViewer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(404);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
var promisePolyfill = __webpack_require__(411);
promisePolyfill.polyfill();
__webpack_require__(1);
__webpack_require__(0);
var application_1 = __webpack_require__(415);
var Global = __webpack_require__(2);
var KnockoutBindingHandlers = __webpack_require__(926);
__webpack_require__(933);
KnockoutBindingHandlers.registerKnockoutBindingHandlers();
$.ajaxSetup({
    xhrFields: {
        withCredentials: true,
    },
});
var app = new application_1.Application();
Global.storeAppSingleton(app);
Global.app().init().done(function () {
    $("div[data-id='siteWaitContainer']").hide();
});
function receiveMessage(event) {
    if (event.data === "save") {
        app.pageManager().saveCurrentPage();
    }
}
window.addEventListener("message", receiveMessage, false);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

module.exports = "/res/wvgovlogo.bf61.png";

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var Backbone = __webpack_require__(90);
var ko = __webpack_require__(4);
__webpack_require__(417);
var _ = __webpack_require__(9);
var moment = __webpack_require__(0);
var Global = __webpack_require__(2);
var AuthenticationData = __webpack_require__(32);
var AppHost = __webpack_require__(418);
var Constants = __webpack_require__(5);
var enterPasswordDialog_1 = __webpack_require__(434);
var Navigation = __webpack_require__(435);
var PageManagerModule = __webpack_require__(436);
var saml_1 = __webpack_require__(923);
var templates_1 = __webpack_require__(924);
var UI = __webpack_require__(3);
var Util = __webpack_require__(8);
var Application = (function () {
    function Application() {
        this.isLoggedIn = false;
        this.userSession = null;
        this.authenticationToken = null;
        this.reportToken = null;
        this.hideMenu = false;
        this.sessionExpirationTimer = null;
    }
    Application.prototype.loginUser = function (authenticationToken, userSession, reportToken) {
        this.setUserSession(userSession);
        this.setAuthenticationToken(authenticationToken);
        this.setReportToken(reportToken);
        this.isLoggedIn = true;
        this.pageManagerSingleton.login();
        this.navigationBar.load(userSession);
    };
    Application.prototype.setUserSession = function (userSession) {
        this.userSession = userSession;
    };
    Application.prototype.setAuthenticationToken = function (authenticationToken) {
        var _this = this;
        this.authenticationToken = authenticationToken;
        Util.setCookie(Constants.COOKIE_AUTHENTICATIONTOKEN, authenticationToken);
        if (this.sessionExpirationTimer) {
            clearTimeout(this.sessionExpirationTimer);
        }
        if (this.global.SessionTimeoutMinutes > this.global.SessionTimeoutWarningMinutes) {
            var waitTimeInMilliseconds = (this.global.SessionTimeoutMinutes - this.global.SessionTimeoutWarningMinutes) * 60 * 1000;
            this.sessionExpirationTimer = window.setTimeout(function () {
                _this.sessionExpirationTimer = null;
                UI.showSessionTimeWarningDialog();
            }, waitTimeInMilliseconds);
        }
    };
    Application.prototype.logoutUser = function () {
        this.userSession = null;
        this.isLoggedIn = false;
        Util.setCookie(Constants.COOKIE_AUTHENTICATIONTOKEN, "");
        Util.setCookie(Constants.COOKIE_REPORTAUTHENTICATIONTOKEN, "");
        if (this.sessionExpirationTimer) {
            clearTimeout(this.sessionExpirationTimer);
            this.sessionExpirationTimer = null;
        }
        if (this.global.AuthenticationMethod === "SAML") {
            this.samlLoginManager.logout();
        }
        else {
            window.location.href = "/";
        }
    };
    Application.prototype.templates = function () {
        if (this.templatesSingleton == null) {
            this.templatesSingleton = new templates_1.Templates();
        }
        return this.templatesSingleton;
    };
    Application.prototype.events = function () {
        if (this.eventsSingleton == null) {
            this.eventsSingleton = _.clone(Backbone.Events);
        }
        return this.eventsSingleton;
    };
    Application.prototype.router = function () {
        return this.routerSingleton;
    };
    Application.prototype.pageManager = function () {
        return this.pageManagerSingleton;
    };
    Application.prototype.showErrorMessage = function (messages) {
        UI.showErrorMessage(messages);
    };
    Application.prototype.showPasswordDialog = function () {
        enterPasswordDialog_1.showPasswordDialog();
    };
    Application.prototype.redirectToExternalLoginIfRequired = function () {
        if (this.isLoggedIn) {
            return false;
        }
        if (window.location.pathname && window.location.pathname.indexOf("Login") >= 0) {
            return false;
        }
        if (this.global.AuthenticationMethod === "SAML") {
            if (this.samlLoginManager.isCurrentPageSAMLLogin()) {
                return false;
            }
            else {
                this.samlLoginManager.login();
                return true;
            }
        }
        return false;
    };
    Application.prototype.init = function () {
        var me = this;
        var authenticationToken = Util.getCookie(Constants.COOKIE_AUTHENTICATIONTOKEN);
        var reportToken = Util.getCookie(Constants.COOKIE_REPORTAUTHENTICATIONTOKEN);
        var deferred = $.Deferred();
        this.setWebServiceBaseURLs();
        this.checkForHideMenuQueryParameter();
        if (kendo.ui.FilterMenu.fn.options.operators) {
            kendo.ui.FilterMenu.fn.options.operators.string = {
                eq: "Is equal to",
                neq: "Is not equal to",
                startswith: "Starts with",
                endswith: "Ends with",
                contains: "Contains",
                doesnotcontain: "Does not contain",
            };
            kendo.ui.FilterMenu.fn.options.operators.date = {
                eq: "Is equal to",
                neq: "Is not equal to",
                lt: "Is before",
                lte: "Is before or equal to",
                gt: "Is after",
                gte: "Is after or equal to",
            };
            kendo.ui.FilterMenu.fn.options.operators.number = {
                eq: "Is equal to",
                neq: "Is not equal to",
                lt: "Is less than",
                lte: "Is less than or equal to",
                gt: "Is greater than",
                gte: "Is greater than or equal to",
            };
        }
        Util.callWebService("/api/App/AppLoadValues", "GET")
            .done(function (response) {
            if (response.Success) {
                me.global = response.Payload;
                me.initExternalLoginHandlers(response.Payload);
            }
            me.routerSingleton = new AppHost.AppRouter();
            me.pageManagerSingleton = new PageManagerModule.PageManager();
            me.navigationBar = new Navigation.NavigationBar();
            me.createKOValidationRules();
            me.createKOBindingHandlers();
        })
            .always(function () {
            if (!Util.isNullOrEmpty(authenticationToken)) {
                AuthenticationData.AuthenticateUserWithToken({ Token: authenticationToken })
                    .done(function (response) {
                    if (response.Success && response.Payload.IsAuthenticated) {
                        me.loginUser(response.Payload.AuthenticationToken, response.Payload.UserSession, reportToken);
                    }
                })
                    .always(function () {
                    if (!me.redirectToExternalLoginIfRequired()) {
                        me.routerSingleton.startRouter();
                    }
                    deferred.resolve();
                });
            }
            else {
                if (!me.redirectToExternalLoginIfRequired()) {
                    me.routerSingleton.startRouter();
                }
                deferred.resolve();
            }
        });
        return deferred.promise();
    };
    Application.prototype.setWebServiceBaseURLs = function () {
        switch (window.location.host.toLowerCase()) {
            case "localhost:8080":
                this.reportingWebServiceBaseURL = "http://localhost:39922";
                this.webServiceBaseURL = "http://localhost:39921";
                this.webServiceBaseDomain = "localhost";
                break;
            case "portaldev.oncue360dev.com":
                this.reportingWebServiceBaseURL = "https://reportservicedev.oncue360dev.com";
                this.webServiceBaseURL = "https://webservicedev.oncue360dev.com";
                this.webServiceBaseDomain = "oncue360dev.com";
                break;
            case "portalqa.oncue360dev.com":
                this.reportingWebServiceBaseURL = "https://reportserviceqa.oncue360dev.com";
                this.webServiceBaseURL = "https://webserviceqa.oncue360dev.com";
                this.webServiceBaseDomain = "oncue360dev.com";
                break;
            case "portaldemo.oncue360dev.com":
                this.reportingWebServiceBaseURL = "https://reportservicedemo.oncue360dev.com";
                this.webServiceBaseURL = "https://webservicedemo.oncue360dev.com";
                this.webServiceBaseDomain = "oncue360dev.com";
                break;
            case "portalcsap.oncue360dev.com":
                this.reportingWebServiceBaseURL = "https://reportservicecsap.oncue360dev.com";
                this.webServiceBaseURL = "https://webservicecsap.oncue360dev.com";
                this.webServiceBaseDomain = "oncue360dev.com";
                break;
            case "www.cgioncue360.ca":
                this.reportingWebServiceBaseURL = "https://reportservice.cgioncue360.ca";
                this.webServiceBaseURL = "https://webservice.cgioncue360.ca";
                this.webServiceBaseDomain = "cgioncue360.ca";
                break;
            case "www.wvgrantstest.com":
                this.reportingWebServiceBaseURL = "https://reportservice.wvgrantstest.com";
                this.webServiceBaseURL = "https://webservice.wvgrantstest.com";
                this.webServiceBaseDomain = "wvgrantstest.com";
                break;
            case "www.findwvgrants.com":
                this.reportingWebServiceBaseURL = "https://reportservice.findwvgrants.com";
                this.webServiceBaseURL = "https://webservice.findwvgrants.com";
                this.webServiceBaseDomain = "findwvgrants.com";
                break;
            case "grantsapp.wv.gov":
                this.reportingWebServiceBaseURL = "https://grantsappnfo.wv.gov";
                this.webServiceBaseURL = "https://grantsappapi.wv.gov";
                this.webServiceBaseDomain = "wv.gov";
                break;
        }
    };
    Application.prototype.createKOBindingHandlers = function () {
        ko.bindingHandlers.bootstrapShowModal = {
            update: function (element, valueAccessor) {
                var value = valueAccessor();
                if (ko.utils.unwrapObservable(value)) {
                    $(element).modal("show");
                    $("input", element).focus();
                }
                else {
                    $(element).modal("hide");
                }
            },
        };
        ko.bindingHandlers.slideVisible = {
            update: function (element, valueAccessor, allBindingsAccessor) {
                var value = valueAccessor();
                var allBindings = allBindingsAccessor();
                var valueUnwrapped = ko.utils.unwrapObservable(value);
                var duration = allBindings.slideDuration || 300;
                if (valueUnwrapped === true) {
                    $(element).slideDown(duration);
                }
                else {
                    $(element).slideUp(duration);
                }
            },
        };
    };
    Application.prototype.createKOValidationRules = function () {
        ko.validation.init({
            registerExtenders: true,
            messagesOnModified: true,
            decorateElementOnModified: true,
            insertMessages: true,
            errorMessageClass: "alert alert-warning",
            decorateInputElement: true,
            errorClass: "has-error",
            parseInputAttributes: true,
            messageTemplate: "master_fieldValidationTemplate",
            grouping: { deep: true },
        }, true);
        ko.validation.rules.mustEqual = {
            validator: function (val, otherVal) {
                return val === otherVal;
            },
            message: "The field must equal {0}",
        };
        var isDateTimeValid = function (date, time, dateTime) {
            var app = Global.app();
            var customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
            var dateFormat = UI.GetCustomerSetting(customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT);
            var timeFormat = UI.GetCustomerSetting(customerSettings, Constants.SETTING_KEY_TIMEFORMAT, Constants.DEFAULT_TIME_FORMAT);
            var momentDateFormat = UI.getMomentDateFormat(dateFormat);
            var momentTimeFormat = UI.getMomentTimeFormat(timeFormat);
            var dateTimeString = dateTime ? dateTime : (date ? date : moment().format(momentDateFormat)) + " " + (time ? time : moment().format(momentTimeFormat));
            var dateTimeMoment = moment(dateTimeString, momentDateFormat + " " + momentTimeFormat, true);
            return dateTimeMoment.isValid();
        };
        ko.validation.rules.dateValid = {
            validator: function (val) {
                return isDateTimeValid(val, null, null);
            },
            message: "The date is not valid",
        };
        ko.validation.rules.timeValid = {
            validator: function (val) {
                return isDateTimeValid(null, val, null);
            },
            message: "The time is not valid",
        };
        ko.validation.rules.dateTimeValid = {
            validator: function (val) {
                return isDateTimeValid(null, null, val);
            },
            message: "The date/time is not valid",
        };
        ko.validation.registerExtenders();
    };
    Application.prototype.setReportToken = function (reportToken) {
        if (reportToken) {
            this.reportToken = reportToken;
            Util.setCookie(Constants.COOKIE_REPORTAUTHENTICATIONTOKEN, reportToken);
        }
    };
    Application.prototype.initExternalLoginHandlers = function (appConfig) {
        if (appConfig.AuthenticationMethod === "SAML") {
            appConfig.SelfRegistrationAllowed = false;
            this.samlLoginManager = new saml_1.SAMLLoginManager({
                loginPageURL: appConfig.AuthenticationExternalWebURL,
                logoutPageURL: appConfig.AuthenticationExternalLogoutWebURL,
            });
        }
    };
    Application.prototype.checkForHideMenuQueryParameter = function () {
        var hideMenu = Util.getURLParameter("hidemenu");
        if (hideMenu.toLowerCase() === "true") {
            this.hideMenu = true;
        }
    };
    return Application;
}());
exports.Application = Application;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Backbone = __webpack_require__(90);
var onCueRouter_1 = __webpack_require__(419);
var AppRouter = (function () {
    function AppRouter() {
        this.router = new onCueRouter_1.OnCueRouter();
    }
    AppRouter.prototype.startRouter = function () {
        Backbone.history.start({ pushState: true });
    };
    AppRouter.prototype.navigate = function (url, trigger) {
        this.router.navigate(url, { trigger: trigger });
    };
    return AppRouter;
}());
exports.AppRouter = AppRouter;


/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Backbone = __webpack_require__(90);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var OnCueRouter = (function (_super) {
    __extends(OnCueRouter, _super);
    function OnCueRouter() {
        var _this = this;
        var routerOptions = {
            routes: {
                "Logout": "logout",
                ":controller(/:param1)(/:param2)(/:param3)": "loadController",
                "": "defaultRoute",
                "*path": "unknownPage",
            },
        };
        _this = _super.call(this, routerOptions) || this;
        return _this;
    }
    OnCueRouter.prototype.loadController = function (controller, param1, param2, param3) {
        var params = [];
        if (param1 != null) {
            params.push(param1);
        }
        if (param2 != null) {
            params.push(param2);
        }
        if (param3 != null) {
            params.push(param3);
        }
        Global.app().pageManager().displayController(controller, params);
    };
    OnCueRouter.prototype.defaultRoute = function () {
        Global.app().pageManager().gotoDefaultPage();
    };
    OnCueRouter.prototype.logout = function () {
        Global.app().pageManager().logout();
    };
    OnCueRouter.prototype.unknownPage = function () {
        UI.showErrorMessage(["The requested page does not exist."]);
    };
    return OnCueRouter;
}(Backbone.Router));
exports.OnCueRouter = OnCueRouter;


/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var AuthenticationData = __webpack_require__(32);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var dialogIsCreated = false;
var container;
var dialog;
var viewModel = {};
function showPasswordDialog() {
    if (!dialogIsCreated) {
        render().done(function () {
            dialog = container.find(".modal");
            dialogIsCreated = true;
            displayDialog();
        });
    }
    else {
        displayDialog();
    }
}
exports.showPasswordDialog = showPasswordDialog;
function render() {
    var app = Global.app();
    var deferred = $.Deferred();
    viewModel = {
        UserName: ko.observable(""),
        Password: ko.observable(""),
        UserNameMissing: ko.observable(false),
        PasswordMissing: ko.observable(false),
        LoginInvalid: ko.observable(false),
        AccountLocked: ko.observable(false),
        AccountLockedLength: ko.observable(0),
        onLogin: function () {
            processLoginRequest();
        },
        onCancel: function () {
            dialog.modal("hide");
            app.pageManager().logout();
        },
    };
    container = $("<div></div>").appendTo("body");
    app.templates().render("enterpassworddialog", "template_enterpassworddialog", container)
        .done(function () {
        ko.applyBindings(viewModel, container[0]);
        deferred.resolve();
    });
    return deferred.promise();
}
function displayDialog() {
    viewModel.UserName("");
    viewModel.Password("");
    viewModel.UserNameMissing(false);
    viewModel.PasswordMissing(false);
    viewModel.LoginInvalid(false);
    viewModel.AccountLocked(false);
    dialog.modal("show");
}
function processLoginRequest() {
    var app = Global.app();
    var waitContainer;
    var request;
    if (!validateLogin()) {
        setFocusToUserNameField();
        return;
    }
    waitContainer = UI.showWaitIndicator(dialog);
    request = {
        UserName: viewModel.UserName(),
        Password: viewModel.Password(),
    };
    AuthenticationData.AuthenticateUser(request)
        .done(function (response) {
        if (response.Success) {
            if (response.Payload.IsAuthenticated) {
                viewModel.LoginInvalid(false);
                viewModel.AccountLocked(false);
                app.loginUser(response.Payload.AuthenticationToken, response.Payload.UserSession, response.Payload.ReportToken);
                dialog.modal("hide");
                location.reload();
            }
            else {
                if (response.Payload.MustChangePassword) {
                    dialog.modal("hide");
                    app.router().navigate("/ResetPassword/Expired/" + response.Payload.PasswordResetToken, true);
                }
                else if (response.Payload.ExceededMaximumAttempts) {
                    viewModel.LoginInvalid(false);
                    viewModel.AccountLocked(true);
                    viewModel.AccountLockedLength(response.Payload.AccountLockedLength);
                }
                else {
                    setFocusToUserNameField();
                    viewModel.LoginInvalid(true);
                    viewModel.AccountLocked(false);
                }
            }
        }
        else {
            UI.showErrorMessage(response.ErrorMessages);
        }
    })
        .always(function () {
        UI.hideWaitIndicator(dialog, waitContainer);
    });
}
function validateLogin() {
    var isValid = true;
    isValid = UI.setRequiredStringError(viewModel.UserName(), "UserNameMissing", viewModel) ? isValid : false;
    isValid = UI.setRequiredStringError(viewModel.Password(), "PasswordMissing", viewModel) ? isValid : false;
    return isValid;
}
function setFocusToUserNameField() {
    container.find("input[data-id='loginField']").first().focus();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var EventUtil = __webpack_require__(26);
var Global = __webpack_require__(2);
var Util = __webpack_require__(8);
var NavigationBar = (function () {
    function NavigationBar() {
        var me = this;
        this.viewModel = {
            topMenu: ko.observableArray(),
            customers: ko.observableArray(),
            currentCustomerShortName: ko.observable(""),
            userName: ko.observable(""),
            userItems: ko.observableArray([]),
            showUserItems: ko.observable(false),
            onMenuItemClick: function (menuItem) {
                Global.app().router().navigate(menuItem.URL, true);
            },
            onContactUsClick: function () {
                Global.app().router().navigate("/ContactUs", true);
            },
            onCustomerClick: function (customer) {
                me.viewModel.currentCustomerShortName(customer.ShortName);
            },
        };
        ko.applyBindings(this.viewModel, $("nav[data-id='master_Navigation']")[0]);
        Global.app().events().on(EventUtil.EVENT_TARGETTEMPLATECHANGE, function () {
            me.reloadMenu();
        });
    }
    NavigationBar.prototype.load = function (userSession) {
        var _this = this;
        if (userSession == null) {
            this.viewModel.showUserItems(false);
        }
        else {
            this.viewModel.showUserItems(!Global.app().hideMenu);
            this.updateApplicationNavigationViewModel(userSession.ApplicationNavigation);
            this.viewModel.userName(userSession.FirstName);
            this.viewModel.customers.removeAll();
            userSession.Customers.forEach(function (customer) {
                _this.viewModel.customers.push(customer);
            });
            if (userSession.Customers.length > 0) {
                this.viewModel.currentCustomerShortName(userSession.Customers[0].ShortName);
            }
            this.viewModel.userItems(this.getUserMenuItems(userSession));
            $("nav[data-id='master_Navigation']").removeClass("hidden");
        }
    };
    NavigationBar.prototype.updateApplicationNavigationViewModel = function (applicationNavigation) {
        var _this = this;
        this.viewModel.topMenu.removeAll();
        applicationNavigation.TopMenu.forEach(function (topMenu) {
            _this.viewModel.topMenu.push(topMenu);
        });
    };
    NavigationBar.prototype.getUserMenuItems = function (userSession) {
        var menuItems = [];
        if (!userSession.UsesExternalAuthentication) {
            menuItems.push({ ItemName: "Change Password", URL: "/ChangePassword" });
        }
        menuItems.push({ ItemName: "Edit Your Profile", URL: "/UserProfile" });
        menuItems.push({ ItemName: "Logout", URL: "/Logout" });
        return menuItems;
    };
    NavigationBar.prototype.reloadMenu = function () {
        var me = this;
        Util.callWebService("/api/App/LoggedInMenu", "GET")
            .done(function (response) {
            if (response.Success) {
                me.updateApplicationNavigationViewModel(response.Payload);
            }
        });
    };
    return NavigationBar;
}());
exports.NavigationBar = NavigationBar;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var _ = __webpack_require__(9);
var AuthenticationData = __webpack_require__(32);
var Constants = __webpack_require__(5);
var ControllerRegistry = __webpack_require__(437);
var EventUtil = __webpack_require__(26);
var Global = __webpack_require__(2);
var TabScroller = __webpack_require__(922);
var UI = __webpack_require__(3);
var PageManager = (function () {
    function PageManager() {
        var _this = this;
        this.redirectURL = "";
        this.pageHeaderViewModel = {};
        var me = this;
        this.saveRequestRunning = false;
        this.pagesViewModel = {
            pages: ko.observableArray(),
            select: function (page) {
                me.displayLoadedRoute(page.ID());
            },
            tabClose: function (page, event) {
                event.preventDefault();
                me.tryClosePage(page);
            },
            closeAllTabs: function () { return __awaiter(_this, void 0, void 0, function () {
                var _i, _a, page, pagesToRemove, _b, pagesToRemove_1, page;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            for (_i = 0, _a = this.pagesViewModel.pages(); _i < _a.length; _i++) {
                                page = _a[_i];
                                page.ContentContainer.hide();
                                page.IsActive(false);
                            }
                            pagesToRemove = this.pagesViewModel.pages().filter(function (page) { return page.URL !== me.getDefaultPage(); });
                            _b = 0, pagesToRemove_1 = pagesToRemove;
                            _c.label = 1;
                        case 1:
                            if (!(_b < pagesToRemove_1.length)) return [3, 4];
                            page = pagesToRemove_1[_b];
                            this.pagesViewModel.select(page);
                            return [4, this.tryClosePage(page)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _b++;
                            return [3, 1];
                        case 4:
                            this.displayController(me.getDefaultPage(), []);
                            this.tabScroller.reset();
                            return [2];
                    }
                });
            }); },
        };
        ko.applyBindings(this.pagesViewModel, $("div[data-id='master_Tabs']")[0]);
        this.tabScroller = new TabScroller.TabScrollerControl($("div[data-id='master_Tabs']"));
        this.pageHeaderViewModel = {
            title: ko.observable(""),
            subTitle: ko.observable(""),
            showClose: ko.observable(false),
            showSave: ko.observable(false),
            showAdd: ko.observable(false),
            onClose: function (data, event) {
                var page = me.getActivePage();
                me.tryClosePage(page);
            },
            onSave: function (data, event) {
                me.saveCurrentPage();
            },
            onSaveAndClose: function (data, event) {
                var activePage = me.getActivePage();
                if (activePage.UIController.save != null && !me.saveRequestRunning) {
                    me.saveRequestRunning = true;
                    activePage.UIController.save().done(function () {
                        me.closePage(activePage.ID());
                    }).always(function () {
                        me.saveRequestRunning = false;
                    });
                }
            },
            onAdd: function (data, event) {
                var activePage = me.getActivePage();
                if (activePage.UIController.add != null) {
                    activePage.UIController.add();
                }
            },
        };
        this.pageHeaderViewModel.showSaveAndClose = ko.pureComputed(function () {
            return me.pageHeaderViewModel.showClose() && me.pageHeaderViewModel.showSave();
        });
        ko.applyBindings(this.pageHeaderViewModel, $("div[data-id='master_PageHeader']")[0]);
        Global.app().events().on(EventUtil.EVENT_ROUTECHANGE, this.onControllerRouteChange, this);
        Global.app().events().on(EventUtil.EVENT_ROUTECLOSE, function (data) {
            me.closePage(data.appRouterID);
        }, this);
        $(window).resize(function () {
            me.resizePage();
        });
        $(window).bind("beforeunload", this.onBeforeUnload.bind(this));
        this.pagesContainer = $("div[data-id='master_PagesContainer']");
        this.resizePage();
    }
    PageManager.prototype.displayController = function (controller, params) {
        var uiController = ControllerRegistry.getController(controller);
        if ((!uiController.AllowAnonymousAccess || !uiController.AllowAnonymousAccess()) && !Global.app().isLoggedIn) {
            this.redirectURL = window.location.href;
            this.closeAllAndGotoDefaultPage();
            return;
        }
        if (!this.displayLoadedRoute(uiController.appRouterID(params))) {
            this.addNewPage(uiController, controller, params);
        }
    };
    PageManager.prototype.login = function () {
        if (!Global.app().hideMenu) {
            $("div[data-id='master_Tabs']").removeClass().addClass("container-fluid");
            $("div[data-id='master_PageHeader']").removeClass("hidden");
            $(".master-page-footer").removeClass("hidden");
        }
        $("div[data-id='master_PagesContainer']").removeClass().addClass("master-page-pages-container");
        this.resizePage();
    };
    PageManager.prototype.logout = function () {
        UI.showWaitIndicator(this.pagesContainer);
        this.removeAllPages();
        AuthenticationData.Logout().always(function () {
            Global.app().logoutUser();
        });
    };
    PageManager.prototype.closeAllAndNavigate = function (url) {
        this.removeAllPages();
        this.navigate(url, true);
    };
    PageManager.prototype.closeAllAndGotoDefaultPage = function () {
        this.removeAllPages();
        this.gotoDefaultPage();
    };
    PageManager.prototype.gotoDefaultPage = function () {
        if (Global.app().isLoggedIn) {
            this.navigate(this.getDefaultPage(), true);
        }
        else {
            this.navigate("/Home", true);
        }
    };
    PageManager.prototype.closeCurrentPage = function () {
        var pages = this.pagesViewModel.pages();
        var page;
        var pageIndex;
        if (pages.length > 0) {
            pageIndex = this.getActivePageIndex();
            if (pageIndex >= 0) {
                page = this.pagesViewModel.pages.splice(pageIndex, 1)[0];
                $(page.ContentContainer).remove();
                if (pages.length > 0) {
                    if (pageIndex > 0) {
                        this.displayLoadedRoute(pages[pageIndex - 1].ID());
                    }
                    else {
                        this.displayLoadedRoute(pages[0].ID());
                    }
                }
                else {
                    this.gotoDefaultPage();
                }
                this.tabScroller.resize();
            }
        }
    };
    PageManager.prototype.closeAndNavigate = function (url) {
        var pages = this.pagesViewModel.pages();
        var page;
        var pageIndex;
        if (pages.length > 0) {
            pageIndex = this.getActivePageIndex();
            if (pageIndex >= 0) {
                page = this.pagesViewModel.pages.splice(pageIndex, 1)[0];
                $(page.ContentContainer).remove();
            }
        }
        this.navigate(url, true);
    };
    PageManager.prototype.refreshCurrentPageTitle = function () {
        var tabModel;
        var title;
        var subTitle;
        if (this.pagesViewModel.pages().length <= 0) {
            return;
        }
        var pageIndex = this.getActivePageIndex();
        if (pageIndex < 0) {
            return;
        }
        tabModel = this.pagesViewModel.pages()[pageIndex];
        title = tabModel.UIController.title();
        subTitle = tabModel.UIController.subTitle();
        tabModel.Title(title);
        tabModel.SubTitle(subTitle);
        this.pageHeaderViewModel.title(title);
        this.pageHeaderViewModel.subTitle(subTitle);
    };
    PageManager.prototype.workspaceHeight = function () {
        var height = _.defaultTo($(window).height(), 0) - 104;
        if (height < 0) {
            height = 0;
        }
        return height;
    };
    PageManager.prototype.gotoTaskPage = function (taskId, closeAfter) {
        if (closeAfter === void 0) { closeAfter = false; }
        var app = Global.app();
        var url = "";
        if (app.userSession != null && app.userSession.Permissions.indexOf(Constants.PERMISSION_USE_TASK_ENTRY_PAGE) >= 0) {
            url = "/TaskEntry/" + taskId;
        }
        else {
            url = "/Task/" + taskId;
        }
        if (closeAfter) {
            this.closeAndNavigate(url);
        }
        else {
            app.router().navigate(url, true);
        }
    };
    PageManager.prototype.saveCurrentPage = function () {
        var _this = this;
        var activePage = this.getActivePage();
        if (activePage.UIController.save != null && !this.saveRequestRunning) {
            this.saveRequestRunning = true;
            activePage.UIController.save().always(function () {
                _this.saveRequestRunning = false;
            });
        }
    };
    PageManager.prototype.getDefaultPage = function () {
        var app = Global.app();
        if (app.userSession && app.userSession.Permissions.indexOf(Constants.PERMISSION_TASK_DASHBOARD) >= 0) {
            return Constants.DEFAULT_CONTROLLER_TASK;
        }
        else {
            return Constants.DEFAULT_CONTROLLER;
        }
    };
    PageManager.prototype.makeAllPagesInactive = function () {
        _.forEach(this.pagesViewModel.pages(), function (page) {
            if (page.IsActive()) {
                page.IsActive(false);
            }
        });
    };
    PageManager.prototype.displayLoadedRoute = function (appRouterID) {
        var isLoaded = false;
        var pages = this.pagesViewModel.pages();
        var max = pages.length;
        var i;
        var page;
        for (i = 0; i < max; i++) {
            page = pages[i];
            if (page.ID() === appRouterID) {
                isLoaded = true;
                this.hideAllPages();
                page.ContentContainer.show();
                this.navigate(page.URL, false);
                this.makeAllPagesInactive();
                page.IsActive(true);
                this.updatePageHeaderViewModel(page);
                if (page.UIController.refresh != null) {
                    page.UIController.refresh();
                }
                break;
            }
        }
        return isLoaded;
    };
    PageManager.prototype.addNewPage = function (uiController, controller, params) {
        var me = this;
        var container;
        container = $("<div class='pageContainer'></div>").appendTo(this.pagesContainer);
        Global.app().templates().render(controller.toLowerCase(), "template_" + controller.toLowerCase(), container)
            .done(function () {
            uiController
                .render(container)
                .done(function () {
                var appRouterID = uiController.appRouterID(params);
                var pagesViewModel = {
                    ID: ko.observable(appRouterID),
                    Title: ko.observable(uiController.title()),
                    SubTitle: ko.observable(uiController.subTitle()),
                    ContentContainer: container,
                    UIController: uiController,
                    URL: "",
                    IsActive: ko.observable(true),
                    CanClose: ko.observable(controller !== me.getDefaultPage()),
                };
                if (uiController.height) {
                    uiController.height(me.workspaceHeight());
                }
                pagesViewModel.URL = controller;
                _.forEach(params, function (param) {
                    if (param != null) {
                        pagesViewModel.URL += "/" + param;
                    }
                });
                me.hideAllPages();
                me.makeAllPagesInactive();
                me.pagesViewModel.pages.push(pagesViewModel);
                me.tabScroller.resize();
                uiController
                    .load(params)
                    .done(function () {
                    pagesViewModel.Title(uiController.title());
                    pagesViewModel.SubTitle(uiController.subTitle());
                    me.updatePageHeaderViewModel(pagesViewModel);
                    me.tabScroller.scrollRight();
                })
                    .fail(function () {
                    me.closePage(appRouterID);
                });
            });
        });
    };
    PageManager.prototype.getPageModel = function (appRouterID) {
        var pages = this.pagesViewModel.pages();
        var max = pages.length;
        var i;
        var page;
        for (i = 0; i < max; i++) {
            page = pages[i];
            if (page.ID() === appRouterID) {
                return page;
            }
        }
        return null;
    };
    PageManager.prototype.removeAllPages = function () {
        var pages = this.pagesViewModel.pages();
        _.forEach(pages, function (page) {
            $(page.ContentContainer).remove();
        });
        this.pagesViewModel.pages.removeAll();
        this.pageHeaderViewModel.title("");
        this.pageHeaderViewModel.subTitle("");
        this.tabScroller.resize();
    };
    PageManager.prototype.onControllerRouteChange = function (data) {
        var tabModel = this.getPageModel(data.appRouterID);
        if (tabModel != null) {
            tabModel.Title(data.title);
            tabModel.SubTitle(data.subTitle);
            tabModel.URL = data.url;
            this.navigate(data.url, false);
            this.pageHeaderViewModel.title(data.title);
            this.pageHeaderViewModel.subTitle(data.subTitle);
            if (data.newAppRouterID != null &&
                data.newAppRouterID !== "" &&
                data.newAppRouterID !== data.appRouterID) {
                tabModel.ID(data.newAppRouterID);
            }
        }
    };
    PageManager.prototype.closePage = function (appRouterID) {
        var pages = this.pagesViewModel.pages();
        var max;
        var i;
        var page;
        max = pages.length;
        for (i = 0; i < max; i++) {
            if (pages[i].ID() === appRouterID) {
                page = this.pagesViewModel.pages.splice(i, 1)[0];
                $(page.ContentContainer).remove();
                if (pages.length > 0) {
                    if (page.IsActive()) {
                        if (i > 0) {
                            this.displayLoadedRoute(pages[i - 1].ID());
                        }
                        else {
                            this.displayLoadedRoute(pages[0].ID());
                        }
                    }
                }
                else {
                    this.gotoDefaultPage();
                }
                this.tabScroller.resize();
                break;
            }
        }
    };
    PageManager.prototype.getActivePage = function () {
        var page = _.find(this.pagesViewModel.pages(), function (thePage) {
            return thePage.IsActive();
        });
        if (page) {
            return page;
        }
        else {
            throw new Error("Unable to find active page");
        }
    };
    PageManager.prototype.getActivePageIndex = function () {
        return _.findIndex(this.pagesViewModel.pages(), function (page) {
            return page.IsActive();
        });
    };
    PageManager.prototype.updatePageHeaderViewModel = function (page) {
        this.pageHeaderViewModel.title(page.Title());
        this.pageHeaderViewModel.subTitle(page.SubTitle());
        this.pageHeaderViewModel.showClose(page.CanClose());
        this.pageHeaderViewModel.showSave(page.UIController.save != null &&
            (!page.UIController.showSaveButton || page.UIController.showSaveButton()));
        this.pageHeaderViewModel.showAdd(page.UIController.add != null);
    };
    PageManager.prototype.onBeforeUnload = function () {
        var pages = this.pagesViewModel.pages();
        var tabsWithUnsavedChanged = [];
        _.forEach(pages, function (page) {
            if (page.UIController.haveFieldsChanged()) {
                tabsWithUnsavedChanged.push(page.Title() + " " + page.SubTitle());
            }
        });
        if (tabsWithUnsavedChanged.length > 0) {
            var unloadMessage = "The following pages have unsaved changes:\r\r    " +
                tabsWithUnsavedChanged.join("\r    ") +
                "\r\rAre you sure you want to leave this page and lose any unsaved changes?";
            return unloadMessage;
        }
        return;
    };
    PageManager.prototype.navigate = function (url, trigger) {
        Global.app().router().navigate(url, trigger);
    };
    PageManager.prototype.hideAllPages = function () {
        $.each(this.pagesViewModel.pages(), function (index, page) {
            page.ContentContainer.hide();
        });
    };
    PageManager.prototype.resizePage = function () {
        var height = this.workspaceHeight();
        var app = Global.app();
        $.each(this.pagesViewModel.pages(), function (index, page) {
            if (page.UIController.height) {
                page.UIController.height(height);
            }
        });
        var heightAdjustment = 0;
        if (app.isLoggedIn) {
            if (app.hideMenu) {
                heightAdjustment = -35;
            }
            else {
                heightAdjustment = 64;
            }
        }
        $("div[data-id='master_PagesContainer']").height(height - heightAdjustment);
        this.tabScroller.resize();
    };
    PageManager.prototype.tryClosePage = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var deferred;
            var _this = this;
            return __generator(this, function (_a) {
                deferred = $.Deferred();
                if (page != null) {
                    if (page.UIController.haveFieldsChanged()) {
                        UI.showConfirmDialog(Constants.PHRASE_UNSAVEDCHANGESONCLOSE, function () {
                            _this.closePage(page.ID());
                            deferred.resolve();
                        }, function () {
                            deferred.resolve();
                        });
                    }
                    else {
                        this.closePage(page.ID());
                        deferred.resolve();
                    }
                }
                return [2, deferred.promise()];
            });
        });
    };
    return PageManager;
}());
exports.PageManager = PageManager;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
var changePassword_1 = __webpack_require__(488);
var contactUs_1 = __webpack_require__(489);
var customer_1 = __webpack_require__(490);
var customerAdd_1 = __webpack_require__(491);
var customers_1 = __webpack_require__(492);
var customerSettings_1 = __webpack_require__(514);
var dashboard_1 = __webpack_require__(517);
var documentLibrary_1 = __webpack_require__(827);
var forgotPassword_1 = __webpack_require__(829);
var home_1 = __webpack_require__(830);
var login_1 = __webpack_require__(831);
var manageReports_1 = __webpack_require__(832);
var oauthLogin_1 = __webpack_require__(836);
var resetPassword_1 = __webpack_require__(837);
var samlLogin_1 = __webpack_require__(838);
var selfRegistration_1 = __webpack_require__(839);
var target_1 = __webpack_require__(841);
var targetImport_1 = __webpack_require__(842);
var targets_1 = __webpack_require__(843);
var targetTemplate_1 = __webpack_require__(844);
var targetTemplates_1 = __webpack_require__(846);
var task_1 = __webpack_require__(847);
var taskAdd_1 = __webpack_require__(850);
var taskAutoAdd_1 = __webpack_require__(852);
var taskCalendar_1 = __webpack_require__(853);
var taskDashboard_1 = __webpack_require__(873);
var taskEntry_1 = __webpack_require__(875);
var tasks_1 = __webpack_require__(876);
var template_1 = __webpack_require__(892);
var templateAccessRole_1 = __webpack_require__(893);
var templateAccessRoles_1 = __webpack_require__(894);
var templateForm_1 = __webpack_require__(895);
var templateForms_1 = __webpack_require__(902);
var templatePhrase_1 = __webpack_require__(903);
var templatePhrases_1 = __webpack_require__(907);
var templates_1 = __webpack_require__(908);
var user_1 = __webpack_require__(909);
var userProfile_1 = __webpack_require__(910);
var users_1 = __webpack_require__(912);
var viewReport_1 = __webpack_require__(913);
var viewReports_1 = __webpack_require__(921);
function getController(controllerName) {
    switch (controllerName) {
        case "ChangePassword": return new changePassword_1.ChangePasswordController();
        case "ContactUs": return new contactUs_1.ContactUsController();
        case "Customer": return new customer_1.CustomerController();
        case "CustomerAdd": return new customerAdd_1.CustomerAddController();
        case "CustomerSettings": return new customerSettings_1.CustomerSettingsController();
        case "Customers": return new customers_1.CustomersController();
        case "Dashboard": return new dashboard_1.DashboardController();
        case "DocumentLibrary": return new documentLibrary_1.DocumentLibraryController();
        case "ForgotPassword": return new forgotPassword_1.ForgotPasswordController();
        case "Home": return new home_1.HomeController();
        case "Login": return new login_1.LoginController();
        case "ManageReports": return new manageReports_1.ManageReportsController();
        case "OAuthLogin": return new oauthLogin_1.OAuthLoginController();
        case "ResetPassword": return new resetPassword_1.ResetPasswordController();
        case "SAMLLogin": return new samlLogin_1.SAMLLoginController();
        case "SelfRegistration": return new selfRegistration_1.SelfRegistrationController();
        case "Target": return new target_1.TargetController();
        case "TargetImport": return new targetImport_1.TargetImportController();
        case "Targets": return new targets_1.TargetsController();
        case "TargetTemplate": return new targetTemplate_1.TargetTemplateController();
        case "TargetTemplates": return new targetTemplates_1.TargetTemplatesController();
        case "Task": return new task_1.TaskController();
        case "TaskAdd": return new taskAdd_1.TaskAddController();
        case "TaskAutoAdd": return new taskAutoAdd_1.TaskAutoAddController();
        case "TaskCalendar": return new taskCalendar_1.TaskCalendarController();
        case "TaskDashboard": return new taskDashboard_1.TaskDashboardController();
        case "TaskEntry": return new taskEntry_1.TaskEntryController();
        case "Tasks": return new tasks_1.TasksController();
        case "Template": return new template_1.TemplateController();
        case "TemplateAccessRole": return new templateAccessRole_1.TemplateAccessRoleController();
        case "TemplateAccessRoles": return new templateAccessRoles_1.TemplateAccessRolesController();
        case "TemplateForm": return new templateForm_1.TemplateFormController();
        case "TemplateForms": return new templateForms_1.TemplateFormsController();
        case "TemplatePhrase": return new templatePhrase_1.TemplatePhraseController();
        case "TemplatePhrases": return new templatePhrases_1.TemplatePhrasesController();
        case "Templates": return new templates_1.TemplatesController();
        case "User": return new user_1.UserController();
        case "UserProfile": return new userProfile_1.UserProfileController();
        case "Users": return new users_1.UsersController();
        case "ViewReport": return new viewReport_1.ViewReportController();
        case "ViewReports": return new viewReports_1.ViewReportsController();
    }
    throw new Error("Unable to construct controller named " + controllerName);
}
exports.getController = getController;


/***/ }),

/***/ 438:
/***/ (function(module, exports) {

module.exports = "/templates/appointmentlocationlogmap.html";

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

module.exports = "/templates/changepassword.html";

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

module.exports = "/templates/contactus.html";

/***/ }),

/***/ 441:
/***/ (function(module, exports) {

module.exports = "/templates/customer.html";

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

module.exports = "/templates/customeradd.html";

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

module.exports = "/templates/customers.html";

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

module.exports = "/templates/customersettings.html";

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

module.exports = "/templates/dashboard.html";

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

module.exports = "/templates/documentlibrary.html";

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

module.exports = "/templates/enterpassworddialog.html";

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

module.exports = "/templates/forgotpassword.html";

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

module.exports = "/templates/formdataentrycontrol.html";

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
exports.TARGETEMPLTETYPEID_LOCATION = 1;
exports.TARGETEMPLTETYPEID_CUSTOM = 2;
function GetTargetsConfig(targetName) {
    return Util.callWebService("/api/Targets/Config?name=" + targetName, "GET");
}
exports.GetTargetsConfig = GetTargetsConfig;
function GetTargetMaster(targetName, targetID) {
    var url = "/api/Target/Get/" + targetName;
    if (targetID != null && targetID > 0) {
        url += "/" + targetID;
    }
    return Util.callWebService(url, "GET");
}
exports.GetTargetMaster = GetTargetMaster;
function Save(targetMaster) {
    return Util.callWebService("/api/Target/Save", "POST", targetMaster);
}
exports.Save = Save;
function SetIsActive(request) {
    return Util.callWebService("/api/Target/SetIsActive", "POST", request);
}
exports.SetIsActive = SetIsActive;
function ValidateTargetImportFile(targetTemplateID, importFileKey) {
    return Util.callWebService("/api/Targets/VerifyImport/" + targetTemplateID, "POST", importFileKey);
}
exports.ValidateTargetImportFile = ValidateTargetImportFile;
function ProcessImport(targetTemplateID, importFileKey) {
    return Util.callWebService("/api/Targets/ProcessImport/" + targetTemplateID, "POST", importFileKey);
}
exports.ProcessImport = ProcessImport;
function GetImportConfiguration(targetName) {
    return Util.callWebService("/api/Target/GetImportConfiguration/" + targetName, "GET");
}
exports.GetImportConfiguration = GetImportConfiguration;
function getTargetTemplate(templateID) {
    return Util.callWebService("/api/TargetTemplate/GetTargetTemplate", "POST", templateID);
}
exports.getTargetTemplate = getTargetTemplate;


/***/ }),

/***/ 450:
/***/ (function(module, exports) {

module.exports = "/templates/gridfiltercontrol.html";

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

module.exports = "/templates/home.html";

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

module.exports = "/templates/login.html";

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

module.exports = "/templates/logincontrol.html";

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

module.exports = "/templates/managereports.html";

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

module.exports = "/templates/oauthlogin.html";

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

module.exports = "/templates/reportviewer.html";

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

module.exports = "/templates/resetpassword.html";

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

module.exports = "/templates/samllogin.html";

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

module.exports = "/templates/selfregistration.html";

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

module.exports = "/templates/target.html";

/***/ }),

/***/ 461:
/***/ (function(module, exports) {

module.exports = "/templates/targeteditcontrol.html";

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

module.exports = "/templates/targetimport.html";

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

module.exports = "/templates/targets.html";

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

module.exports = "/templates/targettemplate.html";

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

module.exports = "/templates/targettemplates.html";

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

module.exports = "/templates/task.html";

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

module.exports = "/templates/taskadd.html";

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

module.exports = "/templates/taskautoadd.html";

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

module.exports = "/templates/taskcalendar.html";

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

module.exports = "/templates/taskdashboard.html";

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

module.exports = "/templates/taskentry.html";

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

module.exports = "/templates/tasks.html";

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

module.exports = "/templates/template.html";

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

module.exports = "/templates/templateaccessrole.html";

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

module.exports = "/templates/templateaccessroles.html";

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

module.exports = "/templates/templateform.html";

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

module.exports = "/templates/templateforms.html";

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

module.exports = "/templates/templatephrase.html";

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

module.exports = "/templates/templatephraseimportcontrol.html";

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

module.exports = "/templates/templatephrases.html";

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

module.exports = "/templates/templates.html";

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

module.exports = "/templates/user.html";

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

module.exports = "/templates/userprofile.html";

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

module.exports = "/templates/users.html";

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

module.exports = "/templates/viewreport.html";

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

module.exports = "/templates/viewreports.html";

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

module.exports = "/data-files/us-states.json";

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var UserData = __webpack_require__(91);
var ChangePasswordController = (function () {
    function ChangePasswordController() {
    }
    ChangePasswordController.prototype.save = function () {
        var _this = this;
        var deferred = $.Deferred();
        var waitContainer;
        var app = Global.app();
        if (this.viewModel.isValid()) {
            waitContainer = UI.showWaitIndicator(this.container);
            var request = {
                CurrentPassword: this.viewModel.PasswordValues().CurrentPassword(),
                NewPassword: this.viewModel.PasswordValues().NewPassword(),
                NewPasswordConfirm: this.viewModel.PasswordValues().NewPasswordConfirm(),
            };
            UserData.ChangePassword(request)
                .done(function (response) {
                if (response.Success) {
                    UI.showNotificationMessage(Constants.PHRASE_PASSWORDCHANGED, UI.messageTypeValues.success);
                    deferred.resolve();
                }
                else {
                    if (response.Payload.ShouldReauthenticate) {
                        app.pageManager().logout();
                        UI.showErrorMessage([Constants.PHRASE_CHANGEPASSWORDACCOUNTLOCKED]);
                        location.href = "/";
                    }
                    else {
                        UI.showErrorMessage(response.ErrorMessages);
                    }
                    deferred.reject();
                }
            })
                .fail(function () {
                deferred.reject();
            })
                .always(function () {
                _this.viewModel.PasswordValues(_this.createPasswordValuesModel());
                UI.hideWaitIndicator(_this.container, waitContainer);
            });
        }
        else {
            deferred.reject();
        }
        return deferred.promise();
    };
    ChangePasswordController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        deferred.resolve();
        return deferred.promise();
    };
    ChangePasswordController.prototype.load = function (params) {
        var deferred = $.Deferred();
        var me = this;
        UserData.GetPasswordRequirements()
            .done(function (response) {
            if (response.Success) {
                me.passwordRequirements = response.Payload;
                me.setupAndBindViewModel();
            }
        });
        deferred.resolve();
        return deferred.promise();
    };
    ChangePasswordController.prototype.haveFieldsChanged = function () {
        return false;
    };
    ChangePasswordController.prototype.appRouterID = function (params) {
        return "ChangePassword";
    };
    ChangePasswordController.prototype.title = function () {
        return "Change Password";
    };
    ChangePasswordController.prototype.subTitle = function () {
        return "";
    };
    ChangePasswordController.prototype.mustEqual = function (val1, val2) {
        return val1 === val2;
    };
    ChangePasswordController.prototype.setupAndBindViewModel = function () {
        var _this = this;
        this.viewModel = {
            UserID: ko.observable(),
            PasswordValues: ko.observable(this.createPasswordValuesModel()),
            MinimumPasswordLength: ko.observable(this.passwordRequirements.MinimumPasswordLength),
            PasswordComplexityRequirements: ko.observable(this.passwordRequirements.PasswordComplexityRequirements),
            isValid: function () {
                if (_this.viewModel.errors && _this.viewModel.errors().length > 0) {
                    _this.viewModel.errors.showAllMessages();
                    UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
                    return false;
                }
                return true;
            },
        };
        this.viewModel.errors = ko.validation.group(this.viewModel);
        ko.applyBindings(this.viewModel, this.container[0]);
    };
    ChangePasswordController.prototype.createPasswordValuesModel = function () {
        var passwordValues = {
            CurrentPassword: ko.observable().extend({ required: true }),
            NewPassword: ko.observable().extend({ required: true, minLength: this.passwordRequirements.MinimumPasswordLength }),
            NewPasswordConfirm: ko.observable(),
        };
        passwordValues.NewPasswordConfirm = ko.observable().extend({
            required: true,
            minLength: this.passwordRequirements.MinimumPasswordLength,
            validation: {
                validator: this.mustEqual,
                message: "Passwords do not match.",
                params: passwordValues.NewPassword,
            },
        });
        return passwordValues;
    };
    return ChangePasswordController;
}());
exports.ChangePasswordController = ChangePasswordController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ContactUsController = (function () {
    function ContactUsController() {
        return;
    }
    ContactUsController.prototype.render = function (container) {
        var deferred = $.Deferred();
        deferred.resolve();
        return deferred.promise();
    };
    ContactUsController.prototype.load = function (params) {
        var deferred = $.Deferred();
        deferred.resolve();
        return deferred.promise();
    };
    ContactUsController.prototype.appRouterID = function (params) {
        return "contactUs";
    };
    ContactUsController.prototype.title = function () {
        return "Contact Us";
    };
    ContactUsController.prototype.subTitle = function () {
        return "";
    };
    ContactUsController.prototype.haveFieldsChanged = function () {
        return false;
    };
    return ContactUsController;
}());
exports.ContactUsController = ContactUsController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var CustomerData = __webpack_require__(266);
var CustomerController = (function () {
    function CustomerController() {
        var _this = this;
        this.fieldsOnLoad = "";
        var me = this;
        this.viewModel = {
            Name: ko.observable().extend({ required: true }),
            ShortName: ko.observable().extend({ required: true }),
            IsActive: ko.observable(true),
            Users: ko.observableArray([]),
            AllLanguages: ko.observableArray([]),
            LanguageID: ko.observable(),
            OnInactivate: function () {
                UI.showConfirmDialog("Are you sure you want to make the customer inactive?", function () { me.toggleIsActive(); });
            },
            OnActivate: function () {
                UI.showConfirmDialog("Are you sure you want to make the customer active?", function () { me.toggleIsActive(); });
            },
            CustomerLanguages: ko.pureComputed(function () {
                var customerLanguages = [];
                me.viewModel.AllLanguages().forEach(function (allLanguage) {
                    if (allLanguage.IsSelected() === true) {
                        customerLanguages.push({ ID: allLanguage.ID, Name: allLanguage.Name, Abbreviation: "" });
                    }
                });
                return customerLanguages;
            }),
        };
        this.viewModel.UpdateCustomerSettings = function () {
            var url = "/CustomerSettings/" + _this.customerID;
            Global.app().router().navigate(url, true);
        };
        this.viewModel.Errors = ko.validation.group(this.viewModel, { deep: true });
    }
    CustomerController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    CustomerController.prototype.load = function (params) {
        if (!params || params.length === 0) {
            Global.app().pageManager().closeCurrentPage();
            var deferred = $.Deferred();
            deferred.resolve();
            return deferred.promise();
        }
        this.customerID = params[0];
        return this.loadRecord(this.customerID);
    };
    CustomerController.prototype.haveFieldsChanged = function () {
        var fieldValues = JSON.stringify(this.createCustomerEditMaster());
        return fieldValues !== this.fieldsOnLoad;
    };
    CustomerController.prototype.appRouterID = function (params) {
        var appRouterID = "Customer";
        if (params != null && params.length === 1) {
            appRouterID += params[0];
        }
        return appRouterID;
    };
    CustomerController.prototype.save = function () {
        var _this = this;
        var waitContainer;
        var deferred = $.Deferred();
        if (this.isValid()) {
            waitContainer = UI.showWaitIndicator(this.container);
            CustomerData.SaveCustomer(this.createCustomerEditMaster())
                .done(function (response) {
                if (response.Success) {
                    _this.updateViewModel(response.Payload);
                    UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                    deferred.resolve();
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                    deferred.reject();
                }
            })
                .fail(function () {
                deferred.reject();
            })
                .always(function () {
                UI.hideWaitIndicator(_this.container, waitContainer);
            });
        }
        else {
            deferred.reject();
        }
        return deferred.promise();
    };
    CustomerController.prototype.title = function () {
        return "Customer";
    };
    CustomerController.prototype.subTitle = function () {
        return this.viewModel.Name();
    };
    CustomerController.prototype.loadRecord = function (customerID) {
        var _this = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        CustomerData.GetCustomer(this.customerID)
            .done(function (response) {
            if (response.Success) {
                _this.updateViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(_this.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    CustomerController.prototype.isValid = function () {
        var isValid = true;
        if (this.viewModel.Errors &&
            this.viewModel.Errors().length > 0) {
            this.viewModel.Errors.showAllMessages();
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
            isValid = false;
        }
        return isValid;
    };
    CustomerController.prototype.toggleIsActive = function () {
        var _this = this;
        var waitContainer = UI.showWaitIndicator(this.container);
        var request = {
            CustomerID: this.customerID,
            IsActive: !this.viewModel.IsActive(),
        };
        CustomerData.ChangeIsActive(request)
            .done(function (response) {
            if (response.Success) {
                _this.updateViewModel(response.Payload);
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(_this.container, waitContainer);
        });
    };
    CustomerController.prototype.updateViewModel = function (customerMaster) {
        var customerLanguages = [];
        customerMaster.AllLanguages.forEach(function (allLanguage) {
            var isSelected = ko.observable(customerMaster.CustomerLanguages.filter(function (x) { return x.ID === allLanguage.ID; }).length > 0);
            var customerLanguage = {
                ID: allLanguage.ID,
                Name: allLanguage.Name,
                IsSelected: isSelected,
                Abbreviation: "",
            };
            customerLanguages.push(customerLanguage);
        });
        this.viewModel.AllLanguages(customerLanguages);
        this.viewModel.Name(customerMaster.Name);
        this.viewModel.ShortName(customerMaster.ShortName);
        this.viewModel.IsActive(customerMaster.IsActive);
        this.viewModel.Users(customerMaster.Users || []);
        this.viewModel.LanguageID(customerMaster.LanguageID);
        this.fieldsOnLoad = JSON.stringify(this.createCustomerEditMaster());
    };
    CustomerController.prototype.createCustomerEditMaster = function () {
        var customerEditMaster = {
            ID: this.customerID,
            Name: this.viewModel.Name(),
            ShortName: this.viewModel.ShortName(),
            IsActive: this.viewModel.IsActive(),
            CustomerLanguages: this.viewModel.CustomerLanguages(),
            LanguageID: this.viewModel.LanguageID(),
            AllLanguages: this.viewModel.AllLanguages(),
        };
        return customerEditMaster;
    };
    return CustomerController;
}());
exports.CustomerController = CustomerController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var CustomerData = __webpack_require__(266);
var CustomerAddController = (function () {
    function CustomerAddController() {
        var _this = this;
        this.fieldsOnLoad = {};
        this.viewModel = {
            CustomerName: ko.observable().extend({ required: true }),
            CustomerShortName: ko.observable().extend({ required: true }),
            UserName: ko.observable().extend({ required: true }),
            UserFirstName: ko.observable().extend({ required: true }),
            UserLastName: ko.observable().extend({ required: true }),
            UserEmail: ko.observable().extend({ required: true }),
            IsCustomerCreated: ko.observable(false),
            TemporaryPassword: ko.observable(),
            OnAddCustomer: function () { return _this.addCustomer(); },
            OnClose: function () {
                var app = Global.app();
                app.pageManager().closeCurrentPage();
            },
            OnCopyPassword: function () {
                var passwordText = _this.container.find("[data-id='password']")[0];
                var range = document.createRange();
                range.selectNode(passwordText);
                window.getSelection().addRange(range);
                try {
                    var successful = document.execCommand("copy");
                    if (successful) {
                        UI.showNotificationMessage("Password copied to clipboard.", UI.messageTypeValues.success);
                    }
                    else {
                        UI.showNotificationMessage("Password could not be copied to clipboard.", UI.messageTypeValues.error);
                    }
                }
                catch (err) {
                    UI.showNotificationMessage("Password could not be copied to clipboard.", UI.messageTypeValues.error);
                }
                window.getSelection().removeAllRanges();
            },
        };
        this.viewModel.Errors = ko.validation.group(this.viewModel, { deep: true });
    }
    CustomerAddController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    CustomerAddController.prototype.load = function (params) {
        var deferred = $.Deferred();
        this.setDefaultValues();
        this.fieldsOnLoad = JSON.stringify(this.getCustomerAddRequest());
        deferred.resolve();
        return deferred.promise();
    };
    CustomerAddController.prototype.haveFieldsChanged = function () {
        var fieldValues = JSON.stringify(this.getCustomerAddRequest());
        return fieldValues !== this.fieldsOnLoad;
    };
    CustomerAddController.prototype.appRouterID = function (params) {
        return "CustomerAdd";
    };
    CustomerAddController.prototype.title = function () {
        return "Add Customer";
    };
    CustomerAddController.prototype.subTitle = function () {
        return "";
    };
    CustomerAddController.prototype.isValid = function () {
        if (!this.viewModel.Errors) {
            return true;
        }
        if (this.viewModel.Errors().length > 0) {
            this.viewModel.Errors.showAllMessages();
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
            return false;
        }
        return true;
    };
    CustomerAddController.prototype.addCustomer = function () {
        var _this = this;
        var me = this;
        var waitContainer;
        var deferred = $.Deferred();
        if (this.isValid()) {
            waitContainer = UI.showWaitIndicator(me.container);
            CustomerData.AddCustomer(this.getCustomerAddRequest())
                .done(function (response) {
                if (response.Success) {
                    _this.viewModel.TemporaryPassword(response.Payload.TemporaryPassword);
                    _this.viewModel.IsCustomerCreated(true);
                    deferred.resolve();
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                    deferred.reject();
                }
            })
                .fail(function () {
                deferred.reject();
            })
                .always(function () {
                UI.hideWaitIndicator(me.container, waitContainer);
            });
        }
        else {
            deferred.reject();
        }
        return deferred.promise();
    };
    CustomerAddController.prototype.getCustomerAddRequest = function () {
        var customerAddRequest = {
            CustomerName: this.viewModel.CustomerName(),
            CustomerShortName: this.viewModel.CustomerShortName(),
            UserName: this.viewModel.UserName(),
            UserFirstName: this.viewModel.UserFirstName(),
            UserLastName: this.viewModel.UserLastName(),
            UserEmail: this.viewModel.UserEmail(),
        };
        return customerAddRequest;
    };
    CustomerAddController.prototype.setDefaultValues = function () {
        this.viewModel.IsCustomerCreated(false);
        this.viewModel.TemporaryPassword("");
        var app = Global.app();
        if (!app) {
            return;
        }
        var userSession = app.userSession;
        if (!userSession) {
            return;
        }
        this.viewModel.UserFirstName(userSession.FirstName);
        this.viewModel.UserLastName(userSession.LastName);
        this.viewModel.UserEmail(userSession.UserEmail);
    };
    return CustomerAddController;
}());
exports.CustomerAddController = CustomerAddController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var data_1 = __webpack_require__(23);
var Global = __webpack_require__(2);
var GridUtil = __webpack_require__(27);
var UI = __webpack_require__(3);
var CustomersController = (function () {
    function CustomersController() {
    }
    CustomersController.prototype.render = function (container) {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        me.gridContainer = container.find("div[data-id='grid']");
        me.dataSource = new kendo.data.DataSource({
            pageSize: 100,
        });
        me.grid = me.gridContainer.kendoGrid({
            dataSource: me.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                { title: "Customer Name", field: "Name", template: kendo.template($("#template_customers_customername").html()) },
                { title: "Short Name", field: "ShortName" },
                { title: "Active Users", field: "NumberOfActiveUsers", width: "140px" },
                { title: "Last Login Date", field: "LastLoginDate", format: "{0:d}", width: "180px" },
            ],
            excel: {
                fileName: "Customers.xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");
        me.gridFilterControl = new GridUtil.GridFilterControl(container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showExportToExcel: true,
            showFilters: true,
            showRefresh: true,
            filters: [
                { name: Constants.PHRASE_FILTER_SHOWACTIVE, checked: true },
                { name: Constants.PHRASE_FILTER_SHOWINACTIVE, checked: false },
            ],
            grid: me.grid,
        });
        me.gridContainer.on("click", "a[data-id='link']", function (e) {
            var path = $(this).attr("href");
            e.preventDefault();
            app.router().navigate(_.defaultTo(path, ""), true);
            return false;
        });
        deferred.resolve();
        return deferred.promise();
    };
    CustomersController.prototype.load = function (params) {
        var app = Global.app();
        var me = this;
        var dataSource;
        var deferred = $.Deferred();
        dataSource = data_1.createWebServiceDataSource("/api/Customers", {
            id: "ID",
            fields: {
                ID: { type: "long" },
                Name: { type: "string" },
                ShortName: { type: "string" },
                IsActive: { type: "boolean" },
                NumberOfActiveUsers: { type: "number" },
                LastLoginDate: { type: "date" },
            },
        }, function (data) {
            me.setDataFilter(data);
        }, function (status) {
            if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                app.pageManager().closeCurrentPage();
            }
        });
        me.grid.setDataSource(dataSource);
        deferred.resolve();
        return deferred.promise();
    };
    CustomersController.prototype.add = function () {
        Global.app().router().navigate("/CustomerAdd", true);
    };
    CustomersController.prototype.haveFieldsChanged = function () {
        return false;
    };
    CustomersController.prototype.height = function (height) {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    };
    CustomersController.prototype.refresh = function () {
        this.grid.dataSource.read();
    };
    CustomersController.prototype.appRouterID = function (params) {
        return "Customers";
    };
    CustomersController.prototype.title = function () {
        return "Customers";
    };
    CustomersController.prototype.subTitle = function () {
        return "";
    };
    CustomersController.prototype.setDataFilter = function (data) {
        data.IncludeActive = true;
        data.IncludeInactive = false;
        if (this.gridFilterControl != null) {
            this.gridFilterControl.setDataFilter(data);
        }
    };
    return CustomersController;
}());
exports.CustomersController = CustomersController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTP_STATUS_UNAUTHORIZED = 401;
exports.COOKIE_AUTHENTICATIONTOKEN = "token";
exports.COOKIE_REPORTAUTHENTICATIONTOKEN = "report_token";
exports.MOMENT_FORMAT_DATE = "MM/DD/YYYY";
exports.MOMENT_FORMAT_TIME = "hh:mm A";
exports.MOMENT_FORMAT_DATETIME = "MM/DD/YYYY hh:mm A";
exports.MOMENT_FORMAT_DATETIME_FROM_CONFIG = "MM-DD-YYYY HH:mm";
exports.MOMENT_FORMAT_TIME_STANDARDIZED = "HH:mm:ss";
exports.MOMENT_FORMAT_DATE_STANDARDIZED = "YYYY-MM-DD";
exports.PHRASE_UNSAVEDCHANGESONCLOSE = "There are unsaved changes on this page.  Are you sure you want to " +
    "close this page and lose these unsaved changes?";
exports.PHRASE_PAGELOADERROR = "An error has occurred while loading this page.  Please try again.";
exports.PHRASE_RECORDLOADERROR = "An error has occurred while loading the record.  Please try again.";
exports.PHRASE_SAVEERROR = "An error has occurred saving the record.";
exports.PHRASE_INVALIDFIELDSONSAVE = "One or more fields have incorrect values.  Please review all warning messages.";
exports.PHRASE_RECORDSAVED = "Record was saved successfully";
exports.PHRASE_PASSWORDCHANGED = "Password Updated";
exports.PHRASE_RECORDDELETED = "Record was deleted successfully";
exports.PHRASE_GENERALACTIONFAILURE = "An unexpected error has occurred while processing your request.  Please try again.";
exports.PHRASE_INVALIDFILETYPESELECTION = "The selected file is not permitted. Please select a file with one of these extensions: ";
exports.PHRASE_SESSIONEXPIRED = "Your session has expired.  Please login and try again.";
exports.PHRASE_CHANGEPASSWORDACCOUNTLOCKED = "There was a problem updating your password.  Please log in and try again.";
exports.PHRASE_EXCELFILEBEINGCREATED = "The Excel file is being created, please wait...";
exports.PHRASE_UNAUTHORIZEDACCESS = "You do not have permissions to perform this action.";
exports.PHRASE_FILTER_SHOWACTIVE = "Show active";
exports.PHRASE_FILTER_SHOWINACTIVE = "Show inactive";
exports.PHRASE_ITEMSAVED = "Item saved";
exports.PHRASE_ITEMDELETED = "Item deleted";
exports.PHRASE_ITEMUNSAVEDCHANGES = "There are unsaved changes for this item.  Are you sure you want " +
    "to lose these unsaved changes?";
exports.PHRASE_NOTSELECTED = "(not selected)";
exports.LABEL_APPOINTMENT = "Application";
exports.LABEL_APPOINTMENTS = "Applications";
exports.LABEL_INSPECTOR = "Mobile User";
exports.LABEL_INSPECTORS = "Mobile Users";
exports.LABEL_QUESTION = "Item";
exports.LABEL_QUESTIONS = "Items";
exports.PHRASE_CANNOTDELETEREADONLYIMAGE = "You can not delete Image after " + exports.LABEL_APPOINTMENT + " is completed";
exports.QuestionType = {
    TEXTBOX: 1,
    RADIOBUTTONLIST: 2,
    DROPDOWN: 3,
    CHECKBOXLIST: 4,
    TEXTAREA: 5,
    DATE: 6,
    MULTIPLECOMMENTS: 7,
    MULTIPLECOMMENTSPICS: 8,
    TEXTDESCRIPTION: 9,
    SIGNATURE: 10,
    SECTION: 11,
    BUTTON: 12,
    NUMERIC: 13,
    BARCODE: 14,
    DOCUMENTS: 15,
    DATETIME: 16,
    TIME: 17,
    EMAIL: 18,
    PHONE: 19,
    LINKEDDOCUMENTS: 20,
    TARGET: 21,
    ADDRESS: 22,
    PICTURE: 23,
    GEOLOCAITON: 24,
    SLIDER: 25,
    SINGLECHECKBOX: 26,
};
exports.SETTING_KEY_REGISTRATION_CODE = "Registration Code";
exports.SETTING_KEY_DEFAULT_USER_ROLE = "Default User Roles";
exports.SETTING_KEY_DEFAULT_TEMPLATEACCESS_ROLE = "Default Template Access Roles";
exports.SETTING_TYPE_COLOR = "color";
exports.SETTING_TYPE_IMAGE = "image";
exports.SETTING_TYPE_DATE = "date";
exports.SETTING_TYPE_TIME = "time";
exports.SETTING_TYPE_BOOL = "bool";
exports.SETTING_KEY_DATEFORMAT = "Date Format";
exports.SETTING_KEY_TIMEFORMAT = "Time Format";
exports.SETTING_KEY_TEMPLATE_ACCESS_SECURITY = "Template Access Security";
exports.SETTING_KEY_MAKE_TASK_READ_ONLY_WHEN_COMPLETED = "Make Task Read-Only When Completed";
exports.SETTING_KEY_REPORT_RECIPIENT_EMAIL_ADDRESS = "Report Recipient Email Address";
exports.SETTING_KEY_REPORT_RECIPIENT_EMAIL_FIELD_PATH = "Report Recipient Email Field Path";
exports.DATE_FORMATS = ["MM/DD/YYYY", "DD/MM/YYYY", "DD-MMM-YYYY"];
exports.DEFAULT_TIME_FORMAT = "12H";
exports.DEFAULT_DATE_FORMAT = "MM/DD/YYYY";
exports.TIME_PLACEHOLDER = "HH:MM";
exports.NUMERIC_PLACEHOLDER = "0";
exports.MOMENT_DATE_FORMAT_MAP = {
    "MM/DD/YYYY": "MM/DD/YYYY",
    "DD/MM/YYYY": "DD/MM/YYYY",
    "DD-MMM-YYYY": "DD-MMM-YYYY",
};
exports.MOMENT_TIME_FORMAT_MAP = {
    "12H": "h:m A",
    "24H": "H:m",
};
exports.KENDO_DATE_FORMAT_MAP = {
    "MM/DD/YYYY": "MM/dd/yyyy",
    "DD/MM/YYYY": "dd/MM/yyyy",
    "DD-MMM-YYYY": "dd-MMM-yyyy",
};
exports.KENDO_TIME_FORMAT_MAP = {
    "12H": "hh:mm tt",
    "24H": "HH:mm",
};
exports.PERMISSION_PERFORM_APPOINTMENTS = 1;
exports.PERMISSION_CREATE_APPOINTMENTS = 2;
exports.PERMISSION_EDIT_APPOINTMENTS = 3;
exports.PERMISSION_EDIT_USERS = 4;
exports.PERMISSION_EDIT_FORM_TEMPLATES = 5;
exports.PERMISSION_EDIT_TEMPLATES = 6;
exports.PERMISSION_VIEW_APPOINTMENTS = 7;
exports.PERMISSION_VIEW_TARGETS = 8;
exports.PERMISSION_EDIT_TARGET_TEMPLATES = 9;
exports.PERMISSION_EDIT_TEMPLATE_PHRASES = 10;
exports.PERMISSION_ALL_USERS = 11;
exports.PERMISSION_EDIT_TARGETS = 12;
exports.PERMISSION_VIEW_LOCATION_LOGS = 13;
exports.PERMISSION_VIEW_REPORTS = 14;
exports.PERMISSION_MANAGE_REPORTS = 15;
exports.PERMISSION_CUSTOMER_ADMINISTRATION = 16;
exports.PERMISSION_EDIT_CUSTOMER_CONFIGURATION = 17;
exports.PERMISSION_EDIT_ALL_CUSTOMER_CONFIGURATION = 18;
exports.PERMISSION_EDIT_DOCUMENT_LIBRARY = 19;
exports.PERMISSION_EDIT_TEMPLATE_ACCESS_ROLES = 20;
exports.PERMISSION_VIEW_MOBILE_USERS = 21;
exports.PERMISSION_RUN_REPORTS = 22;
exports.PERMISSION_TASK_DASHBOARD = 24;
exports.PERMISSION_USE_TASK_ENTRY_PAGE = 25;
exports.TEMPLATE_SETTING_TYPE_SEND_EMAIL_WHEN_TASK_COMPLETED = 1;
exports.TEMPLATE_SETTING_TYPE_REPORT_EMAIL_ADDRESS = 2;
exports.TEMPLATE_SETTING_TYPE_REPORT_EMAIL_FIELD_PATH = 3;
exports.TEMPLATE_SETTING_GROUP_EMAIL_RECIPIENTS = "EmailRecipients";
exports.TEMPLATE_SETTING_GROUP_MOBILE_TASK_LIST = "MobileTaskList";
exports.TEMPLATE_MOBILE_SETTING_KEY_FIELD_PATH = "Field Path";
exports.TEMPLATE_FORM_CHOICES_CUSTOM = "custom";
exports.TEMPLATE_FORM_CHOICES_PHRASES = "phrases";
exports.SINGLECHECKBOX_ANSWER_FALSE = "false";
exports.SINGLECHECKBOX_ANSWER_TRUE = "true";
exports.DEFAULT_CONTROLLER = "Dashboard";
exports.DEFAULT_CONTROLLER_TASK = "TaskDashboard";
exports.QUERYSTRING_PAGE_TO_SHOW = "pagetoshow";
exports.QUERYSTRING_HIDE_MENU = "hidemenu";


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(282);
var ko = __webpack_require__(4);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var customerSettingsData = __webpack_require__(516);
var CustomerSettingsController = (function () {
    function CustomerSettingsController() {
        var _this = this;
        this.fieldsOnLoad = {};
        var app = Global.app();
        var me = this;
        this.viewModel = {
            customerID: ko.observable(),
            ColorSettingTypes: ko.observableArray(),
            ReportEmailSettingTypes: ko.observableArray(),
            ImageSettingTypes: ko.observableArray(),
            SettingTypes: [],
            ColorSettings: ko.observableArray(),
            ReportEmailSettings: ko.observableArray(),
            RegistrationCodes: ko.observableArray(),
            registrationCodeValue: ko.observable(),
            registrationCodeSettingTypeID: 0,
            selfRegistrationAllowed: app.global.SelfRegistrationAllowed,
            AvailableUserRoles: ko.observableArray([]),
            AvailableTemplateAccessRoles: ko.observableArray([]),
            templateSecurityEnabled: ko.pureComputed(function () { return me.getSecurityEnabledValue(); }),
            DefaultTempAccRoleSettingTypeID: 0,
            DefaultUserRoleSettingTypeID: 0,
            CustomerImages: ko.observableArray(),
            CustomerTimeSetting: ko.observable(),
            CustomerDateSetting: ko.observable(),
            CustomerTemplateAccessSecuritySetting: ko.observable(),
            MakeTaskReadOnlyWhenCompletedSetting: ko.observable(),
            DateSettingTypes: [],
            colorHexValue: ko.observable(),
            colorSettingTypeID: ko.observable(),
            reportEmailSettingTypeID: ko.observable(),
            reportEmailSettingValue: ko.observable(),
            imageSettingTypeID: ko.observable(),
            settingKey: ko.observable(),
            imageUploadedNotSavedYet: ko.observable(false),
            TempFileExtension: ko.observable(),
            TempFileKey: ko.observable(),
            TempFileName: ko.observable(),
            url: Global.app().webServiceBaseURL,
            PictureURL: ko.observable(),
            closeUploadImageModal: function () {
                me.container.find("div[data-id='uploadImageDialog']").modal("hide");
            },
            closeViewImageModal: function () {
                me.container.find("div[data-id='viewImageFormDialog']").modal("hide");
            },
            addColorSetting: function () {
                if (me.viewModel.colorSettingTypeID() && me.viewModel.colorHexValue() &&
                    (!me.viewModel.ColorSettings().some(function (x) { return x.CustomerSettingTypeID() === me.viewModel.colorSettingTypeID() &&
                        x.IsActive() === true; }))) {
                    var settingKey = me.viewModel.ColorSettingTypes().filter(function (x) { return x.ID === me.viewModel.colorSettingTypeID(); });
                    var customerSetting = {
                        ID: ko.observable(0),
                        CustomerSettingTypeID: ko.observable(me.viewModel.colorSettingTypeID()),
                        SettingKey: ko.observable(settingKey[0].SettingKey),
                        Value: ko.observable(me.viewModel.colorHexValue()),
                        SettingType: ko.observable("color"),
                        IsActive: ko.observable(true),
                    };
                    me.viewModel.ColorSettings.push(customerSetting);
                    _this.viewModel.colorSettingTypeID(null);
                    me.viewModel.colorHexValue("");
                    me.viewModel.ColorSettingTypes.remove(settingKey[0]);
                }
            },
            openUploadImage: function (data) {
                me.viewModel.PictureURL(me.viewModel.url + "/api/CustomerSettings/GetCustomerPicture/" + data.ID());
                me.container.find("div[data-id='viewImageFormDialog']").modal("show");
            },
            openUploadImageForCustomer: function (data) {
                me.viewModel.PictureURL(me.viewModel.url +
                    "/api/CustomerSettings/GetCustomerPictureForCustomer/" +
                    _this.viewModel.customerID() + "/" + data.ID());
                me.container.find("div[data-id='viewImageFormDialog']").modal("show");
            },
            openTempImageForCustomer: function (index) {
                var customerImageSetting = _this.viewModel.CustomerImages()[index()];
                if (customerImageSetting.TempFileKey() && customerImageSetting.FileExtension && customerImageSetting.TempFileName()) {
                    me.viewModel.PictureURL(me.viewModel.url +
                        "/api/CustomerSettings/GetTempCustomerPictureForCustomer/" +
                        _this.viewModel.customerID() + "/" + customerImageSetting.TempFileName() +
                        "/" + customerImageSetting.TempFileExtension());
                    me.container.find("div[data-id='viewImageFormDialog']").modal("show");
                }
            },
            openCustomerTempImage: function (index) {
                var customerImageSetting = _this.viewModel.CustomerImages()[index()];
                if (customerImageSetting.TempFileKey() && customerImageSetting.TempFileName() && customerImageSetting.TempFileExtension()) {
                    me.viewModel.PictureURL(me.viewModel.url + "/api/CustomerSettings/GetTempCustomerPicture/"
                        + customerImageSetting.TempFileName() + "/" + customerImageSetting.TempFileExtension());
                    me.container.find("div[data-id='viewImageFormDialog']").modal("show");
                }
            },
            removeImageSetting: function (index) {
                var selectedImageSetting = me.viewModel.CustomerImages()[index()];
                UI.showConfirmDialog("Are you sure you want to delete \"" + selectedImageSetting.SettingKey() + "\"?", function () { me.DeleteCustomerImage(selectedImageSetting); });
            },
            removeColorSetting: function (index) {
                var selectedSetting = me.viewModel.ColorSettings()[index()];
                UI.showConfirmDialog("Are you sure you want to delete \"" + selectedSetting.SettingKey() + "\"?", function () { me.DeleteColorSetting(selectedSetting); });
            },
            addRegistrationCode: function () {
                if (me.viewModel.registrationCodeValue()) {
                    for (var _i = 0, _a = me.viewModel.RegistrationCodes(); _i < _a.length; _i++) {
                        var code = _a[_i];
                        if ((code.Value().toLowerCase() === me.viewModel.registrationCodeValue().toLowerCase()) && (code.IsActive() === true)) {
                            UI.showErrorMessage(["Duplicate Entry. Please add a new value."]);
                            return;
                        }
                    }
                    var customerSetting = {
                        ID: ko.observable(0),
                        CustomerSettingTypeID: ko.observable(me.viewModel.registrationCodeSettingTypeID),
                        SettingKey: ko.observable(Constants.SETTING_KEY_REGISTRATION_CODE),
                        Value: ko.observable(me.viewModel.registrationCodeValue()),
                        SettingType: ko.observable("string"),
                        IsActive: ko.observable(true),
                    };
                    me.viewModel.RegistrationCodes.push(customerSetting);
                    me.viewModel.registrationCodeValue("");
                }
            },
            removeRegistrationCode: function (index) {
                var selectedSetting = me.viewModel.RegistrationCodes()[index()];
                UI.showConfirmDialog("Are you sure you want to delete \"" + selectedSetting.SettingKey() + "\"?", function () { me.DeleteRegistrationCode(selectedSetting); });
            },
            addReportEmailSetting: function () {
                if (me.viewModel.reportEmailSettingTypeID() && me.viewModel.reportEmailSettingValue()) {
                    for (var _i = 0, _a = me.viewModel.ReportEmailSettings(); _i < _a.length; _i++) {
                        var email = _a[_i];
                        if ((email.Value().toLowerCase() === me.viewModel.reportEmailSettingValue().toLowerCase()) && (email.IsActive() === true)) {
                            UI.showErrorMessage(["This email is already added to the list. Please add a new email"]);
                            return;
                        }
                    }
                    var settingKey = me.viewModel.ReportEmailSettingTypes().filter(function (x) { return x.ID === me.viewModel.reportEmailSettingTypeID(); });
                    var customerSetting = {
                        ID: ko.observable(0),
                        CustomerSettingTypeID: ko.observable(me.viewModel.reportEmailSettingTypeID()),
                        SettingKey: ko.observable(settingKey[0].SettingKey),
                        Value: ko.observable(me.viewModel.reportEmailSettingValue()),
                        SettingType: ko.observable("string"),
                        IsActive: ko.observable(true),
                    };
                    me.viewModel.ReportEmailSettings.push(customerSetting);
                    _this.viewModel.reportEmailSettingTypeID(null);
                    me.viewModel.reportEmailSettingValue("");
                }
            },
            removeReportEmailSetting: function (index) {
                var selectedSetting = me.viewModel.ReportEmailSettings()[index()];
                UI.showConfirmDialog("Are you sure you want to delete \"" + selectedSetting.SettingKey() + "\"?", function () { me.DeleteReportEmailSetting(selectedSetting); });
            },
        };
        this.viewModel.DateSettingTypes = Constants.DATE_FORMATS;
    }
    CustomerSettingsController.prototype.haveFieldsChanged = function () {
        var fieldValues = ko.toJSON(this.getAllCustomerSettings());
        return fieldValues !== this.fieldsOnLoad;
    };
    CustomerSettingsController.prototype.appRouterID = function (params) {
        return "CustomerSettings";
    };
    CustomerSettingsController.prototype.title = function () {
        return "Customer Settings";
    };
    CustomerSettingsController.prototype.subTitle = function () {
        return "";
    };
    CustomerSettingsController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        this.uploadControl = this.container.find("input[data-id='uploadImageControl']").kendoUpload({
            async: {
                saveUrl: "save",
                removeUrl: "remove",
                autoUpload: true,
            },
            validation: {
                allowedExtensions: [".jpg", ".jpeg", ".png"],
            },
            upload: this.onImageUpload.bind(this),
            success: this.onUploadSuccess.bind(this),
            multiple: false,
        }).data("kendoUpload");
        ko.applyBindings(this.viewModel, this.container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    CustomerSettingsController.prototype.load = function (params) {
        if (!params || params.length === 0) {
            return this.loadSettings();
        }
        else {
            this.viewModel.customerID(params[0]);
            return this.loadSettingsForCustomer(this.viewModel.customerID());
        }
    };
    CustomerSettingsController.prototype.save = function () {
        var _this = this;
        var me = this;
        var app = Global.app();
        var waitContainer;
        var deferred = $.Deferred();
        waitContainer = UI.showWaitIndicator(me.container);
        var saveMethod = me.viewModel.customerID() ?
            function () { return customerSettingsData.SaveForCustomer(_this.viewModel.customerID(), _this.getAllCustomerSettings()); } :
            function () { return customerSettingsData.SaveCustomerSettings(_this.getAllCustomerSettings()); };
        var loadMethod = me.viewModel.customerID() ?
            function () { return _this.loadSettingsForCustomer(_this.viewModel.customerID()); } :
            function () { return _this.loadSettings(); };
        saveMethod()
            .done(function (response) {
            if (response.Success) {
                app.pageManager().refreshCurrentPageTitle();
                _this.viewModel.ColorSettings.removeAll();
                _this.viewModel.CustomerImages.removeAll();
                loadMethod();
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    CustomerSettingsController.prototype.DeleteColorSetting = function (selectedCustomerSetting) {
        var me = this;
        var settingKey = me.viewModel.SettingTypes.filter(function (x) { return x.ID === selectedCustomerSetting.CustomerSettingTypeID(); });
        if (selectedCustomerSetting.ID() === 0) {
            me.viewModel.ColorSettings.remove(selectedCustomerSetting);
        }
        else {
            selectedCustomerSetting.IsActive(false);
        }
        me.viewModel.ColorSettingTypes.push(settingKey[0]);
    };
    CustomerSettingsController.prototype.DeleteCustomerImage = function (selectedCustomerImageSetting) {
        var me = this;
        var settingKey = me.viewModel.SettingTypes.filter(function (x) { return x.ID === selectedCustomerImageSetting.CustomerSettingTypeID(); });
        if (selectedCustomerImageSetting.ID() === 0) {
            me.viewModel.CustomerImages.remove(selectedCustomerImageSetting);
        }
        else {
            selectedCustomerImageSetting.IsActive(false);
        }
        me.viewModel.ImageSettingTypes.push(settingKey[0]);
    };
    CustomerSettingsController.prototype.DeleteReportEmailSetting = function (selectedCustomerSetting) {
        var me = this;
        if (selectedCustomerSetting.ID() === 0) {
            me.viewModel.ReportEmailSettings.remove(selectedCustomerSetting);
        }
        else {
            selectedCustomerSetting.IsActive(false);
        }
    };
    CustomerSettingsController.prototype.DeleteRegistrationCode = function (selectedCustomerSetting) {
        var me = this;
        if (selectedCustomerSetting.ID() === 0) {
            me.viewModel.RegistrationCodes.remove(selectedCustomerSetting);
        }
        else {
            selectedCustomerSetting.IsActive(false);
        }
    };
    CustomerSettingsController.prototype.getAllCustomerSettings = function () {
        var customerAllSettings = {
            CustomerSettings: this.getCustomerSettings(),
            CustomerImages: this.getCustomerImages(),
        };
        return customerAllSettings;
    };
    CustomerSettingsController.prototype.getCustomerSetting = function (customerSetting) {
        var setting = {
            ID: customerSetting.ID(),
            CustomerSettingTypeID: customerSetting.CustomerSettingTypeID(),
            SettingKey: customerSetting.SettingKey(),
            SettingType: customerSetting.SettingType(),
            IsActive: customerSetting.IsActive(),
            Value: customerSetting.Value(),
        };
        return setting;
    };
    CustomerSettingsController.prototype.getCustomerSettings = function () {
        var _this = this;
        var customerSettings = [];
        var me = this;
        this.viewModel.ColorSettings().forEach(function (customerSetting) {
            customerSettings.push(me.getCustomerSetting(customerSetting));
        });
        this.viewModel.ReportEmailSettings().forEach(function (customerSetting) {
            customerSettings.push(me.getCustomerSetting(customerSetting));
        });
        this.viewModel.RegistrationCodes().forEach(function (customerSetting) {
            customerSettings.push(me.getSettingFromObservable(customerSetting));
        });
        this.viewModel.AvailableUserRoles().forEach(function (role) {
            if (role.IsSelected() || role.CustomerSettingID > 0) {
                customerSettings.push(me.geCustomerSettingFromObservable(role, Constants.SETTING_KEY_DEFAULT_USER_ROLE, _this.viewModel.DefaultUserRoleSettingTypeID));
            }
        });
        this.viewModel.AvailableTemplateAccessRoles().forEach(function (role) {
            if (role.IsSelected() || role.CustomerSettingID > 0) {
                customerSettings.push(me.geCustomerSettingFromObservable(role, Constants.SETTING_KEY_DEFAULT_TEMPLATEACCESS_ROLE, _this.viewModel.DefaultTempAccRoleSettingTypeID));
            }
        });
        if (me.viewModel.CustomerTimeSetting().Value()) {
            customerSettings.push(me.getSettingFromObservable(me.viewModel.CustomerTimeSetting()));
        }
        if (me.viewModel.CustomerDateSetting().Value()) {
            customerSettings.push(me.getSettingFromObservable(me.viewModel.CustomerDateSetting()));
        }
        if (me.viewModel.CustomerTemplateAccessSecuritySetting().Value()) {
            customerSettings.push(me.getSettingFromObservable(me.viewModel.CustomerTemplateAccessSecuritySetting()));
        }
        if (me.viewModel.MakeTaskReadOnlyWhenCompletedSetting().Value()) {
            customerSettings.push(me.getSettingFromObservable(me.viewModel.MakeTaskReadOnlyWhenCompletedSetting()));
        }
        return customerSettings;
    };
    CustomerSettingsController.prototype.geCustomerSettingFromObservable = function (role, settingKey, customerSettingTypeID) {
        var setting = {
            ID: role.CustomerSettingID,
            CustomerSettingTypeID: customerSettingTypeID,
            SettingKey: settingKey,
            SettingType: "string",
            IsActive: role.IsSelected(),
            Value: role.RoleID.toString(),
        };
        return setting;
    };
    CustomerSettingsController.prototype.getSettingFromObservable = function (settingObservable) {
        var setting = {
            ID: settingObservable.ID(),
            CustomerSettingTypeID: settingObservable.CustomerSettingTypeID(),
            SettingKey: settingObservable.SettingKey(),
            SettingType: settingObservable.SettingType(),
            IsActive: settingObservable.IsActive(),
            Value: settingObservable.Value(),
        };
        return setting;
    };
    CustomerSettingsController.prototype.getCustomerImages = function () {
        var customerImages = [];
        this.viewModel.CustomerImages().forEach(function (customerImage) {
            var imageSetting = {
                ID: customerImage.ID(),
                CustomerSettingTypeID: customerImage.CustomerSettingTypeID(),
                SettingKey: customerImage.SettingKey(),
                ImageData: customerImage.ImageData(),
                IsActive: customerImage.IsActive(),
                TempFileKey: customerImage.TempFileKey(),
                FileExtension: customerImage.FileExtension(),
            };
            customerImages.push(imageSetting);
        });
        return customerImages;
    };
    CustomerSettingsController.prototype.onImageUpload = function (e) {
        var url = Global.app().webServiceBaseURL;
        if (this.uploadControl.options.async) {
            if (this.viewModel.customerID()) {
                this.uploadControl.options.async.saveUrl = url + "/api/CustomerSettings/UploadCustomerImageForCustomer/" + this.viewModel.customerID();
            }
            else {
                this.uploadControl.options.async.saveUrl = url + "/api/CustomerSettings/UploadCustomerImage";
            }
        }
    };
    CustomerSettingsController.prototype.onUploadSuccess = function (e) {
        var me = this;
        me.viewModel.TempFileKey(e.response.TempFileKey);
        me.viewModel.TempFileName(e.response.TempFileName);
        me.viewModel.TempFileExtension(e.response.TempFileExtension);
        if (me.viewModel.TempFileKey()) {
            var fileExtension = "." + me.viewModel.TempFileExtension().toLowerCase();
            var settingKey = me.viewModel.ImageSettingTypes().filter(function (x) { return x.ID === me.viewModel.imageSettingTypeID(); });
            var newCustomerImageSetting = {
                ID: ko.observable(0),
                CustomerSettingTypeID: ko.observable(me.viewModel.imageSettingTypeID()),
                SettingKey: ko.observable(settingKey[0].SettingKey),
                TempFileKey: ko.observable(me.viewModel.TempFileKey()),
                TempFileName: ko.observable(me.viewModel.TempFileName()),
                TempFileExtension: ko.observable(me.viewModel.TempFileExtension().toLowerCase()),
                ImageData: ko.observable(""),
                IsActive: ko.observable(true),
                FileExtension: ko.observable(fileExtension),
            };
            me.viewModel.CustomerImages.push(newCustomerImageSetting);
            me.viewModel.ImageSettingTypes.remove(settingKey[0]);
            me.viewModel.imageSettingTypeID(null);
        }
    };
    CustomerSettingsController.prototype.loadSettings = function () {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        customerSettingsData.GetAllSettings()
            .done(function (response) {
            if (response.Success) {
                me.updateViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    CustomerSettingsController.prototype.loadSettingsForCustomer = function (customerID) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        customerSettingsData.GetAllSettingsForCustomer(customerID)
            .done(function (response) {
            if (response.Success) {
                me.updateViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    CustomerSettingsController.prototype.updateViewModel = function (master) {
        var me = this;
        me.viewModel.ReportEmailSettings.removeAll();
        me.viewModel.RegistrationCodes.removeAll();
        me.viewModel.ColorSettings.removeAll();
        me.viewModel.SettingTypes = master.SettingTypes;
        me.viewModel.AvailableUserRoles(me.getRoleSelectionObservablesForUserRoles(master));
        me.viewModel.AvailableTemplateAccessRoles(me.getRoleSelectionObservablesForTemplateAccessRoles(master));
        master.CustomerSettings.forEach(function (customerSetting) {
            if (customerSetting.SettingType === Constants.SETTING_TYPE_COLOR) {
                me.viewModel.ColorSettings.push(me.CustomerSetting(customerSetting));
            }
            if (customerSetting.SettingKey === Constants.SETTING_KEY_REPORT_RECIPIENT_EMAIL_ADDRESS ||
                customerSetting.SettingKey === Constants.SETTING_KEY_REPORT_RECIPIENT_EMAIL_FIELD_PATH) {
                me.viewModel.ReportEmailSettings.push(me.CustomerSetting(customerSetting));
            }
            if (customerSetting.SettingKey === Constants.SETTING_KEY_REGISTRATION_CODE) {
                me.viewModel.RegistrationCodes.push(me.CustomerSetting(customerSetting));
            }
        });
        master.CustomerImages.forEach(function (customerImage) {
            me.viewModel.CustomerImages.push(me.CustomerImage(customerImage));
        });
        me.viewModel.ReportEmailSettingTypes.removeAll();
        master.SettingTypes.forEach(function (settingType) {
            if (settingType.SettingKey === Constants.SETTING_KEY_REPORT_RECIPIENT_EMAIL_ADDRESS ||
                settingType.SettingKey === Constants.SETTING_KEY_REPORT_RECIPIENT_EMAIL_FIELD_PATH) {
                me.viewModel.ReportEmailSettingTypes.push(settingType);
            }
        });
        me.viewModel.registrationCodeSettingTypeID = master.SettingTypes.filter(function (x) { return x.SettingKey === Constants.SETTING_KEY_REGISTRATION_CODE; })[0].ID;
        me.viewModel.DefaultUserRoleSettingTypeID = master.SettingTypes.filter(function (x) { return x.SettingKey === Constants.SETTING_KEY_DEFAULT_USER_ROLE; })[0].ID;
        me.viewModel.DefaultTempAccRoleSettingTypeID = master.SettingTypes.filter(function (x) { return x.SettingKey === Constants.SETTING_KEY_DEFAULT_TEMPLATEACCESS_ROLE; })[0].ID;
        me.viewModel.CustomerDateSetting(me.createCustomerSettingObservable(master, Constants.DEFAULT_DATE_FORMAT, Constants.SETTING_KEY_DATEFORMAT));
        me.viewModel.CustomerTimeSetting(me.createCustomerSettingObservable(master, Constants.DEFAULT_TIME_FORMAT, Constants.SETTING_KEY_TIMEFORMAT));
        me.viewModel.CustomerTemplateAccessSecuritySetting(me.createCustomerSettingObservable(master, "false", Constants.SETTING_KEY_TEMPLATE_ACCESS_SECURITY));
        me.viewModel.MakeTaskReadOnlyWhenCompletedSetting(me.createCustomerSettingObservable(master, "false", Constants.SETTING_KEY_MAKE_TASK_READ_ONLY_WHEN_COMPLETED));
        if (me.viewModel.ColorSettings().length === 0) {
            me.viewModel.ColorSettingTypes(me.viewModel.SettingTypes.filter(function (x) { return x.SettingType === Constants.SETTING_TYPE_COLOR; }));
        }
        else {
            var colorSettings_1 = me.viewModel.SettingTypes.filter(function (x) { return x.SettingType === Constants.SETTING_TYPE_COLOR; });
            master.CustomerSettings.forEach(function (customerSetting) {
                colorSettings_1 = colorSettings_1.filter(function (x) { return x.ID !== customerSetting.CustomerSettingTypeID; });
            });
            me.viewModel.ColorSettingTypes(colorSettings_1);
        }
        if (master.CustomerImages.length === 0) {
            me.viewModel.ImageSettingTypes(me.viewModel.SettingTypes.filter(function (x) { return x.SettingType === Constants.SETTING_TYPE_IMAGE; }));
        }
        else {
            var imageSettings_1 = me.viewModel.SettingTypes.filter(function (x) { return x.SettingType === Constants.SETTING_TYPE_IMAGE; });
            master.CustomerImages.forEach(function (customerImage) {
                imageSettings_1 = imageSettings_1.filter(function (x) { return x.ID !== customerImage.CustomerSettingTypeID; });
            });
            me.viewModel.ImageSettingTypes(imageSettings_1);
        }
        me.viewModel.showUploadImageModal = function () {
            me.container.find("div[data-id='uploadImageDialog']").modal("show");
            me.container.find(".k-upload-status-total").remove();
        };
        this.fieldsOnLoad = ko.toJSON(this.getAllCustomerSettings());
    };
    CustomerSettingsController.prototype.getRoleSelectionObservablesForUserRoles = function (master) {
        var roleSelectionObservables = [];
        master.UserRoles.forEach(function (availableRole) {
            var customerSettings = master.CustomerSettings.filter(function (x) { return x.Value === availableRole.ID.toString()
                && x.SettingKey === Constants.SETTING_KEY_DEFAULT_USER_ROLE; });
            var templateAccessRole = {
                RoleID: availableRole.ID,
                RoleName: availableRole.RoleName,
                IsSelected: ko.observable(customerSettings.length > 0),
                CustomerSettingID: customerSettings.length > 0 ? customerSettings[0].ID : 0,
            };
            roleSelectionObservables.push(templateAccessRole);
        });
        return roleSelectionObservables;
    };
    CustomerSettingsController.prototype.getRoleSelectionObservablesForTemplateAccessRoles = function (master) {
        var roleSelectionObservables = [];
        master.TemplateAccessRoles.forEach(function (availableRole) {
            var customerSettings = master.CustomerSettings.filter(function (x) { return x.Value === availableRole.ID.toString()
                && x.SettingKey === Constants.SETTING_KEY_DEFAULT_TEMPLATEACCESS_ROLE; });
            var templateAccessRole = {
                RoleID: availableRole.ID,
                RoleName: availableRole.Name,
                IsSelected: ko.observable(customerSettings.length > 0),
                CustomerSettingID: customerSettings.length > 0 ? customerSettings[0].ID : 0,
            };
            roleSelectionObservables.push(templateAccessRole);
        });
        return roleSelectionObservables;
    };
    CustomerSettingsController.prototype.createCustomerSettingObservable = function (master, defaultValue, settingKey) {
        var settingIndex = master.CustomerSettings.map(function (x) { return x.SettingKey; }).indexOf(settingKey);
        var settingType = master.SettingTypes.filter(function (x) { return x.SettingKey === settingKey; });
        var settingObservable = {
            ID: ko.observable(master.CustomerSettings[settingIndex] ? master.CustomerSettings[settingIndex].ID : 0),
            CustomerSettingTypeID: ko.observable(master.CustomerSettings[settingIndex] ?
                master.CustomerSettings[settingIndex].CustomerSettingTypeID : settingType[0].ID),
            SettingKey: ko.observable(master.CustomerSettings[settingIndex] ? master.CustomerSettings[settingIndex].SettingKey : settingType[0].SettingKey),
            Value: ko.observable(master.CustomerSettings[settingIndex] ? master.CustomerSettings[settingIndex].Value : defaultValue),
            SettingType: ko.observable(master.CustomerSettings[settingIndex] ? master.CustomerSettings[settingIndex].SettingType : settingType[0].SettingType),
            IsActive: ko.observable(master.CustomerSettings[settingIndex] ? master.CustomerSettings[settingIndex].IsActive : true),
        };
        return settingObservable;
    };
    CustomerSettingsController.prototype.CustomerImage = function (customerImage) {
        var vmCustomerImage = {
            ID: ko.observable(customerImage.ID),
            CustomerSettingTypeID: ko.observable(customerImage.CustomerSettingTypeID),
            SettingKey: ko.observable(customerImage.SettingKey),
            FileExtension: ko.observable(customerImage.FileExtension),
            TempFileKey: ko.observable(customerImage ? customerImage.TempFileKey : ""),
            ImageData: ko.observable(customerImage ? customerImage.ImageData : ""),
            IsActive: ko.observable(customerImage.IsActive),
            TempFileExtension: ko.observable(""),
            TempFileName: ko.observable(""),
        };
        return vmCustomerImage;
    };
    CustomerSettingsController.prototype.CustomerSetting = function (customerSetting) {
        var vmCustomerSetting = {
            ID: ko.observable(customerSetting.ID),
            CustomerSettingTypeID: ko.observable(customerSetting.CustomerSettingTypeID),
            SettingKey: ko.observable(customerSetting.SettingKey),
            Value: ko.observable(customerSetting.Value),
            SettingType: ko.observable(customerSetting.SettingType),
            IsActive: ko.observable(customerSetting.IsActive),
        };
        return vmCustomerSetting;
    };
    CustomerSettingsController.prototype.getSecurityEnabledValue = function () {
        var me = this;
        var enabled = true;
        if (me.viewModel.CustomerTemplateAccessSecuritySetting() === undefined ||
            me.viewModel.CustomerTemplateAccessSecuritySetting().Value() === "false") {
            enabled = false;
        }
        return enabled;
    };
    return CustomerSettingsController;
}());
exports.CustomerSettingsController = CustomerSettingsController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function GetAllSettings() {
    return Util.callWebService("/api/CustomerSettings/GetAllSettings", "GET");
}
exports.GetAllSettings = GetAllSettings;
function SaveCustomerSettings(customerAllSettings) {
    return Util.callWebService("/api/CustomerSettings/Save", "POST", customerAllSettings);
}
exports.SaveCustomerSettings = SaveCustomerSettings;
function GetAllSettingsForCustomer(customerID) {
    return Util.callWebService("/api/CustomerSettings/GetAllSettingsForCustomer/" + customerID, "GET");
}
exports.GetAllSettingsForCustomer = GetAllSettingsForCustomer;
function SaveForCustomer(customerID, customerAllSettings) {
    return Util.callWebService("/api/CustomerSettings/SaveforCustomer/" + customerID, "POST", customerAllSettings);
}
exports.SaveForCustomer = SaveForCustomer;


/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var crossfilter = __webpack_require__(518);
var d3 = __webpack_require__(531);
var dc = __webpack_require__(823);
var ko = __webpack_require__(4);
var moment = __webpack_require__(0);
var constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var appointmentDataModule = __webpack_require__(58);
var DashboardController = (function () {
    function DashboardController() {
        this.viewModel = {};
        var me = this;
        this.viewModel = {
            isErrorLoadingAppointments: ko.observable(false),
            resetNumberOfAppointmentsByUser: function () {
                me.numberOfAppointmentsByUserChart.filterAll();
                dc.redrawAll();
            },
            resetNumberOfAppointmentsByTemplate: function () {
                me.numberOfAppointmentsByTemplateChart.filterAll();
                dc.redrawAll();
            },
            resetNumberOfAppointmentsByDay: function () {
                me.numberOfAppointmentsByDay.filterAll();
                dc.redrawAll();
            },
            topMenu: ko.observableArray(),
            onMenuItemClick: function (menuItem) {
                Global.app().router().navigate(menuItem.URL, true);
            },
        };
    }
    DashboardController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, this.container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    DashboardController.prototype.load = function (params) {
        var deferred = $.Deferred();
        this.loadStats();
        var userSession = Global.app().userSession;
        if (userSession) {
            this.viewModel.topMenu(userSession.ApplicationNavigation.TopMenu);
        }
        deferred.resolve();
        return deferred.promise();
    };
    DashboardController.prototype.haveFieldsChanged = function () {
        return false;
    };
    DashboardController.prototype.appRouterID = function (params) {
        return "Dashboard";
    };
    DashboardController.prototype.title = function () {
        return "Dashboard";
    };
    DashboardController.prototype.subTitle = function () {
        return "";
    };
    DashboardController.prototype.loadStats = function () {
        var _this = this;
        var waitContainer = UI.showWaitIndicator(this.container);
        var request = {
            startDate: moment().add(-30, "days").format(constants.MOMENT_FORMAT_DATE),
            endDate: moment().add(30, "days").format(constants.MOMENT_FORMAT_DATE),
        };
        appointmentDataModule.GetForDashboardCount(request)
            .done(function (response) {
            if (response.Success) {
                _this.viewModel.isErrorLoadingAppointments(false);
                _this.loadChartControls(response.Payload);
            }
            else {
                _this.viewModel.isErrorLoadingAppointments(true);
            }
        })
            .fail(function () {
            _this.viewModel.isErrorLoadingAppointments(true);
        })
            .always(function () {
            UI.hideWaitIndicator(_this.container, waitContainer);
        });
    };
    DashboardController.prototype.loadChartControls = function (appointmentData) {
        this.numberOfAppointmentsByUserChart = dc.pieChart("#number-of-appointments-by-user-chart");
        this.numberOfAppointmentsByTemplateChart = dc.rowChart("#number-of-appointments-by-template-chart");
        this.numberOfAppointmentsByDay = dc.lineChart("#number-of-appointments-by-day-chart");
        if (!appointmentData || appointmentData.length === 0) {
            return;
        }
        var parseDate = d3.timeParse("%Y-%m-%d");
        appointmentData.forEach(function (d) {
            d.AppointmentDateAsDate = parseDate(d.AppointmentDate);
        });
        var ndx = crossfilter(appointmentData);
        var assignedUserNameDim = ndx.dimension(function (d) { return d.AssignedUserName; });
        var numberOfAppointmentsPerAssignedUserName = assignedUserNameDim.group().reduceSum(function (d) { return +d.NumberOfAppointments; });
        var appointmentTemplateNameDim = ndx.dimension(function (d) { return d.AppointmentTemplateName; });
        var numberOfAppointmentsPerTemplateName = appointmentTemplateNameDim.group().reduceSum(function (d) { return +d.NumberOfAppointments; });
        var appointmentDateDim = ndx.dimension(function (d) { return d.AppointmentDateAsDate || new Date(); });
        var minDate = appointmentDateDim.bottom(1)[0].AppointmentDateAsDate || new Date();
        var maxDate = appointmentDateDim.top(1)[0].AppointmentDateAsDate || new Date();
        var numberOfAppointmentsPerDay = appointmentDateDim.group().reduceSum(function (d) { return +d.NumberOfAppointments; });
        this.numberOfAppointmentsByUserChart
            .height(300)
            .dimension(assignedUserNameDim)
            .group(numberOfAppointmentsPerAssignedUserName)
            .innerRadius(50)
            .controlsUseVisibility(true);
        this.numberOfAppointmentsByTemplateChart
            .height(500)
            .dimension(appointmentTemplateNameDim)
            .group(numberOfAppointmentsPerTemplateName)
            .elasticX(true)
            .controlsUseVisibility(true);
        this.numberOfAppointmentsByDay
            .renderArea(true)
            .height(300)
            .elasticY(true)
            .dimension(appointmentDateDim)
            .group(numberOfAppointmentsPerDay)
            .yAxisLabel("Number of Tasks")
            .x(d3.scaleTime().domain([minDate, maxDate]))
            .xAxis()
            .tickFormat(d3.timeFormat("%m-%d-%y"));
        function show_empty_message(chart) {
            var isEmpty = d3.sum(chart.group().all().map(chart.valueAccessor())) === 0;
            var data = isEmpty ? [1] : [];
            var empty = chart.svg().selectAll(".empty-message").data(data);
            empty.enter().append("text")
                .text("NO DATA!")
                .attr({
                "text-anchor": "middle",
                "alignment-baseline": "middle",
                "class": "empty-message",
                "x": chart.margins().left + chart.effectiveWidth() / 2,
                "y": chart.margins().top + chart.effectiveHeight() / 2,
            })
                .style("opacity", 0);
            empty.transition().duration(1000).style("opacity", 1);
            empty.exit().remove();
        }
        this.numberOfAppointmentsByTemplateChart.on("pretransition", show_empty_message);
        this.numberOfAppointmentsByDay.on("pretransition", show_empty_message);
        dc.renderAll();
    };
    return DashboardController;
}());
exports.DashboardController = DashboardController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function GetMaster(id) {
    return Util.callWebService("/api/Appointment/GetAppointmentByID/" + id, "GET");
}
exports.GetMaster = GetMaster;
function GetFormItemsByTemplateFormID(templateFormID, appointmentID, navigationID, origFormItemID, listID) {
    return Util.callWebService("/api/Appointment/GetFormItemsByTemplateFormID", "POST", {
        appointmentID: appointmentID,
        listID: listID,
        navigationID: navigationID,
        origFormItemID: origFormItemID,
        templateFormID: templateFormID,
    });
}
exports.GetFormItemsByTemplateFormID = GetFormItemsByTemplateFormID;
function GetAdditionalFormItemsByTemplateFormID(templateFormID, appointmentID, navigationID, origFormItemID, listID) {
    return Util.callWebService("/api/Appointment/GetAdditionalFormItemsByTemplateFormID", "POST", {
        appointmentID: appointmentID,
        listID: listID,
        navigationID: navigationID,
        origFormItemID: origFormItemID,
        templateFormID: templateFormID,
    });
}
exports.GetAdditionalFormItemsByTemplateFormID = GetAdditionalFormItemsByTemplateFormID;
function SaveAppointmentDetail(request) {
    return Util.callWebService("/api/Appointment/SaveAppointmentDetail", "POST", request);
}
exports.SaveAppointmentDetail = SaveAppointmentDetail;
function SaveAppointmentForm(appointmentFormItems, navigationID, skipValidation, listID) {
    return Util.callWebService("/api/Appointment/SaveAppointmentFormItemAnswers", "POST", {
        appointmentFormItems: appointmentFormItems,
        listID: listID,
        navigationID: navigationID,
        skipValidation: skipValidation,
    });
}
exports.SaveAppointmentForm = SaveAppointmentForm;
function SaveAppointmentAdditionalForm(appointmentFormItems, navigationID, listID, origFormItemID) {
    return Util.callWebService("/api/Appointment/SaveAppointmentAdditionalFormItemAnswers", "POST", {
        appointmentFormItems: appointmentFormItems,
        listID: listID,
        navigationID: navigationID,
        origFormItemID: origFormItemID,
    });
}
exports.SaveAppointmentAdditionalForm = SaveAppointmentAdditionalForm;
function SaveNewListForm(listName, ID, appointmentID, navigationID) {
    return Util.callWebService("/api/Appointment/SaveNewListForm", "POST", {
        appointmentID: appointmentID,
        listItemID: ID,
        listName: listName,
        navigationID: navigationID,
    });
}
exports.SaveNewListForm = SaveNewListForm;
function SaveListOrder(lists) {
    return Util.callWebService("/api/Appointment/SaveListOrder", "POST", {
        lists: lists,
    });
}
exports.SaveListOrder = SaveListOrder;
function GetUploadedFile(id) {
    return Util.callWebService("/api/FileUploadApi/GetUploadedFile/" + id, "GET");
}
exports.GetUploadedFile = GetUploadedFile;
function DeletePictures(pictureType, pictureID) {
    return Util.callWebService("/api/AppointmentPicture/delete/" + pictureType + "/" + pictureID, "POST");
}
exports.DeletePictures = DeletePictures;
function GetExceptionReportData(appointmentID) {
    return Util.callWebService("/api/Appointment/GetExceptionReportData", "POST", appointmentID);
}
exports.GetExceptionReportData = GetExceptionReportData;
function GetLocationLogs(appointmentID) {
    return Util.callWebService("/api/Appointment/GetLocationLogs/" + appointmentID, "GET");
}
exports.GetLocationLogs = GetLocationLogs;
function CloneAppointment(appointmentID) {
    return Util.callWebService("/api/Appointment/Clone/" + appointmentID, "POST");
}
exports.CloneAppointment = CloneAppointment;
function CompleteAppointment(appointmentID) {
    var request = {
        AppointmentID: appointmentID,
    };
    return Util.callWebService("/api/Appointment/CompleteAppointment", "POST", request);
}
exports.CompleteAppointment = CompleteAppointment;
function CancelAppointment(appointmentID) {
    var request = {
        AppointmentID: appointmentID,
    };
    return Util.callWebService("/api/Appointment/CancelAppointment", "POST", request);
}
exports.CancelAppointment = CancelAppointment;
function OpenAppointment(appointmentID) {
    var request = {
        AppointmentID: appointmentID,
    };
    return Util.callWebService("/api/Appointment/OpenAppointment", "POST", request);
}
exports.OpenAppointment = OpenAppointment;
function GetForDashboardCount(request) {
    return Util.callWebService("/api/Appointments/ForDashboardCount", "POST", request, false);
}
exports.GetForDashboardCount = GetForDashboardCount;
function ValidateAppointment(appointmentID) {
    return Util.callWebService("/api/Appointment/ValidateTask", "POST", appointmentID);
}
exports.ValidateAppointment = ValidateAppointment;


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
function callWebService(url, type, request, showMessageOnError) {
    var data;
    var headers;
    var app = Global.app();
    var deferred = $.Deferred();
    if (request != null) {
        data = JSON.stringify(request);
    }
    if (app.userSession != null && app.authenticationToken != null) {
        headers = { Authorization: "token " + app.authenticationToken };
    }
    $.ajax({
        type: type,
        url: app.webServiceBaseURL + url,
        data: data,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        headers: headers,
        success: function (result) {
            if (result.RotateAuthenticationToken) {
                app.setAuthenticationToken(result.AuthenticationToken);
            }
            deferred.resolve(result);
        },
        error: function (theXhr, status, error) {
            deferred.reject(theXhr, status, error);
        },
    });
    if (showMessageOnError == null ||
        showMessageOnError === true) {
        deferred.fail(function (jqXHR, textStatus, errorThrown) {
            handleAjaxError(jqXHR);
        });
    }
    return deferred;
}
exports.callWebService = callWebService;
function callReportService(url, type, request) {
    var data;
    var app = Global.app();
    var headers = { Authorization: "Bearer " + app.reportToken };
    var deferred = $.Deferred();
    if (request != null) {
        data = JSON.stringify(request);
    }
    $.ajax({
        type: type,
        url: app.reportingWebServiceBaseURL + url,
        data: data,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        headers: headers,
        success: function (result) {
            deferred.resolve(result);
        },
        error: function (theXhr, status, error) {
            deferred.reject(theXhr, status, error);
        },
    });
    return deferred;
}
exports.callReportService = callReportService;
function handleAjaxError(jqXHR) {
    var authenticateHeader;
    if (jqXHR.status === Constants.HTTP_STATUS_UNAUTHORIZED) {
        authenticateHeader = jqXHR.getResponseHeader("WWW-Authenticate");
        if (authenticateHeader == null || authenticateHeader === "") {
            Global.app().showErrorMessage([Constants.PHRASE_UNAUTHORIZEDACCESS]);
        }
        else {
            window.location.href = "/";
        }
    }
    else {
        Global.app().showErrorMessage([Constants.PHRASE_GENERALACTIONFAILURE]);
    }
}
exports.handleAjaxError = handleAjaxError;
function getURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split("&");
    for (var _i = 0, sURLVariables_1 = sURLVariables; _i < sURLVariables_1.length; _i++) {
        var urlVar = sURLVariables_1[_i];
        var sParameterName = urlVar.split("=");
        if (sParameterName[0] === sParam) {
            return sParameterName[1];
        }
    }
    return "";
}
exports.getURLParameter = getURLParameter;
function getURLParameters() {
    var params = [];
    var url = window.location.search.substring(1);
    var qsValues = url.split("&");
    for (var _i = 0, qsValues_1 = qsValues; _i < qsValues_1.length; _i++) {
        var qsValue = qsValues_1[_i];
        var qsSplit = qsValue.split("=");
        params.push({ Key: qsSplit[0], Value: qsSplit[1] });
    }
    return params;
}
exports.getURLParameters = getURLParameters;
function getURLNumberParameter(sParam) {
    var value = getURLParameter(sParam);
    if (value === "" || isNaN(Number(value))) {
        return null;
    }
    else {
        return Number(value);
    }
}
exports.getURLNumberParameter = getURLNumberParameter;
function isNullOrEmpty(value) {
    return _.isUndefined(value) || value === null || _.isEmpty(value);
}
exports.isNullOrEmpty = isNullOrEmpty;
function isNullOrSpace(value) {
    return _.isUndefined(value) || value === null || _.isEmpty(value) || value.trim().length === 0;
}
exports.isNullOrSpace = isNullOrSpace;
function setCookie(cname, cvalue) {
    var app = Global.app();
    if (app.webServiceBaseDomain === "localhost") {
        document.cookie = cname + "=" + cvalue + ";path=/;";
    }
    else {
        document.cookie = cname + "=" + cvalue + ";path=/;domain=." + app.webServiceBaseDomain + "; SameSite=None; Secure;";
    }
}
exports.setCookie = setCookie;
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var _i = 0, ca_1 = ca; _i < ca_1.length; _i++) {
        var c = ca_1[_i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
exports.getCookie = getCookie;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(9);
var Util = __webpack_require__(8);
function CreateReportTreeDataSource(reports) {
    var treeItems = [];
    var reportsAtRoot = [];
    var _loop_1 = function (report) {
        if (report.FolderName === "") {
            reportsAtRoot.push({ text: report.Name, report: report, items: [], spriteCssClass: "fa fa-file-text-o" });
            return "continue";
        }
        var folderItem = _.find(treeItems, function (value) {
            return value.text === report.FolderName;
        });
        if (!folderItem) {
            folderItem = { text: report.FolderName, items: [], expanded: true };
            treeItems.push(folderItem);
        }
        folderItem.items.push({ text: report.Name, report: report, items: [], spriteCssClass: "fa fa-file-text-o" });
    };
    for (var _i = 0, reports_1 = reports; _i < reports_1.length; _i++) {
        var report = reports_1[_i];
        _loop_1(report);
    }
    treeItems.push.apply(treeItems, reportsAtRoot);
    return treeItems;
}
exports.CreateReportTreeDataSource = CreateReportTreeDataSource;
function GetAllReports() {
    var url = "/api/Report/GetAll";
    return Util.callWebService(url, "GET");
}
exports.GetAllReports = GetAllReports;
function SaveReport(report) {
    var url = "/api/Report/Save";
    return Util.callWebService(url, "POST", report);
}
exports.SaveReport = SaveReport;
function EmailReport(request) {
    return Util.callReportService("/api/ReportData/EmailReport", "POST", request);
}
exports.EmailReport = EmailReport;
function EmailReportToDefaultRecipients(taskID) {
    return Util.callReportService("/api/ReportData/EmailReportToDefaultRecipients/" + taskID, "POST", null);
}
exports.EmailReportToDefaultRecipients = EmailReportToDefaultRecipients;


/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var DocumentLibraryData = __webpack_require__(828);
var DocumentLibraryController = (function () {
    function DocumentLibraryController() {
        var _this = this;
        this.allowedExtensions = this.ValidFiles();
        this.fieldsOnLoad = "";
        var app = Global.app();
        this.viewModel = {
            Documents: ko.observableArray(),
            DocumentID: ko.observable(),
            FileName: ko.observable(),
            TempFileKey: ko.observable(),
            DownloadUrl: app.webServiceBaseURL + "/api/DocumentLibrary/Download/",
            AllowedExtensions: this.allowedExtensions.join(", "),
            closeUploadModal: function () {
                _this.uploadDialog.modal("hide");
            },
            replaceDocument: function (doc) {
                _this.viewModel.DocumentID(doc.ID());
                _this.uploadDialog.modal("show");
            },
            deleteDocument: function (doc) {
                var msg = "Are you sure you want to delete this document?";
                if (doc.DocumentInUse()) {
                    msg += "\n\nWarning: This document is currently linked to at least one entity."
                        + "\nIf you proceed this document will be removed from any linked templates, tasks and targets.";
                }
                UI.showConfirmDialog(msg, function () {
                    if (doc.ID()) {
                        doc.IsActive(false);
                    }
                    else {
                        _this.viewModel.Documents.remove(doc);
                    }
                });
            },
        };
    }
    DocumentLibraryController.prototype.ValidFiles = function () {
        var appGlobal = Global.app().global;
        var allowedExtensions = [];
        for (var i = 0; i < appGlobal.ValidFileExtensions.length; ++i) {
            allowedExtensions[i] = appGlobal.ValidFileExtensions[i].DocumentTypeExtension;
        }
        return allowedExtensions;
    };
    DocumentLibraryController.prototype.save = function () {
        var _this = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        DocumentLibraryData.Save(this.createCustomerDocumentList())
            .done(function (response) {
            if (response.Success) {
                _this.loadViewModel(response.Payload);
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .always(function () {
            UI.hideWaitIndicator(_this.container, waitContainer);
        });
        return deferred.promise();
    };
    DocumentLibraryController.prototype.add = function () {
        this.viewModel.DocumentID(null);
        this.viewModel.FileName(null);
        this.viewModel.TempFileKey(null);
        this.uploadControl.clearAllFiles();
        this.uploadDialog.modal("show");
    };
    DocumentLibraryController.prototype.render = function (container) {
        var _this = this;
        var deferred = $.Deferred();
        var app = Global.app();
        this.container = container;
        this.uploadDialog = this.container.find("div[data-id='uploadDocumentDialog']");
        this.uploadControl = this.container.find("input[data-id='uploadDocumentControl']").kendoUpload({
            async: {
                saveUrl: "save",
                autoUpload: true,
            },
            validation: {
                allowedExtensions: this.allowedExtensions,
            },
            upload: function (e) {
                if (e.sender.options.async) {
                    e.sender.options.async.saveUrl = app.webServiceBaseURL + "/api/DocumentLibrary/Upload";
                }
            },
            success: function (e) {
                _this.viewModel.FileName(e.response.FileName);
                _this.viewModel.TempFileKey(e.response.TempFileKey);
                if (_this.viewModel.TempFileKey()) {
                    if (_this.viewModel.DocumentID()) {
                        _this.viewModel.Documents().forEach(function (doc) {
                            if (doc.ID() === _this.viewModel.DocumentID()) {
                                doc.TempFileKey(_this.viewModel.TempFileKey());
                                doc.FileName(_this.viewModel.FileName());
                            }
                        });
                    }
                    else {
                        _this.viewModel.Documents.push({
                            ID: ko.observable(),
                            Description: ko.observable(),
                            FileName: ko.observable(_this.viewModel.FileName()),
                            TempFileKey: ko.observable(_this.viewModel.TempFileKey()),
                            IsActive: ko.observable(true),
                            StorageKey: ko.observable(),
                            DocumentInUse: ko.observable(false),
                        });
                    }
                }
            },
            multiple: false,
        }).data("kendoUpload");
        ko.applyBindings(this.viewModel, this.container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    DocumentLibraryController.prototype.load = function (params) {
        var _this = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        DocumentLibraryData.GetAllDocuments()
            .done(function (response) {
            if (response.Success) {
                _this.loadViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(_this.container, waitContainer);
        });
        deferred.resolve();
        return deferred.promise();
    };
    DocumentLibraryController.prototype.haveFieldsChanged = function () {
        var fieldValues = JSON.stringify(this.createCustomerDocumentList());
        return fieldValues !== this.fieldsOnLoad;
    };
    DocumentLibraryController.prototype.appRouterID = function (params) {
        return "DocumentLibrary";
    };
    DocumentLibraryController.prototype.title = function () {
        return "Document Library";
    };
    DocumentLibraryController.prototype.subTitle = function () {
        return "";
    };
    DocumentLibraryController.prototype.createCustomerDocumentList = function () {
        var docList = [];
        this.viewModel.Documents().forEach(function (docObservable) {
            docList.push({
                ID: docObservable.ID(),
                StorageKey: docObservable.StorageKey(),
                IsActive: docObservable.IsActive(),
                Description: docObservable.Description(),
                FileName: docObservable.FileName(),
                TempFileKey: docObservable.TempFileKey(),
                DocumentInUse: docObservable.DocumentInUse(),
            });
        });
        return docList;
    };
    DocumentLibraryController.prototype.loadViewModel = function (docs) {
        var _this = this;
        this.fieldsOnLoad = JSON.stringify(docs);
        this.viewModel.Documents.removeAll();
        docs.forEach(function (doc) {
            _this.viewModel.Documents.push({
                ID: ko.observable(doc.ID),
                DocumentInUse: ko.observable(doc.DocumentInUse),
                StorageKey: ko.observable(doc.StorageKey),
                IsActive: ko.observable(doc.IsActive),
                Description: ko.observable(doc.Description),
                FileName: ko.observable(doc.FileName),
                TempFileKey: ko.observable(doc.TempFileKey),
            });
        });
    };
    return DocumentLibraryController;
}());
exports.DocumentLibraryController = DocumentLibraryController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function GetAllDocuments() {
    return Util.callWebService("/api/DocumentLibrary/GetAllDocuments", "GET");
}
exports.GetAllDocuments = GetAllDocuments;
function Save(docs) {
    return Util.callWebService("/api/DocumentLibrary/Save", "POST", docs);
}
exports.Save = Save;


/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var Util = __webpack_require__(8);
var AuthenticationData = __webpack_require__(32);
var ForgotPasswordController = (function () {
    function ForgotPasswordController() {
        this.viewModel = {};
        var me = this;
        this.viewModel = {
            UserIdentification: ko.observable(""),
            UserIdentificationMissing: ko.observable(false),
            Success: ko.observable(false),
            LoginHelp: ko.observable(""),
            onForgotPassword: function (e) {
                me.processPasswordRequest();
            },
            onGotoHomePage: function (e) {
                var app = Global.app();
                app.pageManager().closeCurrentPage();
            },
        };
        this.viewModel.hasLoginHelp = ko.pureComputed(function () {
            return !Util.isNullOrEmpty(me.viewModel.LoginHelp());
        });
    }
    ForgotPasswordController.prototype.render = function (container) {
        var me = this;
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, container[0]);
        this.container.find("input[data-id='emailField']").keypress(function (e) {
            if (e.which === 13) {
                $(e.target).blur();
                me.processPasswordRequest();
            }
        });
        deferred.resolve();
        return deferred.promise();
    };
    ForgotPasswordController.prototype.load = function (params) {
        var deferred = $.Deferred();
        this.viewModel.UserIdentification("");
        this.viewModel.UserIdentificationMissing(false);
        this.viewModel.Success(false);
        this.container.find("input").first().focus();
        deferred.resolve();
        return deferred.promise();
    };
    ForgotPasswordController.prototype.haveFieldsChanged = function () {
        return false;
    };
    ForgotPasswordController.prototype.appRouterID = function (params) {
        return "ForgotPassword";
    };
    ForgotPasswordController.prototype.title = function () {
        return "Forgot Password";
    };
    ForgotPasswordController.prototype.subTitle = function () {
        return "";
    };
    ForgotPasswordController.prototype.AllowAnonymousAccess = function () {
        return true;
    };
    ForgotPasswordController.prototype.processPasswordRequest = function () {
        var me = this;
        var waitContainer;
        var request;
        if (!this.validatePaswordReset()) {
            return;
        }
        waitContainer = UI.showWaitIndicator(this.container);
        request = {
            UserIdentification: this.viewModel.UserIdentification(),
        };
        AuthenticationData.EmailPasswordReset(request)
            .done(function (response) {
            if (response.Success) {
                me.viewModel.Success(true);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
    };
    ForgotPasswordController.prototype.validatePaswordReset = function () {
        var isValid = true;
        isValid = UI.setRequiredStringError(this.viewModel.UserIdentification(), "UserIdentificationMissing", this.viewModel) ? isValid : false;
        return isValid;
    };
    return ForgotPasswordController;
}());
exports.ForgotPasswordController = ForgotPasswordController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var Global = __webpack_require__(2);
var login_1 = __webpack_require__(367);
var HomeController = (function () {
    function HomeController() {
        this.loginControl = new login_1.LoginControl();
    }
    HomeController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.loginControl.render(container.find("div[data-id='loginControl']"));
        deferred.resolve();
        return deferred.promise();
    };
    HomeController.prototype.load = function (params) {
        var deferred = $.Deferred();
        var app = Global.app();
        if (app.isLoggedIn) {
            app.pageManager().closeAllAndGotoDefaultPage();
        }
        else {
            Global.app().redirectToExternalLoginIfRequired();
        }
        deferred.resolve();
        return deferred.promise();
    };
    HomeController.prototype.haveFieldsChanged = function () {
        return false;
    };
    HomeController.prototype.appRouterID = function (params) {
        return "Home";
    };
    HomeController.prototype.title = function () {
        return "Home";
    };
    HomeController.prototype.subTitle = function () {
        return "";
    };
    HomeController.prototype.AllowAnonymousAccess = function () {
        return true;
    };
    return HomeController;
}());
exports.HomeController = HomeController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var Global = __webpack_require__(2);
var login_1 = __webpack_require__(367);
var LoginController = (function () {
    function LoginController() {
        this.loginControl = new login_1.LoginControl();
    }
    LoginController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.loginControl.render(container.find("div[data-id='loginControl']"));
        deferred.resolve();
        return deferred.promise();
    };
    LoginController.prototype.load = function (params) {
        var deferred = $.Deferred();
        var app = Global.app();
        if (app.isLoggedIn) {
            app.pageManager().closeAllAndGotoDefaultPage();
        }
        deferred.resolve();
        return deferred.promise();
    };
    LoginController.prototype.haveFieldsChanged = function () {
        return false;
    };
    LoginController.prototype.appRouterID = function (params) {
        return "Login";
    };
    LoginController.prototype.title = function () {
        return "Login";
    };
    LoginController.prototype.subTitle = function () {
        return "";
    };
    LoginController.prototype.AllowAnonymousAccess = function () {
        return true;
    };
    return LoginController;
}());
exports.LoginController = LoginController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(368);
__webpack_require__(80);
var ko = __webpack_require__(4);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var ReportData = __webpack_require__(81);
var ManageReportsController = (function () {
    function ManageReportsController() {
        var _this = this;
        var app = Global.app();
        this.viewModel = {
            reports: ko.observableArray(),
            newFolder: ko.observable(),
            reportFolders: ko.observableArray(),
            ID: ko.observable(-1),
            Name: ko.observable("").extend({ required: true }),
            FileName: ko.observable(""),
            FolderName: ko.observable(""),
            FileKey: ko.observable(""),
            IsActive: ko.observable(true),
            IsNameUnique: ko.observable(true),
            EmailSubjectTemplate: ko.observable(""),
            reportDesignerDownloadUrl: ko.observable(app.webServiceBaseURL + "/api/report/downloadreportdesigner"),
            reportDownloadUrl: ko.observable(),
            selectedReport: ko.pureComputed(function () {
                return _this.viewModel.ID() >= 0;
            }),
            createNewFolder: function () {
                if (_this.viewModel.newFolder()) {
                    _this.createTreeviewFolder(_this.viewModel.newFolder());
                    _this.viewModel.newFolder("");
                }
            },
            createNewReport: function () {
                _this.treeView.select($());
                _this.viewModel.IsNameUnique(true);
                _this.bindReportToViewModel({ ID: 0, Name: "", FolderName: "", FileKey: "", FileName: "", EmailSubjectTemplate: "", IsActive: true });
            },
            saveReport: function () {
                if (_this.viewModel.isValid()) {
                    var waitIndicator_1 = UI.showWaitIndicator(_this.container);
                    ReportData.SaveReport(ko.toJS(_this.viewModel))
                        .done(function (saveResponse) {
                        if (saveResponse.Success) {
                            _this.viewModel.IsNameUnique(true);
                            if (_this.uploadControl.getFiles().length > 0) {
                                _this.uploadControl.upload();
                            }
                            else {
                                _this.loadReports(_this.viewModel.Name());
                            }
                        }
                        else {
                            UI.showErrorMessage(saveResponse.ErrorMessages);
                        }
                    })
                        .always(function () {
                        UI.hideWaitIndicator(_this.container, waitIndicator_1);
                    });
                }
            },
            downloadReport: function () {
                _this.container.find("form[name='downloadReportForm']").submit();
            },
            deleteReport: function () {
                UI.showConfirmDialog("Are you sure you want to delete this report?", function () {
                    var waitIndicator = UI.showWaitIndicator(_this.container);
                    _this.viewModel.IsActive(false);
                    ReportData.SaveReport(ko.toJS(_this.viewModel))
                        .done(function (response) {
                        _this.loadReports();
                    }).always(function () {
                        UI.hideWaitIndicator(_this.container, waitIndicator);
                    });
                });
            },
            isValid: function () {
                var reportNames = _this.viewModel.reports().filter(function (x) { return x.ID !== _this.viewModel.ID(); }).map(function (x) { return x.Name.toLowerCase(); });
                if (reportNames.indexOf(_this.viewModel.Name().toLowerCase()) > -1) {
                    _this.viewModel.IsNameUnique(false);
                    UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
                    return false;
                }
                if (_this.viewModel.errors && _this.viewModel.errors().length > 0) {
                    _this.viewModel.errors.showAllMessages();
                    UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
                    return false;
                }
                return true;
            },
        };
        this.viewModel.errors = ko.validation.group(this.viewModel, { deep: true });
    }
    ManageReportsController.prototype.render = function (container) {
        var _this = this;
        var deferred = $.Deferred();
        var app = Global.app();
        var me = this;
        this.container = container;
        ko.applyBindings(this.viewModel, container[0]);
        this.uploadControl = this.container.find(".uploadFiles").kendoUpload({
            async: {
                saveUrl: "save",
                autoUpload: false,
            },
            validation: {
                allowedExtensions: [".trdp"],
            },
            upload: function (e) {
                if (e.sender.options.async) {
                    e.sender.options.async.saveUrl = app.webServiceBaseURL + "/api/Report/Upload/" + _this.viewModel.ID();
                }
            },
            complete: function (e) {
                _this.loadReports(_this.viewModel.Name());
            },
            multiple: false,
        }).data("kendoUpload");
        me.treeView = $(me.container).find(".reportsTree").kendoTreeView({
            change: function (e) {
                var dataItem = me.treeView.dataItem(me.treeView.select());
                if (dataItem && dataItem.report) {
                    me.bindReportToViewModel(dataItem.report);
                }
                else {
                    me.bindReportToViewModel(null);
                }
            },
            select: function (e) {
                if (me.haveFieldsChanged()) {
                    if (!confirm(Constants.PHRASE_ITEMUNSAVEDCHANGES)) {
                        e.preventDefault();
                        return;
                    }
                }
            },
        }).data("kendoTreeView");
        $(".reportsTree").on("click", ".k-in", function (e) {
            me.treeView.toggle($(e.target).closest(".k-item"));
        });
        deferred.resolve();
        return deferred.promise();
    };
    ManageReportsController.prototype.load = function (params) {
        var deferred = $.Deferred();
        this.loadReports("", deferred);
        return deferred.promise();
    };
    ManageReportsController.prototype.appRouterID = function (params) {
        return "Manage Reports";
    };
    ManageReportsController.prototype.title = function () {
        return "Manage Reports";
    };
    ManageReportsController.prototype.subTitle = function () {
        return "";
    };
    ManageReportsController.prototype.haveFieldsChanged = function () {
        var fieldValues = ko.toJSON(this.viewModel);
        return (this.viewModel.ID() !== -1 && fieldValues !== this.fieldsOnLoad)
            || this.uploadControl.getFiles().length > 0;
    };
    ManageReportsController.prototype.loadReports = function (selectedItemText, deferred) {
        var _this = this;
        var waitContainer = UI.showWaitIndicator(this.container);
        this.bindReportToViewModel(null);
        ReportData.GetAllReports()
            .done(function (response) {
            var activeReports = response.Payload.filter(function (report) {
                return (report.IsActive === true);
            });
            _this.viewModel.reports(activeReports);
            _this.treeDataSource = ReportData.CreateReportTreeDataSource(activeReports);
            _this.treeView.setDataSource(_this.treeDataSource);
            _this.updateFolderList();
            if (selectedItemText) {
                _this.treeView.select(_this.treeView.findByText(selectedItemText));
            }
            if (deferred) {
                deferred.resolve();
            }
        }).always(function () {
            UI.hideWaitIndicator(_this.container, waitContainer);
        });
    };
    ManageReportsController.prototype.createTreeviewFolder = function (folderName) {
        for (var _i = 0, _a = this.treeDataSource; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.text === folderName) {
                return;
            }
        }
        this.treeDataSource.push({
            text: folderName,
            items: [],
        });
        this.treeView.setDataSource(this.treeDataSource);
        this.updateFolderList();
    };
    ManageReportsController.prototype.updateFolderList = function () {
        var folders = [""];
        for (var _i = 0, _a = this.treeDataSource; _i < _a.length; _i++) {
            var treeItem = _a[_i];
            if (!treeItem.report) {
                folders.push(treeItem.text);
            }
        }
        this.viewModel.reportFolders(folders);
    };
    ManageReportsController.prototype.bindReportToViewModel = function (report) {
        var app = Global.app();
        this.uploadControl.clearAllFiles();
        if (report && report.ID > 0) {
            this.uploadControl.enable();
        }
        else {
            this.uploadControl.disable();
        }
        if (report === null) {
            this.viewModel.ID(-1);
            this.viewModel.Name("");
            this.viewModel.FolderName("");
            this.viewModel.FileName("");
            this.viewModel.FileKey(null);
            this.viewModel.EmailSubjectTemplate("");
            this.viewModel.reportDownloadUrl("");
        }
        else {
            this.viewModel.ID(report.ID);
            this.viewModel.Name(report.Name);
            this.viewModel.FolderName(report.FolderName);
            this.viewModel.FileName(report.FileName);
            this.viewModel.FileKey(report.FileKey);
            this.viewModel.EmailSubjectTemplate(report.EmailSubjectTemplate);
            this.viewModel.reportDownloadUrl(app.webServiceBaseURL + "/api/report/download/" + this.viewModel.ID());
        }
        this.fieldsOnLoad = ko.toJSON(this.viewModel);
        this.viewModel.Name.isModified(false);
    };
    return ManageReportsController;
}());
exports.ManageReportsController = ManageReportsController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var OAuthLoginController = (function () {
    function OAuthLoginController() {
    }
    OAuthLoginController.prototype.render = function (container) {
        var deferred = $.Deferred();
        deferred.resolve();
        return deferred.promise();
    };
    OAuthLoginController.prototype.load = function (params) {
        var deferred = $.Deferred();
        deferred.resolve();
        return deferred.promise();
    };
    OAuthLoginController.prototype.haveFieldsChanged = function () {
        return false;
    };
    OAuthLoginController.prototype.appRouterID = function (params) {
        return "OAuthLogin";
    };
    OAuthLoginController.prototype.title = function () {
        return "External Login";
    };
    OAuthLoginController.prototype.subTitle = function () {
        return "";
    };
    OAuthLoginController.prototype.AllowAnonymousAccess = function () {
        return true;
    };
    return OAuthLoginController;
}());
exports.OAuthLoginController = OAuthLoginController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var Util = __webpack_require__(8);
var AuthenticationData = __webpack_require__(32);
var ResetPasswordController = (function () {
    function ResetPasswordController() {
        this.viewModel = {};
        var me = this;
        var app = Global.app();
        this.viewModel = {
            FirstName: ko.observable(""),
            Email: ko.observable(""),
            Password: ko.observable(""),
            PasswordConfirm: ko.observable(""),
            MinimumPasswordLength: ko.observable(0),
            PasswordComplexityRequirements: ko.observable(""),
            LoginHelp: ko.observable(""),
            CheckingKey: ko.observable(false),
            DataLoaded: ko.observable(false),
            ResetCodeInvalid: ko.observable(false),
            ResetComplete: ko.observable(false),
            IsExpired: ko.observable(false),
            IsReset: ko.observable(false),
            PasswordMissing: ko.observable(false),
            PasswordsDoNotMatch: ko.observable(false),
            PasswordInvalid: ko.observable(false),
            PasswordInvalidLength: ko.observable(false),
            PasswordInvalidReason: ko.observable(""),
            onResetPassword: function () {
                me.resetPassword();
            },
            onGotoDefaultPage: function () {
                app.pageManager().closeAllAndGotoDefaultPage();
            },
            onGotoForgotPasswordPage: function () {
                app.pageManager().closeAndNavigate("/ForgotPassword");
            },
        };
        this.viewModel.isPasswordValid = ko.pureComputed(function () {
            var password = me.viewModel.Password();
            var isValid = false;
            if (password.length >= me.viewModel.MinimumPasswordLength()) {
                isValid = true;
            }
            return isValid;
        });
        this.viewModel.isPasswordConfirmValid = ko.pureComputed(function () {
            var passwordConfirm = me.viewModel.PasswordConfirm();
            var isValid = false;
            if (passwordConfirm.length >= me.viewModel.MinimumPasswordLength() &&
                passwordConfirm === me.viewModel.Password()) {
                isValid = true;
            }
            return isValid;
        });
        this.viewModel.hasLoginHelp = ko.pureComputed(function () {
            return !Util.isNullOrEmpty(me.viewModel.LoginHelp());
        });
    }
    ResetPasswordController.prototype.render = function (container) {
        var me = this;
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, container[0]);
        this.container.find("input[data-id='passwordField']").keypress(function (e) {
            if (e.which === 13) {
                $(e.target).blur();
                me.resetPassword();
            }
        });
        this.setFocusToFirstField();
        deferred.resolve();
        return deferred.promise();
    };
    ResetPasswordController.prototype.load = function (params) {
        var me = this;
        var deferred = $.Deferred();
        var validateKeyRequest;
        if (params.length === 1) {
            this.viewModel.IsReset(true);
            this.token = params[0];
        }
        else if (params.length === 2) {
            switch (params[0]) {
                case "Expired":
                    this.viewModel.IsExpired(true);
                    break;
                case "Reset":
                    this.viewModel.IsReset(true);
                    break;
                default:
                    deferred.reject();
                    return deferred.promise();
            }
            this.token = params[1];
        }
        else {
            deferred.reject();
            return deferred.promise();
        }
        validateKeyRequest = {
            Token: this.token,
        };
        me.viewModel.CheckingKey(true);
        me.viewModel.DataLoaded(false);
        me.viewModel.ResetCodeInvalid(false);
        if (Util.isNullOrEmpty(this.token)) {
            me.viewModel.ResetCodeInvalid(true);
            me.viewModel.CheckingKey(false);
            deferred.resolve();
        }
        else {
            AuthenticationData.ValidateResetPasswordKey(validateKeyRequest)
                .done(function (response) {
                if (response.Success && response.Payload.IsValid) {
                    me.updateViewModel(response.Payload);
                }
                else {
                    me.viewModel.ResetCodeInvalid(true);
                }
                deferred.resolve();
            })
                .fail(function () {
                me.viewModel.ResetCodeInvalid(true);
                deferred.resolve();
            })
                .always(function () {
                me.viewModel.CheckingKey(false);
            });
        }
        return deferred.promise();
    };
    ResetPasswordController.prototype.haveFieldsChanged = function () {
        return false;
    };
    ResetPasswordController.prototype.appRouterID = function (params) {
        return "ResetPassword";
    };
    ResetPasswordController.prototype.title = function () {
        return "Change Password";
    };
    ResetPasswordController.prototype.subTitle = function () {
        return "";
    };
    ResetPasswordController.prototype.AllowAnonymousAccess = function () {
        return true;
    };
    ResetPasswordController.prototype.updateViewModel = function (response) {
        this.viewModel.FirstName(response.FirstName);
        this.viewModel.Email(response.Email);
        this.viewModel.MinimumPasswordLength(response.MinimumPasswordLength);
        this.viewModel.PasswordComplexityRequirements(response.PasswordComplexityRequirements);
        this.viewModel.Password("");
        this.viewModel.PasswordConfirm("");
        this.viewModel.PasswordMissing(false);
        this.viewModel.PasswordsDoNotMatch(false);
        this.viewModel.PasswordInvalidLength(false);
        this.viewModel.DataLoaded(true);
        this.viewModel.ResetComplete(false);
        this.viewModel.ResetCodeInvalid(false);
    };
    ResetPasswordController.prototype.validatePassword = function () {
        var isValid = true;
        var password = this.viewModel.Password();
        isValid = UI.setRequiredStringError(password, "PasswordMissing", this.viewModel) ? isValid : false;
        if (isValid) {
            if (this.viewModel.Password() !== this.viewModel.PasswordConfirm()) {
                isValid = false;
                this.viewModel.PasswordsDoNotMatch(true);
            }
            else {
                this.viewModel.PasswordsDoNotMatch(false);
                if (password.length < this.viewModel.MinimumPasswordLength()) {
                    isValid = false;
                    this.viewModel.PasswordInvalidLength(true);
                }
                else {
                    this.viewModel.PasswordInvalidLength(false);
                }
            }
        }
        return isValid;
    };
    ResetPasswordController.prototype.resetPassword = function () {
        var me = this;
        var request;
        var waitContainer;
        if (this.validatePassword()) {
            waitContainer = UI.showWaitIndicator(this.container);
            request = {
                Password: this.viewModel.Password(),
                Token: this.token,
            };
            AuthenticationData.ResetPassword(request)
                .done(function (response) {
                var app = Global.app();
                if (response.Success) {
                    if (response.Payload.Success) {
                        app.loginUser(response.Payload.AuthenticationToken, response.Payload.UserSession, response.Payload.ReportToken);
                        me.viewModel.ResetComplete(true);
                    }
                    else {
                        me.viewModel.PasswordInvalid(response.Payload.PasswordInvalid);
                        me.viewModel.PasswordInvalidReason(response.Payload.PasswordInvalidReason);
                        me.setFocusToFirstField();
                    }
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                }
            })
                .always(function () {
                UI.hideWaitIndicator(me.container, waitContainer);
            });
        }
        else {
            this.setFocusToFirstField();
        }
    };
    ResetPasswordController.prototype.setFocusToFirstField = function () {
        this.container.find("input[data-id='passwordField']").first().focus();
    };
    return ResetPasswordController;
}());
exports.ResetPasswordController = ResetPasswordController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var util_1 = __webpack_require__(8);
var Util = __webpack_require__(8);
var AuthenticationData = __webpack_require__(32);
var SAMLLoginController = (function () {
    function SAMLLoginController() {
    }
    SAMLLoginController.prototype.render = function (container) {
        var deferred = $.Deferred();
        deferred.resolve();
        return deferred.promise();
    };
    SAMLLoginController.prototype.load = function (params) {
        var _this = this;
        var deferred = $.Deferred();
        var app = Global.app();
        var pageManager = app.pageManager();
        if (!params || params.length === 0) {
            pageManager.closeAllAndGotoDefaultPage();
            deferred.resolve();
            return deferred.promise();
        }
        var authenticationToken = params[0];
        AuthenticationData.AuthenticateUserWithExternalToken({ Token: authenticationToken })
            .done(function (response) {
            if (response.Success && response.Payload.IsAuthenticated) {
                app.loginUser(response.Payload.AuthenticationToken, response.Payload.UserSession, response.Payload.ReportToken);
                var queryStrings = util_1.getURLParameters();
                if (queryStrings.length > 0) {
                    var query = _this.buildUrlEndPoint(queryStrings);
                    _this.useQueryAndNavigate(query);
                }
            }
            else {
                pageManager.closeAllAndGotoDefaultPage();
            }
        }).fail(function () {
            pageManager.closeAllAndGotoDefaultPage();
        });
        deferred.resolve();
        return deferred.promise();
    };
    SAMLLoginController.prototype.haveFieldsChanged = function () {
        return false;
    };
    SAMLLoginController.prototype.appRouterID = function (params) {
        return "SAMLLogin";
    };
    SAMLLoginController.prototype.title = function () {
        return "External Login";
    };
    SAMLLoginController.prototype.subTitle = function () {
        return "";
    };
    SAMLLoginController.prototype.AllowAnonymousAccess = function () {
        return true;
    };
    SAMLLoginController.prototype.buildUrlEndPoint = function (queryStrings) {
        var query = "";
        var pageToShow = queryStrings.filter(function (kvp) { return kvp.Key === Constants.QUERYSTRING_PAGE_TO_SHOW; });
        if (pageToShow.length > 0) {
            query += pageToShow[0].Value;
            if (queryStrings.length > 1) {
                for (var _i = 0, queryStrings_1 = queryStrings; _i < queryStrings_1.length; _i++) {
                    var queryString = queryStrings_1[_i];
                    if (queryString !== pageToShow[0]) {
                        if (query.indexOf("?") < 0) {
                            query += "?" + queryString.Key + "=" + queryString.Value;
                        }
                        else {
                            query += "&" + queryString.Key + "=" + queryString.Value;
                        }
                    }
                }
            }
        }
        return query;
    };
    SAMLLoginController.prototype.useQueryAndNavigate = function (query) {
        var pageManager = Global.app().pageManager();
        if (Util.isNullOrEmpty(query)) {
            pageManager.closeAllAndGotoDefaultPage();
        }
        else {
            pageManager.closeAllAndNavigate(query);
        }
    };
    return SAMLLoginController;
}());
exports.SAMLLoginController = SAMLLoginController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var RegistrationData = __webpack_require__(840);
var UserData = __webpack_require__(91);
var SelfRegistrationController = (function () {
    function SelfRegistrationController() {
        this.EST_TIME_ZONE_ID = 234;
        this.fieldsOnLoad = {};
        this.registrationCriteria = "";
        var me = this;
        var app = Global.app();
        this.viewModel = {
            RegistrationCode: ko.observable(""),
            RegistrationCodeMissing: ko.observable(false),
            IsRegistrationCodeValid: ko.observable(false),
            UserName: ko.observable("").extend({ required: true }),
            Email: ko.observable(""),
            FirstName: ko.observable("").extend({ required: true }),
            LastName: ko.observable("").extend({ required: true }),
            Password: ko.observable(""),
            ConfirmPassword: ko.observable(""),
            IsEditing: ko.observable(false),
            IsActive: ko.observable(true),
            TimeZoneID: ko.observable(0),
            Roles: ko.observableArray(),
            ShowPassword: ko.observable(false),
            IsRegistrationComplete: ko.observable(false),
            TimeZones: ko.observableArray(),
            MinimumPasswordLength: ko.observable(0),
            PasswordComplexityRequirements: ko.observable(""),
            ResetPasswordOnNextLogin: ko.observable(true),
            passwordVisible: function (user) {
                user.ShowPassword(!user.ShowPassword());
            },
            onIsRegistrationCodeValidForWorkForce: function () {
                me.registrationCriteria = RegistrationData.WEST_VIRGINIA_CRITERIA_IN_WORK_FORCE;
                me.isRegistrationCodeValid(me.registrationCriteria);
            },
            onIsRegistrationCodeValidForOasis: function () {
                me.registrationCriteria = RegistrationData.WEST_VIRGINIA_CRITERIA_IN_OASIS;
                me.isRegistrationCodeValid(me.registrationCriteria);
            },
            onCancel: function () {
                app.pageManager().closeCurrentPage();
            },
            onSubmit: function () {
                me.submitForm();
            },
            onContinue: function () {
                app.pageManager().closeCurrentPage();
            },
        };
        this.viewModel.Password = ko.observable("").extend({
            required: {
                message: "Please enter a password",
                params: true,
                onlyIf: me.viewModel.ShowPassword,
            },
        });
        this.viewModel.ConfirmPassword = ko.observable("").extend({
            required: {
                message: "Please confirm password",
                params: true,
                onlyIf: me.viewModel.ShowPassword,
            },
        });
    }
    SelfRegistrationController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, container[0]);
        this.loadPasswordRequirements();
        this.getTimeZones();
        deferred.resolve();
        return deferred.promise();
    };
    SelfRegistrationController.prototype.load = function (params) {
        var deferred = $.Deferred();
        var app = Global.app();
        if (app.isLoggedIn) {
            app.pageManager().closeAllAndGotoDefaultPage();
        }
        deferred.resolve();
        return deferred.promise();
    };
    SelfRegistrationController.prototype.appRouterID = function (params) {
        return "SelfRegistration";
    };
    SelfRegistrationController.prototype.title = function () {
        return "Self Registration";
    };
    SelfRegistrationController.prototype.subTitle = function () {
        return "";
    };
    SelfRegistrationController.prototype.AllowAnonymousAccess = function () {
        return true;
    };
    SelfRegistrationController.prototype.haveFieldsChanged = function () {
        var fieldValues = ko.toJSON(this.viewModel);
        return fieldValues !== this.fieldsOnLoad;
    };
    SelfRegistrationController.prototype.isRegistrationCodeValid = function (registrationCriteria) {
        var me = this;
        var targetContainer = this.container.find("div[data-id='reg_code']");
        var waitContainer = UI.showWaitIndicator(targetContainer);
        var request = {
            RegistrationCode: this.viewModel.RegistrationCode(),
            RegistrationCriteria: registrationCriteria,
        };
        if (!this.isRegistrationCodeEntered()) {
            me.setFocusToRegistrationCodeField();
            UI.hideWaitIndicator(targetContainer, waitContainer);
            return;
        }
        RegistrationData.ValidateRegistrationCode(request)
            .done(function (response) {
            if (response.Success) {
                me.viewModel.IsRegistrationCodeValid(response.Payload.IsValid);
                if (!me.viewModel.IsRegistrationCodeValid()) {
                    UI.showErrorMessage([response.Payload.ValidationMessage]);
                }
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(targetContainer, waitContainer);
        });
    };
    SelfRegistrationController.prototype.submitForm = function () {
        var _this = this;
        var deferred = $.Deferred();
        if (this.isValid()) {
            var targetContainer_1 = this.container.find("form[data-id='reg_form']");
            var waitContainer_1 = UI.showWaitIndicator(targetContainer_1);
            var request = {
                RegistrationCode: this.viewModel.RegistrationCode(),
                RegistrationCriteria: this.registrationCriteria,
                UserName: this.viewModel.UserName(),
                Password: this.viewModel.Password(),
                ConfirmPassword: this.viewModel.ConfirmPassword(),
                Email: this.viewModel.Email(),
                FirstName: this.viewModel.FirstName(),
                LastName: this.viewModel.LastName(),
                TimeZoneID: this.EST_TIME_ZONE_ID,
            };
            RegistrationData.CreateUser(request)
                .done(function (response) {
                if (response.Success) {
                    deferred.resolve();
                    targetContainer_1.hide("fast");
                    _this.viewModel.IsRegistrationComplete(true);
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                    deferred.reject();
                }
            })
                .always(function () {
                UI.hideWaitIndicator(targetContainer_1, waitContainer_1);
            });
        }
        else {
            deferred.reject();
        }
        return deferred.promise();
    };
    SelfRegistrationController.prototype.isRegistrationCodeEntered = function () {
        return UI.setRequiredStringError(this.viewModel.RegistrationCode(), "RegistrationCodeMissing", this.viewModel);
    };
    SelfRegistrationController.prototype.isValid = function () {
        var view = this.viewModel;
        if (view.Password() !== view.ConfirmPassword()) {
            UI.showErrorMessage(["Passwords do not match"]);
            return false;
        }
        return true;
    };
    SelfRegistrationController.prototype.setFocusToRegistrationCodeField = function () {
        this.container.find("input[data-id='reg_code']").first().focus();
    };
    SelfRegistrationController.prototype.getTimeZones = function () {
        var me = this;
        var timezones = Global.app().global.TimeZones;
        me.viewModel.TimeZones.push.apply(me.viewModel.TimeZones, timezones);
    };
    SelfRegistrationController.prototype.loadPasswordRequirements = function () {
        var me = this;
        UserData.GetPasswordRequirements()
            .done(function (response) {
            if (response.Success) {
                me.viewModel.MinimumPasswordLength(response.Payload.MinimumPasswordLength);
                me.viewModel.PasswordComplexityRequirements(response.Payload.PasswordComplexityRequirements);
            }
        });
    };
    return SelfRegistrationController;
}());
exports.SelfRegistrationController = SelfRegistrationController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function GetMaster(id) {
    return Util.callWebService("/api/Template/" + id, "GET");
}
exports.GetMaster = GetMaster;
function Save(template) {
    return Util.callWebService("/api/Template/Save", "POST", template);
}
exports.Save = Save;
function SetIsActive(request) {
    return Util.callWebService("/api/Template/SetIsActive", "POST", request);
}
exports.SetIsActive = SetIsActive;
function CopyTemplate(ID) {
    return Util.callWebService("/api/Template/CopyTemplate", "POST", {
        ID: ID,
    });
}
exports.CopyTemplate = CopyTemplate;
exports.NAVIGATIONTYPE_FORM = 1;
exports.NAVIGATIONTYPE_LIST = 2;
exports.NAVIGATIONTYPE_REPORT = 3;


/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
exports.WEST_VIRGINIA_CRITERIA_IN_WORK_FORCE = "WORKFORCE";
exports.WEST_VIRGINIA_CRITERIA_IN_OASIS = "OASIS";
exports.WEST_VIRGINIA_CRITERIA_NONE = "NONE";
function ValidateRegistrationCode(request) {
    return Util.callWebService("/api/UserRegistration/ValidateRegistrationCode", "POST", request);
}
exports.ValidateRegistrationCode = ValidateRegistrationCode;
function CreateUser(request) {
    return Util.callWebService("/api/UserRegistration/CreateUserSelfRegistration", "POST", request);
}
exports.CreateUser = CreateUser;


/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var EventUtil = __webpack_require__(26);
var Global = __webpack_require__(2);
var targetEdit_1 = __webpack_require__(369);
var TargetController = (function () {
    function TargetController() {
        this.targetEditControl = new targetEdit_1.TargetEditControl();
    }
    TargetController.prototype.render = function (container) {
        return this.targetEditControl.render(container.find("div[data-id='targetEditControl']"));
    };
    TargetController.prototype.load = function (params) {
        if (params == null || params.length < 1 || params.length > 2) {
            Global.app().pageManager().closeCurrentPage();
            var deferred = $.Deferred();
            deferred.resolve();
            return deferred.promise();
        }
        this.targetTemplateURLName = params[0];
        var targetID = null;
        if (params.length === 2) {
            targetID = params[1];
            this.isNewTarget = false;
        }
        else {
            this.isNewTarget = true;
        }
        return this.targetEditControl.load(this.targetTemplateURLName, targetID);
    };
    TargetController.prototype.haveFieldsChanged = function () {
        return this.targetEditControl.haveFieldsChanged();
    };
    TargetController.prototype.appRouterID = function (params) {
        var routerID = "Target";
        if (params.length > 0) {
            routerID += "-" + params[0];
        }
        if (params.length > 1) {
            routerID += "-" + params[1];
        }
        else {
            routerID += "-NEW";
        }
        return routerID;
    };
    TargetController.prototype.title = function () {
        return "Target";
    };
    TargetController.prototype.subTitle = function () {
        return this.targetEditControl.subTitle();
    };
    TargetController.prototype.save = function () {
        var me = this;
        var deferred = $.Deferred();
        this.targetEditControl.save()
            .done(function (targetMaster) {
            if (me.isNewTarget) {
                me.updateURL(targetMaster.ID);
            }
            else {
                Global.app().pageManager().refreshCurrentPageTitle();
            }
            deferred.resolve();
        })
            .fail(function () {
            deferred.reject();
        });
        return deferred.promise();
    };
    TargetController.prototype.updateURL = function (newID) {
        var routeChange = {
            appRouterID: this.appRouterID([this.targetTemplateURLName]),
            url: "/Target/" + this.targetTemplateURLName + "/" + newID,
            title: this.title(),
            subTitle: this.subTitle(),
            newAppRouterID: this.appRouterID([this.targetTemplateURLName, newID]),
        };
        Global.app().events().trigger(EventUtil.EVENT_ROUTECHANGE, routeChange);
    };
    return TargetController;
}());
exports.TargetController = TargetController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(80);
var ko = __webpack_require__(4);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var TargetData = __webpack_require__(45);
var TargetImportController = (function () {
    function TargetImportController() {
        this.fieldsOnLoad = {};
        var me = this;
        me.viewModel = {
            CurrentStep: ko.observable(1),
            TargetTemplateID: ko.observable(),
            TargetTemplateName: ko.observable(),
            TargetTemplateURLName: ko.observable(),
            FormItems: ko.observable(),
            UploadedFileKey: ko.observable(),
            TemplateDownloadUrl: ko.observable(),
            VerificationResults: ko.observable(),
            ImportCompleted: ko.observable(false),
            NumberOfTargetsImported: ko.observable(0),
            VerifyUploadedFile: me.verifyUpload.bind(me),
            BackToStep1: me.backToStep1.bind(me),
            ImportRecords: me.importRecords.bind(me),
            Finished: me.finished.bind(me),
        };
    }
    TargetImportController.prototype.render = function (container) {
        var _this = this;
        var me = this;
        var deferred = $.Deferred();
        var app = Global.app();
        me.container = container;
        ko.applyBindings(this.viewModel, container[0]);
        me.uploadControl = this.container.find(".uploadFiles").kendoUpload({
            async: {
                saveUrl: "save",
                autoUpload: true,
            },
            validation: {
                allowedExtensions: [".csv", ".xls", ".xlsx"],
            },
            upload: function (e) {
                me.viewModel.UploadedFileKey(null);
                if (e.sender.options.async) {
                    e.sender.options.async.saveUrl = app.webServiceBaseURL + "/api/Targets/Import/" + _this.viewModel.TargetTemplateID();
                }
            },
            success: function (e) {
                if (e.operation === "upload" && e.response) {
                    me.viewModel.UploadedFileKey(e.response);
                }
            },
            multiple: false,
        }).data("kendoUpload");
        deferred.resolve();
        return deferred.promise();
    };
    TargetImportController.prototype.load = function (params) {
        var _this = this;
        var app = Global.app();
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        if (params == null || params.length !== 1) {
            app.pageManager().closeCurrentPage();
            deferred.resolve();
            return deferred.promise();
        }
        var targetTemplateURLName = params[0];
        TargetData.GetImportConfiguration(targetTemplateURLName)
            .done(function (response) {
            if (response.Success) {
                _this.viewModel.TargetTemplateID(response.Payload.TargetTemplateID);
                _this.viewModel.TargetTemplateName(response.Payload.TargetTemplateName);
                _this.viewModel.TargetTemplateURLName(response.Payload.TargetTemplateURLName);
                _this.viewModel.TemplateDownloadUrl(app.webServiceBaseURL + "/api/Targets/DownloadImportTemplate/" + response.Payload.TargetTemplateID);
                _this.viewModel.FormItems(response.Payload.FormItems);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            me.fieldsOnLoad = ko.toJSON(_this.viewModel);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TargetImportController.prototype.haveFieldsChanged = function () {
        var fieldValues = ko.toJSON(this.viewModel);
        return fieldValues !== this.fieldsOnLoad;
    };
    TargetImportController.prototype.appRouterID = function (params) {
        var targetName = "UNKNOWN";
        if (params.length > 0) {
            targetName = params[0];
        }
        return "TargetsImport" + targetName;
    };
    TargetImportController.prototype.title = function () {
        return "Import Targets";
    };
    TargetImportController.prototype.subTitle = function () {
        if (this.viewModel) {
            return this.viewModel.TargetTemplateName();
        }
        return "";
    };
    TargetImportController.prototype.verifyUpload = function () {
        var me = this;
        me.viewModel.CurrentStep(2);
        var waitContainer = UI.showWaitIndicator(this.container);
        TargetData.ValidateTargetImportFile(me.viewModel.TargetTemplateID(), me.viewModel.UploadedFileKey())
            .done(function (response) {
            if (response.Success) {
                me.viewModel.VerificationResults(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
    };
    TargetImportController.prototype.backToStep1 = function () {
        var me = this;
        me.viewModel.UploadedFileKey("");
        me.viewModel.VerificationResults(null);
        me.uploadControl.clearAllFiles();
        me.viewModel.CurrentStep(1);
    };
    TargetImportController.prototype.importRecords = function () {
        var me = this;
        UI.showConfirmDialog("Are you sure you want to import these targets?", function () {
            me.viewModel.CurrentStep(3);
            TargetData.ProcessImport(me.viewModel.TargetTemplateID(), me.viewModel.UploadedFileKey())
                .done(function (response) {
                if (response.Success) {
                    me.viewModel.ImportCompleted(true);
                    me.viewModel.NumberOfTargetsImported(response.Payload);
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                }
            });
        });
    };
    TargetImportController.prototype.finished = function () {
        Global.app().pageManager().closeAndNavigate("/Targets/" + this.viewModel.TargetTemplateURLName());
    };
    return TargetImportController;
}());
exports.TargetImportController = TargetImportController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var data_1 = __webpack_require__(23);
var Global = __webpack_require__(2);
var GridUtil = __webpack_require__(27);
var UI = __webpack_require__(3);
var TargetData = __webpack_require__(45);
var TargetsController = (function () {
    function TargetsController() {
        this.targetTemplateURLName = "";
        this.targetName = "";
    }
    TargetsController.prototype.render = function (container) {
        var me = this;
        var deferred = $.Deferred();
        me.container = container;
        me.gridContainer = container.find("div[data-id='grid']");
        deferred.resolve();
        return deferred.promise();
    };
    TargetsController.prototype.load = function (params) {
        var app = Global.app();
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        if (params == null || params.length !== 1) {
            app.pageManager().closeCurrentPage();
            deferred.resolve();
            return deferred.promise();
        }
        this.targetTemplateURLName = params[0];
        TargetData.GetTargetsConfig(this.targetTemplateURLName)
            .done(function (response) {
            if (response.Success) {
                me.targetName = response.Payload.TargetName;
                me.createGridControl(response.Payload.ResultScheme);
                me.createGridFilterControl();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TargetsController.prototype.add = function () {
        Global.app().router().navigate("/Target/" + this.targetTemplateURLName, true);
    };
    TargetsController.prototype.haveFieldsChanged = function () {
        return false;
    };
    TargetsController.prototype.height = function (height) {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    };
    TargetsController.prototype.refresh = function () {
        this.grid.dataSource.read();
    };
    TargetsController.prototype.appRouterID = function (params) {
        var targetName = "UNKNOWN";
        if (params.length > 0) {
            targetName = params[0];
        }
        return "Targets" + targetName;
    };
    TargetsController.prototype.title = function () {
        return "Targets";
    };
    TargetsController.prototype.subTitle = function () {
        return this.targetName;
    };
    TargetsController.prototype.setDataFilter = function (data) {
        data.TargetTemplateURLName = this.targetTemplateURLName;
        data.IncludeActive = true;
        data.IncludeInactive = false;
        if (this.gridFilterControl != null) {
            this.gridFilterControl.setDataFilter(data);
        }
    };
    TargetsController.prototype.createGridControl = function (resultScheme) {
        var me = this;
        var app = Global.app();
        _.forEach(resultScheme.Columns, function (column) {
            if (column.IsLinkToDetail) {
                column.TemplateHTML = $("#template_targets_targetname").html()
                    .replace(/FIELDNAME/g, column.Field)
                    .replace(/TARGETURL/g, me.targetTemplateURLName);
            }
        });
        this.dataSource = data_1.createWebServiceDataSource("/api/Targets", GridUtil.createDataSourceModel(resultScheme), function (data) {
            me.setDataFilter(data);
        }, function (status) {
            if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                app.pageManager().closeCurrentPage();
            }
        });
        this.grid = this.gridContainer.kendoGrid({
            dataSource: this.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: GridUtil.createColumnsModel(resultScheme),
            excel: {
                fileName: me.targetTemplateURLName + ".xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");
        me.gridContainer.on("click", "a[data-id='link']", function (e) {
            var path = $(this).attr("href");
            e.preventDefault();
            app.router().navigate(_.defaultTo(path, ""), true);
            return false;
        });
    };
    TargetsController.prototype.importTargets = function () {
        Global.app().router().navigate("/TargetImport/" + this.targetTemplateURLName, true);
    };
    TargetsController.prototype.createGridFilterControl = function () {
        var me = this;
        me.gridFilterControl = new GridUtil.GridFilterControl(me.container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showExportToExcel: true,
            showFilters: true,
            showRefresh: true,
            filters: [
                { name: Constants.PHRASE_FILTER_SHOWACTIVE, checked: true },
                { name: Constants.PHRASE_FILTER_SHOWINACTIVE, checked: false },
            ],
            grid: me.grid,
            buttons: [{ name: "Import Targets", iconClass: "fa fa-upload", onClick: this.importTargets.bind(me) }],
        });
    };
    return TargetsController;
}());
exports.TargetsController = TargetsController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Constants = __webpack_require__(5);
var EventUtil = __webpack_require__(26);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var TargetTemplateData = __webpack_require__(845);
var TargetTemplateController = (function () {
    function TargetTemplateController() {
        this.fieldsOnLoad = {};
        var me = this;
        this.viewModel = {
            TargetTemplate: {
                ID: ko.observable(0),
                TemplateName: ko.observable(),
                TargetTemplateTypeID: ko.observable(),
                AddressFormItems: ko.observableArray(),
                IsTemplateNameMissing: ko.observable(false),
                IsTargetTemplateTypeIDMissing: ko.observable(false),
            },
            ActiveFormItems: ko.observableArray(),
            InactiveFormItems: ko.observableArray(),
            ShowCustomFields: ko.observable(false),
            TargetTemplateTypes: ko.observableArray(),
            ControlTypes: ko.observableArray(),
            IsActive: ko.observable(true),
            QuestionLabel: Constants.LABEL_QUESTION,
            TemplatePhrases: ko.observableArray(),
            toggleIsActive: function () {
                var message;
                if (this.IsActive()) {
                    message = "Are you sure you want to make this template inactive?";
                }
                else {
                    message = "Are you sure you want to make this template active?";
                }
                UI.showConfirmDialog(message, function () {
                    me.toggleIsActive();
                });
            },
            getSelectTargetTemplateType: function () {
                var targetTemplateTypeID = this.TargetTemplate.TargetTemplateTypeID();
                var match;
                if (targetTemplateTypeID != null && targetTemplateTypeID > 0) {
                    var matches = this.TargetTemplateTypes().filter(function (targetTemplateType) {
                        return targetTemplateType.ID === targetTemplateTypeID;
                    });
                    if (matches.length > 0) {
                        match = matches[0];
                    }
                }
                return match;
            },
            onAddField: function () {
                me.viewModel.ActiveFormItems.push(me.createEmptyFormItemObservable());
            },
            onToggleFormItemIsActive: function (formItem) {
                if (formItem.IsActive()) {
                    UI.showConfirmDialog("Are you sure you want to make this item inactive?  It will not be displayed on any forms or reports.  This action can be undone.", function () {
                        me.viewModel.ActiveFormItems.remove(formItem);
                        me.viewModel.InactiveFormItems.push(formItem);
                        formItem.IsActive(false);
                    });
                }
                else {
                    me.viewModel.ActiveFormItems.push(formItem);
                    me.viewModel.InactiveFormItems.remove(formItem);
                    formItem.IsActive(true);
                }
            },
            onDeleteFormItem: function (formItem) {
                me.viewModel.ActiveFormItems.remove(formItem);
            },
            onMoveFormItemUp: function (formItem) {
                var index = me.viewModel.ActiveFormItems.indexOf(formItem);
                me.viewModel.ActiveFormItems.remove(formItem);
                me.viewModel.ActiveFormItems.splice(index - 1, 0, formItem);
            },
            onMoveFormItemDown: function (formItem) {
                var index = me.viewModel.ActiveFormItems.indexOf(formItem);
                me.viewModel.ActiveFormItems.remove(formItem);
                me.viewModel.ActiveFormItems.splice(index + 1, 0, formItem);
            },
            onDuplicateFormItem: function (formItem) {
                var index = me.viewModel.ActiveFormItems.indexOf(formItem);
                me.viewModel.ActiveFormItems.splice(index + 1, 0, me.copyFormItemObservable(formItem));
            },
            onInsertFormItem: function (formItem) {
                var index = me.viewModel.ActiveFormItems.indexOf(formItem);
                me.viewModel.ActiveFormItems.splice(index + 1, 0, me.createEmptyFormItemObservable());
            },
            hasInactiveFormItems: function () {
                return me.viewModel.InactiveFormItems().length > 0;
            },
            formTextForTitle: function (index) {
                var formItem = me.viewModel.ActiveFormItems()[index];
                if (formItem.FormText() !== null && formItem.FormText().length > 0) {
                    return formItem.FormText();
                }
                else if (formItem.ID > 0) {
                    return "(No " + Constants.LABEL_QUESTION + " Title)";
                }
                else {
                    return "(New " + Constants.LABEL_QUESTION + ")";
                }
            },
            canMoveUp: function (index) {
                return index > 1;
            },
            canMoveDown: function (index) {
                return index > 0 && index + 1 < me.viewModel.ActiveFormItems().length;
            },
            canDelete: function (index) {
                return me.viewModel.ActiveFormItems()[index].ID <= 0;
            },
            displayShowInGrid: function (index) {
                var controlType = me.getControlTypeForFormItemIndex(index);
                return controlType != null && !controlType.IsBinaryData;
            },
            displayShowInMobileAppointmentHeader: function (index) {
                var controlType = me.getControlTypeForFormItemIndex(index);
                return controlType != null && !controlType.IsBinaryData;
            },
            canChangeTargetTemplateTypes: function () {
                return me.viewModel.TargetTemplate.ID() <= 0;
            },
            addListValue: function (formItem) {
                if (formItem.NewFieldText() !== "") {
                    formItem.ListValues.push({
                        ID: 0,
                        Value: ko.observable(formItem.NewFieldText()),
                        IsActive: ko.observable(true),
                    });
                    formItem.NewFieldText("");
                }
            },
            removeListValue: function (formItem) {
                formItem.IsActive(false);
            },
            displayTypeIsRadio: function (index) {
                var controlType = me.getControlTypeForFormItemIndex(index);
                return controlType != null && controlType.ID === Constants.QuestionType.RADIOBUTTONLIST;
            },
            displayTypeIsDropdown: function (index) {
                var controlType = me.getControlTypeForFormItemIndex(index);
                return controlType != null && controlType.ID === Constants.QuestionType.DROPDOWN;
            },
        };
        this.viewModel.showCustomFields = ko.pureComputed(function () {
            var targetTemplateType = me.viewModel.getSelectTargetTemplateType();
            if (targetTemplateType != null) {
                return targetTemplateType.HasCustomFields;
            }
            return false;
        });
        this.viewModel.showAddressFields = ko.pureComputed(function () {
            var targetTemplateType = me.viewModel.getSelectTargetTemplateType();
            if (targetTemplateType != null) {
                return targetTemplateType.HasAddressFields;
            }
            return false;
        });
    }
    TargetTemplateController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    TargetTemplateController.prototype.load = function (params) {
        var id = 0;
        if (params != null && params.length === 1) {
            id = params[0];
        }
        return this.loadRecord(id);
    };
    TargetTemplateController.prototype.haveFieldsChanged = function () {
        var fieldValues = JSON.stringify(this.GetTargetTemplateFromViewModel());
        return fieldValues !== this.fieldsOnLoad;
    };
    TargetTemplateController.prototype.appRouterID = function (params) {
        if (params != null && params.length === 1) {
            return "TargetTemplate" + params[0];
        }
        else {
            return "TargetTemplateNew";
        }
    };
    TargetTemplateController.prototype.title = function () {
        return "Target Template";
    };
    TargetTemplateController.prototype.subTitle = function () {
        if (this.viewModel.TargetTemplate.ID() > 0) {
            return this.viewModel.TargetTemplate.TemplateName();
        }
        else {
            return "New";
        }
    };
    TargetTemplateController.prototype.save = function () {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        var waitContainer;
        if (!this.isValid()) {
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
            deferred.reject();
            return deferred.promise();
        }
        waitContainer = UI.showWaitIndicator(this.container);
        TargetTemplateData.Save(this.GetTargetTemplateFromViewModel())
            .done(function (response) {
            var currentID;
            if (response.Success) {
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                app.events().trigger(EventUtil.EVENT_TARGETTEMPLATECHANGE, { targetTemplateID: response.Payload.ID });
                currentID = me.viewModel.TargetTemplate.ID();
                me.updateTargetTemplateViewModel(response.Payload);
                if (currentID <= 0) {
                    me.updateURL(response.Payload.ID, response.Payload.TemplateName);
                }
                else {
                    app.pageManager().refreshCurrentPageTitle();
                }
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    TargetTemplateController.prototype.GetTargetTemplateFromViewModel = function () {
        var targetTemplateVM = this.viewModel.TargetTemplate;
        var targetTemplate = {
            ID: targetTemplateVM.ID(),
            TemplateName: targetTemplateVM.TemplateName(),
            TargetTemplateTypeID: targetTemplateVM.TargetTemplateTypeID(),
            IsActive: this.viewModel.IsActive(),
            FormItems: this.GetTargetTemplateFormItemsFromObservable(this.viewModel.ActiveFormItems),
            AddressFormItems: this.GetTargetTemplateFormItemsFromObservable(targetTemplateVM.AddressFormItems),
        };
        if (this.viewModel.InactiveFormItems().length > 0) {
            targetTemplate.FormItems = targetTemplate.FormItems.concat(this.GetTargetTemplateFormItemsFromObservable(this.viewModel.InactiveFormItems));
        }
        return targetTemplate;
    };
    TargetTemplateController.prototype.GetTargetTemplateFormItemsFromObservable = function (formItemObservables) {
        var formItems = [];
        for (var _i = 0, _a = formItemObservables(); _i < _a.length; _i++) {
            var formItemObservable = _a[_i];
            var listValues = [];
            for (var _b = 0, _c = formItemObservable.ListValues(); _b < _c.length; _b++) {
                var listValueObservables = _c[_b];
                listValues.push({
                    ID: listValueObservables.ID,
                    Value: listValueObservables.Value(),
                    IsActive: listValueObservables.IsActive(),
                });
            }
            formItems.push({
                ID: formItemObservable.ID,
                FormText: formItemObservable.FormText(),
                IsRequired: formItemObservable.IsRequired(),
                ControlTypeID: formItemObservable.ControlTypeID(),
                IsActive: formItemObservable.IsActive(),
                ShowInGrid: formItemObservable.ShowInGrid(),
                ShowInMobileAppointmentHeader: formItemObservable.ShowInMobileAppointmentHeader(),
                CanChangeControlType: formItemObservable.CanChangeControlType,
                ListValues: listValues,
                TemplatePhraseID: (formItemObservable.PhraseOrCustomChoice() === Constants.TEMPLATE_FORM_CHOICES_PHRASES ? formItemObservable.TemplatePhraseID() : 0),
            });
        }
        return formItems;
    };
    TargetTemplateController.prototype.loadRecord = function (id) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        TargetTemplateData.GetMaster(id)
            .done(function (response) {
            if (response.Success) {
                me.updateViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TargetTemplateController.prototype.isValid = function () {
        var isValid = true;
        var targetTemplate = this.viewModel.TargetTemplate;
        var targetTemplateType = this.viewModel.getSelectTargetTemplateType();
        isValid = UI.setRequiredString(targetTemplate.TemplateName, targetTemplate.IsTemplateNameMissing) ? isValid : false;
        isValid = UI.setRequiredNumber(targetTemplate.TargetTemplateTypeID, targetTemplate.IsTargetTemplateTypeIDMissing, true) ?
            isValid : false;
        if (targetTemplateType != null && targetTemplateType.HasCustomFields) {
            for (var _i = 0, _a = this.viewModel.ActiveFormItems(); _i < _a.length; _i++) {
                var formItem = _a[_i];
                isValid = UI.setRequiredNumber(formItem.ControlTypeID, formItem.IsControlTypeMissing, true) ? isValid : false;
                isValid = UI.setRequiredString(formItem.FormText, formItem.IsFormTextMissing) ? isValid : false;
                formItem.IsFieldsMissing(false);
                if ((formItem.TemplatePhraseID() === null) && this.numberOfActiveListValues(formItem.ListValues) === 0 &&
                    (formItem.ControlTypeID() === Constants.QuestionType.DROPDOWN ||
                        formItem.ControlTypeID() === Constants.QuestionType.RADIOBUTTONLIST)) {
                    formItem.IsFieldsMissing(true);
                    isValid = false;
                }
            }
        }
        return isValid;
    };
    TargetTemplateController.prototype.numberOfActiveListValues = function (values) {
        var count = 0;
        values().forEach(function (value) {
            if (value.IsActive()) {
                count++;
            }
        });
        return count;
    };
    TargetTemplateController.prototype.updateURL = function (newID, templateName) {
        var app = Global.app();
        var routeChange = {
            appRouterID: this.appRouterID([]),
            url: "/TargetTemplate/" + newID,
            title: this.title(),
            subTitle: templateName,
            newAppRouterID: this.appRouterID([newID]),
        };
        app.events().trigger(EventUtil.EVENT_ROUTECHANGE, routeChange);
    };
    TargetTemplateController.prototype.updateViewModel = function (master) {
        this.viewModel.TargetTemplateTypes(master.TargetTemplateTypes);
        this.viewModel.TargetTemplateTypes.splice(0, 0, { ID: 0, Name: "(select template type)", HasCustomFields: false, HasAddressFields: false });
        this.viewModel.ControlTypes(master.ControlTypes);
        this.viewModel.ControlTypes.splice(0, 0, { ID: 0, Name: "(select a control type)", IsBinaryData: false, HasListValues: false });
        this.viewModel.TemplatePhrases(master.TemplatePhrases);
        this.updateTargetTemplateViewModel(master.TargetTemplate);
    };
    TargetTemplateController.prototype.updateTargetTemplateViewModel = function (targetTemplate) {
        var me = this;
        this.viewModel.TargetTemplate.ID(targetTemplate.ID);
        this.viewModel.TargetTemplate.TemplateName(targetTemplate.TemplateName);
        this.viewModel.TargetTemplate.TargetTemplateTypeID(targetTemplate.TargetTemplateTypeID);
        this.viewModel.ActiveFormItems.removeAll();
        this.viewModel.InactiveFormItems.removeAll();
        for (var _i = 0, _a = targetTemplate.FormItems; _i < _a.length; _i++) {
            var formItem = _a[_i];
            if (formItem.IsActive) {
                me.viewModel.ActiveFormItems.push(me.createFormItemObservable(formItem));
            }
            else {
                me.viewModel.InactiveFormItems.push(me.createFormItemObservable(formItem));
            }
        }
        if (targetTemplate.FormItems.length === 0) {
            this.viewModel.ActiveFormItems.push(this.createEmptyFormItemObservable());
        }
        this.viewModel.TargetTemplate.AddressFormItems.removeAll();
        for (var _b = 0, _c = targetTemplate.AddressFormItems; _b < _c.length; _b++) {
            var formItem = _c[_b];
            me.viewModel.TargetTemplate.AddressFormItems.push(me.createFormItemObservable(formItem));
        }
        this.viewModel.IsActive(targetTemplate.IsActive);
        this.fieldsOnLoad = JSON.stringify(this.GetTargetTemplateFromViewModel());
        me.viewModel.TemplatePhrases.unshift(me.GetCodeModelObservable({ ID: null, Name: Constants.PHRASE_NOTSELECTED }));
    };
    TargetTemplateController.prototype.createFormItemObservable = function (formItem) {
        var listValueObservables = [];
        for (var _i = 0, _a = formItem.ListValues; _i < _a.length; _i++) {
            var listValue = _a[_i];
            listValueObservables.push({
                ID: listValue.ID,
                Value: ko.observable(listValue.Value),
                IsActive: ko.observable(listValue.IsActive),
            });
        }
        var observable = {
            ID: formItem.ID,
            FormText: ko.observable(formItem.FormText),
            IsRequired: ko.observable(formItem.IsRequired),
            IsFormTextMissing: ko.observable(false),
            IsControlTypeMissing: ko.observable(false),
            ControlTypeID: ko.observable(formItem.ControlTypeID),
            IsActive: ko.observable(formItem.IsActive),
            ShowInGrid: ko.observable(formItem.ShowInGrid),
            ShowInMobileAppointmentHeader: ko.observable(formItem.ShowInMobileAppointmentHeader),
            CanChangeControlType: formItem.CanChangeControlType,
            ListValues: ko.observableArray(listValueObservables),
            TemplatePhraseID: ko.observable(formItem ? formItem.TemplatePhraseID : 0),
            PhraseOrCustomChoice: ko.observable(formItem.TemplatePhraseID == null ? Constants.TEMPLATE_FORM_CHOICES_CUSTOM : Constants.TEMPLATE_FORM_CHOICES_PHRASES),
            PhraseOrCustomOptions: ko.observableArray([{ text: "Enter Values", value: Constants.TEMPLATE_FORM_CHOICES_CUSTOM },
                { text: "Use Template Phrases", value: Constants.TEMPLATE_FORM_CHOICES_PHRASES }]),
            Fields: ko.observableArray(),
            NewFieldText: ko.observable(""),
            IsFieldsMissing: ko.observable(false),
        };
        return observable;
    };
    TargetTemplateController.prototype.createEmptyFormItemObservable = function () {
        var observable = {
            ID: 0,
            FormText: ko.observable(""),
            IsRequired: ko.observable(false),
            IsFormTextMissing: ko.observable(false),
            IsControlTypeMissing: ko.observable(false),
            ControlTypeID: ko.observable(Constants.QuestionType.TEXTBOX),
            IsActive: ko.observable(true),
            ShowInGrid: ko.observable(true),
            ShowInMobileAppointmentHeader: ko.observable(true),
            CanChangeControlType: true,
            ListValues: ko.observableArray(),
            TemplatePhraseID: ko.observable(0),
            PhraseOrCustomChoice: ko.observable(Constants.TEMPLATE_FORM_CHOICES_CUSTOM),
            PhraseOrCustomOptions: ko.observableArray([{ text: "Enter Values", value: Constants.TEMPLATE_FORM_CHOICES_CUSTOM },
                { text: "Use Template Phrases", value: Constants.TEMPLATE_FORM_CHOICES_PHRASES }]),
            Fields: ko.observableArray(),
            NewFieldText: ko.observable(""),
            IsFieldsMissing: ko.observable(false),
        };
        observable.PhraseOrCustomChoice.subscribe(function (data) {
            if (!data) {
                return;
            }
            if (data === Constants.TEMPLATE_FORM_CHOICES_CUSTOM) {
                observable.TemplatePhraseID(null);
            }
        });
        return observable;
    };
    TargetTemplateController.prototype.copyFormItemObservable = function (source) {
        var observable = {
            ID: 0,
            FormText: ko.observable(source.FormText()),
            IsRequired: ko.observable(source.IsRequired()),
            IsFormTextMissing: ko.observable(source.IsFormTextMissing()),
            IsControlTypeMissing: ko.observable(source.IsControlTypeMissing()),
            ControlTypeID: ko.observable(source.ControlTypeID()),
            IsActive: ko.observable(source.IsActive()),
            ShowInGrid: ko.observable(source.ShowInGrid()),
            ShowInMobileAppointmentHeader: ko.observable(source.ShowInMobileAppointmentHeader()),
            CanChangeControlType: true,
            ListValues: ko.observableArray(source.ListValues()),
            TemplatePhraseID: ko.observable(source.TemplatePhraseID()),
            PhraseOrCustomChoice: ko.observable(source.PhraseOrCustomChoice()),
            PhraseOrCustomOptions: ko.observableArray(source.PhraseOrCustomOptions()),
            Fields: ko.observableArray(source.Fields()),
            NewFieldText: ko.observable(source.NewFieldText()),
            IsFieldsMissing: ko.observable(source.IsFieldsMissing()),
        };
        return observable;
    };
    TargetTemplateController.prototype.toggleIsActive = function () {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        var newIsActive = !this.viewModel.IsActive();
        var targetTemplateID = this.viewModel.TargetTemplate.ID();
        var request = {
            TargetTemplateID: targetTemplateID,
            IsActive: newIsActive,
        };
        TargetTemplateData.SetIsActive(request)
            .done(function (response) {
            if (response.Success) {
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                app.events().trigger(EventUtil.EVENT_TARGETTEMPLATECHANGE, { targetTemplateID: targetTemplateID });
                me.viewModel.IsActive(newIsActive);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve(true);
        });
        return deferred.promise();
    };
    TargetTemplateController.prototype.getControlTypeForFormItemIndex = function (formItemIndex) {
        var controlTypeID = this.viewModel.ActiveFormItems()[formItemIndex].ControlTypeID();
        var controlType = this.viewModel.ControlTypes().filter(function (x) { return x.ID === controlTypeID; });
        if (controlType.length > 0) {
            return controlType[0];
        }
        else {
            return null;
        }
    };
    TargetTemplateController.prototype.GetCodeModelObservable = function (src) {
        return {
            ID: ko.observable(src ? src.ID : 0),
            Name: ko.observable(src ? src.Name : ""),
        };
    };
    return TargetTemplateController;
}());
exports.TargetTemplateController = TargetTemplateController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function GetMaster(id) {
    return Util.callWebService("/api/TargetTemplate/" + id, "GET");
}
exports.GetMaster = GetMaster;
function Save(targetTemplate) {
    return Util.callWebService("/api/TargetTemplate/Save", "POST", targetTemplate);
}
exports.Save = Save;
function SetIsActive(request) {
    return Util.callWebService("/api/TargetTemplate/SetIsActive", "POST", request);
}
exports.SetIsActive = SetIsActive;


/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var data_1 = __webpack_require__(23);
var Global = __webpack_require__(2);
var GridUtil = __webpack_require__(27);
var UI = __webpack_require__(3);
var TargetTemplatesController = (function () {
    function TargetTemplatesController() {
    }
    TargetTemplatesController.prototype.render = function (container) {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        me.gridContainer = container.find("div[data-id='grid']");
        me.dataSource = new kendo.data.DataSource({
            pageSize: 100,
        });
        me.grid = me.gridContainer.kendoGrid({
            dataSource: me.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                { title: "Name", field: "TemplateName", template: kendo.template($("#template_targettemplates_templatename").html()) },
                { title: "Type", field: "TemplateTypeName" },
                {
                    title: "Last Modified", field: "DateTimeModified",
                    template: kendo.template($("#template_targettemplates_lastmodifieddate").html()),
                },
                { title: "Modified By", field: "ModifedByFullName" },
            ],
            excel: {
                fileName: "TargetTemplates.xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");
        me.gridFilterControl = new GridUtil.GridFilterControl(container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showRefresh: true,
            showExportToExcel: true,
            showFilters: true,
            filters: [
                { name: Constants.PHRASE_FILTER_SHOWACTIVE, checked: true },
                { name: Constants.PHRASE_FILTER_SHOWINACTIVE, checked: false },
            ],
            grid: me.grid,
        });
        me.gridContainer.on("click", "a[data-id='link']", function (e) {
            var path = $(this).attr("href");
            e.preventDefault();
            app.router().navigate(_.defaultTo(path, ""), true);
            return false;
        });
        deferred.resolve();
        return deferred.promise();
    };
    TargetTemplatesController.prototype.load = function (params) {
        var app = Global.app();
        var me = this;
        var dataSource;
        var deferred = $.Deferred();
        dataSource = data_1.createWebServiceDataSource("/api/TargetTemplates", {
            id: "ID",
            fields: {
                ID: { type: "long" },
                TemplateName: { type: "string" },
                URLFriendlyName: { type: "string" },
                DateTimeModified: { type: "date" },
                IsActive: { type: "boolean" },
                TemplateTypeName: { type: "string" },
                ModifedByFullName: { type: "string" },
            },
        }, function (data) {
            me.setDataFilter(data);
        }, function (status) {
            if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                app.pageManager().closeCurrentPage();
            }
        });
        me.grid.setDataSource(dataSource);
        deferred.resolve();
        return deferred.promise();
    };
    TargetTemplatesController.prototype.add = function () {
        Global.app().router().navigate("/TargetTemplate", true);
    };
    TargetTemplatesController.prototype.haveFieldsChanged = function () {
        return false;
    };
    TargetTemplatesController.prototype.height = function (height) {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    };
    TargetTemplatesController.prototype.refresh = function () {
        this.grid.dataSource.read();
    };
    TargetTemplatesController.prototype.appRouterID = function (params) {
        return "TargetTemplates";
    };
    TargetTemplatesController.prototype.title = function () {
        return "Target Templates";
    };
    TargetTemplatesController.prototype.subTitle = function () {
        return "";
    };
    TargetTemplatesController.prototype.setDataFilter = function (data) {
        data.IncludeActive = true;
        data.IncludeInactive = false;
        if (this.gridFilterControl != null) {
            this.gridFilterControl.setDataFilter(data);
        }
    };
    return TargetTemplatesController;
}());
exports.TargetTemplatesController = TargetTemplatesController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(22);
__webpack_require__(83);
var ko = __webpack_require__(4);
var _ = __webpack_require__(9);
var moment = __webpack_require__(0);
var addFormDialog_1 = __webpack_require__(372);
var AppointmentLocationLogMap = __webpack_require__(848);
var Constants = __webpack_require__(5);
var FormDataEntry = __webpack_require__(378);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var Util = __webpack_require__(8);
var AppointmentData = __webpack_require__(58);
var ReportData = __webpack_require__(81);
var TargetData = __webpack_require__(45);
var TemplateData = __webpack_require__(84);
var TaskController = (function () {
    function TaskController() {
        this.NAVIGATIONTYPE_APPOINTMENTDETAIL = -1;
        this.NAVIGATIONTYPE_LOCATIONLOGMAP = -2;
        this.skipValidation = false;
        var me = this;
        var app = Global.app();
        this.customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
        this.viewModelTree = this.createViewModelTree();
        this.viewModelExceptionReport = this.createViewModelExceptionReport();
        this.viewModelAppointmentDetail = this.createViewModelAppointmentDetail();
        this.additionalFormControl = new FormDataEntry.FormDataEntryControl({});
        this.formControl = new FormDataEntry.FormDataEntryControl({
            openAdditionalForm: function (formItemIndex, hasExceptionForm, templateFormID, field) {
                me.additionalviewModel.formItemIndex(formItemIndex);
                if (field) {
                    me.additionalviewModel.field(field);
                }
                else {
                    me.additionalviewModel.field(null);
                }
                me.additionalviewModel.hasExceptionForm(hasExceptionForm);
                me.openAdditionalForm(templateFormID);
            },
        });
        this.additionalviewModel = {
            formItemIndex: ko.observable(0),
            field: ko.observable(null),
            hasExceptionForm: ko.observable(false),
            SaveProcessStarted: ko.observable(false),
            onSaveForm: function () {
                var _this = this;
                this.SaveProcessStarted(true);
                me.save(true).always(function () {
                    _this.SaveProcessStarted(false);
                });
            },
            onCancelForm: function () {
                me.container.find("div[data-id='additionalFormDialog']").modal("hide");
                if (me.additionalviewModel.hasExceptionForm()) {
                    var myformitems = me.formControl.getFormItems();
                    if (myformitems.FormItems[me.additionalviewModel.formItemIndex()].ControlTypeID === Constants.QuestionType.DROPDOWN) {
                        myformitems.FormItems[me.additionalviewModel.formItemIndex()].dropdownselected = null;
                    }
                    else if (myformitems.FormItems[me.additionalviewModel.formItemIndex()].ControlTypeID === Constants.QuestionType.RADIOBUTTONLIST) {
                        myformitems.FormItems[me.additionalviewModel.formItemIndex()].selected = "";
                    }
                    else if (myformitems.FormItems[me.additionalviewModel.formItemIndex()].ControlTypeID === Constants.QuestionType.CHECKBOXLIST) {
                        var selectedArray = myformitems.FormItems[me.additionalviewModel.formItemIndex()].selectedArray;
                        var field = me.additionalviewModel.field();
                        if (selectedArray && field) {
                            selectedArray.splice(selectedArray.indexOf(field.FieldValue()), 1);
                        }
                    }
                }
            },
        };
        this.addFormDialog = new addFormDialog_1.AddFormDialog();
        this.locationLogMapControl = new AppointmentLocationLogMap.AppointmentLocationLogMapControl();
    }
    TaskController.prototype.save = function (isAddtionalForm) {
        if (isAddtionalForm === void 0) { isAddtionalForm = false; }
        var me = this;
        var waitContainer;
        var deferred = $.Deferred();
        if (this.appointmentDetail) {
            return this.saveAppointmentDetail();
        }
        else {
            if (this.isFormItemsValid(isAddtionalForm)) {
                waitContainer = UI.showWaitIndicator(me.container);
                if (isAddtionalForm) {
                    var myformitems = me.formControl.getFormItems();
                    var originalFormItemID = myformitems.FormItems[me.additionalviewModel.formItemIndex()].ID;
                    AppointmentData.SaveAppointmentAdditionalForm(ko.toJS(me.additionalFormControl.getFormItemsForSave()), this.navigationID, this.listID, originalFormItemID)
                        .done(function (response) {
                        if (response.Success) {
                            me.container.find("div[data-id='additionalFormDialog']").modal("hide");
                            UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                            deferred.resolve();
                        }
                        else {
                            UI.showErrorMessage(response.ErrorMessages);
                            deferred.reject();
                        }
                    })
                        .fail(function () {
                        deferred.reject();
                    })
                        .always(function () {
                        UI.hideWaitIndicator(me.container, waitContainer);
                    });
                }
                else {
                    AppointmentData.SaveAppointmentForm(ko.toJS(me.formControl.getFormItemsForSave()), this.navigationID, this.skipValidation, this.listID)
                        .done(function (response) {
                        if (response.Success) {
                            UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                            me.loadFormItemsByTemplateFormID(me.templateFormID, me.appointmentID).done(function () {
                                deferred.resolve();
                            })
                                .fail(function () {
                                deferred.reject();
                            });
                        }
                        else {
                            UI.showErrorMessage(response.ErrorMessages);
                            deferred.reject();
                        }
                    })
                        .fail(function () {
                        deferred.reject();
                    })
                        .always(function () {
                        UI.hideWaitIndicator(me.container, waitContainer);
                    });
                }
            }
            else {
                deferred.reject();
            }
        }
        return deferred.promise();
    };
    TaskController.prototype.render = function (container) {
        var me = this;
        var deferred = $.Deferred();
        var appointment = this.viewModelAppointmentDetail;
        me.container = container;
        me.formControl.render(container.find("div[data-id='formContainer']").find(".tree-detail-container")).done(function () {
            me.additionalFormControl.render(container.find("div[data-id='additionalFormContainer']")).done(function () {
                me.locationLogMapControl.render(container.find("div[data-id='locationLogMapContainer']")).done(function () {
                    ko.applyBindings(me.viewModelTree, container.find("div[data-id='treeContainer']")[0]);
                    ko.applyBindings(me.viewModelAppointmentDetail, container.find("div[data-id='appointmentDetailContainer']")[0]);
                    ko.applyBindings(me.additionalviewModel, container.find("div[data-id='additionalFormButtons']")[0]);
                    ko.applyBindings(me.viewModelExceptionReport, container.find("div[data-id='exceptionReportContainer']")[0]);
                    me.addFormDialog.render(container);
                    me.appointmentDateControl = me.container.find("input[data-id='appointmentDate']");
                    me.appointmentTimeControl = me.container.find("input[data-id='appointmentTime']");
                    me.appointmentDateControl.kendoDatePicker({ format: UI.getKendoDateFormat(appointment.DateFormat) });
                    me.appointmentTimeControl.kendoTimePicker({ format: UI.getKendoTimeFormat(appointment.TimeFormat), interval: 15 });
                    deferred.resolve();
                });
            });
        });
        return deferred.promise();
    };
    TaskController.prototype.load = function (params) {
        if (params != null && params.length === 1) {
            this.appointmentID = params[0];
        }
        else {
            this.appointmentID = 0;
        }
        return this.loadRecord(this.appointmentID);
    };
    TaskController.prototype.haveFieldsChanged = function () {
        var me = this;
        return me.detailsChanged();
    };
    TaskController.prototype.height = function (height) {
        var detailHeight = height - 60;
        if (detailHeight > 0) {
            this.container.find("div[data-id='formContainer']").find(".tree-detail-container").css("min-height", detailHeight);
            this.container.find("div[data-id='additionalFormContainer']").find(".tree-detail-container").css("min-height", detailHeight);
            this.container.find("div[data-id='appointmentDetailContainer']").find(".tree-detail-container").css("min-height", detailHeight);
        }
    };
    TaskController.prototype.appRouterID = function (params) {
        var routerID = "Appointment";
        if (params != null && params.length === 1) {
            routerID += params[0];
        }
        return routerID;
    };
    TaskController.prototype.title = function () {
        return Constants.LABEL_APPOINTMENT;
    };
    TaskController.prototype.subTitle = function () {
        var subTitle = "";
        if (this.appointmentID == null) {
            subTitle = "New";
        }
        else {
            subTitle = this.viewModelAppointmentDetail.TargetShortDescription();
        }
        return subTitle;
    };
    TaskController.prototype.createViewModelExceptionReport = function () {
        return {
            ExceptionNavigations: ko.observableArray(),
            AppointmentLabel: ko.observable(Constants.LABEL_APPOINTMENT),
            QuestionLabel: ko.observable(Constants.LABEL_QUESTION),
        };
    };
    TaskController.prototype.createViewModelTree = function () {
        var me = this;
        return {
            Navigations: ko.observableArray(),
            onEditAppointmentDetail: function (navigationObservable) {
                me.confirmDetailChange(function () {
                    me.editAppointmentDetail(navigationObservable);
                    me.loadRecord(me.appointmentID);
                });
            },
            onEditNavigation: function (navigationObservable) {
                me.confirmDetailChange(function () {
                    me.editNavigation(navigationObservable);
                });
            },
            onShowNavigationReport: function (navigationObservable) {
                me.confirmDetailChange(function () {
                    me.showNavigationReport(navigationObservable);
                });
            },
            onShowLocationLogMap: function (navigationObservable) {
                me.confirmDetailChange(function () {
                    me.showLocationLogMap(navigationObservable);
                });
            },
            onAddNavigationList: function (navigationObservable) {
                me.confirmDetailChange(function () {
                    me.addFormDialog.show(navigationObservable.ListItems(), function (listName, templateFormID, ID) {
                        me.createNewForm(ID, listName, templateFormID, navigationObservable.ID())
                            .done(function (listObservable) {
                            navigationObservable.Lists.push(listObservable);
                            me.editList(listObservable);
                        });
                    });
                });
            },
            onNavigationShowActions: function (navigationObservable) {
                navigationObservable.ShowActions(true);
            },
            onNavigationHideActions: function (navigationObservable) {
                navigationObservable.ShowActions(false);
            },
            onEditList: function (listObservable) {
                me.confirmDetailChange(function () {
                    me.editList(listObservable);
                });
            },
            onNavigationToggleExpanded: function (navigationObservable) {
                navigationObservable.IsExpanded(!navigationObservable.IsExpanded());
            },
            onAddList: function (listObservable) {
                me.addFormDialog.show(listObservable.ListItems(), function (listName, templateFormID, ID) {
                    me.createNewForm(ID, listName, templateFormID, listObservable.NavigationID())
                        .done(function (newListObservable) {
                        listObservable.Children.push(newListObservable);
                    });
                });
            },
            onMoveListUp: function (listObservable) {
                me.moveListItem(listObservable, true);
            },
            onMoveListDown: function (listObservable) {
                me.moveListItem(listObservable, false);
            },
            onListToggleExpanded: function (listObservable) {
                listObservable.IsExpanded(!listObservable.IsExpanded());
            },
            onListShowActions: function (listObservable) {
                listObservable.ShowActions(true);
            },
            onListHideActions: function (listObservable) {
                listObservable.ShowActions(false);
            },
        };
    };
    TaskController.prototype.createViewModelAppointmentDetail = function () {
        var _this = this;
        var app = Global.app();
        var me = this;
        var languages = [];
        if (app.userSession && app.userSession.Languages) {
            languages = app.userSession.Languages;
        }
        var viewModel = {
            AppointmentDate: ko.observable(),
            AppointmentTime: ko.observable(),
            UserID: ko.observable(),
            StatusID: ko.observable(),
            StatusValues: ko.observableArray(),
            AppointmentUsers: ko.observableArray(),
            TargetDescription: ko.observableArray(),
            TargetShortDescription: ko.observable(""),
            AppointmentDateTimeInvalid: ko.observable(false),
            AppointmentExportUrl: ko.observable(),
            AppointmentID: ko.observable(),
            AppointmentTemplateName: ko.observable(),
            AppointmentTemplateID: ko.observable(),
            TargetID: ko.observable(),
            TargetTemplateID: ko.observable(),
            AppointmentLabel: ko.observable(Constants.LABEL_APPOINTMENT),
            AppointmentsLabel: ko.observable(Constants.LABEL_APPOINTMENTS),
            LinkedCustomerDocuments: ko.observableArray(),
            CustomerDocumentDownloadUrl: app.webServiceBaseURL + "/api/DocumentLibrary/Download/",
            DateFormat: UI.GetCustomerSetting(this.customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT),
            TimeFormat: UI.GetCustomerSetting(this.customerSettings, Constants.SETTING_KEY_TIMEFORMAT, Constants.DEFAULT_TIME_FORMAT),
            ReportEmailLogs: ko.observableArray(),
            ReportEmailLogAttachmentDownloadURL: app.webServiceBaseURL + "/api/Report/ReportEmailLogAttachment/",
            ReportID: ko.observable(),
            ReportRecipients: ko.observableArray(),
            RelatedAppointments: ko.observableArray(),
            MomentDateFormat: ko.observable(),
            LanguageID: ko.observable(0),
            Languages: languages,
            viewReport: function () {
                app.router().navigate("/ViewReport/" + viewModel.ReportID() + "?appointmentID=" + viewModel.AppointmentID(), true);
            },
            emailReport: function () {
                var recipients = me.viewModelAppointmentDetail.ReportRecipients().join(", ");
                UI.showConfirmDialog("Are you sure you want to email this report?  \n\nRecipients: " + recipients, function () {
                    var waitcontainer = UI.showWaitIndicator(_this.container);
                    ReportData.EmailReportToDefaultRecipients(me.viewModelAppointmentDetail.AppointmentID())
                        .then(function (response) {
                        if (response.Success) {
                            UI.showNotificationMessage("Report Emailed", UI.messageTypeValues.success);
                            me.loadRecord(me.viewModelAppointmentDetail.AppointmentID());
                        }
                        else {
                            UI.showErrorMessage(response.ErrorMessages);
                        }
                    })
                        .always(function () {
                        UI.hideWaitIndicator(me.container, waitcontainer);
                    });
                });
            },
            copyTask: function () {
                UI.showConfirmDialog("Are you sure you want to copy this " + Constants.LABEL_APPOINTMENT + "?", function () {
                    var waitcontainer = UI.showWaitIndicator(_this.container);
                    AppointmentData.CloneAppointment(viewModel.AppointmentID()).then(function (response) {
                        if (response.Success) {
                            UI.showNotificationMessage(Constants.LABEL_APPOINTMENT + " copied.", UI.messageTypeValues.success);
                            app.pageManager().gotoTaskPage(response.Payload, false);
                        }
                        else {
                            UI.showErrorMessage(response.ErrorMessages);
                        }
                    })
                        .always(function () {
                        UI.hideWaitIndicator(_this.container, waitcontainer);
                    });
                });
            },
            loadAppointment: function (appointmentID) {
                app.pageManager().gotoTaskPage(appointmentID, false);
            },
        };
        return viewModel;
    };
    TaskController.prototype.loadAdditionalFormItemsByTemplateFormID = function (templateFormID, appointmentID, origFormItemID) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        AppointmentData.GetAdditionalFormItemsByTemplateFormID(templateFormID, appointmentID, this.navigationID, origFormItemID, this.listID)
            .done(function (response) {
            if (response.Success) {
                me.updateAdditionalFormItems(response.Payload.AppointmentFormItem);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TaskController.prototype.loadFormItemsByTemplateFormID = function (templateFormID, appointmentID, origFormItemID) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        AppointmentData.GetFormItemsByTemplateFormID(templateFormID, appointmentID, this.navigationID, origFormItemID, this.listID)
            .done(function (response) {
            if (response.Success) {
                me.updateFormItems(response.Payload.AppointmentFormItem);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TaskController.prototype.updateAdditionalFormItems = function (appointmentFormItems) {
        var formItems = appointmentFormItems.map(function (formItem) {
            var formItemCopy = {
                ID: formItem.ID,
                TemplateFormItemID: formItem.TemplateFormItemID,
                FormAnswer: formItem.FormAnswer,
                Comments: formItem.Comments,
                Documents: formItem.Documents,
                AdditionalFormItems: formItem.AdditionalFormItems,
                ControlTypeID: formItem.ControlTypeID,
                AppointmentID: formItem.AppointmentID,
                FormText: formItem.FormText,
                FormTextTranslations: formItem.FormTextTranslations,
                SortOrder: formItem.SortOrder,
                IsRequired: formItem.IsRequired,
                IsReadOnly: formItem.IsReadOnly,
                IsVisible: formItem.IsVisible,
                Fields: formItem.Fields,
                AppointmentControlTypeAttribute: formItem.AppointmentControlTypeAttribute,
                AppointmentFormItemDocumentTypesAllowed: formItem.AppointmentFormItemDocumentTypesAllowed,
                TemplatePhraseID: formItem.TemplatePhraseID,
                TemplatePhrases: formItem.TemplatePhrases,
                AdditionalTemplateFormID: formItem.AdditionalTemplateFormID,
                IsAdditionalForm: true,
                AppointmentFormItemLinkedCustomerDocuments: formItem.AppointmentFormItemLinkedCustomerDocuments,
                MultipleAdditionalForms: formItem.MultipleAdditionalForms,
                Targets: formItem.Targets,
            };
            return formItemCopy;
        });
        var loadParams = {
            FormItems: formItems,
            LanguageID: this.viewModelAppointmentDetail.LanguageID(),
        };
        this.additionalFormControl.load(loadParams);
        this.additionalFormControl.show();
        this.showAdditionalFormDialog();
    };
    TaskController.prototype.updateExceptionReport = function (items) {
        this.viewModelExceptionReport.ExceptionNavigations(items.ExceptionReportNavigations);
    };
    TaskController.prototype.updateFormItems = function (appointmentFormItems) {
        var formItems = appointmentFormItems.map(function (formItem) {
            var formItemCopy = {
                ID: formItem.ID,
                TemplateFormItemID: formItem.TemplateFormItemID,
                FormAnswer: formItem.FormAnswer,
                Comments: formItem.Comments,
                Documents: formItem.Documents,
                AdditionalFormItems: formItem.AdditionalFormItems,
                ControlTypeID: formItem.ControlTypeID,
                AppointmentID: formItem.AppointmentID,
                FormText: formItem.FormText,
                FormTextTranslations: formItem.FormTextTranslations,
                SortOrder: formItem.SortOrder,
                IsRequired: formItem.IsRequired,
                IsReadOnly: formItem.IsReadOnly,
                IsVisible: formItem.IsVisible,
                Fields: formItem.Fields,
                AppointmentControlTypeAttribute: formItem.AppointmentControlTypeAttribute,
                AppointmentFormItemDocumentTypesAllowed: formItem.AppointmentFormItemDocumentTypesAllowed,
                TemplatePhraseID: formItem.TemplatePhraseID,
                TemplatePhrases: formItem.TemplatePhrases,
                AdditionalTemplateFormID: formItem.AdditionalTemplateFormID,
                AppointmentFormItemLinkedCustomerDocuments: formItem.AppointmentFormItemLinkedCustomerDocuments,
                MultipleAdditionalForms: formItem.MultipleAdditionalForms,
                Targets: formItem.Targets,
            };
            return formItemCopy;
        });
        var loadParams = {
            FormItems: formItems,
            LanguageID: this.viewModelAppointmentDetail.LanguageID(),
        };
        this.formControl.load(loadParams);
    };
    TaskController.prototype.loadRecord = function (id) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        AppointmentData.GetMaster(id)
            .done(function (response) {
            if (response.Success) {
                me.updateViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TaskController.prototype.updateViewModel = function (master) {
        this.updateViewModelTree(master.Appointment);
        this.updateViewModelAppointmentDetail(master);
        this.editAppointmentDetail(this.viewModelTree.Navigations()[0]);
    };
    TaskController.prototype.updateViewModelTree = function (appointment) {
        var me = this;
        this.viewModelTree.Navigations.removeAll();
        me.viewModelTree.Navigations.push(this.createNavigationObservable({
            ID: 0,
            Lists: [],
            Forms: [],
            NavigationTypeID: this.NAVIGATIONTYPE_APPOINTMENTDETAIL,
            TemplateFormID: null,
            NavigationName: Constants.LABEL_APPOINTMENT,
            NavigationNameTranslations: [],
            NavigationIcon: null,
            SortOrder: 0,
            ListItems: [],
        }));
        appointment.Navigations.forEach(function (navigation) {
            me.viewModelTree.Navigations.push(me.createNavigationObservable(navigation));
        });
        me.viewModelTree.Navigations.push(this.createNavigationObservable({
            ID: 0,
            Lists: [],
            Forms: [],
            NavigationTypeID: this.NAVIGATIONTYPE_LOCATIONLOGMAP,
            TemplateFormID: null,
            NavigationName: "Map",
            NavigationNameTranslations: [],
            NavigationIcon: null,
            SortOrder: 0,
            ListItems: [],
        }));
    };
    TaskController.prototype.createNavigationObservable = function (navigation) {
        var me = this;
        var navigationObservable = {
            ID: ko.observable(navigation.ID),
            TemplateFormID: ko.observable(navigation.TemplateFormID),
            NavigationTypeID: ko.observable(navigation.NavigationTypeID),
            NavigationName: ko.pureComputed(function () {
                if (navigationObservable.NavigationNameTranslations) {
                    var translations = navigationObservable.NavigationNameTranslations
                        .filter(function (navigationNameTranslations) { return navigationNameTranslations.LanguageID === me.viewModelAppointmentDetail.LanguageID(); });
                    if (translations && translations.length > 0 && translations[0].TranslatedText) {
                        return translations[0].TranslatedText;
                    }
                    else {
                        return navigationObservable.NavigationNameDefault();
                    }
                }
                else {
                    return navigationObservable.NavigationNameDefault();
                }
            }),
            NavigationNameDefault: ko.observable(navigation.NavigationName),
            NavigationNameTranslations: navigation.NavigationNameTranslations,
            NavigationIcon: ko.observable(navigation.NavigationIcon),
            SortOrder: ko.observable(navigation.SortOrder),
            IsExpanded: ko.observable(true),
            ListItems: ko.observableArray(navigation.ListItems),
            Lists: ko.observableArray(this.createListObservables(navigation.Lists, navigation.ID)),
            Forms: navigation.Forms,
            IsSelected: ko.observable(false),
            ShowActions: ko.observable(false),
        };
        navigationObservable.typeIsForm = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_FORM;
        });
        navigationObservable.typeIsList = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_LIST;
        });
        navigationObservable.typeIsReport = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_REPORT;
        });
        navigationObservable.typeIsAppointmentDetail = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === me.NAVIGATIONTYPE_APPOINTMENTDETAIL;
        });
        navigationObservable.typeIsLocationLogMap = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === me.NAVIGATIONTYPE_LOCATIONLOGMAP;
        });
        navigationObservable.numberOfLists = ko.pureComputed(function () {
            return navigationObservable.Lists().length;
        });
        navigationObservable.rowStyle = ko.pureComputed(function () {
            if (navigationObservable.IsSelected()) {
                return "tree-item tree-item-selected";
            }
            else {
                return "tree-item";
            }
        });
        return navigationObservable;
    };
    TaskController.prototype.updateViewModelAppointmentDetail = function (appointmentMaster) {
        var app = Global.app();
        var me = this;
        var appointment = this.viewModelAppointmentDetail;
        var momentDate = UI.getMomentDateFormat(appointment.DateFormat);
        var momentTime = UI.getMomentTimeFormat(appointment.TimeFormat);
        appointment.StatusValues(appointmentMaster.StatusValues);
        appointment.AppointmentUsers(appointmentMaster.AppointmentUsers);
        if (appointmentMaster.Appointment.AppointmentDate != null) {
            appointment.AppointmentDate(moment(appointmentMaster.Appointment.AppointmentDate).format(momentDate));
            appointment.AppointmentTime(moment(appointmentMaster.Appointment.AppointmentDate).format(momentTime));
            me.appointmentDateControl.data("kendoDatePicker").value(appointment.AppointmentDate());
            me.appointmentTimeControl.data("kendoTimePicker").value(appointment.AppointmentTime());
        }
        var docList = [];
        for (var _i = 0, _a = appointmentMaster.Appointment.LinkedCustomerDocuments; _i < _a.length; _i++) {
            var doc = _a[_i];
            docList.push({
                CustomerDocumentID: doc.CustomerDocumentID,
                Description: doc.Description,
                FileName: doc.FileName,
                IsActive: doc.IsActive,
            });
        }
        for (var _b = 0, _c = appointmentMaster.Appointment.Target.LinkedCustomerDocuments; _b < _c.length; _b++) {
            var doc = _c[_b];
            docList.push({
                CustomerDocumentID: doc.CustomerDocumentID,
                Description: doc.Description,
                FileName: doc.FileName,
                IsActive: doc.IsActive,
            });
        }
        appointment.LinkedCustomerDocuments(_.uniqWith(docList, function (a, b) { return a.CustomerDocumentID === b.CustomerDocumentID; }));
        appointment.UserID(appointmentMaster.Appointment.UserID);
        appointment.StatusID(appointmentMaster.Appointment.StatusID);
        appointment.AppointmentExportUrl(app.webServiceBaseURL + "/api/appointment/export/" + me.appointmentID);
        for (var _d = 0, _e = appointmentMaster.ReportEmailLogs; _d < _e.length; _d++) {
            var log = _e[_d];
            log.DateTimeCreated = moment(log.DateTimeCreated)
                .format(UI.GetCustomerSetting(this.customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT));
        }
        appointment.ReportEmailLogs(appointmentMaster.ReportEmailLogs);
        appointment.TargetDescription.removeAll();
        this.getTargetDescription(appointmentMaster.Appointment.Target).forEach(function (value) {
            appointment.TargetDescription.push(value);
        });
        appointment.TargetShortDescription(this.getTargetShortDescription(appointmentMaster.Appointment.Target));
        appointment.AppointmentID(appointmentMaster.Appointment.ID);
        appointment.AppointmentTemplateID(appointmentMaster.Appointment.TemplateID);
        appointment.AppointmentTemplateName(appointmentMaster.Appointment.TemplateName);
        appointment.TargetID(appointmentMaster.Appointment.TargetID);
        appointment.TargetTemplateID(appointmentMaster.Appointment.Target.TargetTemplateID);
        appointment.ReportID(appointmentMaster.Appointment.ReportID);
        appointment.ReportRecipients(appointmentMaster.Appointment.ReportRecipients);
        appointment.RelatedAppointments(appointmentMaster.RelatedAppointments);
        appointment.MomentDateFormat(momentDate);
        appointment.LanguageID(appointmentMaster.Appointment.LanguageID);
        this.fieldsOnLoad = ko.toJSON(this.viewModelAppointmentDetail);
    };
    TaskController.prototype.getTargetDescription = function (target) {
        var description = [];
        var cityStateZip = "";
        switch (target.TargetTemplateTypeID) {
            case TargetData.TARGETEMPLTETYPEID_LOCATION:
                if (!Util.isNullOrEmpty(target.Address)) {
                    description.push(target.Address);
                }
                if (!Util.isNullOrEmpty(target.Address2)) {
                    description.push(target.Address2);
                }
                if (!Util.isNullOrEmpty(target.City)) {
                    cityStateZip += target.City + ", ";
                }
                if (!Util.isNullOrEmpty(target.State)) {
                    cityStateZip += target.State + " ";
                }
                if (!Util.isNullOrEmpty(target.Zip)) {
                    cityStateZip += target.Zip;
                }
                if (!Util.isNullOrEmpty(cityStateZip)) {
                    description.push(cityStateZip);
                }
                if (!Util.isNullOrEmpty(target.Phone)) {
                    description.push(target.Phone);
                }
                break;
            case TargetData.TARGETEMPLTETYPEID_CUSTOM:
                for (var _i = 0, _a = target.FormItems; _i < _a.length; _i++) {
                    var formItem = _a[_i];
                    if (!Util.isNullOrEmpty(formItem.FormText)) {
                        var formItemValue = formItem.Value === null ? "" : UI.formatValueFromControlType(formItem.Value, formItem.ControlTypeID);
                        description.push(formItem.FormText + " : " + formItemValue);
                    }
                }
                break;
        }
        return description;
    };
    TaskController.prototype.getTargetShortDescription = function (target) {
        var description = "";
        switch (target.TargetTemplateTypeID) {
            case TargetData.TARGETEMPLTETYPEID_LOCATION:
                description = target.Address;
                break;
            case TargetData.TARGETEMPLTETYPEID_CUSTOM:
                if (target.FormItems.length > 0) {
                    description = target.FormItems[0].Value;
                }
                break;
        }
        return description;
    };
    TaskController.prototype.createListObservables = function (appointmentLists, navigationID) {
        var me = this;
        var listObservables = [];
        appointmentLists.forEach(function (appointmentList) {
            listObservables.push(me.createListObservable(appointmentList, navigationID));
        });
        return listObservables;
    };
    TaskController.prototype.createListObservable = function (appointmentList, navigationID) {
        var listObservable = {
            ID: ko.observable(appointmentList.ID),
            NavigationID: ko.observable(navigationID),
            ListName: ko.observable(appointmentList.ListName),
            HasForm: ko.observable(appointmentList.HasForm),
            HasAttributes: ko.observable(appointmentList.HasAttributes),
            SortOrder: ko.observable(appointmentList.SortOrder),
            CanDelete: ko.observable(appointmentList.CanDelete),
            IsActive: ko.observable(appointmentList.IsActive),
            Children: ko.observableArray(this.createListObservables(appointmentList.Children, navigationID)),
            ListItems: ko.observableArray(appointmentList.ListItems),
            ListForm: appointmentList.ListForm,
            TemplateFormID: ko.observable(appointmentList.TemplateFormID),
            IsExpanded: ko.observable(true),
            IsSelected: ko.observable(false),
            ShowActions: ko.observable(false),
        };
        listObservable.typeIsForm = ko.pureComputed(function () {
            return listObservable.HasForm();
        });
        listObservable.typeIsList = ko.pureComputed(function () {
            return !listObservable.HasForm();
        });
        listObservable.numberOfLists = ko.pureComputed(function () {
            return listObservable.Children().length;
        });
        listObservable.rowStyle = ko.pureComputed(function () {
            if (listObservable.IsSelected()) {
                return "tree-item tree-item-selected";
            }
            else {
                return "tree-item";
            }
        });
        return listObservable;
    };
    TaskController.prototype.editAppointmentDetail = function (navigationObservable) {
        this.hideExceptionReportContainer();
        this.hideFormContainer();
        this.showAppointmentDetailContainer();
        this.hideLocationLogMapContainer();
        this.appointmentDetail = true;
        this.formDetail = false;
        this.listID = null;
        this.templateFormID = null;
        this.unselectAllNavigation();
        navigationObservable.IsSelected(true);
    };
    TaskController.prototype.showLocationLogMap = function (navigationObservable) {
        this.hideAppointmentDetailContainer();
        this.hideExceptionReportContainer();
        this.hideFormContainer();
        this.showLocationLogMapContainer();
        this.locationLogMapControl.show();
        this.locationLogMapControl.load(this.appointmentID);
        this.appointmentDetail = false;
        this.formDetail = false;
        this.listID = null;
        this.templateFormID = null;
        this.unselectAllNavigation();
        navigationObservable.IsSelected(true);
    };
    TaskController.prototype.editNavigation = function (navigationObservable) {
        this.navigationID = navigationObservable.ID();
        this.templateFormID = navigationObservable.TemplateFormID();
        this.listID = null;
        this.hideAppointmentDetailContainer();
        this.hideLocationLogMapContainer();
        this.hideExceptionReportContainer();
        this.formDetail = true;
        this.appointmentDetail = false;
        this.loadFormItemsByTemplateFormID(navigationObservable.TemplateFormID(), this.appointmentID);
        this.showFormContainer();
        this.formControl.show();
        this.unselectAllNavigation();
        navigationObservable.IsSelected(true);
    };
    TaskController.prototype.showNavigationReport = function (navigationObservable) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(me.container);
        this.hideFormContainer();
        this.hideAppointmentDetailContainer();
        this.hideLocationLogMapContainer();
        this.showExceptionReportContainer();
        this.appointmentDetail = false;
        this.formDetail = false;
        AppointmentData.GetExceptionReportData(me.appointmentID)
            .done(function (response) {
            if (response.Success) {
                me.updateExceptionReport(response.Payload);
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        this.unselectAllNavigation();
        navigationObservable.IsSelected(true);
        return deferred.promise();
    };
    TaskController.prototype.editList = function (listObservable) {
        this.hideAppointmentDetailContainer();
        this.hideLocationLogMapContainer();
        this.hideExceptionReportContainer();
        this.showFormContainer();
        this.listID = listObservable.ID();
        this.appointmentDetail = false;
        this.formDetail = true;
        this.navigationID = listObservable.NavigationID();
        this.templateFormID = listObservable.TemplateFormID();
        this.loadFormItemsByTemplateFormID(listObservable.TemplateFormID(), this.appointmentID);
        this.formControl.show();
        this.unselectAllNavigation();
        listObservable.IsSelected(true);
    };
    TaskController.prototype.moveListItem = function (listObservableToMove, moveUp) {
        var me = this;
        var i = 1;
        var itemFound = false;
        this.viewModelTree.Navigations().forEach(function (navigation) {
            if (itemFound) {
                return;
            }
            var index = navigation.Lists.indexOf(listObservableToMove);
            if (index >= 0) {
                navigation.Lists.remove(listObservableToMove);
                if (moveUp) {
                    index = index - 1;
                }
                else {
                    index = index + 1;
                }
                navigation.Lists.splice(index, 0, listObservableToMove);
                navigation.Lists().forEach(function (list) {
                    list.SortOrder(i);
                    i++;
                });
                me.saveListOrder(navigation.Lists());
                listObservableToMove.ShowActions(false);
                itemFound = true;
            }
            else {
                navigation.Lists().forEach(function (list) {
                    if (itemFound) {
                        return;
                    }
                    if (list.Children().length === 0) {
                        return;
                    }
                    itemFound = me.moveListItemForList(listObservableToMove, moveUp, list);
                });
            }
        });
    };
    TaskController.prototype.moveListItemForList = function (listObservableToMove, moveUp, parentList) {
        var me = this;
        var i = 1;
        var itemFound = false;
        var index = parentList.Children.indexOf(listObservableToMove);
        if (index >= 0) {
            parentList.Children.remove(listObservableToMove);
            if (moveUp) {
                index = index - 1;
            }
            else {
                index = index + 1;
            }
            parentList.Children.splice(index, 0, listObservableToMove);
            parentList.Children().forEach(function (list) {
                list.SortOrder(i);
                i++;
            });
            me.saveListOrder(parentList.Children());
            listObservableToMove.ShowActions(false);
            return true;
        }
        parentList.Children().forEach(function (child) {
            if (itemFound) {
                return;
            }
            if (child.Children().length === 0) {
                return;
            }
            itemFound = me.moveListItemForList(listObservableToMove, moveUp, child);
        });
        return itemFound;
    };
    TaskController.prototype.createNewForm = function (ID, listName, templateFormID, navigationID) {
        var me = this;
        var deferred = $.Deferred();
        AppointmentData.SaveNewListForm(listName, ID, me.appointmentID, navigationID)
            .done(function (response) {
            if (response.Success) {
                me.listID = response.Payload.ID;
                var appointmentList = {
                    ID: response.Payload.ID,
                    ParentID: response.Payload.ParentID,
                    NavigationID: navigationID,
                    Children: [],
                    AttributeForm: [],
                    TemplateFormID: templateFormID,
                    ListForm: me.getAppointmentFormItems(response.Payload.ListForm),
                    ListName: listName,
                    IsActive: true,
                    HasForm: true,
                    HasAttributes: false,
                    SortOrder: 0,
                    CanDelete: true,
                    ListItems: [],
                };
                var listObservable = me.createListObservable(appointmentList, navigationID);
                deferred.resolve(listObservable);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        });
        return deferred.promise();
    };
    TaskController.prototype.getAppointmentFormItems = function (FormItems) {
        var formItems = [];
        var me = this;
        FormItems.forEach(function (FormItem) {
            var formItem = {
                ID: FormItem.ID,
                TemplateFormItemID: FormItem.ID,
                AppointmentID: me.appointmentID,
                FormAnswer: FormItem.FormAnswer,
                Comments: [],
                Documents: [],
                AdditionalFormItems: [],
                ControlTypeID: FormItem.ControlTypeID,
                FormText: FormItem.FormText,
                SortOrder: FormItem.SortOrder,
                IsRequired: FormItem.IsRequired,
                IsReadOnly: FormItem.IsReadOnly,
                IsVisible: FormItem.IsVisible,
                Fields: FormItem.Fields,
                AppointmentControlTypeAttribute: FormItem.AppointmentControlTypeAttribute,
                AppointmentFormItemDocumentTypesAllowed: FormItem.AppointmentFormItemDocumentTypesAllowed,
                TemplatePhraseID: FormItem.TemplatePhraseID,
                AdditionalTemplateFormID: FormItem.AdditionalTemplateFormID,
                MultipleAdditionalForms: FormItem.MultipleAdditionalForms,
                Targets: FormItem.Targets,
            };
            formItems.push(formItem);
        });
        return formItems;
    };
    TaskController.prototype.isFormItemsValid = function (isAdditionalForm) {
        var me = this;
        if (isAdditionalForm) {
            if (!me.additionalFormControl.isValid()) {
                UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
                return false;
            }
        }
        else {
            if (!me.formControl.isValid()) {
                UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
                return false;
            }
        }
        return true;
    };
    TaskController.prototype.confirmDetailChange = function (onConfirmed) {
        if (this.detailsChanged()) {
            UI.showConfirmDialog("There are unsaved changes on this page.  "
                + "Are you sure you want to close this page and lose these unsaved changes?", function () { onConfirmed(); });
        }
        else {
            onConfirmed();
        }
    };
    TaskController.prototype.detailsChanged = function () {
        var me = this;
        var formItemsChanged = me.formControl.haveFieldsChanged();
        var taskDetails = ko.toJSON(this.viewModelAppointmentDetail);
        var taskfieldsChanged = (this.fieldsOnLoad !== taskDetails);
        if ((this.appointmentDetail && taskfieldsChanged) ||
            (this.formDetail && formItemsChanged)) {
            return true;
        }
        return false;
    };
    TaskController.prototype.unselectAllNavigation = function () {
        var me = this;
        this.viewModelTree.Navigations().forEach(function (navigation) {
            navigation.IsSelected(false);
            if (navigation.Lists().length > 0) {
                me.unselectAllLists(navigation.Lists);
            }
        });
    };
    TaskController.prototype.unselectAllLists = function (lists) {
        var me = this;
        lists().forEach(function (list) {
            list.IsSelected(false);
            if (list.Children().length > 0) {
                me.unselectAllLists(list.Children);
            }
        });
    };
    TaskController.prototype.showFormContainer = function () {
        this.container.find("div[data-id='formContainer']").removeClass("hidden");
    };
    TaskController.prototype.hideFormContainer = function () {
        this.container.find("div[data-id='formContainer']").addClass("hidden");
    };
    TaskController.prototype.showAdditionalFormDialog = function () {
        this.container.find("div[data-id='additionalFormDialog']").modal("show");
    };
    TaskController.prototype.showAppointmentDetailContainer = function () {
        this.container.find("div[data-id='appointmentDetailContainer']").removeClass("hidden");
    };
    TaskController.prototype.hideAppointmentDetailContainer = function () {
        this.container.find("div[data-id='appointmentDetailContainer']").addClass("hidden");
    };
    TaskController.prototype.showLocationLogMapContainer = function () {
        this.container.find("div[data-id='locationLogMapContainer']").removeClass("hidden");
    };
    TaskController.prototype.hideLocationLogMapContainer = function () {
        this.container.find("div[data-id='locationLogMapContainer']").addClass("hidden");
    };
    TaskController.prototype.showExceptionReportContainer = function () {
        this.container.find("div[data-id='exceptionReportContainer']").removeClass("hidden");
    };
    TaskController.prototype.hideExceptionReportContainer = function () {
        this.container.find("div[data-id='exceptionReportContainer']").addClass("hidden");
    };
    TaskController.prototype.confirmedOpenAdditionalForm = function (templateFormID) {
        var me = this;
        var myformitems = me.formControl.getFormItems();
        var origFormItemID = myformitems.FormItems[me.additionalviewModel.formItemIndex()].ID;
        me.loadAdditionalFormItemsByTemplateFormID(templateFormID, this.appointmentID, origFormItemID);
    };
    TaskController.prototype.openAdditionalForm = function (templateFormID) {
        var me = this;
        me.confirmedOpenAdditionalForm(templateFormID);
    };
    TaskController.prototype.isAppointmentDetailValid = function () {
        var isValid = true;
        var appointment = this.viewModelAppointmentDetail;
        var appointmentDate = this.viewModelAppointmentDetail.AppointmentDate();
        var appointmentTime = this.viewModelAppointmentDetail.AppointmentTime();
        var apptDateTime;
        this.viewModelAppointmentDetail.AppointmentDateTimeInvalid(false);
        var momentDateFormat = UI.getMomentDateFormat(appointment.DateFormat);
        var momentTimeFormat = UI.getMomentTimeFormat(appointment.TimeFormat);
        var momentFormat = momentDateFormat + " " + momentTimeFormat;
        if (!Util.isNullOrEmpty(appointmentDate) || !Util.isNullOrEmpty(appointmentTime)) {
            if (Util.isNullOrEmpty(appointmentDate) || Util.isNullOrEmpty(appointmentTime)) {
                isValid = false;
                this.viewModelAppointmentDetail.AppointmentDateTimeInvalid(true);
            }
            else {
                apptDateTime = moment(this.viewModelAppointmentDetail.AppointmentDate() +
                    " " + this.viewModelAppointmentDetail.AppointmentTime(), momentFormat, true);
                if (!apptDateTime.isValid()) {
                    isValid = false;
                    this.viewModelAppointmentDetail.AppointmentDateTimeInvalid(true);
                }
            }
        }
        return isValid;
    };
    TaskController.prototype.saveListOrder = function (lists) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer;
        waitContainer = UI.showWaitIndicator(me.container);
        AppointmentData.SaveListOrder(ko.toJS(lists))
            .done(function (response) {
            if (response.Success) {
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    TaskController.prototype.saveAppointmentDetail = function () {
        var _this = this;
        var me = this;
        var deferred = $.Deferred();
        var waitContainer;
        var apptDateTime = moment();
        var appointment = this.viewModelAppointmentDetail;
        if (!this.isAppointmentDetailValid()) {
            deferred.reject();
            return deferred.promise();
        }
        var momentDateFormat = UI.getMomentDateFormat(appointment.DateFormat);
        var momentTimeFormat = UI.getMomentTimeFormat(appointment.TimeFormat);
        var momentFormat = momentDateFormat + " " + momentTimeFormat;
        if (appointment.AppointmentDate() && appointment.AppointmentTime()) {
            apptDateTime = moment(appointment.AppointmentDate()
                + " " + appointment.AppointmentTime(), momentFormat);
        }
        waitContainer = UI.showWaitIndicator(me.container);
        var saveAppointmentDetailRequest = {
            appointmentID: this.appointmentID,
            appointmentDate: apptDateTime,
            statusID: this.viewModelAppointmentDetail.StatusID(),
            userID: this.viewModelAppointmentDetail.UserID(),
            languageID: this.viewModelAppointmentDetail.LanguageID(),
        };
        AppointmentData.SaveAppointmentDetail(saveAppointmentDetailRequest)
            .done(function (response) {
            if (response.Success) {
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                _this.fieldsOnLoad = ko.toJSON(_this.viewModelAppointmentDetail);
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    return TaskController;
}());
exports.TaskController = TaskController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var L = __webpack_require__(139);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
var moment = __webpack_require__(0);
var AppointmentData = __webpack_require__(58);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var mapUtil_1 = __webpack_require__(377);
var UI = __webpack_require__(3);
var AppointmentLocationLogMapControl = (function () {
    function AppointmentLocationLogMapControl() {
        this.map = null;
    }
    AppointmentLocationLogMapControl.prototype.render = function (container) {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        this.container = container;
        this.viewModel = {
            LocationLogs: ko.observableArray(),
            DataLoaded: ko.observable(false),
        };
        container.hide();
        app.templates().render("appointmentlocationlogmap", "template_appointmentlocationlogmap", this.container)
            .done(function () {
            ko.applyBindings(me.viewModel, me.container[0]);
            deferred.resolve();
        });
        return deferred.promise();
    };
    AppointmentLocationLogMapControl.prototype.load = function (appointmentID) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        AppointmentData.GetLocationLogs(appointmentID)
            .done(function (response) {
            if (response.Success) {
                var validLogs = response.Payload.filter(function (item) {
                    return item.Latitude !== 0 && item.Longitude !== 0;
                });
                me.viewModel.LocationLogs(validLogs);
                me.viewModel.DataLoaded(true);
                me.loadMap(response.Payload);
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    AppointmentLocationLogMapControl.prototype.show = function () {
        this.container.show();
    };
    AppointmentLocationLogMapControl.prototype.hide = function () {
        this.container.hide();
    };
    AppointmentLocationLogMapControl.prototype.loadMap = function (locationLogs) {
        if (locationLogs.length === 0) {
            return;
        }
        try {
            this.initMap();
            this.drawMapMarkers(locationLogs);
        }
        catch (ex) {
            UI.showErrorMessage([Constants.PHRASE_PAGELOADERROR]);
        }
    };
    AppointmentLocationLogMapControl.prototype.initMap = function () {
        if (this.map !== null) {
            this.map.remove();
        }
        var mapContainer = this.container.find(".map");
        var tiles = mapUtil_1.getMapTileLayer();
        this.map = L.map(mapContainer[0], { layers: [tiles] });
    };
    AppointmentLocationLogMapControl.prototype.drawMapMarkers = function (locationLogs) {
        var markers = L.markerClusterGroup({
            chunkedLoading: true,
            spiderfyDistanceMultiplier: 1.2,
        });
        locationLogs.forEach(function (point, index) {
            if (point.Latitude === 0 && point.Longitude === 0) {
                return;
            }
            var iconHtml = "<i class=\"fa fa-map-marker fa-3x\"></i>";
            var marker = L.marker(L.latLng(point.Latitude, point.Longitude), {
                title: point.Description,
                icon: new L.DivIcon({ html: iconHtml, className: "map-icon", iconSize: [30, 35] }),
            });
            marker.bindPopup(point.Description + "<br /> " + moment(point.RecordedDateTime).format(Constants.MOMENT_FORMAT_DATETIME));
            markers.addLayer(marker);
        });
        if (this.map !== null) {
            var bounds = markers.getBounds();
            if (bounds.isValid()) {
                this.map.addLayer(markers);
                this.map.fitBounds(bounds);
            }
        }
    };
    return AppointmentLocationLogMapControl;
}());
exports.AppointmentLocationLogMapControl = AppointmentLocationLogMapControl;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, global) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(851);
__webpack_require__(22);
__webpack_require__(83);
var ko = __webpack_require__(4);
var moment = __webpack_require__(0);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var targetEdit_1 = __webpack_require__(369);
var UI = __webpack_require__(3);
var Util = __webpack_require__(8);
var AppointmentAddData = __webpack_require__(379);
var TargetData = __webpack_require__(45);
var TaskAddController = (function () {
    function TaskAddController() {
        this.fieldsOnLoad = {};
        var me = this;
        var app = Global.app();
        this.customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
        this.DateFormat = UI.GetCustomerSetting(this.customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT);
        this.TimeFormat = UI.GetCustomerSetting(this.customerSettings, Constants.SETTING_KEY_TIMEFORMAT, Constants.DEFAULT_TIME_FORMAT);
        this.viewModel = {
            InspectorID: ko.observable(0),
            AppointmentDateString: ko.observable(""),
            TemplateID: ko.observable(0),
            IsTemplateIDMissing: ko.observable(false),
            TargetTemplateName: ko.observable("Search Target"),
            Timeframe: ko.observable(0),
            AppointmentDate: ko.observable(""),
            AppointmentTime: ko.observable(""),
            IsAppointmentDateMissing: ko.observable(false),
            IsAppointmentTimeMissing: ko.observable(false),
            IsAppointmentDateTimeInvalid: ko.observable(false),
            TargetTemplateID: ko.observable(0),
            TargetTemplateTypeID: ko.observable(0),
            TargetID: ko.observable(0),
            IsTargetIDMissing: ko.observable(false),
            IsTargetPrepopulated: ko.observable(false),
            TargetTemplateURLName: ko.observable(""),
            Templates: ko.observableArray(),
            Inspectors: ko.observableArray(),
            AppointmentLabel: ko.observable(Constants.LABEL_APPOINTMENT),
            InspectorLabel: ko.observable(Constants.LABEL_INSPECTOR),
            TargetDataSource: AppointmentAddData.getTargetAutocompleteData(function (data) {
                data.TargetTemplateID = me.viewModel.TargetTemplateID();
                data.TargetTemplateTypeID = me.viewModel.TargetTemplateTypeID();
            }),
            AddressFormItems: ko.observableArray(),
            FormItems: ko.observableArray(),
            Languages: ko.observableArray(),
            DefaultLanguageID: ko.observable(0),
            templateSelected: function (e) {
                me.setTargetTemplate(e.TemplateID());
            },
            onOpenAddTargetModal: function () {
                me.addTargetModal.modal("show");
                me.targetEditControl.load(me.viewModel.TargetTemplateURLName());
            },
        };
        this.addTargetViewModel = {
            closeAddTargetModal: function () {
                me.addTargetModal.modal("hide");
            },
            saveNewTarget: function () {
                me.targetEditControl.save().done(function (targetMaster) {
                    me.addTargetModal.modal("hide");
                    me.updateTargetDataFromTargetMaster(targetMaster);
                });
            },
        };
        this.targetEditControl = new targetEdit_1.TargetEditControl();
    }
    TaskAddController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        this.addTargetModal = container.find("div[data-id='addTargetModal']");
        this.targetEditControl.render(container.find("div[data-id='targetEditControl']"));
        ko.applyBindings(this.viewModel, container.find("div[data-id='formContainer']")[0]);
        ko.applyBindings(this.addTargetViewModel, container.find("div[data-id='AddTargetButtons']")[0]);
        deferred.resolve();
        return deferred.promise();
    };
    TaskAddController.prototype.load = function (params) {
        var me = this;
        var momentDate = UI.getMomentDateFormat(me.DateFormat);
        var momentTime = UI.getMomentTimeFormat(me.TimeFormat);
        var defaultAppointmentDateTime = moment();
        if (Util.getURLParameter("date")) {
            defaultAppointmentDateTime = moment(Util.getURLParameter("date"));
        }
        me.viewModel.AppointmentDate(defaultAppointmentDateTime.format(momentDate));
        me.viewModel.AppointmentTime(defaultAppointmentDateTime.format(momentTime));
        me.container.find("input[data-id='appointmentDate']").kendoDatePicker({ format: UI.getKendoDateFormat(me.DateFormat) })
            .attr("placeholder", UI.getKendoDateFormat(me.DateFormat));
        me.container.find("input[data-id='appointmentTime']").kendoTimePicker({ format: UI.getKendoTimeFormat(me.TimeFormat), interval: 15 })
            .attr("placeholder", Constants.TIME_PLACEHOLDER);
        me.container.find("input[data-id='searchTarget']").kendoAutoComplete({
            filter: "contains",
            separator: "\n ",
            minLength: 3,
            select: me.updateTarget.bind(me),
            dataSource: me.viewModel.TargetDataSource,
            template: kendo.template($("#template_appointmentAdd_autocomplete").html()),
            dataTextField: "Target",
        });
        return this.loadRecord();
    };
    TaskAddController.prototype.save = function () {
        var me = this;
        var app = Global.app();
        var waitContainer;
        var deferred = $.Deferred();
        var createApptRequest;
        var apptDateTime = null;
        if (!this.isValid()) {
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
            deferred.reject();
            return deferred.promise();
        }
        if (me.viewModel.AppointmentDate() && me.viewModel.AppointmentTime()) {
            var apptDateTimeMoment = me.getAppointmentDateTimeAsMoment();
            if (apptDateTimeMoment !== null) {
                apptDateTime = apptDateTimeMoment.toDate();
            }
        }
        createApptRequest = {
            AppointmentDate: apptDateTime,
            AssignedToUserID: me.viewModel.InspectorID(),
            TargetID: me.viewModel.TargetID(),
            TemplateID: me.viewModel.TemplateID(),
            StatusID: 1,
            Timeframe: me.viewModel.Timeframe(),
            LanguageID: me.viewModel.DefaultLanguageID(),
        };
        AppointmentAddData.createAppointment(createApptRequest)
            .done(function (response) {
            if (response.Success) {
                app.pageManager().gotoTaskPage(response.Payload.ID, true);
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        waitContainer = UI.showWaitIndicator(me.container);
        return deferred.promise();
    };
    TaskAddController.prototype.haveFieldsChanged = function () {
        var fieldValues = ko.toJSON(this.viewModel);
        return fieldValues !== this.fieldsOnLoad;
    };
    TaskAddController.prototype.appRouterID = function (params) {
        var routerID = "Appointment";
        if (params != null && params.length === 1) {
            routerID += params[0];
        }
        return routerID;
    };
    TaskAddController.prototype.title = function () {
        return "Add " + Constants.LABEL_APPOINTMENT;
    };
    TaskAddController.prototype.subTitle = function () {
        return "";
    };
    TaskAddController.prototype.isValid = function () {
        var me = this;
        var isValid = true;
        isValid = UI.setRequiredNumber(me.viewModel.TemplateID, me.viewModel.IsTemplateIDMissing) ? isValid : false;
        me.viewModel.IsAppointmentTimeMissing(false);
        me.viewModel.IsAppointmentDateMissing(false);
        me.viewModel.IsAppointmentDateTimeInvalid(false);
        if (me.viewModel.AppointmentDate()) {
            isValid = UI.setRequiredString(me.viewModel.AppointmentTime, me.viewModel.IsAppointmentTimeMissing) ? isValid : false;
        }
        if (me.viewModel.AppointmentTime()) {
            isValid = UI.setRequiredString(me.viewModel.AppointmentDate, me.viewModel.IsAppointmentDateMissing) ? isValid : false;
        }
        if (me.viewModel.AppointmentDate() && me.viewModel.AppointmentTime()) {
            var appointmentDateTimeMoment = this.getAppointmentDateTimeAsMoment();
            if (appointmentDateTimeMoment !== null && !appointmentDateTimeMoment.isValid()) {
                isValid = false;
                me.viewModel.IsAppointmentDateTimeInvalid(true);
            }
        }
        if (!me.viewModel.TargetID()) {
            me.viewModel.IsTargetIDMissing(true);
            isValid = false;
        }
        return isValid;
    };
    TaskAddController.prototype.loadRecord = function () {
        var _this = this;
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        if (Util.getURLNumberParameter("targetID")) {
            me.viewModel.IsTargetPrepopulated(true);
        }
        var request = {
            TargetID: Util.getURLNumberParameter("targetID"),
        };
        AppointmentAddData.getAppointmentLookupData(request)
            .done(function (response) {
            if (response.Success) {
                me.updateApptViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            me.fieldsOnLoad = ko.toJSON(_this.viewModel);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TaskAddController.prototype.updateApptViewModel = function (lookupData) {
        var me = this;
        me.viewModel.Templates([]);
        me.viewModel.Inspectors([]);
        me.viewModel.Timeframe(lookupData.MajorTick);
        lookupData.Templates.forEach(function (template) {
            var tt = {
                ID: ko.observable(template.ID),
                Name: ko.observable(template.Name),
            };
            me.viewModel.Templates.push(tt);
        });
        lookupData.Inspectors.forEach(function (inspector) {
            var ip = {
                ID: ko.observable(inspector.ID),
                Name: ko.observable(inspector.Name),
            };
            me.viewModel.Inspectors.push(ip);
        });
        me.viewModel.InspectorID(Util.getURLNumberParameter("inspectorID"));
        if (lookupData.TargetTemplate) {
            me.updateTargetViewModel(lookupData.TargetTemplate);
            me.viewModel.TemplateID(Util.getURLNumberParameter("templateID"));
        }
        if (lookupData.Target) {
            me.updateTargetData(lookupData.Target);
            me.viewModel.IsTargetPrepopulated(true);
            me.viewModel.TargetID(Util.getURLNumberParameter("targetID"));
        }
        me.viewModel.Languages(lookupData.Languages);
        me.viewModel.DefaultLanguageID(lookupData.DefaultLanguageID);
    };
    TaskAddController.prototype.setTargetTemplate = function (templateID) {
        var me = this;
        var deferred = $.Deferred();
        if (me.viewModel.IsTargetPrepopulated()) {
            deferred.resolve();
            return deferred.promise();
        }
        var waitContainer = UI.showWaitIndicator(this.container);
        me.viewModel.AddressFormItems([]);
        me.viewModel.FormItems([]);
        me.viewModel.TargetID(0);
        me.container.find("input[data-id='searchTarget']").data("kendoAutoComplete").value("");
        if (!templateID) {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
            return deferred.promise();
        }
        AppointmentAddData.getTargetTemplate(templateID)
            .done(function (response) {
            if (response.Success) {
                me.updateTargetViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TaskAddController.prototype.updateTargetViewModel = function (targetTemplate) {
        var me = this;
        me.viewModel.AddressFormItems([]);
        me.viewModel.FormItems([]);
        me.viewModel.IsTemplateIDMissing(false);
        me.viewModel.IsTargetIDMissing(false);
        me.viewModel.TargetID(0);
        me.viewModel.TargetTemplateTypeID(targetTemplate.TargetTemplateTypeID);
        me.viewModel.TargetTemplateName("Search " + targetTemplate.TemplateName);
        me.viewModel.TargetTemplateID(targetTemplate.ID);
        me.viewModel.TargetTemplateURLName(targetTemplate.URLFriendlyName);
        if (targetTemplate.TargetTemplateTypeID === TargetData.TARGETEMPLTETYPEID_LOCATION) {
            for (var _i = 0, _a = targetTemplate.AddressFormItems; _i < _a.length; _i++) {
                var address = _a[_i];
                if (address.FormText !== "Address 2" && address.FormText !== "County" && address.FormText !== "Country") {
                    var addr = {
                        ID: ko.observable(address.ID),
                        FormText: ko.observable(address.FormText),
                        IsRequired: ko.observable(address.IsRequired),
                        MaxLength: ko.observable(address.MaxLength),
                        Value: ko.observable(address.Value),
                        IsReadOnly: ko.observable(address.FormText !== "Address"),
                        TargetTemplateFormItemID: ko.observable(0),
                    };
                    me.viewModel.AddressFormItems.push(addr);
                }
            }
        }
        else if (targetTemplate.TargetTemplateTypeID === TargetData.TARGETEMPLTETYPEID_CUSTOM) {
            for (var _b = 0, _c = targetTemplate.FormItems; _b < _c.length; _b++) {
                var item = _c[_b];
                if (item.FormText && item.IsActive && item.ControlTypeID !== Constants.QuestionType.PICTURE) {
                    var itemOb = {
                        ID: ko.observable(item.ID),
                        FormText: ko.observable(item.FormText),
                        IsRequired: ko.observable(item.IsRequired),
                        MaxLength: ko.observable(item.MaxLength),
                        Value: ko.observable(item.Value),
                        IsReadOnly: ko.observable(true),
                        TargetTemplateFormItemID: ko.observable(0),
                    };
                    me.viewModel.FormItems.push(itemOb);
                }
            }
        }
    };
    TaskAddController.prototype.updateTarget = function (e) {
        var me = this;
        if (!e || !e.item || e.item.index() < 0) {
            return;
        }
        me.viewModel.IsTargetIDMissing(false);
        var targetSelected = e.sender.dataItem(e.item.index());
        me.updateTargetData(targetSelected);
    };
    TaskAddController.prototype.updateTargetData = function (targetSelected) {
        var me = this;
        me.viewModel.TargetID(targetSelected.TargetID);
        if (targetSelected.TargetTemplateTypeID === TargetData.TARGETEMPLTETYPEID_LOCATION) {
            me.viewModel.AddressFormItems()[0].Value(targetSelected.Address);
            me.viewModel.AddressFormItems()[1].Value(targetSelected.City);
            me.viewModel.AddressFormItems()[2].Value(targetSelected.State);
            me.viewModel.AddressFormItems()[3].Value(targetSelected.Zip);
            me.viewModel.AddressFormItems()[4].Value(targetSelected.Phone);
        }
        else if (targetSelected.TargetTemplateTypeID === TargetData.TARGETEMPLTETYPEID_CUSTOM) {
            for (var _i = 0, _a = me.viewModel.FormItems(); _i < _a.length; _i++) {
                var itemViewModel = _a[_i];
                itemViewModel.Value("");
                for (var _b = 0, _c = targetSelected.FieldValues; _b < _c.length; _b++) {
                    var fieldValue = _c[_b];
                    if (itemViewModel.FormText() === fieldValue.Name) {
                        itemViewModel.Value(UI.formatValueFromControlType(fieldValue.Value, fieldValue.ControlTypeID));
                        break;
                    }
                }
            }
        }
    };
    TaskAddController.prototype.updateTargetDataFromTargetMaster = function (target) {
        var me = this;
        me.viewModel.TargetID(target.ID);
        if (target.HasAddressFields) {
            me.viewModel.AddressFormItems().forEach(function (item) {
                target.AddressFormItems.forEach(function (formItem) {
                    if (item.FormText() === formItem.FormText) {
                        item.Value(formItem.Value);
                    }
                });
            });
        }
        else {
            me.viewModel.FormItems().forEach(function (item) {
                target.FormItems.forEach(function (formItem) {
                    if (item.FormText() === formItem.FormText) {
                        item.Value(formItem.Value);
                    }
                });
            });
        }
    };
    TaskAddController.prototype.getAppointmentDateTimeAsMoment = function () {
        if (this.viewModel.AppointmentDate() && this.viewModel.AppointmentTime()) {
            var momentFormat = UI.getMomentDateFormat(this.DateFormat) + " " + UI.getMomentTimeFormat(this.TimeFormat);
            return moment(this.viewModel.AppointmentDate() + " " + this.viewModel.AppointmentTime(), momentFormat);
        }
        else {
            return null;
        }
    };
    return TaskAddController;
}());
exports.TaskAddController = TaskAddController;
function formatAutocompleteTarget(targetFieldValue) {
    return UI.formatValueFromControlType(targetFieldValue.Value, targetFieldValue.ControlTypeID);
}
var myGlobal = (window || global);
myGlobal.formatAutocompleteTarget = formatAutocompleteTarget;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(25)))

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var AppointmentAddData = __webpack_require__(379);
var TaskAutoAddController = (function () {
    function TaskAutoAddController() {
        this.viewModel = {
            CreatingTask: ko.observable("Please wait while your " + Constants.LABEL_APPOINTMENT + " is being created..."),
        };
    }
    TaskAutoAddController.prototype.render = function (container) {
        var _this = this;
        var app = Global.app();
        var deferred = $.Deferred();
        this.container = container;
        app.templates().render("taskautoadd", "template_taskautoadd", this.container)
            .done(function () {
            ko.applyBindings(_this.viewModel, _this.container[0]);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TaskAutoAddController.prototype.load = function (params) {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        var templateID = null;
        if (params != null && params.length > 0) {
            templateID = Number(params[0]);
        }
        var request = {
            TemplateID: templateID,
        };
        AppointmentAddData.createDefaultAppointment(request)
            .done(function (response) {
            if (response.Success) {
                app.pageManager().gotoTaskPage(response.Payload.ID, true);
                deferred.resolve();
            }
            else {
                me.showErrorMessages(response.ErrorMessages);
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    TaskAutoAddController.prototype.haveFieldsChanged = function () {
        return false;
    };
    TaskAutoAddController.prototype.appRouterID = function (params) {
        var routerID = "TaskAutoAdd";
        if (params != null && params.length === 1) {
            routerID += params[0];
        }
        return routerID;
    };
    TaskAutoAddController.prototype.title = function () {
        return "Create " + Constants.LABEL_APPOINTMENT;
    };
    TaskAutoAddController.prototype.subTitle = function () {
        return "";
    };
    TaskAutoAddController.prototype.showErrorMessages = function (errMessages) {
        var me = this;
        me.viewModel.CreatingTask(errMessages.join("."));
    };
    return TaskAutoAddController;
}());
exports.TaskAutoAddController = TaskAutoAddController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(854);
var ko = __webpack_require__(4);
var moment = __webpack_require__(0);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var Util = __webpack_require__(8);
var appointmentCalendarData = __webpack_require__(872);
var UPDATE_CALENDAR = "Update Calendar";
var SAVE_AS_DEFAULT = "Save as Default";
var schema = {
    model: {
        id: "taskId",
        fields: {
            taskId: { from: "TaskID", type: "number" },
            title: { from: "Title", defaultValue: "No title", validation: { required: true } },
            start: { type: "date", from: "Start" },
            end: { type: "date", from: "End" },
            startTimezone: { from: "StartTimezone" },
            endTimezone: { from: "EndTimezone" },
            description: { from: "Description" },
            recurrenceId: { from: "RecurrenceID" },
            recurrenceRule: { from: "RecurrenceRule" },
            recurrenceException: { from: "RecurrenceException" },
            ownerId: { from: "OwnerID", defaultValue: 1 },
            isAllDay: { type: "boolean", from: "IsAllDay" },
            reschedule: { from: "Reschedule" },
            isEditable: { type: "boolean", from: "IsEditable" },
            inspectorID: { from: "InspectorID" },
            appointmentStatus: { from: "AppointmentStatus" },
            appointmentShortName: { from: "AppointmentShortName" },
            color: { from: "Color" },
        },
    },
};
var TaskCalendarController = (function () {
    function TaskCalendarController() {
        var _this = this;
        this.currentViewName = "day";
        this.currentDate = new Date();
        this.majorTick = 10;
        var me = this;
        this.viewModel = {
            Inspectors: ko.observableArray(),
            StartTime: ko.observable(""),
            EndTime: ko.observable(""),
            IsInspector: ko.observable(false),
            IsUserManager: ko.observable(false),
            AppointmentSummaryInfo: ko.observable(),
            selectAll: function () {
                me.selectUnselectAll(true);
            },
            deselectAll: function () {
                me.selectUnselectAll(false);
            },
            onSubmit: function () {
                me.inspectorModal.modal("hide");
                me.saveInspectorsFilter(UPDATE_CALENDAR);
            },
            saveDefaultInspectors: function () {
                me.inspectorModal.modal("hide");
                me.saveInspectorsFilter(SAVE_AS_DEFAULT);
            },
            openInspectors: function () {
                me.originalInspectors = [];
                for (var _i = 0, _a = me.viewModel.Inspectors(); _i < _a.length; _i++) {
                    var inspectorObservable = _a[_i];
                    me.originalInspectors.push({
                        ID: inspectorObservable.ID(),
                        IsChecked: inspectorObservable.IsChecked(),
                        Name: inspectorObservable.Name(),
                    });
                }
                me.inspectorModal.modal("show");
            },
            refreshCalendar: function () {
                me.refresh();
            },
            closeInspectorModal: function () {
                me.viewModel.Inspectors.removeAll();
                for (var _i = 0, _a = me.originalInspectors; _i < _a.length; _i++) {
                    var inspector = _a[_i];
                    me.viewModel.Inspectors.push({
                        ID: ko.observable(inspector.ID),
                        IsChecked: ko.observable(inspector.IsChecked),
                        Name: ko.observable(inspector.Name),
                    });
                }
                me.inspectorModal.modal("hide");
            },
            closeAppointmentSummaryModal: function () {
                _this.appointmentSummaryModal.modal("hide");
            },
            InspectorsLabel: Constants.LABEL_INSPECTORS,
            AppointmentLabel: Constants.LABEL_APPOINTMENT,
        };
    }
    TaskCalendarController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        this.inspectorModal = container.find("div[data-id='inspectorModal']");
        this.appointmentSummaryModal = container.find("div[data-id='appointmentSummaryModal']");
        ko.applyBindings(this.viewModel, container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    TaskCalendarController.prototype.load = function () {
        var me = this;
        var waitContainer;
        var deferred = $.Deferred();
        var app = Global.app();
        waitContainer = UI.showWaitIndicator(me.container);
        appointmentCalendarData.loadSettings()
            .done(function (response) {
            var startDate;
            var startDateObject;
            var urlDate = Util.getURLParameter("date");
            if (Util.isNullOrEmpty(urlDate)) {
                startDateObject = moment();
            }
            else {
                startDateObject = moment(urlDate);
            }
            me.currentDate = startDateObject.toDate();
            startDate = startDateObject.format("MM-DD-YYYY");
            me.updateDefaultInspectors(response.Payload.Inspectors);
            me.viewModel.StartTime(startDate + " " + response.Payload.StartTimeString);
            me.viewModel.EndTime(startDate + " " + response.Payload.EndTimeString);
            me.viewModel.IsInspector(response.Payload.IsInspector);
            me.viewModel.IsUserManager(app.userSession ? app.userSession.Permissions.indexOf(Constants.PERMISSION_VIEW_MOBILE_USERS) >= 0 : false);
            me.resources = response.Payload.Resources;
            me.majorTick = response.Payload.MajorTick;
            me.buildControl();
            deferred.resolve();
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    TaskCalendarController.prototype.refresh = function () {
        var deferred = $.Deferred();
        var urlDate;
        var startDateObject;
        urlDate = Util.getURLParameter("date");
        if (!Util.isNullOrEmpty(urlDate)) {
            startDateObject = moment(urlDate);
            this.currentDate = startDateObject.toDate();
            this.scheduler.date(this.currentDate);
        }
        this.schedulerRefresh();
        deferred.resolve();
        return deferred.promise();
    };
    TaskCalendarController.prototype.add = function () {
        Global.app().router().navigate("/TaskAdd", true);
    };
    TaskCalendarController.prototype.saveInspectorsFilter = function (action) {
        var deferred = $.Deferred();
        var me = this;
        var inspectorsFilter = [];
        var waitContainer = UI.showWaitIndicator(me.container);
        me.viewModel.Inspectors().forEach(function (inspector) {
            var record = {
                ID: inspector.ID(),
                Name: inspector.Name(),
                IsChecked: inspector.IsChecked(),
            };
            inspectorsFilter.push(record);
        });
        if (action === SAVE_AS_DEFAULT) {
            appointmentCalendarData.saveInspectors(inspectorsFilter)
                .done(function (response) {
                if (response.Success) {
                    me.updateResources();
                    me.buildControl();
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                }
            })
                .fail(function () {
                deferred.reject();
            })
                .always(function () {
                UI.hideWaitIndicator(me.container, waitContainer);
            });
        }
    };
    TaskCalendarController.prototype.saveDragAndDrop = function (action, scheduledEvent) {
        var me = this;
        var waitContainer = UI.showWaitIndicator(me.container);
        appointmentCalendarData
            .save(action, scheduledEvent)
            .done(function (response) {
            if (response.Success) {
                me.schedulerRefresh();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
            me.schedulerRefresh();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
    };
    TaskCalendarController.prototype.onSchedulerAdd = function (e) {
        var app = Global.app();
        var eStartString = moment(e.event.start).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        e.preventDefault();
        app.router().navigate("/TaskAdd?date=" + eStartString + "&inspectorID=" + e.event.inspectorID, true);
    };
    TaskCalendarController.prototype.onSchedulerEdit = function (e) {
        var app = Global.app();
        var event = e.event;
        e.preventDefault();
        if (event.taskId != null && event.taskId > 0) {
            app.pageManager().gotoTaskPage(event.taskId, false);
        }
    };
    TaskCalendarController.prototype.onSchedulerMoveStart = function (e) {
        var event = e.event;
        if (!event.isEditable) {
            e.preventDefault();
        }
    };
    TaskCalendarController.prototype.onSchedulerMoveEnd = function (e) {
        var me = this;
        var waitContainer = UI.showWaitIndicator(me.container);
        var action = "save";
        var eStartString = moment(e.start).format("MM/DD/YYYY hh:mm A");
        var eEndString = moment(e.end).format("MM/DD/YYYY hh:mm A");
        if (me.isOverlapEvent(e.event, e.start, e.end, e.resources.inspectorID)) {
            UI.showConfirmDialog("This time slot is occupied with another schedule. Do you want to proceed?", function () { me.reschedule(e.event, eStartString, eEndString, e.resources.inspectorID, action); }, function () { me.schedulerRefresh(); });
        }
        else {
            me.reschedule(e.event, eStartString, eEndString, e.resources.inspectorID, action);
        }
        UI.hideWaitIndicator(me.container, waitContainer);
    };
    TaskCalendarController.prototype.onSchedulerResizeStart = function (e) {
        var event = e.event;
        if (event.isEditable === false) {
            e.preventDefault();
        }
    };
    TaskCalendarController.prototype.onSchedulerResizeEnd = function (e) {
        var me = this;
        var waitContainer = UI.showWaitIndicator(me.container);
        var action = "save";
        var eStartString = moment(e.start).format("MM/DD/YYYY hh:mm A");
        var eEndString = moment(e.end).format("MM/DD/YYYY hh:mm A");
        if (me.isOverlapEvent(e.event, e.start, e.end, e.event.inspectorID)) {
            UI.showConfirmDialog("This time slot is occupied with another schedule. Do you want to proceed?", function () { me.reschedule(e.event, eStartString, eEndString, e.event.inspectorID, action); }, function () { me.schedulerRefresh(); });
        }
        else {
            me.reschedule(e.event, eStartString, eEndString, e.event.inspectorID, action);
        }
        UI.hideWaitIndicator(me.container, waitContainer);
    };
    TaskCalendarController.prototype.onNavigate = function (e) {
        this.schedulerRefresh(e.date, e.view);
        this.currentViewName = e.view;
        this.currentDate = e.date;
    };
    TaskCalendarController.prototype.loadScheduleData = function (startDate, actionView) {
        var me = this;
        var waitContainer = UI.showWaitIndicator(me.container);
        var deferred = $.Deferred();
        var inspectors = [];
        me.viewModel.Inspectors().forEach(function (inspectorObservable) {
            var inspector = {
                ID: inspectorObservable.ID(),
                IsChecked: inspectorObservable.IsChecked(),
                Name: inspectorObservable.Name(),
            };
            inspectors.push(inspector);
        });
        appointmentCalendarData
            .loadAppointments(startDate, actionView, inspectors)
            .done(function (response) {
            if (response.Success) {
                me.scheduler.setDataSource(new kendo.data.SchedulerDataSource({
                    data: response.Payload,
                    schema: schema,
                }));
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
            deferred.resolve();
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    TaskCalendarController.prototype.updateDefaultInspectors = function (inspectors) {
        var me = this;
        inspectors.forEach(function (inspector) {
            var koInspector = {
                ID: ko.observable(inspector.ID),
                Name: ko.observable(inspector.Name),
                IsChecked: ko.observable(inspector.IsChecked),
            };
            me.viewModel.Inspectors.push(koInspector);
        });
    };
    TaskCalendarController.prototype.schedulerRefresh = function (schedulerDate, schedulerView) {
        var date = schedulerDate ? schedulerDate : this.scheduler.date();
        var view = schedulerView ? schedulerView : this.scheduler.viewName();
        this.loadScheduleData(moment(date).format("MM-DD-YYYY"), view);
    };
    TaskCalendarController.prototype.selectUnselectAll = function (select) {
        var me = this;
        me.viewModel.Inspectors().forEach(function (inspector) {
            inspector.IsChecked(select);
        });
    };
    TaskCalendarController.prototype.loadRecord = function (id) {
        var deferred = $.Deferred();
        deferred.resolve();
        return deferred.promise();
    };
    TaskCalendarController.prototype.height = function (height) {
        var fieldHeight = height - 110;
        var me = this;
        if (fieldHeight > 0) {
            if (this.scheduler != null) {
                clearTimeout(this.resizeTimeoutID);
                this.resizeTimeoutID = window.setTimeout(function () {
                    me.scheduler.element.height(fieldHeight);
                    me.scheduler.resize(true);
                }, 500);
            }
            this.container.find("div[data-id='scheduler']").height(fieldHeight);
            this.inspectorModal.css("max-height", fieldHeight);
        }
    };
    TaskCalendarController.prototype.doValidation = function () {
        return true;
    };
    TaskCalendarController.prototype.haveFieldsChanged = function () {
        return false;
    };
    TaskCalendarController.prototype.title = function () {
        return Constants.LABEL_APPOINTMENT + " Calendar";
    };
    TaskCalendarController.prototype.subTitle = function () {
        return "";
    };
    TaskCalendarController.prototype.allowRecordToChangeAfterLoad = function () {
        return false;
    };
    TaskCalendarController.prototype.appRouterID = function (params) {
        var routerID = "AppointmentCalendar";
        if (params != null && params.length === 1) {
            routerID += params[0];
        }
        return routerID;
    };
    TaskCalendarController.prototype.isOverlapEvent = function (event, newStart, newEnd, newInspectorID) {
        var me = this;
        var isOverlap = false;
        var eventList = me.scheduler.occurrencesInRange(newStart, newEnd);
        if (eventList != null && eventList.length > 0) {
            if (eventList.filter(function (x) { return x.taskId !== event.taskId && x.inspectorID === newInspectorID; }).length >= 1) {
                isOverlap = true;
            }
        }
        return isOverlap;
    };
    TaskCalendarController.prototype.reschedule = function (event, slotStartString, slotEndString, inspectorID, action) {
        var me = this;
        var newEvent = me.assignEvent(event, inspectorID, slotStartString, slotEndString);
        me.saveDragAndDrop(action, newEvent);
    };
    TaskCalendarController.prototype.assignEvent = function (event, inspectorID, start, end) {
        var newScheduleEvent;
        newScheduleEvent = {
            TaskID: event.taskId,
            InspectorID: inspectorID,
            Title: event.title,
            Description: event.description,
            StartTimezone: event.startTimezone,
            Start: start,
            End: end,
            EndTimezone: event.endTimezone,
            RecurrenceRule: event.recurrenceRule,
            RecurrenceID: event.recurrenceId,
            RecurrenceException: event.recurrenceException,
            IsAllDay: event.isAllDay,
            Reschedule: event.reschedule,
            IsEditable: event.isEditable,
            AppointmentStatus: event.appointmentStatus,
            AppointmentShortName: event.appointmentShortName,
            Color: event.color,
        };
        return newScheduleEvent;
    };
    TaskCalendarController.prototype.updateResources = function () {
        var me = this;
        me.resources = [];
        me.viewModel.Inspectors().forEach(function (inspector) {
            if (inspector.IsChecked()) {
                me.resources.push({ text: inspector.Name(), value: inspector.ID(), color: "#0099FF" });
            }
        });
    };
    TaskCalendarController.prototype.buildControl = function () {
        var app = Global.app();
        var me = this;
        me.customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
        var customerSelectedTimeFormat = UI.GetCustomerSetting(this.customerSettings, Constants.SETTING_KEY_TIMEFORMAT, Constants.DEFAULT_TIME_FORMAT);
        var startDateTime;
        var endDateTime;
        var schedulerContainer = me.container.find("div[data-id='scheduler']");
        var defaultViews;
        startDateTime = moment(me.viewModel.StartTime(), Constants.MOMENT_FORMAT_DATETIME_FROM_CONFIG);
        endDateTime = moment(me.viewModel.EndTime(), Constants.MOMENT_FORMAT_DATETIME_FROM_CONFIG);
        if (me.scheduler) {
            me.scheduler.destroy();
        }
        schedulerContainer.empty();
        defaultViews = [
            { title: "Day", type: "kendo.ui.DayView", showWorkHours: true, selected: (me.currentViewName.toLowerCase().indexOf("day") >= 0) },
            { title: "Month", type: "kendo.ui.MonthView", selected: (me.currentViewName.toLowerCase().indexOf("month") >= 0) },
        ];
        me.scheduler = schedulerContainer.kendoScheduler({
            moveStart: me.onSchedulerMoveStart.bind(me),
            moveEnd: me.onSchedulerMoveEnd.bind(me),
            resizeStart: me.onSchedulerResizeStart.bind(me),
            resizeEnd: me.onSchedulerResizeEnd.bind(me),
            edit: me.onSchedulerEdit.bind(me),
            add: me.onSchedulerAdd.bind(me),
            navigate: me.onNavigate.bind(me),
            date: me.currentDate,
            workDayStart: startDateTime.toDate(),
            workDayEnd: endDateTime.toDate(),
            views: defaultViews,
            majorTimeHeaderTemplate: kendo.template("#=kendo.toString(date,\"" + UI.getKendoTimeFormat(customerSelectedTimeFormat) + "\")#"),
            majorTick: me.majorTick,
            minorTickCount: 2,
            selectable: true,
            allDaySlot: false,
            snap: false,
            eventTemplate: kendo.template($("#template_appointmentcalendar_detail").html()),
            group: {
                resources: ["Inspectors"],
            },
            resources: [
                {
                    field: "inspectorID",
                    name: "Inspectors",
                    dataSource: me.resources,
                    title: "Name",
                },
            ],
            editable: {
                destroy: false,
                create: true,
                move: true,
                resize: true,
            },
            height: 300,
            dataBound: me.onDataBind.bind(me),
        }).data("kendoScheduler");
        me.height(app.pageManager().workspaceHeight());
        me.schedulerRefresh(this.currentDate, this.currentViewName);
    };
    TaskCalendarController.prototype.onDataBind = function (e) {
        var rows = $(".k-scheduler-layout tr:first .k-scheduler-table")
            .not(".k-scheduler-header-all-day")
            .find("tr:eq(1)");
        if (e.sender.view().name === "day") {
            rows.hide();
        }
        $(".calendar-info-link").click(this.onEventInfoClick.bind(this));
    };
    TaskCalendarController.prototype.onEventInfoClick = function (e) {
        var _this = this;
        this.viewModel.AppointmentSummaryInfo(null);
        var taskID = $(e.currentTarget).attr("data-id");
        var waitContainer = UI.showWaitIndicator(this.container);
        appointmentCalendarData.getAppointmentSummary(taskID)
            .then(function (response) {
            if (response.Success) {
                _this.viewModel.AppointmentSummaryInfo(response.Payload);
                _this.appointmentSummaryModal.modal("show");
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        }).always(function () {
            UI.hideWaitIndicator(_this.container, waitContainer);
        });
    };
    return TaskCalendarController;
}());
exports.TaskCalendarController = TaskCalendarController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function loadAppointments(startDate, actionView, inspectors) {
    var request = {
        actionView: actionView,
        calendarInspectors: inspectors,
        startDate: startDate,
    };
    return Util.callWebService("/api/AppointmentCalendar/GetCalendarAppointments", "POST", request);
}
exports.loadAppointments = loadAppointments;
function loadSettings() {
    return Util.callWebService("/api/AppointmentCalendar/GetCalendarSetting", "POST", null, false);
}
exports.loadSettings = loadSettings;
function save(action, data) {
    return Util.callWebService("/api/AppointmentCalendar/SaveAppointment", "POST", data);
}
exports.save = save;
function saveInspectors(data) {
    return Util.callWebService("/api/AppointmentCalendar/SaveCalendarInspectors", "POST", data);
}
exports.saveInspectors = saveInspectors;
function getAppointmentSummary(id) {
    return Util.callWebService("/api/AppointmentCalendar/GetAppointmentSummary/" + id, "POST");
}
exports.getAppointmentSummary = getAppointmentSummary;


/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var moment = __webpack_require__(0);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var Data = __webpack_require__(874);
var TaskDashboardController = (function () {
    function TaskDashboardController() {
        var me = this;
        var app = Global.app();
        me.viewModel = {
            Templates: ko.observableArray(),
            Appointments: ko.observableArray(),
            AppointmentLabel: ko.observable(Constants.LABEL_APPOINTMENT),
            AppointmentsLabel: ko.observable(Constants.LABEL_APPOINTMENTS),
            CustomerDocumentDownloadUrl: app.webServiceBaseURL + "/api/DocumentLibrary/Download/",
            onCreateTask: function (id, name) {
                me.createTask(id, name);
            },
            onEditTask: function (id) {
                me.editTask(id);
            },
        };
    }
    TaskDashboardController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, this.container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    TaskDashboardController.prototype.load = function (params) {
        var deferred = $.Deferred();
        var me = this;
        me.loadData();
        deferred.resolve();
        return deferred.promise();
    };
    TaskDashboardController.prototype.refresh = function () {
        var me = this;
        me.loadData();
    };
    TaskDashboardController.prototype.haveFieldsChanged = function () {
        return false;
    };
    TaskDashboardController.prototype.appRouterID = function (params) {
        return Constants.DEFAULT_CONTROLLER_TASK;
    };
    TaskDashboardController.prototype.title = function () {
        return "Task Dashboard";
    };
    TaskDashboardController.prototype.subTitle = function () {
        return "";
    };
    TaskDashboardController.prototype.loadData = function () {
        var _this = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        Data.GetUserDashboard()
            .done(function (response) {
            if (response.Success) {
                _this.loadUIData(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(_this.container, waitContainer);
        });
        return deferred.promise();
    };
    TaskDashboardController.prototype.createTask = function (id, name) {
        var confirmMessage = "Are you sure you want to start '" + name + "'?";
        var matchingAppointments = this.viewModel.Appointments().filter(function (x) { return x.TemplateName === name; });
        if (matchingAppointments.length > 0) {
            confirmMessage = confirmMessage + "  There are " + matchingAppointments.length + " existing " + Constants.LABEL_APPOINTMENTS.toLowerCase() + " of this type.";
        }
        UI.showConfirmDialog(confirmMessage, function () {
            Global.app().router().navigate("TaskAutoAdd/" + id, true);
        });
    };
    TaskDashboardController.prototype.editTask = function (id) {
        var app = Global.app();
        app.router().navigate("TaskEntry/" + id, true);
    };
    TaskDashboardController.prototype.loadUIData = function (data) {
        data.Appointments.forEach(function (d) {
            d.AppointmentDate = moment(d.AppointmentDate).format("MM-DD-YYYY");
        });
        this.viewModel.Appointments(data.Appointments);
        this.viewModel.Templates(data.Templates);
    };
    return TaskDashboardController;
}());
exports.TaskDashboardController = TaskDashboardController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function GetUserDashboard() {
    return Util.callWebService("/api/Appointment/UserDashboard", "GET");
}
exports.GetUserDashboard = GetUserDashboard;


/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(22);
__webpack_require__(83);
var ko = __webpack_require__(4);
var _ = __webpack_require__(9);
var addFormDialog_1 = __webpack_require__(372);
var Constants = __webpack_require__(5);
var FormDataEntry = __webpack_require__(378);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var AppointmentData = __webpack_require__(58);
var TargetData = __webpack_require__(45);
var TemplateData = __webpack_require__(84);
var TaskEntryController = (function () {
    function TaskEntryController() {
        this.NAVIGATIONTYPE_FINISH_TASK = -1;
        this.skipValidation = true;
        var me = this;
        this.viewModelAppointmentDetail = this.createViewModelAppointmentDetail();
        this.viewModelTree = this.createViewModelTree();
        this.viewModelExceptionReport = this.createViewModelExceptionReport();
        this.viewModelFinishAppointment = this.createViewModelFinishAppointment();
        this.additionalFormControl = new FormDataEntry.FormDataEntryControl({});
        this.formControl = new FormDataEntry.FormDataEntryControl({
            openAdditionalForm: function (formItemIndex, hasExceptionForm, templateFormID, field) {
                me.additionalviewModel.formItemIndex(formItemIndex);
                if (field) {
                    me.additionalviewModel.field(field);
                }
                else {
                    me.additionalviewModel.field(null);
                }
                me.additionalviewModel.hasExceptionForm(hasExceptionForm);
                me.openAdditionalForm(templateFormID);
            },
        });
        this.additionalviewModel = {
            formItemIndex: ko.observable(0),
            field: ko.observable(null),
            hasExceptionForm: ko.observable(false),
            SaveProcessStarted: ko.observable(false),
            onSaveForm: function () {
                var _this = this;
                this.SaveProcessStarted(true);
                me.save(true).always(function () {
                    _this.SaveProcessStarted(false);
                });
            },
            onCancelForm: function () {
                me.container.find("div[data-id='additionalFormDialog']").modal("hide");
                if (me.additionalviewModel.hasExceptionForm()) {
                    var myformitems = me.formControl.getFormItems();
                    if (myformitems.FormItems[me.additionalviewModel.formItemIndex()].ControlTypeID === Constants.QuestionType.DROPDOWN) {
                        myformitems.FormItems[me.additionalviewModel.formItemIndex()].dropdownselected = null;
                    }
                    else if (myformitems.FormItems[me.additionalviewModel.formItemIndex()].ControlTypeID === Constants.QuestionType.RADIOBUTTONLIST) {
                        myformitems.FormItems[me.additionalviewModel.formItemIndex()].selected = "";
                    }
                    else if (myformitems.FormItems[me.additionalviewModel.formItemIndex()].ControlTypeID === Constants.QuestionType.CHECKBOXLIST) {
                        var selectedArray = myformitems.FormItems[me.additionalviewModel.formItemIndex()].selectedArray;
                        var field = me.additionalviewModel.field();
                        if (selectedArray && field) {
                            selectedArray.splice(selectedArray.indexOf(field.FieldValue()), 1);
                        }
                    }
                }
            },
        };
        this.addFormDialog = new addFormDialog_1.AddFormDialog();
    }
    TaskEntryController.prototype.save = function (isAdditionalForm) {
        if (isAdditionalForm === void 0) { isAdditionalForm = false; }
        var me = this;
        var waitContainer;
        var deferred = $.Deferred();
        waitContainer = UI.showWaitIndicator(me.container);
        if (isAdditionalForm) {
            var myformitems = me.formControl.getFormItems();
            var originalFormItemID = myformitems.FormItems[me.additionalviewModel.formItemIndex()].ID;
            AppointmentData.SaveAppointmentAdditionalForm(ko.toJS(me.additionalFormControl.getFormItemsForSave()), this.navigationID, this.listID, originalFormItemID)
                .done(function (response) {
                if (response.Success) {
                    me.container.find("div[data-id='additionalFormDialog']").modal("hide");
                    UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                    deferred.resolve();
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                    deferred.reject();
                }
            })
                .fail(function () {
                deferred.reject();
            })
                .always(function () {
                UI.hideWaitIndicator(me.container, waitContainer);
            });
        }
        else {
            AppointmentData.SaveAppointmentForm(ko.toJS(me.formControl.getFormItemsForSave()), this.navigationID, this.skipValidation, this.listID)
                .done(function (response) {
                if (response.Success) {
                    UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                    me.loadFormItemsByTemplateFormID(me.templateFormID, me.appointmentID).done(function () {
                        deferred.resolve();
                    })
                        .fail(function () {
                        deferred.reject();
                    });
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                    deferred.reject();
                }
            })
                .fail(function () {
                deferred.reject();
            })
                .always(function () {
                UI.hideWaitIndicator(me.container, waitContainer);
            });
        }
        return deferred.promise();
    };
    TaskEntryController.prototype.render = function (container) {
        var me = this;
        var deferred = $.Deferred();
        me.container = container;
        me.formControl.render(container.find("div[data-id='formContainer']").find(".tree-detail-container")).done(function () {
            me.additionalFormControl.render(container.find("div[data-id='additionalFormContainer']")).done(function () {
                ko.applyBindings(me.viewModelTree, container.find("div[data-id='treeContainer']")[0]);
                ko.applyBindings(me.additionalviewModel, container.find("div[data-id='additionalFormButtons']")[0]);
                ko.applyBindings(me.viewModelExceptionReport, container.find("div[data-id='exceptionReportContainer']")[0]);
                ko.applyBindings(me.viewModelFinishAppointment, container.find("div[data-id='finishAppointmentContainer']")[0]);
                me.addFormDialog.render(container);
                deferred.resolve();
            });
        });
        return deferred.promise();
    };
    TaskEntryController.prototype.load = function (params) {
        if (params != null && params.length === 1) {
            this.appointmentID = params[0];
        }
        else {
            this.appointmentID = 0;
        }
        return this.loadRecord(this.appointmentID);
    };
    TaskEntryController.prototype.haveFieldsChanged = function () {
        return false;
    };
    TaskEntryController.prototype.height = function (height) {
        var detailHeight;
        if (Global.app().hideMenu) {
            detailHeight = height;
        }
        else {
            detailHeight = height - 68;
        }
        if (detailHeight > 0) {
            this.container.find("div[data-id='treeContainer']").height(detailHeight);
            this.container.find("div[data-id='formContainer']").height(detailHeight);
            this.container.find("div[data-id='additionalFormContainer']").find(".tree-detail-container").css("min-height", detailHeight);
            this.container.find("div[data-id='finishAppointmentContainer']").height(detailHeight);
        }
    };
    TaskEntryController.prototype.appRouterID = function (params) {
        var routerID = "Appointment";
        if (params != null && params.length === 1) {
            routerID += params[0];
        }
        return routerID;
    };
    TaskEntryController.prototype.title = function () {
        return Constants.LABEL_APPOINTMENT;
    };
    TaskEntryController.prototype.subTitle = function () {
        var subTitle = "";
        if (this.appointmentID == null) {
            subTitle = "New";
        }
        else {
            subTitle = this.viewModelAppointmentDetail.TargetShortDescription();
        }
        return subTitle;
    };
    TaskEntryController.prototype.showSaveButton = function () {
        if (this.viewModelFinishAppointment) {
            return this.viewModelFinishAppointment.isOpen();
        }
        else {
            return false;
        }
    };
    TaskEntryController.prototype.createViewModelExceptionReport = function () {
        return {
            ExceptionNavigations: ko.observableArray(),
            AppointmentLabel: ko.observable(Constants.LABEL_APPOINTMENT),
            QuestionLabel: ko.observable(Constants.LABEL_QUESTION),
        };
    };
    TaskEntryController.prototype.createViewModelTree = function () {
        var me = this;
        return {
            Navigations: ko.observableArray(),
            onEditNavigation: function (navigationObservable) {
                me.confirmDetailChange(function () {
                    me.editNavigation(navigationObservable);
                });
            },
            onShowNavigationReport: function (navigationObservable) {
                me.confirmDetailChange(function () {
                    me.showNavigationReport(navigationObservable);
                });
            },
            onShowFinishAppointment: function (navigationObservable) {
                me.confirmDetailChange(function () {
                    me.showFinishAppointment(navigationObservable);
                });
            },
            onAddNavigationList: function (navigationObservable) {
                me.confirmDetailChange(function () {
                    me.addFormDialog.show(navigationObservable.ListItems(), function (listName, templateFormID, ID) {
                        me.createNewForm(ID, listName, templateFormID, navigationObservable.ID())
                            .done(function (listObservable) {
                            navigationObservable.Lists.push(listObservable);
                            me.editList(listObservable);
                        });
                    });
                });
            },
            onNavigationShowActions: function (navigationObservable) {
                navigationObservable.ShowActions(true);
            },
            onNavigationHideActions: function (navigationObservable) {
                navigationObservable.ShowActions(false);
            },
            onEditList: function (listObservable) {
                me.confirmDetailChange(function () {
                    me.editList(listObservable);
                });
            },
            onNavigationToggleExpanded: function (navigationObservable) {
                navigationObservable.IsExpanded(!navigationObservable.IsExpanded());
            },
            onAddList: function (listObservable) {
                me.addFormDialog.show(listObservable.ListItems(), function (listName, templateFormID, ID) {
                    me.createNewForm(ID, listName, templateFormID, listObservable.NavigationID())
                        .done(function (newListObservable) {
                        listObservable.Children.push(newListObservable);
                    });
                });
            },
            onMoveListUp: function (listObservable) {
                me.moveListItem(listObservable, true);
            },
            onMoveListDown: function (listObservable) {
                me.moveListItem(listObservable, false);
            },
            onListToggleExpanded: function (listObservable) {
                listObservable.IsExpanded(!listObservable.IsExpanded());
            },
            onListShowActions: function (listObservable) {
                listObservable.ShowActions(true);
            },
            onListHideActions: function (listObservable) {
                listObservable.ShowActions(false);
            },
        };
    };
    TaskEntryController.prototype.createViewModelAppointmentDetail = function () {
        var app = Global.app();
        var languages = [];
        if (app.userSession && app.userSession.Languages) {
            languages = app.userSession.Languages;
        }
        var viewModel = {
            TargetShortDescription: ko.observable(""),
            LinkedCustomerDocuments: ko.observableArray(),
            CustomerDocumentDownloadUrl: app.webServiceBaseURL + "/api/DocumentLibrary/Download/",
            LanguageID: ko.observable(0),
            Languages: languages,
        };
        return viewModel;
    };
    TaskEntryController.prototype.createViewModelFinishAppointment = function () {
        var _this = this;
        var me = this;
        var viewModel = {
            appointmentLabel: Constants.LABEL_APPOINTMENT,
            finishButtonLabel: "Finish " + Constants.LABEL_APPOINTMENT,
            isOpen: ko.observable(true),
            isCancelled: ko.observable(false),
            hasValidationErrors: ko.observable(false),
            navigationErrors: ko.observableArray([]),
            onFinishAppointment: function () {
                UI.showConfirmDialog("Are you sure you want to finish this " + Constants.LABEL_APPOINTMENT + "?  The " + Constants.LABEL_APPOINTMENT + " cannot be changed once it is finished.", function () {
                    var waitContainer = UI.showWaitIndicator(_this.container);
                    AppointmentData.CompleteAppointment(me.appointmentID)
                        .done(function (response) {
                        if (response.Success) {
                            UI.showNotificationMessage("The " + Constants.LABEL_APPOINTMENT + " has been finished.", UI.messageTypeValues.success);
                            Global.app().pageManager().closeAllAndGotoDefaultPage();
                        }
                        else {
                            UI.showErrorMessage(response.ErrorMessages);
                        }
                    })
                        .always(function () {
                        UI.hideWaitIndicator(me.container, waitContainer);
                    });
                });
            },
            onEditNavigationAfterFailedValidation: function (model) {
                var navObservable = me.viewModelTree.Navigations().find(function (x) { return x.ID() === model.NavigationID; });
                me.editNavigation(navObservable)
                    .done(function () {
                    me.formControl.isValid();
                });
            },
            onCancelAppointment: function () {
                UI.showConfirmDialog("Are you sure you want to cancel this " + Constants.LABEL_APPOINTMENT + "?", function () {
                    var waitContainer = UI.showWaitIndicator(_this.container);
                    AppointmentData.CancelAppointment(me.appointmentID)
                        .done(function (response) {
                        if (response.Success) {
                            UI.showNotificationMessage("The " + Constants.LABEL_APPOINTMENT + " is now cancelled.", UI.messageTypeValues.success);
                            Global.app().pageManager().closeAllAndGotoDefaultPage();
                        }
                        else {
                            UI.showErrorMessage(response.ErrorMessages);
                        }
                    })
                        .always(function () {
                        UI.hideWaitIndicator(me.container, waitContainer);
                    });
                });
            },
            onOpenAppointment: function () {
                UI.showConfirmDialog("Are you sure you want to open this " + Constants.LABEL_APPOINTMENT + "?", function () {
                    var waitContainer = UI.showWaitIndicator(_this.container);
                    AppointmentData.OpenAppointment(me.appointmentID)
                        .done(function (response) {
                        if (response.Success) {
                            UI.showNotificationMessage("The " + Constants.LABEL_APPOINTMENT + " has been opened.", UI.messageTypeValues.success);
                            me.viewModelFinishAppointment.isCancelled(false);
                            me.viewModelFinishAppointment.isOpen(true);
                            me.validateAppointment();
                        }
                        else {
                            UI.showErrorMessage(response.ErrorMessages);
                        }
                    })
                        .always(function () {
                        UI.hideWaitIndicator(me.container, waitContainer);
                    });
                });
            },
        };
        return viewModel;
    };
    TaskEntryController.prototype.validateAppointment = function () {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        AppointmentData.ValidateAppointment(me.appointmentID)
            .done(function (response) {
            if (response.Success) {
                me.displayNavigationErrors(response.Payload.NavigationErrors);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TaskEntryController.prototype.displayNavigationErrors = function (navErrors) {
        this.viewModelFinishAppointment.hasValidationErrors(navErrors.length > 0);
        this.viewModelFinishAppointment.navigationErrors(navErrors);
    };
    TaskEntryController.prototype.loadAdditionalFormItemsByTemplateFormID = function (templateFormID, appointmentID, origFormItemID) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        AppointmentData.GetAdditionalFormItemsByTemplateFormID(templateFormID, appointmentID, this.navigationID, origFormItemID, this.listID)
            .done(function (response) {
            if (response.Success) {
                me.updateAdditionalFormItems(response.Payload.AppointmentFormItem);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TaskEntryController.prototype.loadFormItemsByTemplateFormID = function (templateFormID, appointmentID, origFormItemID) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        AppointmentData.GetFormItemsByTemplateFormID(templateFormID, appointmentID, this.navigationID, origFormItemID, this.listID)
            .done(function (response) {
            if (response.Success) {
                me.updateFormItems(response.Payload.AppointmentFormItem);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TaskEntryController.prototype.updateAdditionalFormItems = function (appointmentFormItems) {
        var formItems = appointmentFormItems.map(function (formItem) {
            var formItemCopy = {
                ID: formItem.ID,
                TemplateFormItemID: formItem.TemplateFormItemID,
                FormAnswer: formItem.FormAnswer,
                Comments: formItem.Comments,
                Documents: formItem.Documents,
                AdditionalFormItems: formItem.AdditionalFormItems,
                ControlTypeID: formItem.ControlTypeID,
                AppointmentID: formItem.AppointmentID,
                FormText: formItem.FormText,
                FormTextTranslations: formItem.FormTextTranslations,
                SortOrder: formItem.SortOrder,
                IsRequired: formItem.IsRequired,
                IsReadOnly: formItem.IsReadOnly,
                IsVisible: formItem.IsVisible,
                Fields: formItem.Fields,
                AppointmentControlTypeAttribute: formItem.AppointmentControlTypeAttribute,
                AppointmentFormItemDocumentTypesAllowed: formItem.AppointmentFormItemDocumentTypesAllowed,
                TemplatePhraseID: formItem.TemplatePhraseID,
                TemplatePhrases: formItem.TemplatePhrases,
                AdditionalTemplateFormID: formItem.AdditionalTemplateFormID,
                IsAdditionalForm: true,
                AppointmentFormItemLinkedCustomerDocuments: formItem.AppointmentFormItemLinkedCustomerDocuments,
                MultipleAdditionalForms: formItem.MultipleAdditionalForms,
                Targets: formItem.Targets,
            };
            return formItemCopy;
        });
        var loadParams = {
            FormItems: formItems,
            LanguageID: this.viewModelAppointmentDetail.LanguageID(),
        };
        this.additionalFormControl.load(loadParams);
        this.additionalFormControl.show();
        this.showAdditionalFormDialog();
    };
    TaskEntryController.prototype.updateExceptionReport = function (items) {
        this.viewModelExceptionReport.ExceptionNavigations(items.ExceptionReportNavigations);
    };
    TaskEntryController.prototype.updateFormItems = function (appointmentFormItems) {
        var formItems = appointmentFormItems.map(function (formItem) {
            var formItemCopy = {
                ID: formItem.ID,
                TemplateFormItemID: formItem.TemplateFormItemID,
                FormAnswer: formItem.FormAnswer,
                Comments: formItem.Comments,
                Documents: formItem.Documents,
                AdditionalFormItems: formItem.AdditionalFormItems,
                ControlTypeID: formItem.ControlTypeID,
                AppointmentID: formItem.AppointmentID,
                FormText: formItem.FormText,
                FormTextTranslations: formItem.FormTextTranslations,
                SortOrder: formItem.SortOrder,
                IsRequired: formItem.IsRequired,
                IsReadOnly: formItem.IsReadOnly,
                IsVisible: formItem.IsVisible,
                Fields: formItem.Fields,
                AppointmentControlTypeAttribute: formItem.AppointmentControlTypeAttribute,
                AppointmentFormItemDocumentTypesAllowed: formItem.AppointmentFormItemDocumentTypesAllowed,
                TemplatePhraseID: formItem.TemplatePhraseID,
                TemplatePhrases: formItem.TemplatePhrases,
                AdditionalTemplateFormID: formItem.AdditionalTemplateFormID,
                AppointmentFormItemLinkedCustomerDocuments: formItem.AppointmentFormItemLinkedCustomerDocuments,
                MultipleAdditionalForms: formItem.MultipleAdditionalForms,
                Targets: formItem.Targets,
            };
            return formItemCopy;
        });
        var loadParams = {
            FormItems: formItems,
            LanguageID: this.viewModelAppointmentDetail.LanguageID(),
        };
        this.formControl.load(loadParams);
    };
    TaskEntryController.prototype.loadRecord = function (id) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        AppointmentData.GetMaster(id)
            .done(function (response) {
            if (response.Success) {
                me.updateViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TaskEntryController.prototype.updateViewModel = function (master) {
        this.updateViewModelTree(master.Appointment);
        this.updateViewModelAppointmentDetail(master);
        this.updateViewModelFinishAppointment(master);
        if (this.viewModelTree.Navigations().length > 0) {
            this.editNavigation(this.viewModelTree.Navigations()[0]);
        }
    };
    TaskEntryController.prototype.updateViewModelTree = function (appointment) {
        var me = this;
        this.viewModelTree.Navigations.removeAll();
        var hasVisibleFormItems = function (navigation) {
            if (navigation.NavigationTypeID === TemplateData.NAVIGATIONTYPE_FORM) {
                return navigation.Forms && navigation.Forms.some(function (x) { return x.IsVisible; });
            }
            else {
                return true;
            }
        };
        appointment.Navigations.forEach(function (navigation) {
            if (hasVisibleFormItems(navigation)) {
                me.viewModelTree.Navigations.push(me.createNavigationObservable(navigation));
            }
        });
        me.viewModelTree.Navigations.push(this.createNavigationObservable({
            ID: 0,
            Lists: [],
            Forms: [],
            NavigationTypeID: this.NAVIGATIONTYPE_FINISH_TASK,
            TemplateFormID: null,
            NavigationName: "Finish " + Constants.LABEL_APPOINTMENT,
            NavigationNameTranslations: [],
            NavigationIcon: null,
            SortOrder: 0,
            ListItems: [],
        }));
    };
    TaskEntryController.prototype.createNavigationObservable = function (navigation) {
        var me = this;
        var navigationObservable = {
            ID: ko.observable(navigation.ID),
            TemplateFormID: ko.observable(navigation.TemplateFormID),
            NavigationTypeID: ko.observable(navigation.NavigationTypeID),
            NavigationName: ko.pureComputed(function () {
                if (navigationObservable.NavigationNameTranslations) {
                    var translations = navigationObservable.NavigationNameTranslations
                        .filter(function (navigationNameTranslations) { return navigationNameTranslations.LanguageID === me.viewModelAppointmentDetail.LanguageID(); });
                    if (translations && translations.length > 0 && translations[0].TranslatedText) {
                        return translations[0].TranslatedText;
                    }
                    else {
                        return navigationObservable.NavigationNameDefault();
                    }
                }
                else {
                    return navigationObservable.NavigationNameDefault();
                }
            }),
            NavigationNameDefault: ko.observable(navigation.NavigationName),
            NavigationNameTranslations: navigation.NavigationNameTranslations,
            NavigationIcon: ko.observable(navigation.NavigationIcon),
            SortOrder: ko.observable(navigation.SortOrder),
            IsExpanded: ko.observable(true),
            ListItems: ko.observableArray(navigation.ListItems),
            Lists: ko.observableArray(this.createListObservables(navigation.Lists, navigation.ID)),
            Forms: navigation.Forms,
            IsSelected: ko.observable(false),
            ShowActions: ko.observable(false),
        };
        navigationObservable.typeIsForm = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_FORM;
        });
        navigationObservable.typeIsList = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_LIST;
        });
        navigationObservable.typeIsReport = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_REPORT;
        });
        navigationObservable.typeIsFinishTask = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === me.NAVIGATIONTYPE_FINISH_TASK;
        });
        navigationObservable.showFinishTask = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === me.NAVIGATIONTYPE_FINISH_TASK && !Global.app().hideMenu;
        });
        navigationObservable.numberOfLists = ko.pureComputed(function () {
            return navigationObservable.Lists().length;
        });
        navigationObservable.rowStyle = ko.pureComputed(function () {
            if (navigationObservable.IsSelected()) {
                return "list-group-item active";
            }
            else {
                return "list-group-item";
            }
        });
        return navigationObservable;
    };
    TaskEntryController.prototype.updateViewModelAppointmentDetail = function (appointmentMaster) {
        var appointment = this.viewModelAppointmentDetail;
        var docList = [];
        for (var _i = 0, _a = appointmentMaster.Appointment.LinkedCustomerDocuments; _i < _a.length; _i++) {
            var doc = _a[_i];
            docList.push({
                CustomerDocumentID: doc.CustomerDocumentID,
                Description: doc.Description,
                FileName: doc.FileName,
                IsActive: doc.IsActive,
            });
        }
        for (var _b = 0, _c = appointmentMaster.Appointment.Target.LinkedCustomerDocuments; _b < _c.length; _b++) {
            var doc = _c[_b];
            docList.push({
                CustomerDocumentID: doc.CustomerDocumentID,
                Description: doc.Description,
                FileName: doc.FileName,
                IsActive: doc.IsActive,
            });
        }
        appointment.LinkedCustomerDocuments(_.uniqWith(docList, function (a, b) { return a.CustomerDocumentID === b.CustomerDocumentID; }));
        appointment.TargetShortDescription(this.getTargetShortDescription(appointmentMaster.Appointment.Target));
        appointment.LanguageID(appointmentMaster.Appointment.LanguageID);
    };
    TaskEntryController.prototype.updateViewModelFinishAppointment = function (appointmentMaster) {
        this.viewModelFinishAppointment.isOpen(this.isAppointmentOpen(appointmentMaster));
        this.viewModelFinishAppointment.isCancelled(this.isAppointmentCancelled(appointmentMaster));
    };
    TaskEntryController.prototype.isAppointmentOpen = function (appointmentMaster) {
        var status = appointmentMaster.StatusValues.filter(function (statusValue) { return statusValue.ID === appointmentMaster.Appointment.StatusID; });
        if (status && status.length > 0) {
            return status[0].IsOpen;
        }
        else {
            return false;
        }
    };
    TaskEntryController.prototype.isAppointmentCancelled = function (appointmentMaster) {
        var status = appointmentMaster.StatusValues.filter(function (statusValue) { return statusValue.ID === appointmentMaster.Appointment.StatusID; });
        if (status && status.length > 0) {
            return status[0].IsCancelled;
        }
        else {
            return false;
        }
    };
    TaskEntryController.prototype.getTargetShortDescription = function (target) {
        var description = "";
        switch (target.TargetTemplateTypeID) {
            case TargetData.TARGETEMPLTETYPEID_LOCATION:
                description = target.Address;
                break;
            case TargetData.TARGETEMPLTETYPEID_CUSTOM:
                if (target.FormItems.length > 0) {
                    description = target.FormItems[0].Value;
                }
                break;
        }
        return description;
    };
    TaskEntryController.prototype.createListObservables = function (appointmentLists, navigationID) {
        var me = this;
        var listObservables = [];
        appointmentLists.forEach(function (appointmentList) {
            listObservables.push(me.createListObservable(appointmentList, navigationID));
        });
        return listObservables;
    };
    TaskEntryController.prototype.createListObservable = function (appointmentList, navigationID) {
        var listObservable = {
            ID: ko.observable(appointmentList.ID),
            NavigationID: ko.observable(navigationID),
            ListName: ko.observable(appointmentList.ListName),
            HasForm: ko.observable(appointmentList.HasForm),
            HasAttributes: ko.observable(appointmentList.HasAttributes),
            SortOrder: ko.observable(appointmentList.SortOrder),
            CanDelete: ko.observable(appointmentList.CanDelete),
            IsActive: ko.observable(appointmentList.IsActive),
            Children: ko.observableArray(this.createListObservables(appointmentList.Children, navigationID)),
            ListItems: ko.observableArray(appointmentList.ListItems),
            ListForm: appointmentList.ListForm,
            TemplateFormID: ko.observable(appointmentList.TemplateFormID),
            IsExpanded: ko.observable(true),
            IsSelected: ko.observable(false),
            ShowActions: ko.observable(false),
        };
        listObservable.typeIsForm = ko.pureComputed(function () {
            return listObservable.HasForm();
        });
        listObservable.typeIsList = ko.pureComputed(function () {
            return !listObservable.HasForm();
        });
        listObservable.numberOfLists = ko.pureComputed(function () {
            return listObservable.Children().length;
        });
        listObservable.rowStyle = ko.pureComputed(function () {
            if (listObservable.IsSelected()) {
                return "tree-item tree-item-selected";
            }
            else {
                return "tree-item";
            }
        });
        return listObservable;
    };
    TaskEntryController.prototype.showFinishAppointment = function (navigationObservable) {
        this.hideExceptionReportContainer();
        this.hideFormContainer();
        this.showFinishAppointmentContainer();
        if (this.viewModelFinishAppointment.isOpen()) {
            this.validateAppointment();
        }
        this.formDetail = false;
        this.listID = null;
        this.templateFormID = null;
        this.unselectAllNavigation();
        navigationObservable.IsSelected(true);
    };
    TaskEntryController.prototype.editNavigation = function (navigationObservable) {
        var deferred = $.Deferred();
        this.navigationID = navigationObservable.ID();
        this.templateFormID = navigationObservable.TemplateFormID();
        this.listID = null;
        this.hideExceptionReportContainer();
        this.hideFinishAppointmentContainer();
        this.formDetail = true;
        this.loadFormItemsByTemplateFormID(navigationObservable.TemplateFormID(), this.appointmentID)
            .done(function () {
            deferred.resolve();
        });
        this.showFormContainer();
        this.formControl.show();
        this.unselectAllNavigation();
        navigationObservable.IsSelected(true);
        return deferred.promise();
    };
    TaskEntryController.prototype.showNavigationReport = function (navigationObservable) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(me.container);
        this.hideFormContainer();
        this.showExceptionReportContainer();
        this.formDetail = false;
        AppointmentData.GetExceptionReportData(me.appointmentID)
            .done(function (response) {
            if (response.Success) {
                me.updateExceptionReport(response.Payload);
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        this.unselectAllNavigation();
        navigationObservable.IsSelected(true);
        return deferred.promise();
    };
    TaskEntryController.prototype.editList = function (listObservable) {
        this.hideExceptionReportContainer();
        this.hideFinishAppointmentContainer();
        this.showFormContainer();
        this.listID = listObservable.ID();
        this.formDetail = true;
        this.navigationID = listObservable.NavigationID();
        this.templateFormID = listObservable.TemplateFormID();
        this.loadFormItemsByTemplateFormID(listObservable.TemplateFormID(), this.appointmentID);
        this.formControl.show();
        this.unselectAllNavigation();
        listObservable.IsSelected(true);
    };
    TaskEntryController.prototype.moveListItem = function (listObservableToMove, moveUp) {
        var me = this;
        var i = 1;
        var itemFound = false;
        this.viewModelTree.Navigations().forEach(function (navigation) {
            if (itemFound) {
                return;
            }
            var index = navigation.Lists.indexOf(listObservableToMove);
            if (index >= 0) {
                navigation.Lists.remove(listObservableToMove);
                if (moveUp) {
                    index = index - 1;
                }
                else {
                    index = index + 1;
                }
                navigation.Lists.splice(index, 0, listObservableToMove);
                navigation.Lists().forEach(function (list) {
                    list.SortOrder(i);
                    i++;
                });
                me.saveListOrder(navigation.Lists());
                listObservableToMove.ShowActions(false);
                itemFound = true;
            }
            else {
                navigation.Lists().forEach(function (list) {
                    if (itemFound) {
                        return;
                    }
                    if (list.Children().length === 0) {
                        return;
                    }
                    itemFound = me.moveListItemForList(listObservableToMove, moveUp, list);
                });
            }
        });
    };
    TaskEntryController.prototype.moveListItemForList = function (listObservableToMove, moveUp, parentList) {
        var me = this;
        var i = 1;
        var itemFound = false;
        var index = parentList.Children.indexOf(listObservableToMove);
        if (index >= 0) {
            parentList.Children.remove(listObservableToMove);
            if (moveUp) {
                index = index - 1;
            }
            else {
                index = index + 1;
            }
            parentList.Children.splice(index, 0, listObservableToMove);
            parentList.Children().forEach(function (list) {
                list.SortOrder(i);
                i++;
            });
            me.saveListOrder(parentList.Children());
            listObservableToMove.ShowActions(false);
            return true;
        }
        parentList.Children().forEach(function (child) {
            if (itemFound) {
                return;
            }
            if (child.Children().length === 0) {
                return;
            }
            itemFound = me.moveListItemForList(listObservableToMove, moveUp, child);
        });
        return itemFound;
    };
    TaskEntryController.prototype.createNewForm = function (ID, listName, templateFormID, navigationID) {
        var me = this;
        var deferred = $.Deferred();
        AppointmentData.SaveNewListForm(listName, ID, me.appointmentID, navigationID)
            .done(function (response) {
            if (response.Success) {
                me.listID = response.Payload.ID;
                var appointmentList = {
                    ID: response.Payload.ID,
                    ParentID: response.Payload.ParentID,
                    NavigationID: navigationID,
                    Children: [],
                    AttributeForm: [],
                    TemplateFormID: templateFormID,
                    ListForm: me.getAppointmentFormItems(response.Payload.ListForm),
                    ListName: listName,
                    IsActive: true,
                    HasForm: true,
                    HasAttributes: false,
                    SortOrder: 0,
                    CanDelete: true,
                    ListItems: [],
                };
                var listObservable = me.createListObservable(appointmentList, navigationID);
                deferred.resolve(listObservable);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        });
        return deferred.promise();
    };
    TaskEntryController.prototype.getAppointmentFormItems = function (FormItems) {
        var formItems = [];
        var me = this;
        FormItems.forEach(function (FormItem) {
            var formItem = {
                ID: FormItem.ID,
                TemplateFormItemID: FormItem.ID,
                AppointmentID: me.appointmentID,
                FormAnswer: FormItem.FormAnswer,
                Comments: [],
                Documents: [],
                AdditionalFormItems: [],
                ControlTypeID: FormItem.ControlTypeID,
                FormText: FormItem.FormText,
                SortOrder: FormItem.SortOrder,
                IsRequired: FormItem.IsRequired,
                IsReadOnly: FormItem.IsReadOnly,
                IsVisible: FormItem.IsVisible,
                Fields: FormItem.Fields,
                AppointmentControlTypeAttribute: FormItem.AppointmentControlTypeAttribute,
                AppointmentFormItemDocumentTypesAllowed: FormItem.AppointmentFormItemDocumentTypesAllowed,
                TemplatePhraseID: FormItem.TemplatePhraseID,
                AdditionalTemplateFormID: FormItem.AdditionalTemplateFormID,
                MultipleAdditionalForms: FormItem.MultipleAdditionalForms,
                Targets: FormItem.Targets,
            };
            formItems.push(formItem);
        });
        return formItems;
    };
    TaskEntryController.prototype.confirmDetailChange = function (onConfirmed) {
        if (!this.viewModelFinishAppointment.isOpen() ||
            !this.formDetail) {
            onConfirmed();
            return;
        }
        var showFieldValidationError = function () {
            UI.showErrorMessage(["There are errors in this section.  Please correct before moving to another section."]);
        };
        if (this.detailsChanged()) {
            this.save(false)
                .done(function () {
                onConfirmed();
            })
                .fail(function () {
                showFieldValidationError();
            });
        }
        else {
            onConfirmed();
        }
    };
    TaskEntryController.prototype.unselectAllNavigation = function () {
        var me = this;
        this.viewModelTree.Navigations().forEach(function (navigation) {
            navigation.IsSelected(false);
            if (navigation.Lists().length > 0) {
                me.unselectAllLists(navigation.Lists);
            }
        });
    };
    TaskEntryController.prototype.unselectAllLists = function (lists) {
        var me = this;
        lists().forEach(function (list) {
            list.IsSelected(false);
            if (list.Children().length > 0) {
                me.unselectAllLists(list.Children);
            }
        });
    };
    TaskEntryController.prototype.detailsChanged = function () {
        var formItemsChanged = this.formControl.haveFieldsChanged();
        if (this.formDetail && formItemsChanged) {
            return true;
        }
        return false;
    };
    TaskEntryController.prototype.showFormContainer = function () {
        this.container.find("div[data-id='formContainer']").removeClass("hidden");
    };
    TaskEntryController.prototype.hideFormContainer = function () {
        this.container.find("div[data-id='formContainer']").addClass("hidden");
    };
    TaskEntryController.prototype.showAdditionalFormDialog = function () {
        this.container.find("div[data-id='additionalFormDialog']").modal("show");
    };
    TaskEntryController.prototype.showExceptionReportContainer = function () {
        this.container.find("div[data-id='exceptionReportContainer']").removeClass("hidden");
    };
    TaskEntryController.prototype.hideExceptionReportContainer = function () {
        this.container.find("div[data-id='exceptionReportContainer']").addClass("hidden");
    };
    TaskEntryController.prototype.showFinishAppointmentContainer = function () {
        this.container.find("div[data-id='finishAppointmentContainer']").removeClass("hidden");
    };
    TaskEntryController.prototype.hideFinishAppointmentContainer = function () {
        this.container.find("div[data-id='finishAppointmentContainer']").addClass("hidden");
    };
    TaskEntryController.prototype.confirmedOpenAdditionalForm = function (templateFormID) {
        var me = this;
        var myformitems = me.formControl.getFormItems();
        var origFormItemID = myformitems.FormItems[me.additionalviewModel.formItemIndex()].ID;
        me.loadAdditionalFormItemsByTemplateFormID(templateFormID, this.appointmentID, origFormItemID);
    };
    TaskEntryController.prototype.openAdditionalForm = function (templateFormID) {
        var me = this;
        me.confirmedOpenAdditionalForm(templateFormID);
    };
    TaskEntryController.prototype.saveListOrder = function (lists) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer;
        waitContainer = UI.showWaitIndicator(me.container);
        AppointmentData.SaveListOrder(ko.toJS(lists))
            .done(function (response) {
            if (response.Success) {
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    return TaskEntryController;
}());
exports.TaskEntryController = TaskEntryController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(877);
var ko = __webpack_require__(4);
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var data_1 = __webpack_require__(23);
var Global = __webpack_require__(2);
var GridUtil = __webpack_require__(27);
var UI = __webpack_require__(3);
var TasksController = (function () {
    function TasksController() {
        var me = this;
        var app = Global.app();
        me.customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
        this.dateFormat = UI.GetCustomerSetting(this.customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT);
        this.timeFormat = UI.GetCustomerSetting(this.customerSettings, Constants.SETTING_KEY_TIMEFORMAT, Constants.DEFAULT_TIME_FORMAT);
    }
    TasksController.prototype.render = function (container) {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        me.container = container;
        me.gridContainer = container.find("div[data-id='grid']");
        me.dataSource = new kendo.data.DataSource({
            pageSize: 100,
        });
        var descriptionTemplateHtml = $("#template_appointments_description_nolink").html();
        if (app.userSession.Permissions.indexOf(Constants.PERMISSION_VIEW_TARGETS) >= 0) {
            descriptionTemplateHtml = $("#template_appointments_description").html();
        }
        var templateNameTemplateHtml = $("#template_appointments_templatename_nolink").html();
        if (app.userSession.Permissions.indexOf(Constants.PERMISSION_EDIT_APPOINTMENTS) >= 0) {
            templateNameTemplateHtml = $("#template_appointments_templatename").html();
        }
        var runReportTemplateHtml = $("#template_appointments_report_nolink").html();
        if (app.userSession.Permissions.indexOf(Constants.PERMISSION_RUN_REPORTS) >= 0) {
            runReportTemplateHtml = $("#template_appointments_report").html();
        }
        me.grid = me.gridContainer.kendoGrid({
            dataSource: me.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                {
                    title: "Date",
                    field: "AppointmentDate",
                    template: "#= AppointmentDate === null ? \" \" : kendo.toString(AppointmentDate, \"" + UI.getKendoDateFormat(me.dateFormat) + "\")#",
                    width: "120px",
                    filterable: {
                        ui: function (element) {
                            element.kendoDatePicker({
                                format: UI.getKendoDateFormat(me.dateFormat),
                            });
                        },
                    },
                },
                {
                    title: "Time",
                    field: "AppointmentDate",
                    template: "#= AppointmentDate === null ? \" \" : kendo.toString(AppointmentDate, \"" + UI.getKendoTimeFormat(me.timeFormat) + "\")#",
                    width: "120px",
                    filterable: false,
                    sortable: false,
                },
                { title: "Type", field: "TemplateName", template: kendo.template(templateNameTemplateHtml) },
                { title: "Target", field: "Description", template: kendo.template(descriptionTemplateHtml) },
                { title: "Assigned To", field: "AssignedUserName" },
                { title: "Status", field: "StatusName", width: "150px" },
                { title: "Report", width: "110px", template: kendo.template(runReportTemplateHtml) },
            ],
            excel: {
                fileName: Constants.LABEL_APPOINTMENTS + ".xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");
        me.viewModel = {
            searchText: ko.observable(""),
            exportToExcelUrl: app.webServiceBaseURL + "/api/appointments/export",
            sort: ko.observableArray(),
            filter: ko.observable(),
            searchAllFields: ko.observable(false),
        };
        ko.applyBindings(me.viewModel, me.container[0]);
        me.gridFilterControl = new GridUtil.GridFilterControl(container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showExportToExcel: true,
            showFilters: false,
            showRefresh: true,
            showSearchAllFields: true,
            filters: [],
            grid: me.grid,
            buttons: [{ name: "Export " + Constants.LABEL_APPOINTMENT + " Detail", iconClass: "fa fa-file-excel-o", onClick: this.exportAppointmentsToExcel.bind(me) }],
        });
        me.gridContainer.on("click", "a[data-id='link']", function (e) {
            var path = $(this).attr("href");
            e.preventDefault();
            app.router().navigate(_.defaultTo(path, ""), true);
            return false;
        });
        me.gridContainer.on("click", "a[data-id='tasklink']", function (e) {
            var appointmentIDString = $(this).attr("href");
            var appointmentID = Number(appointmentIDString);
            e.preventDefault();
            app.pageManager().gotoTaskPage(appointmentID, false);
            return false;
        });
        deferred.resolve();
        return deferred.promise();
    };
    TasksController.prototype.load = function (params) {
        var app = Global.app();
        var me = this;
        var dataSource;
        var deferred = $.Deferred();
        dataSource = data_1.createWebServiceDataSource("/api/Appointments/ForGrid", {
            id: "ID",
            fields: {
                AppointmentID: { type: "long" },
                StatusID: { type: "long" },
                AppointmentDate: { type: "date" },
                TargetID: { type: "long" },
                Description: { type: "string" },
                StatusName: { type: "string" },
                AssignedUserName: { type: "string" },
                TemplateName: { type: "string" },
                URLFriendlyName: { type: "string" },
                StatusIsOpen: { type: "boolean" },
                StatusIsCompleted: { type: "boolean" },
                StatusIsCancelled: { type: "boolean" },
                ReportID: { type: "long" },
            },
        }, function (data) {
            me.setDataFilter(data);
        }, function (status) {
            if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                app.pageManager().closeCurrentPage();
            }
        });
        me.grid.setDataSource(dataSource);
        deferred.resolve();
        return deferred.promise();
    };
    TasksController.prototype.add = function () {
        var app = Global.app();
        if (app.userSession.Permissions.indexOf(Constants.PERMISSION_CREATE_APPOINTMENTS) >= 0) {
            Global.app().router().navigate("/TaskAdd", true);
        }
    };
    TasksController.prototype.haveFieldsChanged = function () {
        return false;
    };
    TasksController.prototype.height = function (height) {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    };
    TasksController.prototype.refresh = function () {
        this.grid.dataSource.read();
    };
    TasksController.prototype.appRouterID = function (params) {
        return Constants.LABEL_APPOINTMENTS;
    };
    TasksController.prototype.title = function () {
        return Constants.LABEL_APPOINTMENTS;
    };
    TasksController.prototype.subTitle = function () {
        return "";
    };
    TasksController.prototype.setDataFilter = function (data) {
        if (this.gridFilterControl != null) {
            var values = this.gridFilterControl.getValues();
            data.SearchText = values.searchText;
            data.SearchAllFields = values.searchAllFields;
        }
    };
    TasksController.prototype.exportAppointmentsToExcel = function () {
        var values = this.gridFilterControl.getValues();
        var filters = this.grid.dataSource.filter();
        if (filters && filters.filters) {
            for (var _i = 0, _a = filters.filters; _i < _a.length; _i++) {
                var f = _a[_i];
                var filter = f;
                if (_.isDate(filter.value)) {
                    filter.value = filter.value.toJSON();
                }
            }
        }
        this.viewModel.filter(filters);
        this.viewModel.sort(this.grid.dataSource.sort());
        this.viewModel.searchText(values.searchText);
        this.viewModel.searchAllFields(values.searchAllFields ? values.searchAllFields : false);
        this.container.find("form[name='exportAppointmentsForm']").submit();
    };
    return TasksController;
}());
exports.TasksController = TasksController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var EventUtil = __webpack_require__(26);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var Util = __webpack_require__(8);
var TemplateData = __webpack_require__(84);
var TemplateController = (function () {
    function TemplateController() {
        this.LISTTYPE_FORM = "Form";
        this.LISTTYPE_LIST = "List";
        this.viewModelHeader = this.createViewModelHeader();
        this.viewModelTree = this.createViewModelTree();
        this.viewModelDetail = this.createViewModelDetail();
    }
    TemplateController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModelHeader, container.find("div[data-id='headerContainer']")[0]);
        ko.applyBindings(this.viewModelTree, container.find("div[data-id='treeContainer']")[0]);
        ko.applyBindings(this.viewModelDetail, container.find("div[data-id='detailContainer']")[0]);
        this.container.find("a[data-toggle='popover']").popover({ html: true });
        deferred.resolve();
        return deferred.promise();
    };
    TemplateController.prototype.load = function (params) {
        if (params != null && params.length === 1) {
            this.templateID = params[0];
        }
        else {
            this.templateID = 0;
        }
        return this.loadRecord(this.templateID);
    };
    TemplateController.prototype.haveFieldsChanged = function () {
        if (this.hasDetailDataChanged()) {
            return false;
        }
        var fieldValues = ko.toJSON(this.getTemplate());
        return fieldValues !== this.fieldsOnLoad;
    };
    TemplateController.prototype.height = function (height) {
        if (height > 150) {
            this.container.find("div[data-id='detailContainer']").children(".tree-detail-container").css("min-height", height - 150);
        }
    };
    TemplateController.prototype.appRouterID = function (params) {
        var routerID = "Template";
        if (params != null && params.length === 1) {
            routerID += params[0];
        }
        return routerID;
    };
    TemplateController.prototype.title = function () {
        return Constants.LABEL_APPOINTMENT + " Template";
    };
    TemplateController.prototype.subTitle = function () {
        var subTitle = "";
        if (this.templateID == null) {
            subTitle = "New";
        }
        else {
            subTitle = this.viewModelHeader.TemplateName();
        }
        return subTitle;
    };
    TemplateController.prototype.save = function () {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        var waitContainer;
        if (!this.isHeaderValid()) {
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
            deferred.reject();
            return deferred.promise();
        }
        waitContainer = UI.showWaitIndicator(this.container);
        TemplateData.Save(this.getTemplate())
            .done(function (response) {
            var currentID;
            if (response.Success) {
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                currentID = me.viewModelHeader.ID();
                me.clearSearch();
                me.updateViewModel(response.Payload);
                me.viewModelDetail.NavigationVisible(false);
                me.viewModelDetail.ListVisible(false);
                if (currentID <= 0) {
                    me.updateURL(response.Payload.Template.ID, response.Payload.Template.TemplateName);
                }
                else {
                    app.pageManager().refreshCurrentPageTitle();
                }
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    TemplateController.prototype.createViewModelHeader = function () {
        var me = this;
        var vm = {
            ID: ko.observable(),
            TemplateName: ko.observable(),
            TargetTemplateID: ko.observable(),
            IsActive: ko.observable(),
            CanChangeTargetTemplate: ko.observable(),
            TargetTemplates: ko.observableArray(),
            TargetTemplateName: ko.observable(),
            TemplateNameMissing: ko.observable(false),
            TargetTemplateIDMissing: ko.observable(false),
            toggleIsActive: function () {
                var message;
                if (this.IsActive()) {
                    message = "Are you sure you want to make this template inactive?";
                }
                else {
                    message = "Are you sure you want to make this template active?";
                }
                UI.showConfirmDialog(message, function () {
                    me.toggleIsActive();
                });
            },
        };
        return vm;
    };
    TemplateController.prototype.createViewModelTree = function () {
        var _this = this;
        var me = this;
        return {
            Navigations: ko.observableArray(),
            AppointmentLabel: ko.observable(Constants.LABEL_APPOINTMENT),
            onEditNavigation: function (navigationObservable) {
                me.confirmDetailChange(function () {
                    me.editNavigation(navigationObservable);
                });
            },
            onAddNavigation: function () {
                me.confirmDetailChange(function () {
                    me.addNavigation();
                });
            },
            onAddNavigationList: function (navigationObservable) {
                me.confirmDetailChange(function () {
                    me.addListItemToNavigation(navigationObservable);
                });
            },
            onMoveNavigationUp: function (navigationObservable) {
                me.moveNavigationItem(navigationObservable, true);
            },
            onMoveNavigationDown: function (navigationObservable) {
                me.moveNavigationItem(navigationObservable, false);
            },
            onNavigationShowActions: function (navigationObservable) {
                navigationObservable.ShowActions(true);
            },
            onNavigationHideActions: function (navigationObservable) {
                navigationObservable.ShowActions(false);
            },
            onEditList: function (listObservable) {
                me.confirmDetailChange(function () {
                    me.editList(listObservable);
                });
            },
            onNavigationToggleExpanded: function (navigationObservable) {
                navigationObservable.IsExpanded(!navigationObservable.IsExpanded());
            },
            onAddList: function (listObservable) {
                me.confirmDetailChange(function () {
                    me.addListItemToList(listObservable);
                });
            },
            onMoveListUp: function (listObservable) {
                me.moveListItem(listObservable, true);
            },
            onMoveListDown: function (listObservable) {
                me.moveListItem(listObservable, false);
            },
            onListToggleExpanded: function (listObservable) {
                listObservable.IsExpanded(!listObservable.IsExpanded());
            },
            onListShowActions: function (listObservable) {
                listObservable.ShowActions(true);
            },
            onListHideActions: function (listObservable) {
                listObservable.ShowActions(false);
            },
            onShowSettings: function () {
                me.confirmDetailChange(function () {
                    me.unselectAllNavigation();
                    me.viewModelDetail.ListVisible(false);
                    me.viewModelDetail.NavigationVisible(false);
                    me.viewModelDetail.SettingsVisibleDetail(true);
                    me.viewModelDetail.TranslationsVisibleDetail(false);
                    _this.viewModelTree.SettingsVisibleTree(true);
                    _this.viewModelTree.TranslationsVisibleTree(false);
                });
            },
            onShowTranslations: function () {
                me.confirmDetailChange(function () {
                    me.unselectAllNavigation();
                    me.viewModelDetail.ListVisible(false);
                    me.viewModelDetail.NavigationVisible(false);
                    me.viewModelDetail.SettingsVisibleDetail(false);
                    me.viewModelDetail.TranslationsVisibleDetail(true);
                    _this.viewModelTree.SettingsVisibleTree(false);
                    _this.viewModelTree.TranslationsVisibleTree(true);
                });
            },
            SettingsVisibleTree: ko.observable(false),
            TranslationsVisibleTree: ko.observable(false),
        };
    };
    TemplateController.prototype.createViewModelDetail = function () {
        var me = this;
        var app = Global.app();
        var languages = app.userSession ? app.userSession.Languages : [];
        var viewModelDetail = {
            NavigationVisible: ko.observable(false),
            Navigation: {
                ID: ko.observable(),
                TemplateFormID: ko.observable(),
                NavigationTypeID: ko.observable(),
                NavigationName: ko.observable(),
                IsActive: ko.observable(),
                ListForms: ko.observableArray(),
                searchFormName: ko.observable(),
                NavigationTypes: ko.observableArray(),
                NavigationForms: ko.observableArray(),
                TemplateFormIDMissing: ko.observable(false),
                NavigationTypeIDMissing: ko.observable(false),
                NavigationNameMissing: ko.observable(false),
                ListFormsMissing: ko.observable(false),
                onClose: function () {
                    if (me.hasDetailDataChanged()) {
                        UI.showConfirmDialog(Constants.PHRASE_ITEMUNSAVEDCHANGES, function () {
                            me.unselectAllNavigation();
                            me.viewModelDetail.NavigationVisible(false);
                        });
                    }
                    else {
                        me.unselectAllNavigation();
                        me.viewModelDetail.NavigationVisible(false);
                    }
                },
                onDelete: function () {
                    UI.showConfirmDialog("Are you sure you want to delete the navigation item '"
                        + this.NavigationName() + "' and any child items?", function () {
                        me.setNavigationIsActive(false);
                        UI.showNotificationMessage(Constants.PHRASE_ITEMDELETED, UI.messageTypeValues.success);
                    });
                },
                onUndoDelete: function () {
                    me.setNavigationIsActive(true);
                },
                onSave: function () {
                    me.clearSearch();
                    me.saveNavigation();
                },
                onSaveAndClose: function () {
                    me.clearSearch();
                    if (me.saveNavigation()) {
                        me.unselectAllNavigation();
                        me.viewModelDetail.NavigationVisible(false);
                    }
                },
            },
            NavigationOnLoad: "",
            ListVisible: ko.observable(false),
            List: {
                ID: ko.observable(),
                ListName: ko.observable(),
                HasAttributes: ko.observable(),
                IsActive: ko.observable(),
                ListItems: ko.observableArray(),
                ListTypeID: ko.observable(),
                FormID: ko.observable(),
                AttributeFormID: ko.observable(),
                ListTypes: ko.observableArray([me.LISTTYPE_FORM, me.LISTTYPE_LIST]),
                ListForms: ko.observableArray(),
                searchListItemFormName: ko.observable(),
                FormIDMissing: ko.observable(false),
                ListTypeIDMissing: ko.observable(false),
                ListNameMissing: ko.observable(false),
                ListFormsMissing: ko.observable(false),
                onClose: function () {
                    if (me.hasDetailDataChanged()) {
                        UI.showConfirmDialog(Constants.PHRASE_ITEMUNSAVEDCHANGES, function () {
                            me.unselectAllNavigation();
                            me.viewModelDetail.ListVisible(false);
                        });
                    }
                    else {
                        me.unselectAllNavigation();
                        me.viewModelDetail.ListVisible(false);
                    }
                },
                onDelete: function () {
                    UI.showConfirmDialog("Are you sure you want to delete the list item '" + this.ListName() + "' and any child items?", function () {
                        me.setListIsActive(false);
                        UI.showNotificationMessage(Constants.PHRASE_ITEMDELETED, UI.messageTypeValues.success);
                    });
                },
                onUndoDelete: function () {
                    me.setListIsActive(true);
                },
                onSave: function () {
                    me.clearSearch();
                    me.saveList();
                },
                onSaveAndClose: function () {
                    me.clearSearch();
                    if (me.saveList()) {
                        me.unselectAllNavigation();
                        me.viewModelDetail.ListVisible(false);
                    }
                },
            },
            ListOnLoad: "",
            SettingsVisibleDetail: ko.observable(false),
            Settings: {
                TemplateSecurityEnabled: ko.observable(false),
                TemplateRoles: ko.observableArray(),
                AllReports: ko.observableArray(),
                ReportID: ko.observable(),
                TemplateID: ko.observable(),
                CustomerDocumentDownloadUrl: app.webServiceBaseURL + "/api/DocumentLibrary/Download/",
                NotifyUserOnAssignment: ko.observable(),
                SelectedCustomerDocument: ko.observable(),
                AllCustomerDocuments: ko.observableArray(),
                LinkedCustomerDocuments: ko.observableArray(),
                SingleInstanceSettings: ko.observableArray(),
                ReportEmailSettings: ko.observableArray(),
                ReportEmailSettingTypes: ko.observableArray(),
                ReportEmailSettingTypeID: ko.observable(),
                ReportEmailSettingValue: ko.observable(),
                MobileTaskSettingsList: ko.observableArray(),
                MobileTaskSettingPath: ko.observable(),
                MobileSettingTypes: [],
                inValidEntry: ko.observable(false),
                linkDocument: function () {
                    if (viewModelDetail.Settings.SelectedCustomerDocument()) {
                        var doc = viewModelDetail.Settings.SelectedCustomerDocument();
                        var linkedDoc = {
                            TemplateCustomerDocumentID: ko.observable(0),
                            CustomerDocumentID: ko.observable(doc.ID()),
                            Description: ko.observable(doc.Description()),
                            FileName: ko.observable(doc.FileName()),
                            IsActive: ko.observable(doc.IsActive()),
                            StorageKey: ko.observable(doc.StorageKey()),
                        };
                        viewModelDetail.Settings.LinkedCustomerDocuments.push(linkedDoc);
                        viewModelDetail.Settings.SelectedCustomerDocument(null);
                    }
                },
                removeLinkedDocument: function (doc) {
                    UI.showConfirmDialog("Are you sure you want to remove this document?", function () {
                        if (doc.TemplateCustomerDocumentID() > 0) {
                            doc.IsActive(false);
                        }
                        else {
                            viewModelDetail.Settings.LinkedCustomerDocuments.remove(doc);
                        }
                    });
                },
                addReportEmailSetting: function () {
                    var settings = me.viewModelDetail.Settings;
                    if (settings.ReportEmailSettingTypeID() && settings.ReportEmailSettingValue()) {
                        var settingKey = settings.ReportEmailSettingTypes().filter(function (x) { return x.ID === settings.ReportEmailSettingTypeID(); });
                        var templateSetting = {
                            ID: ko.observable(0),
                            TemplateSettingTypeID: ko.observable(settings.ReportEmailSettingTypeID()),
                            SettingKey: ko.observable(settingKey[0].SettingKey),
                            Value: ko.observable(settings.ReportEmailSettingValue()),
                            SettingType: ko.observable("string"),
                            IsActive: ko.observable(true),
                        };
                        settings.ReportEmailSettings.push(templateSetting);
                        settings.ReportEmailSettingTypeID(null);
                        settings.ReportEmailSettingValue("");
                    }
                },
                removeReportEmailSetting: function (index) {
                    var selectedSetting = me.viewModelDetail.Settings.ReportEmailSettings()[index()];
                    UI.showConfirmDialog("Are you sure you want to delete \"" + selectedSetting.SettingKey() + "\"?", function () { me.DeleteReportEmailSetting(selectedSetting); });
                },
                addPathToMobileSettingList: function () {
                    var newSetting = me.viewModelDetail.Settings;
                    if (!Util.isNullOrSpace(newSetting.MobileTaskSettingPath()) &&
                        !newSetting.MobileTaskSettingsList().some(function (x) { return x.Value().toLowerCase() === newSetting.MobileTaskSettingPath().toLowerCase()
                            && x.IsActive() === true; })) {
                        me.viewModelDetail.Settings.inValidEntry(false);
                        var settingKey = newSetting.MobileSettingTypes.filter(function (x) { return x.SettingKey === Constants.TEMPLATE_MOBILE_SETTING_KEY_FIELD_PATH &&
                            x.SettingGroup === Constants.TEMPLATE_SETTING_GROUP_MOBILE_TASK_LIST; });
                        var templateSetting = {
                            ID: ko.observable(0),
                            TemplateSettingTypeID: ko.observable(settingKey[0].ID),
                            SettingKey: ko.observable(settingKey[0].SettingKey),
                            Value: ko.observable(newSetting.MobileTaskSettingPath()),
                            SettingType: ko.observable("string"),
                            IsActive: ko.observable(true),
                        };
                        newSetting.MobileTaskSettingsList.push(templateSetting);
                        newSetting.MobileTaskSettingPath("");
                    }
                    else {
                        me.viewModelDetail.Settings.inValidEntry(true);
                    }
                },
                removeMobileTaskSettingFromList: function (index) {
                    var selectedSetting = me.viewModelDetail.Settings.MobileTaskSettingsList()[index()];
                    UI.showConfirmDialog("Are you sure you want to delete \"" + selectedSetting.SettingKey() + "\"?", function () { me.DeleteMobileSetting(selectedSetting); });
                },
            },
            TranslationsVisibleDetail: ko.observable(false),
            Translations: {
                TranslationFieldTextSearch: ko.observable(""),
                TranslationLanguageIDSearch: ko.observable(0),
                TranslationLanguages: languages,
                Navigations: function () {
                    return me.viewModelTree.Navigations;
                },
                getFilteredTranslatedText: function (navigationObservable) {
                    var _this = this;
                    var searchText = this.TranslationFieldTextSearch() ? this.TranslationFieldTextSearch().toLowerCase() : "";
                    return navigationObservable.NavigationNameTranslations().filter(function (navigationNameTranslations) {
                        return (!_this.TranslationLanguageIDSearch() ||
                            navigationNameTranslations.LanguageID === _this.TranslationLanguageIDSearch())
                            &&
                                (!_this.TranslationFieldTextSearch() ||
                                    (navigationObservable.NavigationName() && navigationObservable.NavigationName().toLowerCase().indexOf(searchText) >= 0));
                    });
                },
            },
        };
        viewModelDetail.Navigation.typeIsForm = ko.pureComputed(function () {
            return viewModelDetail.Navigation.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_FORM;
        });
        viewModelDetail.Navigation.typeIsList = ko.pureComputed(function () {
            return viewModelDetail.Navigation.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_LIST;
        });
        viewModelDetail.Navigation.typeIsReport = ko.pureComputed(function () {
            return viewModelDetail.Navigation.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_REPORT;
        });
        viewModelDetail.List.typeIsForm = ko.pureComputed(function () {
            return viewModelDetail.List.ListTypeID() === me.LISTTYPE_FORM;
        });
        viewModelDetail.List.typeIsList = ko.pureComputed(function () {
            return viewModelDetail.List.ListTypeID() === me.LISTTYPE_LIST;
        });
        viewModelDetail.Navigation.searchResultHasForms = ko.pureComputed(function () {
            return viewModelDetail.Navigation.ListForms().some(function (x) { return x.Visible() === true; });
        });
        viewModelDetail.List.searchResultReturnsForms = ko.pureComputed(function () {
            return viewModelDetail.List.ListItems().some(function (x) { return x.Visible() === true; });
        });
        viewModelDetail.Settings.UnselectedCustomerDocuments = ko.pureComputed(function () {
            var selectedDocumentIDs = viewModelDetail.Settings.LinkedCustomerDocuments().map(function (doc) { return doc.CustomerDocumentID(); });
            return viewModelDetail.Settings.AllCustomerDocuments().filter(function (doc) {
                return selectedDocumentIDs.indexOf(doc.ID()) < 0;
            });
        });
        if (app.userSession) {
            var setting = UI.GetCustomerSetting(app.userSession.CustomerSettings, Constants.SETTING_KEY_TEMPLATE_ACCESS_SECURITY, "false");
            viewModelDetail.Settings.TemplateSecurityEnabled(setting === "true");
        }
        return viewModelDetail;
    };
    TemplateController.prototype.isHeaderValid = function () {
        var isValid = true;
        var header = this.viewModelHeader;
        isValid = UI.setRequiredString(header.TemplateName, header.TemplateNameMissing) ? isValid : false;
        if (header.CanChangeTargetTemplate()) {
            isValid = UI.setRequiredNumber(header.TargetTemplateID, header.TargetTemplateIDMissing, true) ? isValid : false;
        }
        else {
            header.TargetTemplateIDMissing(false);
        }
        return isValid;
    };
    TemplateController.prototype.loadRecord = function (id) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        TemplateData.GetMaster(id)
            .done(function (response) {
            if (response.Success) {
                me.updateViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TemplateController.prototype.updateViewModel = function (templateMaster) {
        this.updateViewModelHeader(templateMaster);
        this.updateViewModelTree(templateMaster);
        this.updateViewModelDetail(templateMaster);
        this.fieldsOnLoad = ko.toJSON(this.getTemplate());
    };
    TemplateController.prototype.updateViewModelHeader = function (templateMaster) {
        var _this = this;
        this.viewModelHeader.TargetTemplates.removeAll();
        this.viewModelHeader.TargetTemplates.push({ ID: 0, TemplateName: "(select target type)", URLFriendlyName: "", TemplateTypeName: "" });
        templateMaster.TargetTemplates.forEach(function (targetTemplate) {
            _this.viewModelHeader.TargetTemplates.push(targetTemplate);
        });
        this.viewModelHeader.ID(templateMaster.Template.ID);
        this.viewModelHeader.TemplateName(templateMaster.Template.TemplateName);
        this.viewModelHeader.TargetTemplateID(templateMaster.Template.TargetTemplateID);
        this.viewModelHeader.IsActive(templateMaster.Template.IsActive);
        this.viewModelHeader.CanChangeTargetTemplate(templateMaster.CanChangeTargetTemplate);
        this.viewModelHeader.TargetTemplateName(templateMaster.TargetTemplateName);
    };
    TemplateController.prototype.updateViewModelTree = function (templateMaster) {
        var me = this;
        this.viewModelTree.Navigations.removeAll();
        templateMaster.Template.Navigations.forEach(function (navigation) {
            me.viewModelTree.Navigations.push(me.createNavigationObservable(navigation));
        });
    };
    TemplateController.prototype.updateViewModelDetail = function (templateMaster) {
        var _this = this;
        var me = this;
        me.viewModelDetail.Navigation.NavigationTypes(templateMaster.NavigationTypes);
        me.viewModelDetail.Navigation.ListForms.removeAll();
        me.viewModelDetail.Navigation.NavigationForms.removeAll();
        me.viewModelDetail.Navigation.NavigationForms.push({ ID: "", FormName: "(select form)", FormDescription: "" });
        templateMaster.NavigationForms.forEach(function (listForm) {
            var listItem = {
                TemplateFormID: ko.observable(listForm.ID),
                TemplateFormName: ko.observable(listForm.FormName),
                TemplateFormDescription: ko.observable(listForm.FormDescription),
                Selected: ko.observable(false),
                Visible: ko.pureComputed(function () { return me.isVisible(me.viewModelDetail.Navigation.searchFormName, listItem); }),
            };
            me.viewModelDetail.Navigation.ListForms.push(listItem);
            me.viewModelDetail.Navigation.NavigationForms.push({ ID: listForm.ID, FormName: listForm.FormName, FormDescription: listForm.FormDescription });
        });
        me.viewModelDetail.List.ListItems.removeAll();
        me.viewModelDetail.List.ListForms.removeAll();
        me.viewModelDetail.List.ListForms.push({ ID: "", FormName: "(select form)", FormDescription: "" });
        templateMaster.NavigationForms.forEach(function (listForm) {
            var listItem = {
                TemplateFormID: ko.observable(listForm.ID),
                TemplateFormName: ko.observable(listForm.FormName),
                TemplateFormDescription: ko.observable(listForm.FormDescription),
                Selected: ko.observable(false),
                Visible: ko.pureComputed(function () { return me.isVisible(me.viewModelDetail.List.searchListItemFormName, listItem); }),
            };
            me.viewModelDetail.List.ListItems.push(listItem);
            me.viewModelDetail.List.ListForms.push({ ID: listForm.ID, FormName: listForm.FormName, FormDescription: listForm.FormDescription });
        });
        this.viewModelDetail.Settings.LinkedCustomerDocuments.removeAll();
        templateMaster.Template.LinkedCustomerDocuments.forEach(function (doc) {
            _this.viewModelDetail.Settings.LinkedCustomerDocuments.push(_this.createLinkedCustomerDocumentObservable(doc));
        });
        this.viewModelDetail.Settings.AllCustomerDocuments.removeAll();
        templateMaster.AllCustomerDocuments.forEach(function (doc) {
            _this.viewModelDetail.Settings.AllCustomerDocuments.push(_this.createCustomerDocumentObservable(doc));
        });
        this.viewModelDetail.Settings.NotifyUserOnAssignment(templateMaster.Template.NotifyUserOnAssignment);
        this.viewModelDetail.Settings.AllReports(templateMaster.AllReports);
        this.viewModelDetail.Settings.ReportID(templateMaster.Template.ReportID);
        this.viewModelDetail.Settings.TemplateRoles.removeAll();
        for (var _i = 0, _a = templateMaster.Template.TemplateRoles; _i < _a.length; _i++) {
            var r = _a[_i];
            this.viewModelDetail.Settings.TemplateRoles.push({
                ID: ko.observable(r.ID),
                TemplateID: ko.observable(templateMaster.Template.ID),
                IsActive: ko.observable(r.IsActive),
                TemplateAccessRoleID: ko.observable(r.TemplateAccessRoleID),
                TemplateAccessRoleName: ko.observable(r.TemplateAccessRoleName),
                TemplateName: ko.observable(r.TemplateName),
            });
        }
        this.viewModelDetail.Settings.SingleInstanceSettings.removeAll();
        this.viewModelDetail.Settings.ReportEmailSettings.removeAll();
        for (var _b = 0, _c = templateMaster.TemplateSettings; _b < _c.length; _b++) {
            var setting = _c[_b];
            if (setting.IsSingleInstance) {
                this.viewModelDetail.Settings.SingleInstanceSettings.push(this.createTemplateSettingObservable(setting));
            }
            else if (setting.SettingGroup === Constants.TEMPLATE_SETTING_GROUP_EMAIL_RECIPIENTS) {
                this.viewModelDetail.Settings.ReportEmailSettings.push(this.createTemplateSettingObservable(setting));
            }
        }
        this.viewModelDetail.Settings.ReportEmailSettingTypes.removeAll();
        for (var _d = 0, _e = templateMaster.TemplateSettingTypes; _d < _e.length; _d++) {
            var settingType = _e[_d];
            if (settingType.SettingGroup === Constants.TEMPLATE_SETTING_GROUP_EMAIL_RECIPIENTS) {
                this.viewModelDetail.Settings.ReportEmailSettingTypes.push(settingType);
            }
        }
        this.viewModelDetail.Settings.MobileTaskSettingsList.removeAll();
        for (var _f = 0, _g = templateMaster.TemplateSettings; _f < _g.length; _f++) {
            var setting = _g[_f];
            if (setting.SettingGroup === Constants.TEMPLATE_SETTING_GROUP_MOBILE_TASK_LIST) {
                this.viewModelDetail.Settings.MobileTaskSettingsList.push(this.createTemplateSettingObservable(setting));
            }
        }
        this.viewModelDetail.Settings.MobileSettingTypes.splice(0, 1);
        for (var _h = 0, _j = templateMaster.TemplateSettingTypes; _h < _j.length; _h++) {
            var settingType = _j[_h];
            if (settingType.SettingGroup === Constants.TEMPLATE_SETTING_GROUP_MOBILE_TASK_LIST) {
                this.viewModelDetail.Settings.MobileSettingTypes.push(settingType);
            }
        }
        this.viewModelDetail.Settings.MobileTaskSettingPath("");
        this.viewModelDetail.Settings.inValidEntry(false);
    };
    TemplateController.prototype.createTemplateSettingObservable = function (templateSetting) {
        var settingObservable = {
            ID: ko.observable(templateSetting.ID),
            TemplateSettingTypeID: ko.observable(templateSetting.TemplateSettingTypeID),
            SettingKey: ko.observable(templateSetting.SettingKey),
            Value: ko.observable(templateSetting.Value),
            SettingType: ko.observable(templateSetting.SettingType),
            IsActive: ko.observable(templateSetting.IsActive),
        };
        return settingObservable;
    };
    TemplateController.prototype.isVisible = function (searchword, listItem) {
        var isValid;
        if (!searchword()) {
            isValid = true;
        }
        else {
            var searchStringIndex = listItem.TemplateFormName().toLowerCase().indexOf(searchword().toLowerCase());
            if (searchStringIndex < 0) {
                isValid = false;
            }
            else {
                isValid = true;
            }
        }
        return isValid;
    };
    TemplateController.prototype.createNavigationObservable = function (navigation) {
        var _this = this;
        var getFormTextTranslationObservables = function (formTextTranslations) {
            var formTextTranslationObservables = _this.createEmptyFormTextTranslations();
            if (formTextTranslations) {
                var _loop_1 = function (formTextTranslationObservable) {
                    var matchingFormTextTranslation = formTextTranslations.filter(function (formTextTranslation) {
                        return formTextTranslation.LanguageID === formTextTranslationObservable.LanguageID;
                    });
                    if (matchingFormTextTranslation.length > 0) {
                        formTextTranslationObservable.TranslatedText(matchingFormTextTranslation[0].TranslatedText);
                    }
                };
                for (var _i = 0, formTextTranslationObservables_1 = formTextTranslationObservables; _i < formTextTranslationObservables_1.length; _i++) {
                    var formTextTranslationObservable = formTextTranslationObservables_1[_i];
                    _loop_1(formTextTranslationObservable);
                }
            }
            return formTextTranslationObservables;
        };
        var navigationObservable = {
            ID: ko.observable(navigation.ID),
            TemplateFormID: ko.observable(navigation.TemplateFormID),
            NavigationTypeID: ko.observable(navigation.NavigationTypeID),
            NavigationName: ko.observable(navigation.NavigationName),
            NavigationNameTranslations: ko.observableArray(getFormTextTranslationObservables(navigation.NavigationNameTranslations)),
            NavigationIcon: ko.observable(navigation.NavigationIcon),
            SortOrder: ko.observable(navigation.SortOrder),
            IsActive: ko.observable(navigation.IsActive),
            IsExpanded: ko.observable(true),
            ListItems: ko.observableArray(this.createListItemIDs(navigation.ListItems)),
            Lists: ko.observableArray(this.createListObservables(navigation.Lists)),
            IsSelected: ko.observable(false),
            ShowActions: ko.observable(false),
        };
        navigationObservable.typeIsForm = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_FORM;
        });
        navigationObservable.typeIsList = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_LIST;
        });
        navigationObservable.typeIsReport = ko.pureComputed(function () {
            return navigationObservable.NavigationTypeID() === TemplateData.NAVIGATIONTYPE_REPORT;
        });
        navigationObservable.numberOfLists = ko.pureComputed(function () {
            return navigationObservable.Lists().length;
        });
        navigationObservable.rowStyle = ko.pureComputed(function () {
            if (navigationObservable.IsSelected()) {
                return "tree-item tree-item-selected";
            }
            else {
                return "tree-item";
            }
        });
        return navigationObservable;
    };
    TemplateController.prototype.createCustomerDocumentObservable = function (doc) {
        return {
            ID: ko.observable(doc.ID),
            Description: ko.observable(doc.Description),
            FileName: ko.observable(doc.FileName),
            IsActive: ko.observable(doc.IsActive),
            StorageKey: ko.observable(doc.StorageKey),
            TempFileKey: ko.observable(doc.TempFileKey),
        };
    };
    TemplateController.prototype.createLinkedCustomerDocumentObservable = function (doc) {
        return {
            TemplateCustomerDocumentID: ko.observable(doc.TemplateCustomerDocumentID),
            CustomerDocumentID: ko.observable(doc.CustomerDocumentID),
            Description: ko.observable(doc.Description),
            FileName: ko.observable(doc.FileName),
            IsActive: ko.observable(doc.IsActive),
            StorageKey: ko.observable(doc.StorageKey),
        };
    };
    TemplateController.prototype.createListItemIDs = function (templateListItems) {
        var listItemIDs = [];
        templateListItems.forEach(function (templateListItem) {
            listItemIDs.push(templateListItem.TemplateFormID);
        });
        return listItemIDs;
    };
    TemplateController.prototype.createListObservables = function (templateLists) {
        var me = this;
        var listObservables = [];
        templateLists.forEach(function (templateList) {
            listObservables.push(me.createListObservable(templateList));
        });
        return listObservables;
    };
    TemplateController.prototype.createListObservable = function (templateList) {
        var listObservable = {
            ID: ko.observable(templateList.ID),
            ListName: ko.observable(templateList.ListName),
            HasForm: ko.observable(templateList.HasForm),
            HasAttributes: ko.observable(templateList.HasAttributes),
            SortOrder: ko.observable(templateList.SortOrder),
            IsActive: ko.observable(templateList.IsActive),
            Children: ko.observableArray(this.createListObservables(templateList.Children)),
            ListItems: ko.observableArray(this.createListItemIDs(templateList.ListItems)),
            FormID: ko.observable(templateList.FormID),
            AttributeFormID: ko.observable(templateList.AttributeFormID),
            IsExpanded: ko.observable(true),
            IsSelected: ko.observable(false),
            ShowActions: ko.observable(false),
        };
        listObservable.typeIsForm = ko.pureComputed(function () {
            return listObservable.HasForm();
        });
        listObservable.typeIsList = ko.pureComputed(function () {
            return !listObservable.HasForm();
        });
        listObservable.numberOfLists = ko.pureComputed(function () {
            return listObservable.Children().length;
        });
        listObservable.rowStyle = ko.pureComputed(function () {
            if (listObservable.IsSelected()) {
                return "tree-item tree-item-selected";
            }
            else {
                return "tree-item";
            }
        });
        return listObservable;
    };
    TemplateController.prototype.toggleIsActive = function () {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        var newIsActive = !this.viewModelHeader.IsActive();
        var request = {
            TemplateID: this.viewModelHeader.ID(),
            IsActive: newIsActive,
        };
        TemplateData.SetIsActive(request)
            .done(function (response) {
            if (response.Success) {
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                me.viewModelHeader.IsActive(newIsActive);
                me.fieldsOnLoad = ko.toJSON(me.getTemplate());
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve(true);
        });
        return deferred.promise();
    };
    TemplateController.prototype.editNavigation = function (navigationObservable) {
        var navigation = this.viewModelDetail.Navigation;
        navigation.ID(navigationObservable.ID());
        navigation.TemplateFormID(navigationObservable.TemplateFormID());
        navigation.NavigationTypeID(navigationObservable.NavigationTypeID());
        navigation.NavigationName(navigationObservable.NavigationName());
        navigation.IsActive(navigationObservable.IsActive());
        var templateFormIDs = navigationObservable.ListItems();
        navigation.ListForms().forEach(function (listItem) {
            var selected = _.includes(templateFormIDs, listItem.TemplateFormID());
            listItem.Selected(selected);
        });
        navigation.NavigationNameMissing(false);
        navigation.NavigationTypeIDMissing(false);
        navigation.TemplateFormIDMissing(false);
        navigation.ListFormsMissing(false);
        this.viewModelDetail.NavigationObservable = navigationObservable;
        this.viewModelDetail.NavigationOnLoad = ko.toJSON(this.viewModelDetail.Navigation);
        this.unselectAllNavigation();
        navigationObservable.IsSelected(true);
        this.viewModelDetail.ListVisible(false);
        this.viewModelDetail.NavigationVisible(true);
        this.viewModelDetail.SettingsVisibleDetail(false);
        this.viewModelTree.SettingsVisibleTree(false);
        this.viewModelTree.TranslationsVisibleTree(false);
        this.container.find("div[data-id='detailContainer']").find("input:first").focus();
    };
    TemplateController.prototype.saveNavigation = function () {
        if (this.viewModelDetail.NavigationObservable == null) {
            this.unselectAllNavigation();
            this.viewModelDetail.NavigationVisible(false);
            return true;
        }
        if (!this.isNavigationValid()) {
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
            return false;
        }
        var navigation = this.viewModelDetail.Navigation;
        var navigationObservable = this.viewModelDetail.NavigationObservable;
        navigationObservable.TemplateFormID(navigation.TemplateFormID());
        navigationObservable.NavigationTypeID(navigation.NavigationTypeID());
        navigationObservable.NavigationName(navigation.NavigationName());
        navigationObservable.ListItems.removeAll();
        navigation.ListForms().forEach(function (listForm) {
            if (listForm.Selected()) {
                navigationObservable.ListItems.push(listForm.TemplateFormID());
            }
        });
        this.viewModelDetail.NavigationOnLoad = ko.toJSON(this.viewModelDetail.Navigation);
        UI.showNotificationMessage(Constants.PHRASE_ITEMSAVED, UI.messageTypeValues.success);
        return true;
    };
    TemplateController.prototype.setNavigationIsActive = function (isActive) {
        if (this.viewModelDetail.NavigationObservable == null) {
            this.unselectAllNavigation();
            this.viewModelDetail.NavigationVisible(false);
            return true;
        }
        this.viewModelDetail.Navigation.IsActive(isActive);
        this.viewModelDetail.NavigationObservable.IsActive(isActive);
        this.viewModelDetail.NavigationOnLoad = ko.toJSON(this.viewModelDetail.Navigation);
        return true;
    };
    TemplateController.prototype.isNavigationValid = function () {
        var isValid = true;
        var navigation = this.viewModelDetail.Navigation;
        if (!navigation.IsActive()) {
            return true;
        }
        isValid = UI.setRequiredNumber(navigation.NavigationTypeID, navigation.NavigationTypeIDMissing, true) ? isValid : false;
        isValid = UI.setRequiredString(navigation.NavigationName, navigation.NavigationNameMissing) ? isValid : false;
        switch (navigation.NavigationTypeID()) {
            case TemplateData.NAVIGATIONTYPE_FORM:
                isValid = UI.setRequiredNumber(navigation.TemplateFormID, navigation.TemplateFormIDMissing, true) ? isValid : false;
                break;
            case TemplateData.NAVIGATIONTYPE_LIST:
                break;
            case TemplateData.NAVIGATIONTYPE_REPORT:
                break;
        }
        return isValid;
    };
    TemplateController.prototype.addNavigation = function () {
        var navigation = {
            ID: 0,
            TemplateFormID: 0,
            NavigationTypeID: TemplateData.NAVIGATIONTYPE_FORM,
            NavigationName: "New Navigation",
            NavigationNameTranslations: [],
            NavigationIcon: "",
            SortOrder: 0,
            IsActive: true,
            ListItems: [],
            Lists: [],
        };
        var navigationObservable = this.createNavigationObservable(navigation);
        this.viewModelTree.Navigations.push(navigationObservable);
        this.editNavigation(navigationObservable);
    };
    TemplateController.prototype.moveNavigationItem = function (navigationObservable, moveUp) {
        var index = this.viewModelTree.Navigations.indexOf(navigationObservable);
        if (index < 0) {
            return;
        }
        this.viewModelTree.Navigations.remove(navigationObservable);
        if (moveUp) {
            index = index - 1;
        }
        else {
            index = index + 1;
        }
        this.viewModelTree.Navigations.splice(index, 0, navigationObservable);
        navigationObservable.ShowActions(false);
    };
    TemplateController.prototype.editList = function (listObservable) {
        var list = this.viewModelDetail.List;
        list.ID(listObservable.ID());
        list.FormID(listObservable.FormID());
        if (listObservable.HasForm()) {
            list.ListTypeID(this.LISTTYPE_FORM);
        }
        else {
            list.ListTypeID(this.LISTTYPE_LIST);
        }
        list.ListName(listObservable.ListName());
        list.IsActive(listObservable.IsActive());
        var templateFormIDs = listObservable.ListItems();
        list.ListItems().forEach(function (listItem) {
            var selected = _.includes(templateFormIDs, listItem.TemplateFormID());
            listItem.Selected(selected);
        });
        list.ListNameMissing(false);
        list.ListTypeIDMissing(false);
        list.FormIDMissing(false);
        list.ListFormsMissing(false);
        this.viewModelDetail.ListObservable = listObservable;
        this.viewModelDetail.ListOnLoad = ko.toJSON(this.viewModelDetail.List);
        this.unselectAllNavigation();
        listObservable.IsSelected(true);
        this.viewModelDetail.ListVisible(true);
        this.viewModelDetail.NavigationVisible(false);
        this.viewModelDetail.SettingsVisibleDetail(false);
        this.viewModelTree.SettingsVisibleTree(false);
        this.viewModelTree.TranslationsVisibleTree(false);
        this.container.find("div[data-id='detailContainer']").find("input:first").focus();
    };
    TemplateController.prototype.saveList = function () {
        if (this.viewModelDetail.ListObservable == null) {
            this.unselectAllNavigation();
            this.viewModelDetail.ListVisible(false);
            return true;
        }
        if (!this.isListValid()) {
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
            return false;
        }
        var list = this.viewModelDetail.List;
        var listObservable = this.viewModelDetail.ListObservable;
        listObservable.FormID(list.FormID());
        if (list.ListTypeID() === this.LISTTYPE_FORM) {
            listObservable.HasForm(true);
        }
        else {
            listObservable.HasForm(false);
        }
        listObservable.ListName(list.ListName());
        listObservable.ListItems.removeAll();
        list.ListItems().forEach(function (listItem) {
            if (listItem.Selected()) {
                listObservable.ListItems.push(listItem.TemplateFormID());
            }
        });
        this.viewModelDetail.ListOnLoad = ko.toJSON(this.viewModelDetail.List);
        UI.showNotificationMessage(Constants.PHRASE_ITEMSAVED, UI.messageTypeValues.success);
        return true;
    };
    TemplateController.prototype.setListIsActive = function (isActive) {
        if (this.viewModelDetail.ListObservable == null) {
            this.unselectAllNavigation();
            this.viewModelDetail.ListVisible(false);
            return true;
        }
        this.viewModelDetail.List.IsActive(isActive);
        this.viewModelDetail.ListObservable.IsActive(isActive);
        this.viewModelDetail.ListOnLoad = ko.toJSON(this.viewModelDetail.List);
        return true;
    };
    TemplateController.prototype.isListValid = function () {
        var isValid = true;
        var list = this.viewModelDetail.List;
        if (!list.IsActive()) {
            return true;
        }
        isValid = UI.setRequiredString(list.ListTypeID, list.ListTypeIDMissing) ? isValid : false;
        isValid = UI.setRequiredString(list.ListName, list.ListNameMissing) ? isValid : false;
        switch (list.ListTypeID()) {
            case this.LISTTYPE_FORM:
                isValid = UI.setRequiredNumber(list.FormID, list.FormIDMissing, true) ? isValid : false;
                break;
            case this.LISTTYPE_LIST:
                break;
        }
        return isValid;
    };
    TemplateController.prototype.createNewListObservable = function () {
        var list = {
            ID: 0,
            FormID: 0,
            HasForm: true,
            HasAttributes: false,
            ListName: "New Item",
            SortOrder: 0,
            IsActive: true,
            ListItems: [],
            Children: [],
        };
        var listObservable = this.createListObservable(list);
        return listObservable;
    };
    TemplateController.prototype.addListItemToList = function (parentList) {
        var newListObservable = this.createNewListObservable();
        parentList.Children.push(newListObservable);
        this.editList(newListObservable);
    };
    TemplateController.prototype.addListItemToNavigation = function (navigation) {
        var newListObservable = this.createNewListObservable();
        navigation.Lists.push(newListObservable);
        this.editList(newListObservable);
    };
    TemplateController.prototype.moveListItem = function (listObservableToMove, moveUp) {
        var me = this;
        var itemFound = false;
        this.viewModelTree.Navigations().forEach(function (navigation) {
            if (itemFound) {
                return;
            }
            var index = navigation.Lists.indexOf(listObservableToMove);
            if (index >= 0) {
                navigation.Lists.remove(listObservableToMove);
                if (moveUp) {
                    index = index - 1;
                }
                else {
                    index = index + 1;
                }
                navigation.Lists.splice(index, 0, listObservableToMove);
                listObservableToMove.ShowActions(false);
                itemFound = true;
            }
            else {
                navigation.Lists().forEach(function (list) {
                    if (itemFound) {
                        return;
                    }
                    if (list.Children().length === 0) {
                        return;
                    }
                    itemFound = me.moveListItemForList(listObservableToMove, moveUp, list);
                });
            }
        });
    };
    TemplateController.prototype.moveListItemForList = function (listObservableToMove, moveUp, parentList) {
        var me = this;
        var itemFound = false;
        var index = parentList.Children.indexOf(listObservableToMove);
        if (index >= 0) {
            parentList.Children.remove(listObservableToMove);
            if (moveUp) {
                index = index - 1;
            }
            else {
                index = index + 1;
            }
            parentList.Children.splice(index, 0, listObservableToMove);
            listObservableToMove.ShowActions(false);
            return true;
        }
        parentList.Children().forEach(function (child) {
            if (itemFound) {
                return;
            }
            if (child.Children().length === 0) {
                return;
            }
            itemFound = me.moveListItemForList(listObservableToMove, moveUp, child);
        });
        return itemFound;
    };
    TemplateController.prototype.getTemplate = function () {
        var template = {
            ID: this.viewModelHeader.ID(),
            TemplateName: this.viewModelHeader.TemplateName(),
            TargetTemplateID: this.viewModelHeader.TargetTemplateID(),
            IsActive: this.viewModelHeader.IsActive(),
            Navigations: this.getTemplateNavigations(),
            NotifyUserOnAssignment: this.viewModelDetail.Settings.NotifyUserOnAssignment(),
            LinkedCustomerDocuments: this.getLinkedCustomerDocuments(),
            TemplateRoles: this.getTemplateRoles(),
            ReportID: this.viewModelDetail.Settings.ReportID(),
            TemplateSettings: this.getTemplateSettingObjects(),
        };
        return template;
    };
    TemplateController.prototype.getTemplateNavigations = function () {
        var me = this;
        var templateNavigations = [];
        this.viewModelTree.Navigations().forEach(function (navigation) {
            var templateNavigation = {
                ID: navigation.ID(),
                TemplateFormID: navigation.TemplateFormID(),
                NavigationTypeID: navigation.NavigationTypeID(),
                NavigationName: navigation.NavigationName(),
                NavigationNameTranslations: me.createTranslationTextsFromObservables(navigation.NavigationNameTranslations),
                NavigationIcon: navigation.NavigationIcon(),
                IsActive: navigation.IsActive(),
                ListItems: me.getTemplateListItems(navigation.ListItems),
                Lists: me.getTemplateLists(navigation.Lists),
            };
            templateNavigations.push(templateNavigation);
        });
        return templateNavigations;
    };
    TemplateController.prototype.getTemplateListItems = function (listItems) {
        var templateListItems = [];
        listItems().forEach(function (listItem) {
            var templateListItem = {
                TemplateFormID: listItem,
            };
            templateListItems.push(templateListItem);
        });
        return templateListItems;
    };
    TemplateController.prototype.getTemplateLists = function (lists) {
        var me = this;
        var templateLists = [];
        lists().forEach(function (list) {
            var templateList = {
                ID: list.ID(),
                ListName: list.ListName(),
                HasForm: list.HasForm(),
                HasAttributes: list.HasAttributes(),
                IsActive: list.IsActive(),
                Children: me.getTemplateLists(list.Children),
                ListItems: me.getTemplateListItems(list.ListItems),
                FormID: list.FormID(),
                AttributeFormID: list.AttributeFormID(),
            };
            templateLists.push(templateList);
        });
        return templateLists;
    };
    TemplateController.prototype.getLinkedCustomerDocuments = function () {
        var docs = [];
        this.viewModelDetail.Settings.LinkedCustomerDocuments().forEach(function (doc) {
            docs.push({
                Description: doc.Description(),
                FileName: doc.FileName(),
                TemplateCustomerDocumentID: doc.TemplateCustomerDocumentID(),
                CustomerDocumentID: doc.CustomerDocumentID(),
                IsActive: doc.IsActive(),
                StorageKey: doc.StorageKey(),
            });
        });
        return docs;
    };
    TemplateController.prototype.getTemplateRoles = function () {
        var roles = [];
        for (var _i = 0, _a = this.viewModelDetail.Settings.TemplateRoles(); _i < _a.length; _i++) {
            var r = _a[_i];
            roles.push({
                ID: r.ID(),
                IsActive: r.IsActive(),
                TemplateAccessRoleID: r.TemplateAccessRoleID(),
                TemplateID: r.TemplateID(),
                TemplateAccessRoleName: r.TemplateAccessRoleName(),
                TemplateName: r.TemplateName(),
            });
        }
        return roles;
    };
    TemplateController.prototype.getTemplateSettingObjects = function () {
        var templateSettings = [];
        var observableToObject = function (templateSettingObservable) {
            var templateSetting = {
                ID: templateSettingObservable.ID(),
                TemplateSettingTypeID: templateSettingObservable.TemplateSettingTypeID(),
                Value: templateSettingObservable.Value(),
                IsActive: templateSettingObservable.IsActive(),
                SettingKey: templateSettingObservable.SettingKey(),
                SettingType: templateSettingObservable.SettingType(),
            };
            return templateSetting;
        };
        for (var _i = 0, _a = this.viewModelDetail.Settings.SingleInstanceSettings(); _i < _a.length; _i++) {
            var templateSettingObservable = _a[_i];
            templateSettings.push(observableToObject(templateSettingObservable));
        }
        for (var _b = 0, _c = this.viewModelDetail.Settings.ReportEmailSettings(); _b < _c.length; _b++) {
            var templateSettingObservable = _c[_b];
            templateSettings.push(observableToObject(templateSettingObservable));
        }
        for (var _d = 0, _e = this.viewModelDetail.Settings.MobileTaskSettingsList(); _d < _e.length; _d++) {
            var templateSettingObservable = _e[_d];
            templateSettings.push(observableToObject(templateSettingObservable));
        }
        return templateSettings;
    };
    TemplateController.prototype.hasDetailDataChanged = function () {
        var hasChanged = false;
        var fieldValues = "";
        if (this.viewModelDetail.NavigationVisible()) {
            fieldValues = ko.toJSON(this.viewModelDetail.Navigation);
            hasChanged = (fieldValues !== this.viewModelDetail.NavigationOnLoad);
        }
        else if (this.viewModelDetail.ListVisible()) {
            fieldValues = ko.toJSON(this.viewModelDetail.List);
            hasChanged = (fieldValues !== this.viewModelDetail.ListOnLoad);
        }
        return hasChanged;
    };
    TemplateController.prototype.confirmDetailChange = function (onConfirmed) {
        if (this.viewModelDetail.NavigationVisible() && !this.isNavigationValid()) {
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
        }
        else if (this.viewModelDetail.ListVisible() && !this.isListValid()) {
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
        }
        else if (this.hasDetailDataChanged()) {
            if (this.viewModelDetail.NavigationVisible()) {
                if (this.saveNavigation()) {
                    onConfirmed();
                }
            }
            else if (this.viewModelDetail.ListVisible()) {
                if (this.saveList()) {
                    onConfirmed();
                }
            }
            else {
                onConfirmed();
            }
        }
        else {
            onConfirmed();
        }
    };
    TemplateController.prototype.updateURL = function (newID, templateName) {
        var app = Global.app();
        var routeChange = {
            appRouterID: this.appRouterID([]),
            url: "/Template/" + newID,
            title: this.title(),
            subTitle: templateName,
            newAppRouterID: this.appRouterID([newID]),
        };
        app.events().trigger(EventUtil.EVENT_ROUTECHANGE, routeChange);
    };
    TemplateController.prototype.clearSearch = function () {
        var me = this;
        me.viewModelDetail.Navigation.searchFormName("");
        me.viewModelDetail.List.searchListItemFormName("");
    };
    TemplateController.prototype.unselectAllNavigation = function () {
        var me = this;
        this.viewModelTree.Navigations().forEach(function (navigation) {
            navigation.IsSelected(false);
            if (navigation.Lists().length > 0) {
                me.unselectAllLists(navigation.Lists);
            }
        });
    };
    TemplateController.prototype.unselectAllLists = function (lists) {
        var me = this;
        lists().forEach(function (list) {
            list.IsSelected(false);
            if (list.Children().length > 0) {
                me.unselectAllLists(list.Children);
            }
        });
    };
    TemplateController.prototype.DeleteReportEmailSetting = function (selectedCustomerSetting) {
        var me = this;
        if (selectedCustomerSetting.ID() === 0) {
            me.viewModelDetail.Settings.ReportEmailSettings.remove(selectedCustomerSetting);
        }
        else {
            selectedCustomerSetting.IsActive(false);
        }
    };
    TemplateController.prototype.DeleteMobileSetting = function (selectedSetting) {
        var me = this;
        if (selectedSetting.ID() === 0) {
            me.viewModelDetail.Settings.MobileTaskSettingsList.remove(selectedSetting);
        }
        else {
            selectedSetting.IsActive(false);
        }
    };
    TemplateController.prototype.createEmptyFormTextTranslations = function () {
        var userSession = Global.app().userSession;
        if (!userSession || !userSession.Languages) {
            return [];
        }
        return userSession.Languages.map(function (language) {
            var translatedTextObservable = {
                LanguageID: language.ID,
                LanguageName: language.Name,
                TranslatedText: ko.observable(""),
            };
            return translatedTextObservable;
        });
    };
    TemplateController.prototype.createTranslationTextsFromObservables = function (translatedTextObservables) {
        return translatedTextObservables().map(function (translatedTextObservable) {
            var translatedText = {
                LanguageID: translatedTextObservable.LanguageID,
                TranslatedText: translatedTextObservable.TranslatedText(),
            };
            return translatedText;
        });
    };
    return TemplateController;
}());
exports.TemplateController = TemplateController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Constants = __webpack_require__(5);
var UI = __webpack_require__(3);
var templateAccessRoleData = __webpack_require__(392);
var TemplateAccessRoleController = (function () {
    function TemplateAccessRoleController() {
        var _this = this;
        this.fieldsOnLoad = "";
        this.viewModel = {
            ID: ko.observable(0),
            Name: ko.observable("").extend({ required: true }),
            IsActive: ko.observable(true),
            UsersInRole: ko.observableArray(),
            TemplatesInRole: ko.observableArray(),
            selectAllUsers: function () { _this.toggleIsActive(true, _this.viewModel.UsersInRole); },
            deselectAllUsers: function () { _this.toggleIsActive(false, _this.viewModel.UsersInRole); },
            selectAllTemplates: function () { _this.toggleIsActive(true, _this.viewModel.TemplatesInRole); },
            deselectAllTemplates: function () { _this.toggleIsActive(false, _this.viewModel.TemplatesInRole); },
        };
        this.viewModel.errors = ko.validation.group(this.viewModel, { deep: true });
    }
    TemplateAccessRoleController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, this.container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    TemplateAccessRoleController.prototype.load = function (params) {
        var _this = this;
        var deferred = $.Deferred();
        var me = this;
        if (params != null && params.length === 1) {
            this.roleID = params[0];
        }
        else {
            this.roleID = 0;
        }
        var waitContainer = UI.showWaitIndicator(me.container);
        templateAccessRoleData.GetByID(this.roleID)
            .then(function (response) {
            _this.bindModel(response);
            deferred.resolve();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    TemplateAccessRoleController.prototype.haveFieldsChanged = function () {
        var fieldValues = ko.toJSON(this.viewModel);
        return fieldValues !== this.fieldsOnLoad;
    };
    TemplateAccessRoleController.prototype.save = function () {
        var me = this;
        var waitContainer;
        var deferred = $.Deferred();
        if (this.isValid()) {
            waitContainer = UI.showWaitIndicator(me.container);
            templateAccessRoleData.Save(this.getTemplateAccessRole())
                .done(function (response) {
                if (response.Success) {
                    UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                    me.bindModel(response);
                    deferred.resolve();
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                    deferred.reject();
                }
            })
                .fail(function () {
                deferred.reject();
            })
                .always(function () {
                UI.hideWaitIndicator(me.container, waitContainer);
            });
        }
        else {
            deferred.reject();
        }
        return deferred.promise();
    };
    TemplateAccessRoleController.prototype.appRouterID = function (params) {
        var appRouterID = "TemplateAccessRole";
        if (params != null && params.length === 1) {
            appRouterID += params[0];
        }
        return appRouterID;
    };
    TemplateAccessRoleController.prototype.title = function () {
        return "Template Access Role " + (this.viewModel.Name() ? this.viewModel.Name() : "New");
    };
    TemplateAccessRoleController.prototype.subTitle = function () {
        return "";
    };
    TemplateAccessRoleController.prototype.bindModel = function (response) {
        this.viewModel.Name(response.Payload.Name);
        this.viewModel.ID(response.Payload.ID);
        this.viewModel.IsActive(response.Payload.IsActive);
        this.getTemplateObservableList(response.Payload.TemplatesInRole, this.viewModel.TemplatesInRole);
        this.getUserObservableList(response.Payload.UsersInRole, this.viewModel.UsersInRole);
        this.fieldsOnLoad = ko.toJSON(this.viewModel);
    };
    TemplateAccessRoleController.prototype.isValid = function () {
        if (this.viewModel.errors && this.viewModel.errors().length > 0) {
            this.viewModel.errors.showAllMessages();
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
            return false;
        }
        return true;
    };
    TemplateAccessRoleController.prototype.getTemplateObservableList = function (templates, templateObservable) {
        templateObservable.removeAll();
        for (var _i = 0, templates_1 = templates; _i < templates_1.length; _i++) {
            var t = templates_1[_i];
            templateObservable.push({
                ID: ko.observable(t.ID),
                TemplateAccessRoleID: ko.observable(t.TemplateAccessRoleID),
                TemplateID: ko.observable(t.TemplateID),
                TemplateName: ko.observable(t.TemplateName),
                IsActive: ko.observable(t.IsActive),
                TemplateAccessRoleName: ko.observable(t.TemplateAccessRoleName),
            });
        }
    };
    TemplateAccessRoleController.prototype.getUserObservableList = function (users, userObservable) {
        userObservable.removeAll();
        for (var _i = 0, users_1 = users; _i < users_1.length; _i++) {
            var u = users_1[_i];
            userObservable.push({
                ID: ko.observable(u.ID),
                TemplateAccessRoleID: ko.observable(u.TemplateAccessRoleID),
                UserID: ko.observable(u.UserID),
                UserName: ko.observable(u.UserName),
                IsActive: ko.observable(u.IsActive),
            });
        }
    };
    TemplateAccessRoleController.prototype.getTemplateAccessRole = function () {
        return {
            ID: this.viewModel.ID(),
            Name: this.viewModel.Name(),
            IsActive: this.viewModel.IsActive(),
            TemplatesInRole: this.getTemplateAccessRoleTemplatesFromObservable(this.viewModel.TemplatesInRole),
            UsersInRole: this.getTemplateAccessRoleUsersFromObservable(this.viewModel.UsersInRole),
        };
    };
    TemplateAccessRoleController.prototype.getTemplateAccessRoleTemplatesFromObservable = function (templates) {
        var result = [];
        for (var _i = 0, _a = templates(); _i < _a.length; _i++) {
            var t = _a[_i];
            result.push({
                ID: t.ID(),
                IsActive: t.IsActive(),
                TemplateName: t.TemplateName(),
                TemplateID: t.TemplateID(),
                TemplateAccessRoleID: t.TemplateAccessRoleID(),
                TemplateAccessRoleName: "",
            });
        }
        return result;
    };
    TemplateAccessRoleController.prototype.getTemplateAccessRoleUsersFromObservable = function (users) {
        var result = [];
        for (var _i = 0, _a = users(); _i < _a.length; _i++) {
            var u = _a[_i];
            result.push({
                ID: u.ID(),
                IsActive: u.IsActive(),
                TemplateAccessRoleID: u.TemplateAccessRoleID(),
                UserID: u.UserID(),
                UserName: u.UserName(),
            });
        }
        return result;
    };
    TemplateAccessRoleController.prototype.toggleIsActive = function (isActive, items) {
        for (var _i = 0, _a = items(); _i < _a.length; _i++) {
            var item = _a[_i];
            item.IsActive(isActive);
        }
    };
    return TemplateAccessRoleController;
}());
exports.TemplateAccessRoleController = TemplateAccessRoleController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var Constants = __webpack_require__(5);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var templateAccessRoleData = __webpack_require__(392);
var TemplateAccessRolesController = (function () {
    function TemplateAccessRolesController() {
        var _this = this;
        var me = this;
        var app = Global.app();
        this.viewModel = {
            Roles: ko.observableArray(),
            TemplateSecurityEnabled: ko.observable(false),
            deleteRole: function (role) {
                UI.showConfirmDialog("Are you sure you want to delete this role?", function () {
                    var waitContainer = UI.showWaitIndicator(me.container);
                    role.IsActive = false;
                    templateAccessRoleData.Delete(role.ID)
                        .then(function (response) {
                        if (response.Success) {
                            UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                        }
                        else {
                            UI.showErrorMessage(response.ErrorMessages);
                        }
                        _this.load([]);
                    })
                        .always(function () {
                        UI.hideWaitIndicator(me.container, waitContainer);
                    });
                });
            },
            editRole: function (role) {
                app.router().navigate("/TemplateAccessRole/" + role.ID, true);
            },
        };
        if (app.userSession) {
            var setting = UI.GetCustomerSetting(app.userSession.CustomerSettings, Constants.SETTING_KEY_TEMPLATE_ACCESS_SECURITY, "false");
            this.viewModel.TemplateSecurityEnabled(setting === "true");
        }
    }
    TemplateAccessRolesController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, this.container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    TemplateAccessRolesController.prototype.refresh = function () {
        this.load([]);
    };
    TemplateAccessRolesController.prototype.load = function (params) {
        var deferred = $.Deferred();
        var me = this;
        var waitContainer = UI.showWaitIndicator(me.container);
        templateAccessRoleData.GetAll()
            .then(function (response) {
            if (response.Success) {
                me.viewModel.Roles(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
            deferred.resolve();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    TemplateAccessRolesController.prototype.add = function () {
        if (this.viewModel.TemplateSecurityEnabled()) {
            var app = Global.app();
            app.router().navigate("/TemplateAccessRole", true);
        }
    };
    TemplateAccessRolesController.prototype.haveFieldsChanged = function () {
        return false;
    };
    TemplateAccessRolesController.prototype.appRouterID = function (params) {
        return "TemplateAccessRoles";
    };
    TemplateAccessRolesController.prototype.title = function () {
        return "Template Access Roles";
    };
    TemplateAccessRolesController.prototype.subTitle = function () {
        return "";
    };
    return TemplateAccessRolesController;
}());
exports.TemplateAccessRolesController = TemplateAccessRolesController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(88);
__webpack_require__(98);
__webpack_require__(896);
__webpack_require__(393);
var ko = __webpack_require__(4);
__webpack_require__(897);
var Constants = __webpack_require__(5);
var EventUtil = __webpack_require__(26);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var templateFormData = __webpack_require__(398);
var TabStateValues;
(function (TabStateValues) {
    TabStateValues[TabStateValues["Fields"] = 0] = "Fields";
    TabStateValues[TabStateValues["Translations"] = 1] = "Translations";
})(TabStateValues || (TabStateValues = {}));
var TemplateFormController = (function () {
    function TemplateFormController() {
        this.fieldsOnLoad = {};
        this.NavigationType = {
            Form: 1,
            AdditionalForm: 2,
        };
        var me = this;
        var userSession = Global.app().userSession;
        var languages = (userSession && userSession.Languages) ? userSession.Languages : [];
        this.viewModel = {
            TemplateForm: {
                ID: ko.observable(0),
                FormName: ko.observable("").extend({ required: true }),
                FormDescription: ko.observable(""),
                FormTypeID: ko.observable(0).extend({ required: true }),
                IsActive: ko.observable(true),
                FormItems: ko.observableArray(),
            },
            QuestionLabel: ko.observable(Constants.LABEL_QUESTION),
            QuestionsLabel: ko.observable(Constants.LABEL_QUESTIONS),
            FormTypes: ko.observableArray(),
            ControlTypes: ko.observableArray(),
            AdditionalForms: ko.observableArray(),
            TemplatePhrases: ko.observableArray(),
            TargetTemplates: ko.observableArray(),
            DocumentFileTypesAllowed: [],
            CustomerDocuments: [],
            TabState: ko.observable(TabStateValues.Fields),
            TranslationLanguages: languages,
            TranslationLanguageIDSearch: ko.observable(),
            TranslationFieldTextSearch: ko.observable(""),
            inactivateForm: function (user) {
                UI.showConfirmDialog("Are you sure you want to make this form inactive?", function () { me.toggleFormStatus(); });
            },
            activateForm: function (user) {
                UI.showConfirmDialog("Are you sure you want to make this form active?", function () { me.toggleFormStatus(); });
            },
            getFormatMasksForItem: function (formItem) {
                return me.getFormatMasksForControlType(formItem.ControlTypeID());
            },
            hasFormatMasksForItem: function (formItem) {
                return me.getFormatMasksForControlType(formItem.ControlTypeID()).length > 0;
            },
            isFieldTabActive: function () {
                return this.TabState() === TabStateValues.Fields;
            },
            isTranslationTabActive: function () {
                return this.TabState() === TabStateValues.Translations;
            },
            makeFieldTabActive: function () {
                this.TabState(TabStateValues.Fields);
            },
            makeTranslationTabActive: function () {
                this.TabState(TabStateValues.Translations);
            },
            getFilteredTranslatedText: function (formItemObservable) {
                var _this = this;
                var searchText = this.TranslationFieldTextSearch() ? this.TranslationFieldTextSearch().toLowerCase() : "";
                return formItemObservable.FormTextTranslations().filter(function (formTextTranslation) {
                    return (!_this.TranslationLanguageIDSearch() ||
                        formTextTranslation.LanguageID === _this.TranslationLanguageIDSearch())
                        &&
                            (!_this.TranslationFieldTextSearch() ||
                                (formItemObservable.FormText() && formItemObservable.FormText().toLowerCase().indexOf(searchText) >= 0));
                });
            },
        };
        this.viewModel.TemplateForm.navTypeIsForm = ko.pureComputed(function () {
            return me.viewModel.TemplateForm.FormTypeID() === me.NavigationType.Form;
        });
        this.viewModel.TemplateForm.navTypeIsAdditionalForm = ko.pureComputed(function () {
            return me.viewModel.TemplateForm.FormTypeID() === me.NavigationType.AdditionalForm;
        });
        this.viewModel.TemplateForm.spliceFormItem = function (index, form) {
            for (var _i = 0, _a = me.viewModel.TemplateForm.FormItems(); _i < _a.length; _i++) {
                var item = _a[_i];
                item.IsEdit(false);
            }
            var formItem = {
                ID: 0,
                FormText: "",
                FormTextTranslations: [],
                TemplateFormID: me.viewModel.TemplateForm.FormItems()[index()].TemplateFormID(),
                ControlTypeID: 1,
                IsRequired: false,
                IsReadOnly: false,
                IsVisible: true,
                IsActive: true,
                IsEdit: true,
                TemplateAdditionalFormID: 0,
                Fields: [],
                TemplateFormItemDocumentTypeAllowed: [],
                LinkedCustomerDocuments: [],
                IsAdditionalFormMissing: false,
                MinMaxInvalid: false,
                ValidNumericDefaultValue: true,
                ValidInterval: true,
                selected: ko.observable(1),
                newFieldText: ko.observable(""),
                MultipleAdditionalForms: false,
                CopyAnswerWhenCloningTask: false,
                ShowOnCalendar: false,
                PhraseOrCustomChoice: Constants.TEMPLATE_FORM_CHOICES_CUSTOM,
                ExternalName: "",
                ReportName: "",
            };
            me.viewModel.TemplateForm.FormItems.splice(index() + 1, 0, me.getFormItemObservable(formItem));
        };
        this.viewModel.TemplateForm.copyFormItem = function (index, form) {
            for (var _i = 0, _a = me.viewModel.TemplateForm.FormItems(); _i < _a.length; _i++) {
                var item = _a[_i];
                item.IsEdit(false);
            }
            var sourceFormItem = me.viewModel.TemplateForm.FormItems()[index()];
            var sourceFormItemDocs = me.getTemplateFormItemDocumentTypeAllowedFromObservable(sourceFormItem.TemplateFormItemDocumentTypeAllowed);
            sourceFormItemDocs.forEach(function (i) { return i.TemplateFormItemID = 0; });
            var sourceFormItemLinkedDocs = me.getTemplateFormItemLinkedCustomerDocumentsFromObservable(sourceFormItem.LinkedCustomerDocuments);
            sourceFormItemLinkedDocs.forEach(function (doc) { return doc.TemplateFormItemCustomerDocumentID = 0; });
            var formItem = {
                ID: 0,
                FormText: sourceFormItem.FormText(),
                FormTextTranslations: me.createTranslationTextsFromObservables(sourceFormItem.FormTextTranslations),
                TemplateFormID: sourceFormItem.TemplateFormID(),
                ControlTypeID: sourceFormItem.ControlTypeID(),
                IsRequired: sourceFormItem.IsRequired(),
                IsReadOnly: sourceFormItem.IsReadOnly(),
                IsVisible: sourceFormItem.IsVisible(),
                IsActive: true,
                IsEdit: true,
                TemplateAdditionalFormID: sourceFormItem.TemplateAdditionalFormID(),
                TemplatePhraseID: sourceFormItem.TemplatePhraseID(),
                TargetTemplateID: sourceFormItem.TargetTemplateID(),
                IsAdditionalFormMissing: false,
                MinMaxInvalid: false,
                ValidNumericDefaultValue: true,
                ValidInterval: true,
                Fields: me.getDuplicateFields(sourceFormItem.Fields),
                TemplateFormItemDocumentTypeAllowed: sourceFormItemDocs,
                LinkedCustomerDocuments: sourceFormItemLinkedDocs,
                TemplateControlTypeAttribute: {
                    ID: 0,
                    MinVal: sourceFormItem.TemplateControlTypeAttribute ? sourceFormItem.TemplateControlTypeAttribute.MinVal() : "",
                    MaxVal: sourceFormItem.TemplateControlTypeAttribute ? sourceFormItem.TemplateControlTypeAttribute.MaxVal() : "",
                    Format: sourceFormItem.TemplateControlTypeAttribute ? sourceFormItem.TemplateControlTypeAttribute.Format() : "",
                    MinLength: sourceFormItem.TemplateControlTypeAttribute ? sourceFormItem.TemplateControlTypeAttribute.MinLength() : "0",
                    MaxLength: sourceFormItem.TemplateControlTypeAttribute ? sourceFormItem.TemplateControlTypeAttribute.MaxLength() : "0",
                    NumDecimals: sourceFormItem.TemplateControlTypeAttribute ?
                        sourceFormItem.TemplateControlTypeAttribute.NumDecimals() : 0,
                    NumericDefaultValue: sourceFormItem.TemplateControlTypeAttribute ? sourceFormItem.TemplateControlTypeAttribute.NumericDefaultValue() : 0,
                    Interval: sourceFormItem.TemplateControlTypeAttribute ? sourceFormItem.TemplateControlTypeAttribute.Interval() : 0,
                },
                selected: ko.observable(1),
                newFieldText: ko.observable(""),
                MultipleAdditionalForms: sourceFormItem.MultipleAdditionalForms(),
                CopyAnswerWhenCloningTask: sourceFormItem.CopyAnswerWhenCloningTask(),
                ShowOnCalendar: sourceFormItem.ShowOnCalendar(),
                PhraseOrCustomChoice: sourceFormItem.PhraseOrCustomChoice(),
                ExternalName: sourceFormItem.ExternalName(),
                ReportName: sourceFormItem.ReportName(),
            };
            me.viewModel.TemplateForm.FormItems.splice(index() + 1, 0, me.getFormItemObservable(formItem));
        };
        this.viewModel.TemplateForm.addFormItem = function (form) {
            for (var _i = 0, _a = me.viewModel.TemplateForm.FormItems(); _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.ID() !== form.TemplateForm.ID()) {
                    item.IsEdit(false);
                }
            }
            var formItem = {
                ID: 0,
                FormText: "",
                FormTextTranslations: [],
                TemplateFormID: form.TemplateForm.ID(),
                ControlTypeID: 1,
                IsRequired: false,
                IsReadOnly: false,
                IsVisible: true,
                IsActive: true,
                IsEdit: true,
                TemplateAdditionalFormID: 0,
                Fields: [],
                TemplateFormItemDocumentTypeAllowed: [],
                LinkedCustomerDocuments: [],
                IsAdditionalFormMissing: false,
                MinMaxInvalid: false,
                ValidNumericDefaultValue: true,
                ValidInterval: true,
                selected: ko.observable(1),
                newFieldText: ko.observable(""),
                MultipleAdditionalForms: false,
                CopyAnswerWhenCloningTask: false,
                ShowOnCalendar: false,
                PhraseOrCustomChoice: Constants.TEMPLATE_FORM_CHOICES_CUSTOM,
                ExternalName: "",
                ReportName: "",
            };
            me.viewModel.TemplateForm.FormItems.push(me.getFormItemObservable(formItem));
        };
        this.viewModel.TemplateForm.removeFormItem = function (form) {
            UI.showConfirmDialog("Are you sure you want to delete \"" + form.formItemTitle() + "\"?", function () { me.DeleteFormItem(form); });
        };
        this.viewModel.Errors = ko.validation.group(this.viewModel.TemplateForm, { deep: true });
    }
    TemplateFormController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        this.container.find(".sortable").sortable();
        this.container.find(".sortable").disableSelection();
        this.container.find(".sortable2").sortable();
        this.container.find(".sortable2").disableSelection();
        ko.applyBindings(this.viewModel, container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    TemplateFormController.prototype.load = function (params) {
        if (params != null && params.length === 1) {
            this.templateFormID = params[0];
        }
        else {
            this.templateFormID = 0;
        }
        return this.loadRecord(this.templateFormID);
    };
    TemplateFormController.prototype.save = function () {
        var me = this;
        var app = Global.app();
        var waitContainer;
        var deferred = $.Deferred();
        if (!this.isValid()) {
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
            deferred.reject();
            return deferred.promise();
        }
        waitContainer = UI.showWaitIndicator(me.container);
        templateFormData.SaveTemplateForm(this.getTemplateForm())
            .done(function (response) {
            if (response.Success) {
                if (me.viewModel.TemplateForm.ID() <= 0) {
                    me.updateURL(response.Payload.ID, me.viewModel.TemplateForm.FormName());
                }
                else {
                    app.pageManager().refreshCurrentPageTitle();
                }
                me.loadRecord(response.Payload.ID);
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    TemplateFormController.prototype.haveFieldsChanged = function () {
        var fieldValues = ko.toJSON(this.getTemplateForm());
        return fieldValues !== this.fieldsOnLoad;
    };
    TemplateFormController.prototype.appRouterID = function (params) {
        var routerID = "TemplateForm";
        if (params != null && params.length === 1) {
            routerID += params[0];
        }
        return routerID;
    };
    TemplateFormController.prototype.title = function () {
        return "Form Template";
    };
    TemplateFormController.prototype.subTitle = function () {
        var subTitle = "";
        if (this.templateFormID == null) {
            subTitle = "New";
        }
        else {
            subTitle = this.viewModel.TemplateForm.FormName();
        }
        return subTitle;
    };
    TemplateFormController.prototype.GetTemplateName = function (controlType) {
        if (controlType === Constants.QuestionType.TEXTBOX) {
            return "templateform_text-template";
        }
        else if (controlType === Constants.QuestionType.DROPDOWN) {
            return "templateform_select-template";
        }
        else if (controlType === Constants.QuestionType.RADIOBUTTONLIST) {
            return "templateform_radio-template";
        }
        else if (controlType === Constants.QuestionType.CHECKBOXLIST) {
            return "templateform_checkbox-template";
        }
        else if (controlType === Constants.QuestionType.DATE) {
            return "templateform_date-template";
        }
        else if (controlType === Constants.QuestionType.TEXTAREA) {
            return "templateform_textarea-template";
        }
        else if (controlType === Constants.QuestionType.NUMERIC) {
            return "templateform_numeric-template";
        }
        else if (controlType === Constants.QuestionType.SECTION) {
            return "templateform_section-template";
        }
        else if (controlType === Constants.QuestionType.TEXTDESCRIPTION) {
            return "templateform_textdescription-template";
        }
        else if (controlType === Constants.QuestionType.BUTTON) {
            return "templateform_button-template";
        }
        else if (controlType === Constants.QuestionType.SIGNATURE) {
            return "templateform_signature-template";
        }
        else if (controlType === Constants.QuestionType.MULTIPLECOMMENTS) {
            return "templateform_multiplecomments-template";
        }
        else if (controlType === Constants.QuestionType.MULTIPLECOMMENTSPICS) {
            return "templateform_multiplecommentspics-template";
        }
        else if (controlType === Constants.QuestionType.BARCODE) {
            return "templateform_barcode-template";
        }
        else if (controlType === Constants.QuestionType.DOCUMENTS) {
            return "templateform_documents-template";
        }
        else if (controlType === Constants.QuestionType.DATETIME) {
            return "templateform_datetime-template";
        }
        else if (controlType === Constants.QuestionType.TIME) {
            return "templateform_time-template";
        }
        else if (controlType === Constants.QuestionType.EMAIL) {
            return "templateform_email-template";
        }
        else if (controlType === Constants.QuestionType.PHONE) {
            return "templateform_phone-template";
        }
        else if (controlType === Constants.QuestionType.LINKEDDOCUMENTS) {
            return "templateform_linkeddocuments-template";
        }
        else if (controlType === Constants.QuestionType.TARGET) {
            return "templateform_target-template";
        }
        else if (controlType === Constants.QuestionType.ADDRESS) {
            return "templateform_address-template";
        }
        else if (controlType === Constants.QuestionType.GEOLOCAITON) {
            return "templateform_geolocation-template";
        }
        else if (controlType === Constants.QuestionType.SLIDER) {
            return "templateform_slider-template";
        }
        else if (controlType === Constants.QuestionType.SINGLECHECKBOX) {
            return "templateform_singlecheckbox-template";
        }
        else {
            return "";
        }
    };
    TemplateFormController.prototype.DeleteFormItem = function (form) {
        var me = this;
        if (form.ID() === 0) {
            me.viewModel.TemplateForm.FormItems.remove(form);
        }
        else {
            form.IsActive(false);
        }
    };
    TemplateFormController.prototype.loadRecord = function (templateFormID) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        var templateFormRequest = {
            TemplateFormID: templateFormID,
        };
        templateFormData.GetTemplateForm(templateFormRequest)
            .done(function (response) {
            if (response.Success) {
                me.updateViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TemplateFormController.prototype.getTemplateFormItemDocumentTypeAllowedFromDocumentFileTypeAllowed = function (documentFileTypesAllowed) {
        var templateFormItemDocumentTypesAllowed = [];
        documentFileTypesAllowed.forEach(function (documentFileTypeAllowed) {
            var templateFormItemDocumentTypeAllowed = {
                TemplateFormItemID: 0,
                DocumentFileTypeAllowedID: documentFileTypeAllowed.ID,
                DocumentTypeExtension: documentFileTypeAllowed.DocumentTypeExtension,
                Description: documentFileTypeAllowed.Description,
                IsActive: true,
            };
            templateFormItemDocumentTypesAllowed.push(templateFormItemDocumentTypeAllowed);
        });
        return templateFormItemDocumentTypesAllowed;
    };
    TemplateFormController.prototype.createTemplateFormItemDocumentTypeAllowedObservable = function (templateFormItemDocumentTypeAllowed) {
        var vmtemplateFormItemDocumentTypeAllowed = {
            TemplateFormItemID: ko.observable(templateFormItemDocumentTypeAllowed.TemplateFormItemID),
            DocumentFileTypeAllowedID: ko.observable(templateFormItemDocumentTypeAllowed.DocumentFileTypeAllowedID),
            Description: ko.observable(templateFormItemDocumentTypeAllowed.Description),
            IsActive: ko.observable(templateFormItemDocumentTypeAllowed.IsActive),
            DocumentTypeExtension: ko.observable(templateFormItemDocumentTypeAllowed.DocumentTypeExtension),
        };
        return vmtemplateFormItemDocumentTypeAllowed;
    };
    TemplateFormController.prototype.getTemplateFormItemDocumentTypeAllowedFromObservable = function (docTypesAllowed) {
        var templateFormDocumentTypesAllowed = [];
        docTypesAllowed().forEach(function (formItemDocumentTypeAllowed) {
            var templateFormDocumentTypeAllowed = {
                TemplateFormItemID: formItemDocumentTypeAllowed.TemplateFormItemID(),
                DocumentFileTypeAllowedID: formItemDocumentTypeAllowed.DocumentFileTypeAllowedID(),
                Description: formItemDocumentTypeAllowed.Description(),
                IsActive: formItemDocumentTypeAllowed.IsActive(),
                DocumentTypeExtension: formItemDocumentTypeAllowed.DocumentTypeExtension(),
            };
            templateFormDocumentTypesAllowed.push(templateFormDocumentTypeAllowed);
        });
        return templateFormDocumentTypesAllowed;
    };
    TemplateFormController.prototype.updateViewModel = function (master) {
        var me = this;
        me.viewModel.ControlTypes(master.ControlTypes);
        me.viewModel.TemplatePhrases([]);
        me.viewModel.FormTypes([]);
        me.viewModel.AdditionalForms([]);
        me.viewModel.TemplateForm.FormItems([]);
        me.viewModel.DocumentFileTypesAllowed = [];
        me.viewModel.DocumentFileTypesAllowed = master.DocumentFileTypes;
        me.viewModel.CustomerDocuments = master.CustomerDocuments;
        master.TargetTemplates.forEach(function (targetTemplate) {
            me.viewModel.TargetTemplates.push({ ID: targetTemplate.ID, Name: targetTemplate.Name });
        });
        me.viewModel.TemplatePhrases.push(me.GetCodeModelObservable({ ID: null, Name: Constants.PHRASE_NOTSELECTED }));
        master.TemplatePhrases.forEach(function (templatePhrases) {
            me.viewModel.TemplatePhrases.push(me.GetCodeModelObservable(templatePhrases));
        });
        master.FormTypes.forEach(function (formTypes) {
            me.viewModel.FormTypes.push(me.GetCodeModelObservable(formTypes));
        });
        me.viewModel.AdditionalForms.push(me.GetCodeModelObservable({ ID: null, Name: Constants.PHRASE_NOTSELECTED }));
        master.AdditionalForms.forEach(function (additionalForms) {
            me.viewModel.AdditionalForms.push(me.GetCodeModelObservable(additionalForms));
        });
        me.viewModel.TemplateForm.ID(master.ID);
        me.viewModel.TemplateForm.FormName(master.FormName);
        me.viewModel.TemplateForm.FormDescription(master.FormDescription);
        me.viewModel.TemplateForm.IsActive(master.IsActive);
        me.viewModel.TemplateForm.FormTypeID(master.FormTypeID);
        if (master.FormItems) {
            master.FormItems.forEach(function (formItem) {
                me.viewModel.TemplateForm.FormItems.push(me.getFormItemObservable(formItem));
            });
        }
        this.fieldsOnLoad = ko.toJSON(this.getTemplateForm());
    };
    TemplateFormController.prototype.toggleFormStatus = function () {
        var me = this;
        var newIsActive = !this.viewModel.TemplateForm.IsActive();
        var waitContainer = UI.showWaitIndicator(me.container);
        var formStatusChanged = me.haveFieldsChanged();
        templateFormData.ChangeFormStatus(this.viewModel.TemplateForm.ID(), newIsActive)
            .done(function (response) {
            if (response.Success) {
                me.viewModel.TemplateForm.IsActive(newIsActive);
                if (!formStatusChanged) {
                    me.fieldsOnLoad = ko.toJSON(me.getTemplateForm());
                }
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
    };
    TemplateFormController.prototype.getFormItemObservable = function (formItem) {
        var me = this;
        var getFormTextTranslationObservables = function (formTextTranslations) {
            var formTextTranslationObservables = me.createEmptyFormTextTranslations();
            if (formTextTranslations) {
                var _loop_1 = function (formTextTranslationObservable) {
                    var matchingFormTextTranslation = formTextTranslations.filter(function (formTextTranslation) {
                        return formTextTranslation.LanguageID === formTextTranslationObservable.LanguageID;
                    });
                    if (matchingFormTextTranslation.length > 0) {
                        formTextTranslationObservable.TranslatedText(matchingFormTextTranslation[0].TranslatedText);
                    }
                };
                for (var _i = 0, formTextTranslationObservables_1 = formTextTranslationObservables; _i < formTextTranslationObservables_1.length; _i++) {
                    var formTextTranslationObservable = formTextTranslationObservables_1[_i];
                    _loop_1(formTextTranslationObservable);
                }
            }
            return formTextTranslationObservables;
        };
        var formItemObservable = {
            ID: ko.observable(formItem ? formItem.ID : 0),
            TemplateFormID: ko.observable(formItem ? formItem.TemplateFormID : 0),
            ControlTypeID: ko.observable(formItem ? formItem.ControlTypeID : 0).extend({ required: true }),
            formItemTitle: ko.pureComputed(function () {
                return formItemObservable.FormText() ? formItemObservable.FormText() : "New Item";
            }),
            FormText: ko.observable(formItem ? formItem.FormText : "").extend({ required: true }),
            FormTextTranslations: ko.observableArray(getFormTextTranslationObservables(formItem.FormTextTranslations)),
            IsRequired: ko.observable(formItem ? formItem.IsRequired : false),
            SortOrder: ko.observable(formItem ? formItem.SortOrder : 0),
            IsReadOnly: ko.observable(formItem ? formItem.IsReadOnly : false),
            IsVisible: ko.observable(formItem ? formItem.IsVisible : true),
            IsActive: ko.observable(formItem ? formItem.IsActive : true),
            IsFormTextMissing: ko.observable(false),
            IsQuestionTypeMissing: ko.observable(false),
            TemplateAdditionalFormID: ko.observable(formItem ? formItem.TemplateAdditionalFormID : 0),
            TargetTemplateID: ko.observable(formItem ? formItem.TargetTemplateID : null),
            IsAdditionalFormMissing: ko.observable(false),
            MinMaxInvalid: ko.observable(false),
            ValidNumericDefaultValue: ko.observable(true),
            ValidInterval: ko.observable(true),
            DocumentFileTypeNotSelected: ko.observable(false),
            TemplatePhraseID: ko.observable(formItem ? formItem.TemplatePhraseID : 0),
            PhraseOrCustomChoice: ko.observable(formItem.TemplatePhraseID == null ? Constants.TEMPLATE_FORM_CHOICES_CUSTOM : Constants.TEMPLATE_FORM_CHOICES_PHRASES),
            PhraseOrCustomOptions: ko.observableArray([{ text: "Enter Values", value: Constants.TEMPLATE_FORM_CHOICES_CUSTOM },
                { text: "Use Template Phrases", value: Constants.TEMPLATE_FORM_CHOICES_PHRASES }]),
            Fields: ko.observableArray(),
            TemplateFormItemDocumentTypeAllowed: ko.observableArray(),
            LinkedCustomerDocuments: ko.observableArray(),
            LinkedDocumentFilter: ko.observable(),
            ExternalName: ko.observable(formItem ? formItem.ExternalName : ""),
            ReportName: ko.observable(formItem ? formItem.ReportName : ""),
            IsFieldsMissing: ko.observable(false),
            TemplateControlTypeAttribute: {
                ID: ko.observable(formItem.TemplateControlTypeAttribute ? formItem.TemplateControlTypeAttribute.ID : 0),
                MinVal: ko.observable(formItem.TemplateControlTypeAttribute ? formItem.TemplateControlTypeAttribute.MinVal : ""),
                MaxVal: ko.observable(formItem.TemplateControlTypeAttribute ? formItem.TemplateControlTypeAttribute.MaxVal : ""),
                Format: ko.observable(formItem.TemplateControlTypeAttribute ? formItem.TemplateControlTypeAttribute.Format : null),
                MinLength: ko.observable(formItem.TemplateControlTypeAttribute ? formItem.TemplateControlTypeAttribute.MinLength : ""),
                MaxLength: ko.observable(formItem.TemplateControlTypeAttribute ? formItem.TemplateControlTypeAttribute.MaxLength : ""),
                NumDecimals: ko.observable(formItem.TemplateControlTypeAttribute ? formItem.TemplateControlTypeAttribute.NumDecimals : 0),
                NumericDefaultValue: ko.observable(formItem.TemplateControlTypeAttribute ? formItem.TemplateControlTypeAttribute.NumericDefaultValue : 0),
                Interval: ko.observable(formItem.TemplateControlTypeAttribute ? formItem.TemplateControlTypeAttribute.Interval : 0),
            },
            selected: ko.observable(1),
            newFieldText: ko.observable(""),
            IsEdit: ko.observable(formItem ? formItem.IsEdit : false),
            HasError: ko.observable(false),
            templateName: ko.pureComputed(function () {
                return me.GetTemplateName(formItemObservable.ControlTypeID());
            }),
            MultipleAdditionalForms: ko.observable(formItem.MultipleAdditionalForms),
            CopyAnswerWhenCloningTask: ko.observable(formItem.CopyAnswerWhenCloningTask),
            ShowOnCalendar: ko.observable(formItem.ShowOnCalendar),
        };
        formItemObservable.TargetTemplateID.extend({
            required: {
                onlyIf: function () {
                    return formItemObservable.typeIsTarget && formItemObservable.typeIsTarget();
                },
                message: "Target Template is required",
            },
        });
        formItemObservable.TemplateControlTypeAttribute.MinVal.extend({
            required: {
                onlyIf: function () {
                    return (formItemObservable.ControlTypeID() === Constants.QuestionType.SLIDER);
                },
                message: "Minimum value is required.",
            },
        });
        formItemObservable.TemplateControlTypeAttribute.MaxVal.extend({
            required: {
                onlyIf: function () {
                    return (formItemObservable.ControlTypeID() === Constants.QuestionType.SLIDER);
                },
                message: "Maximum value is required.",
            },
        });
        formItemObservable.FilteredLinkedCustomerDocuments = ko.pureComputed(function () {
            var filter = formItemObservable.LinkedDocumentFilter();
            return formItemObservable.LinkedCustomerDocuments().filter(function (item) {
                if (!filter) {
                    return true;
                }
                return item.FileName().indexOf(filter) >= 0;
            });
        });
        formItemObservable.removeClass = function (obj, parent) {
            var i;
            for (i = 0; i < parent.TemplateForm.FormItems().length; i++) {
                if (parent.TemplateForm.FormItems()[i].ID() !== obj.ID()) {
                    parent.TemplateForm.FormItems()[i].IsEdit(false);
                }
            }
            obj.IsEdit(!obj.IsEdit());
        };
        formItemObservable.addField = function (newfield) {
            var field = {
                ID: 0,
                FieldText: newfield.newFieldText(),
                HasExceptionForm: false,
                IsActive: true,
                FieldValue: "",
                HasException: false,
                SortOrder: 0,
                TemplateFormID: null,
            };
            if (newfield.newFieldText() !== "") {
                formItemObservable.Fields.push(me.createIFieldObservable(field));
                newfield.newFieldText("");
                me.container.find("input[data-id='autoFocusOnCurrentField']").focus();
            }
        };
        formItemObservable.removeField = function (field) {
            if (field.ID() === 0) {
                formItemObservable.Fields.remove(field);
                me.container.find("input[data-id='autoFocusOnCurrentField']").focus();
            }
            else {
                field.IsActive(false);
            }
        };
        formItemObservable.makeAllActive = function () {
            formItemObservable.TemplateFormItemDocumentTypeAllowed().forEach(function (templateFormItemDocumentTypeAllowed) {
                templateFormItemDocumentTypeAllowed.IsActive(true);
            });
        };
        formItemObservable.makeAllInActive = function () {
            formItemObservable.TemplateFormItemDocumentTypeAllowed().forEach(function (templateFormItemDocumentTypeAllowed) {
                templateFormItemDocumentTypeAllowed.IsActive(false);
            });
        };
        for (var _i = 0, _a = formItem.Fields; _i < _a.length; _i++) {
            var field = _a[_i];
            formItemObservable.Fields.push(me.createIFieldObservable(field));
        }
        if (formItem.TemplateFormItemDocumentTypeAllowed.length === 0) {
            var allFileTypesAllowed = me.getTemplateFormItemDocumentTypeAllowedFromDocumentFileTypeAllowed(me.viewModel.DocumentFileTypesAllowed);
            allFileTypesAllowed.forEach(function (item) {
                formItemObservable.TemplateFormItemDocumentTypeAllowed.push(me.createTemplateFormItemDocumentTypeAllowedObservable(item));
            });
        }
        else {
            formItem.TemplateFormItemDocumentTypeAllowed.forEach(function (item) {
                formItemObservable.TemplateFormItemDocumentTypeAllowed.push(me.createTemplateFormItemDocumentTypeAllowedObservable(item));
            });
        }
        if (formItem.LinkedCustomerDocuments.length === 0) {
            me.viewModel.CustomerDocuments.forEach(function (item) {
                formItemObservable.LinkedCustomerDocuments.push({
                    CustomerDocumentID: ko.observable(item.ID),
                    Description: ko.observable(item.Description),
                    FileName: ko.observable(item.FileName),
                    IsActive: ko.observable(false),
                    TemplateFormItemCustomerDocumentID: ko.observable(0),
                });
            });
        }
        else {
            formItem.LinkedCustomerDocuments.forEach(function (item) {
                formItemObservable.LinkedCustomerDocuments.push({
                    CustomerDocumentID: ko.observable(item.CustomerDocumentID),
                    Description: ko.observable(item.Description),
                    FileName: ko.observable(item.FileName),
                    IsActive: ko.observable(item.IsActive),
                    TemplateFormItemCustomerDocumentID: ko.observable(item.TemplateFormItemCustomerDocumentID),
                });
            });
        }
        formItemObservable.typeIsTextbox = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.TEXTBOX;
        });
        formItemObservable.typeIsNumeric = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.NUMERIC;
        });
        formItemObservable.typeIsTextArea = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.TEXTAREA;
        });
        formItemObservable.typeIsDate = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.DATE;
        });
        formItemObservable.typeIsTime = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.TIME;
        });
        formItemObservable.typeIsDateTime = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.DATETIME;
        });
        formItemObservable.typeIsRadio = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.RADIOBUTTONLIST;
        });
        formItemObservable.typeIsDropdown = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.DROPDOWN;
        });
        formItemObservable.typeIsCheckbox = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.CHECKBOXLIST;
        });
        formItemObservable.typeIsSection = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.SECTION;
        });
        formItemObservable.typeIsButton = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.BUTTON;
        });
        formItemObservable.typeIsTextDesc = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.TEXTDESCRIPTION;
        });
        formItemObservable.typeIsComments = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.MULTIPLECOMMENTS;
        });
        formItemObservable.typeIsCommentsPics = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.MULTIPLECOMMENTSPICS;
        });
        formItemObservable.typeIsBarcode = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.BARCODE;
        });
        formItemObservable.typeIsDocuments = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.DOCUMENTS;
        });
        formItemObservable.typeIsLinkedDocuments = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.LINKEDDOCUMENTS;
        });
        formItemObservable.typeIsSignature = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.SIGNATURE;
        });
        formItemObservable.typeIsTarget = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.TARGET;
        });
        formItemObservable.typeIsAddress = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.ADDRESS;
        });
        formItemObservable.typeIsGeoLocation = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.GEOLOCAITON;
        });
        formItemObservable.typeIsSlider = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.SLIDER;
        });
        formItemObservable.typeIsSingleCheckbox = ko.pureComputed(function () {
            return formItemObservable.ControlTypeID() === Constants.QuestionType.SINGLECHECKBOX;
        });
        formItemObservable.emptyOrNullFormat = ko.pureComputed(function () {
            if (formItemObservable.TemplateControlTypeAttribute.Format()) {
                return false;
            }
            else {
                return true;
            }
        });
        formItemObservable.PhraseOrCustomChoice.subscribe(function (data) {
            if (!data) {
                return;
            }
            if (data === Constants.TEMPLATE_FORM_CHOICES_CUSTOM) {
                formItemObservable.TemplatePhraseID(null);
            }
        });
        return formItemObservable;
    };
    TemplateFormController.prototype.createIFieldObservable = function (field) {
        var vmField = {
            ID: ko.observable(field.ID),
            FieldText: ko.observable(field.FieldText),
            FieldValue: ko.observable(field.FieldValue),
            SortOrder: ko.observable(field.SortOrder),
            HasException: ko.observable(field.HasException),
            HasExceptionForm: ko.observable(field.HasExceptionForm),
            IsActive: ko.observable(field.IsActive),
            TemplateFormID: ko.observable(field.TemplateFormID),
        };
        return vmField;
    };
    TemplateFormController.prototype.isValid = function () {
        var me = this;
        var i;
        var isValid = true;
        var templateForm = this.viewModel.TemplateForm;
        var errors = this.viewModel.Errors;
        if (errors && errors() && errors().length > 0) {
            errors.showAllMessages(true);
            isValid = false;
        }
        templateForm.FormItems().forEach(function (formItem) {
            if (formItem.IsActive()) {
                var formItemIsValid = true;
                formItemIsValid = UI.setRequiredString(formItem.FormText, formItem.IsFormTextMissing) ? formItemIsValid : false;
                formItem.IsFieldsMissing(false);
                if ((formItem.TemplatePhraseID() === null) && me.numberOfActiveFields(formItem.Fields) === 0 &&
                    (formItem.ControlTypeID() === Constants.QuestionType.CHECKBOXLIST ||
                        formItem.ControlTypeID() === Constants.QuestionType.DROPDOWN ||
                        formItem.ControlTypeID() === Constants.QuestionType.RADIOBUTTONLIST)) {
                    formItem.IsFieldsMissing(true);
                    formItemIsValid = false;
                }
                if (formItem.ControlTypeID() === Constants.QuestionType.TEXTAREA ||
                    formItem.ControlTypeID() === Constants.QuestionType.TEXTBOX ||
                    formItem.ControlTypeID() === Constants.QuestionType.BARCODE) {
                    formItemIsValid = UI.validateMinMaxNumericValues(formItem.TemplateControlTypeAttribute.MinLength, formItem.TemplateControlTypeAttribute.MaxLength, false, formItem.MinMaxInvalid) ? formItemIsValid : false;
                }
                if (formItem.ControlTypeID() === Constants.QuestionType.NUMERIC ||
                    formItem.ControlTypeID() === Constants.QuestionType.SLIDER) {
                    formItemIsValid = UI.validateMinMaxNumericValues(formItem.TemplateControlTypeAttribute.MinVal, formItem.TemplateControlTypeAttribute.MaxVal, true, formItem.MinMaxInvalid) ? formItemIsValid : false;
                }
                if ((formItem.TemplatePhraseID() === null) && (formItem.ControlTypeID() === Constants.QuestionType.DROPDOWN ||
                    formItem.ControlTypeID() === Constants.QuestionType.RADIOBUTTONLIST ||
                    formItem.ControlTypeID() === Constants.QuestionType.CHECKBOXLIST)) {
                    for (i = 0; i < formItem.Fields().length; i++) {
                        if (!formItem.MultipleAdditionalForms() && formItem.Fields()[i].HasExceptionForm()
                            && formItem.Fields()[i].IsActive()) {
                            formItemIsValid = UI.setRequiredNumber(formItem.TemplateAdditionalFormID, formItem.IsAdditionalFormMissing) ? formItemIsValid : false;
                        }
                    }
                }
                if (formItem.ControlTypeID() === Constants.QuestionType.DOCUMENTS) {
                    formItem.DocumentFileTypeNotSelected(!formItem.TemplateFormItemDocumentTypeAllowed().some(function (x) { return x.IsActive(); }));
                    formItemIsValid = formItem.DocumentFileTypeNotSelected() ? false : formItemIsValid;
                }
                if (formItem.ControlTypeID() === Constants.QuestionType.SLIDER) {
                    formItemIsValid = me.validateSliderDefaultValueAndInterval(formItem) ? formItemIsValid : false;
                }
                formItem.HasError(!formItemIsValid);
                if (!formItemIsValid) {
                    isValid = false;
                }
            }
        });
        return isValid;
    };
    TemplateFormController.prototype.validateSliderDefaultValueAndInterval = function (formItem) {
        var me = this;
        formItem.ValidNumericDefaultValue(me.validDefaultValue(formItem));
        formItem.ValidInterval(formItem.TemplateControlTypeAttribute.Interval() > 0);
        return formItem.ValidInterval() && formItem.ValidNumericDefaultValue();
    };
    TemplateFormController.prototype.validDefaultValue = function (formItem) {
        var isValid = false;
        var min = parseInt(formItem.TemplateControlTypeAttribute.MinVal(), 10);
        var max = parseInt(formItem.TemplateControlTypeAttribute.MaxVal(), 10);
        if (!isNaN(min) && !isNaN(max) &&
            (formItem.TemplateControlTypeAttribute.NumericDefaultValue() >= min &&
                formItem.TemplateControlTypeAttribute.NumericDefaultValue() <= max)) {
            isValid = true;
        }
        return isValid;
    };
    TemplateFormController.prototype.numberOfActiveFields = function (fields) {
        var count = 0;
        fields().forEach(function (field) {
            if (field.IsActive()) {
                count++;
            }
        });
        return count;
    };
    TemplateFormController.prototype.getTemplateForm = function () {
        var templateForm = {
            ID: this.viewModel.TemplateForm.ID(),
            FormName: this.viewModel.TemplateForm.FormName(),
            FormDescription: this.viewModel.TemplateForm.FormDescription(),
            FormTypeID: this.viewModel.TemplateForm.FormTypeID(),
            IsActive: this.viewModel.TemplateForm.IsActive(),
            FormItems: this.getTemplateFormItems(),
        };
        return templateForm;
    };
    TemplateFormController.prototype.getControlTypeAttribute = function (controlTypeAttribute) {
        var templateControlTypeAttribute = {
            ID: controlTypeAttribute.ID(),
            MinLength: controlTypeAttribute.MinLength(),
            MaxLength: controlTypeAttribute.MaxLength(),
            MinVal: controlTypeAttribute.MinVal(),
            MaxVal: controlTypeAttribute.MaxVal(),
            Format: controlTypeAttribute.Format(),
            NumDecimals: controlTypeAttribute.NumDecimals(),
            NumericDefaultValue: controlTypeAttribute.NumericDefaultValue(),
            Interval: controlTypeAttribute.Interval(),
        };
        return templateControlTypeAttribute;
    };
    TemplateFormController.prototype.getFields = function (fields) {
        var templateFormFields = [];
        fields().forEach(function (field) {
            var templateFormField = {
                ID: field.ID(),
                FieldText: field.FieldText(),
                FieldValue: field.FieldValue(),
                SortOrder: field.SortOrder(),
                IsActive: field.IsActive(),
                HasException: field.HasException(),
                HasExceptionForm: field.HasExceptionForm(),
                TemplateFormID: field.TemplateFormID(),
            };
            templateFormFields.push(templateFormField);
        });
        return templateFormFields;
    };
    TemplateFormController.prototype.getDuplicateFields = function (fields) {
        var templateFormFields = [];
        fields().forEach(function (field) {
            var templateFormField = {
                ID: 0,
                FieldText: field.FieldText(),
                FieldValue: field.FieldValue(),
                SortOrder: field.SortOrder(),
                IsActive: field.IsActive(),
                HasException: field.HasException(),
                HasExceptionForm: field.HasExceptionForm(),
                TemplateFormID: field.TemplateFormID(),
            };
            templateFormFields.push(templateFormField);
        });
        return templateFormFields;
    };
    TemplateFormController.prototype.getTemplateFormItems = function () {
        var me = this;
        var templateFormItems = [];
        this.viewModel.TemplateForm.FormItems().forEach(function (formItem) {
            var templateFormItem = {
                ID: formItem.ID(),
                FormText: formItem.FormText(),
                FormTextTranslations: me.createTranslationTextsFromObservables(formItem.FormTextTranslations),
                TemplateFormID: formItem.TemplateFormID(),
                TemplatePhraseID: ((formItem.PhraseOrCustomChoice() === Constants.TEMPLATE_FORM_CHOICES_PHRASES
                    || formItem.ControlTypeID() === Constants.QuestionType.TEXTBOX || formItem.ControlTypeID() === Constants.QuestionType.TEXTAREA
                    || formItem.ControlTypeID() === Constants.QuestionType.MULTIPLECOMMENTS
                    || formItem.ControlTypeID() === Constants.QuestionType.MULTIPLECOMMENTSPICS)
                    ? formItem.TemplatePhraseID() : 0),
                TemplateAdditionalFormID: formItem.MultipleAdditionalForms() ? 0 : formItem.TemplateAdditionalFormID(),
                ControlTypeID: formItem.ControlTypeID(),
                IsRequired: formItem.IsRequired(),
                SortOrder: formItem.SortOrder(),
                IsReadOnly: formItem.IsReadOnly(),
                IsVisible: formItem.IsVisible(),
                IsActive: formItem.IsActive(),
                Fields: me.getFields(formItem.Fields),
                TemplateControlTypeAttribute: me.getControlTypeAttribute(formItem.TemplateControlTypeAttribute),
                TemplateFormItemDocumentTypeAllowed: me.getTemplateFormItemDocumentTypeAllowedFromObservable(formItem.TemplateFormItemDocumentTypeAllowed),
                LinkedCustomerDocuments: me.getTemplateFormItemLinkedCustomerDocumentsFromObservable(formItem.LinkedCustomerDocuments),
                IsEdit: false,
                MultipleAdditionalForms: formItem.MultipleAdditionalForms(),
                CopyAnswerWhenCloningTask: formItem.CopyAnswerWhenCloningTask(),
                ShowOnCalendar: formItem.ShowOnCalendar(),
                TargetTemplateID: formItem.TargetTemplateID(),
                PhraseOrCustomChoice: formItem.PhraseOrCustomChoice(),
                ExternalName: formItem.ExternalName(),
                ReportName: formItem.ReportName(),
            };
            templateFormItems.push(templateFormItem);
        });
        return templateFormItems;
    };
    TemplateFormController.prototype.getTemplateFormItemLinkedCustomerDocumentsFromObservable = function (linkedDocs) {
        var result = [];
        linkedDocs().forEach(function (item) {
            result.push({
                CustomerDocumentID: item.CustomerDocumentID(),
                Description: item.Description(),
                FileName: item.FileName(),
                IsActive: item.IsActive(),
                TemplateFormItemCustomerDocumentID: item.TemplateFormItemCustomerDocumentID(),
            });
        });
        return result;
    };
    TemplateFormController.prototype.updateURL = function (newID, FormName) {
        var app = Global.app();
        var routeChange = {
            appRouterID: this.appRouterID([]),
            url: "/TemplateForm/" + newID,
            title: this.title(),
            subTitle: FormName,
            newAppRouterID: this.appRouterID([newID]),
        };
        app.events().trigger(EventUtil.EVENT_ROUTECHANGE, routeChange);
    };
    TemplateFormController.prototype.GetCodeModelObservable = function (src) {
        return {
            ID: ko.observable(src ? src.ID : 0),
            Name: ko.observable(src ? src.Name : ""),
        };
    };
    TemplateFormController.prototype.getFormatMasksForControlType = function (controlTypeID) {
        var formatMasks = [];
        var controlTypeMatches = this.viewModel.ControlTypes().filter(function (x) { return x.ID === controlTypeID; });
        if (controlTypeMatches.length > 0 &&
            controlTypeMatches[0].Formats.length > 0) {
            formatMasks.push({
                ID: 0,
                UniqueID: "",
                Description: Constants.PHRASE_NOTSELECTED,
                WebMask: "",
            });
            for (var _i = 0, _a = controlTypeMatches[0].Formats; _i < _a.length; _i++) {
                var format = _a[_i];
                formatMasks.push({
                    ID: format.ID,
                    UniqueID: format.UniqueID,
                    Description: format.Description,
                    WebMask: format.WebMask,
                });
            }
        }
        return formatMasks;
    };
    TemplateFormController.prototype.createEmptyFormTextTranslations = function () {
        var userSession = Global.app().userSession;
        if (!userSession || !userSession.Languages) {
            return [];
        }
        return userSession.Languages.map(function (language) {
            var translatedTextObservable = {
                LanguageID: language.ID,
                LanguageName: language.Name,
                TranslatedText: ko.observable(""),
            };
            return translatedTextObservable;
        });
    };
    TemplateFormController.prototype.createTranslationTextsFromObservables = function (translatedTextObservables) {
        return translatedTextObservables().map(function (translatedTextObservable) {
            var translatedText = {
                LanguageID: translatedTextObservable.LanguageID,
                TranslatedText: translatedTextObservable.TranslatedText(),
            };
            return translatedText;
        });
    };
    return TemplateFormController;
}());
exports.TemplateFormController = TemplateFormController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var data_1 = __webpack_require__(23);
var Global = __webpack_require__(2);
var GridUtil = __webpack_require__(27);
var UI = __webpack_require__(3);
var templateFormData = __webpack_require__(398);
var TemplateFormsController = (function () {
    function TemplateFormsController() {
    }
    TemplateFormsController.prototype.render = function (container) {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        me.gridContainer = container.find("div[data-id='grid']");
        me.dataSource = new kendo.data.DataSource({
            pageSize: 100,
        });
        me.gridContainer.on("click", "a[data-id='copyLink']", function (e) {
            e.preventDefault();
            var ID = $(this).attr("href");
            UI.showConfirmDialog("Are you sure you want to copy this form?", function () {
                templateFormData.CopyForm(ID)
                    .done(function (response) {
                    if (response.Success) {
                        UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                        me.refresh();
                        deferred.resolve();
                    }
                    else {
                        UI.showErrorMessage(response.ErrorMessages);
                        deferred.reject();
                    }
                })
                    .fail(function () {
                    deferred.reject();
                });
            });
        });
        me.grid = me.gridContainer.kendoGrid({
            dataSource: me.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                { title: "ID", field: "ID" },
                { title: "Name", field: "FormName", template: kendo.template($("#template_templateforms_formname").html()) },
                { title: "Type", field: "FormTypeName" },
                { title: "Copy Form", template: "<a href=\"#: ID #\" title=\"Open Template\" data-id=\"copyLink\">Copy Form</a>" },
                {
                    title: "Last Modified", field: "DateTimeModified",
                    template: kendo.template($("#template_templateforms_lastmodifieddate").html()),
                },
                { title: "Modified By", field: "ModifedByFullName" },
            ],
            excel: {
                fileName: "FormTemplates.xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");
        me.grid.hideColumn(0);
        me.gridFilterControl = new GridUtil.GridFilterControl(container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showExportToExcel: true,
            showFilters: true,
            showRefresh: true,
            filters: [
                { name: Constants.PHRASE_FILTER_SHOWACTIVE, checked: true },
                { name: Constants.PHRASE_FILTER_SHOWINACTIVE, checked: false },
            ],
            grid: me.grid,
        });
        me.gridContainer.on("click", "a[data-id='link']", function (e) {
            var path = $(this).attr("href");
            e.preventDefault();
            app.router().navigate(_.defaultTo(path, ""), true);
            return false;
        });
        deferred.resolve();
        return deferred.promise();
    };
    TemplateFormsController.prototype.load = function (params) {
        var app = Global.app();
        var me = this;
        var dataSource;
        var deferred = $.Deferred();
        dataSource = data_1.createWebServiceDataSource("/api/TemplateForms", {
            id: "ID",
            fields: {
                ID: { type: "long" },
                FormName: { type: "string" },
                DateTimeModified: { type: "date" },
                IsActive: { type: "boolean" },
                FormTypeName: { type: "string" },
                ModifedByFullName: { type: "string" },
            },
        }, function (data) {
            me.setDataFilter(data);
        }, function (status) {
            if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                app.pageManager().closeCurrentPage();
            }
        });
        me.grid.setDataSource(dataSource);
        deferred.resolve();
        return deferred.promise();
    };
    TemplateFormsController.prototype.add = function () {
        Global.app().router().navigate("/TemplateForm", true);
    };
    TemplateFormsController.prototype.haveFieldsChanged = function () {
        return false;
    };
    TemplateFormsController.prototype.height = function (height) {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    };
    TemplateFormsController.prototype.refresh = function () {
        this.grid.dataSource.read();
    };
    TemplateFormsController.prototype.appRouterID = function (params) {
        return "FormTemplates";
    };
    TemplateFormsController.prototype.title = function () {
        return "Form Templates";
    };
    TemplateFormsController.prototype.subTitle = function () {
        return "";
    };
    TemplateFormsController.prototype.setDataFilter = function (data) {
        data.IncludeActive = true;
        data.IncludeInactive = false;
        if (this.gridFilterControl != null) {
            this.gridFilterControl.setDataFilter(data);
        }
    };
    return TemplateFormsController;
}());
exports.TemplateFormsController = TemplateFormsController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var EventUtil = __webpack_require__(26);
var Global = __webpack_require__(2);
var templatePhraseImport_1 = __webpack_require__(904);
var UI = __webpack_require__(3);
var templatePhraseData = __webpack_require__(906);
var TemplatePhraseController = (function () {
    function TemplatePhraseController() {
        var _this = this;
        var me = this;
        this.viewModel = {
            TemplatePhrase: {
                ID: ko.observable(0),
                PhraseName: ko.observable(""),
                IsActive: ko.observable(true),
                AdditionalTextLabel1: ko.observable(""),
                AdditionalTextLabel2: ko.observable(""),
                AdditionalNumberLabel1: ko.observable(""),
                AdditionalNumberLabel2: ko.observable(""),
                Details: ko.observableArray(),
                IsPhraseNameMissing: ko.observable(false),
            },
            IsDoingImport: ko.observable(false),
            Errors: ko.observable(false),
            ExportToExcelUrl: Global.app().webServiceBaseURL + "/api/templatephrase/export",
            inactivatePhrase: function (phrase) {
                UI.showConfirmDialog("Are you sure you want to make this phrase inactive?", function () { me.togglePhraseStatus(); });
            },
            activatePhrase: function (phrase) {
                UI.showConfirmDialog("Are you sure you want to make this phrase active?", function () { me.togglePhraseStatus(); });
            },
            addPhraseDetail: function () {
                me.addPhraseDetail();
            },
            deletePhrase: function (detail) {
                me.deletePhrase(detail);
            },
            undoDeletePhrase: function (detail) {
                me.undoDeletePhrase(detail);
            },
            startImport: function () {
                me.importControl.load(me.viewModel.TemplatePhrase.ID());
                me.viewModel.IsDoingImport(true);
            },
            startExport: function () {
                me.container.find("form[name='exportTemplatePhrasesForm']").submit();
            },
        };
        this.importControl = new templatePhraseImport_1.TemplatePhraseImportControl(function () {
            me.viewModel.IsDoingImport(false);
        }, function () {
            me.viewModel.IsDoingImport(false);
            _this.loadRecord(_this.viewModel.TemplatePhrase.ID());
        });
    }
    TemplatePhraseController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, container.find("div[data-id='phraseInput']")[0]);
        this.importControl.render(container.find("div[data-id='importControl']"));
        deferred.resolve();
        return deferred.promise();
    };
    TemplatePhraseController.prototype.load = function (params) {
        if (params != null && params.length === 1) {
            this.templatePhraseID = params[0];
        }
        else {
            this.templatePhraseID = 0;
        }
        return this.loadRecord(this.templatePhraseID);
    };
    TemplatePhraseController.prototype.save = function () {
        var me = this;
        var app = Global.app();
        var waitContainer;
        var deferred = $.Deferred();
        if (!this.isValid()) {
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
            deferred.reject();
            return deferred.promise();
        }
        waitContainer = UI.showWaitIndicator(me.container);
        templatePhraseData.SaveTemplatePhrase(this.getTemplatePhrase())
            .done(function (response) {
            if (response.Success) {
                if (me.viewModel.TemplatePhrase.ID() <= 0) {
                    me.updateURL(response.Payload.ID, me.viewModel.TemplatePhrase.PhraseName());
                }
                else {
                    app.pageManager().refreshCurrentPageTitle();
                }
                me.loadRecord(response.Payload.ID);
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                deferred.resolve();
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
                deferred.reject();
            }
        })
            .fail(function () {
            deferred.reject();
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
        return deferred.promise();
    };
    TemplatePhraseController.prototype.haveFieldsChanged = function () {
        var fieldValues = JSON.stringify(this.getTemplatePhrase());
        if (fieldValues !== this.fieldsOnLoad || this.isImportInProgress()) {
            return true;
        }
        return false;
    };
    TemplatePhraseController.prototype.appRouterID = function (params) {
        var routerID = "TemplatePhrase";
        if (params != null && params.length === 1) {
            routerID += params[0];
        }
        return routerID;
    };
    TemplatePhraseController.prototype.title = function () {
        return "Template Phrase";
    };
    TemplatePhraseController.prototype.subTitle = function () {
        var subTitle = "";
        if (this.templatePhraseID == null) {
            subTitle = "New";
        }
        else {
            subTitle = this.viewModel.TemplatePhrase.PhraseName();
        }
        return subTitle;
    };
    TemplatePhraseController.prototype.isImportInProgress = function () {
        return this.importControl.isUploadInProcess();
    };
    TemplatePhraseController.prototype.loadRecord = function (templatePhraseID) {
        var me = this;
        var i;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        var templatePhraseRequest = {
            TemplatePhraseID: templatePhraseID,
        };
        templatePhraseData.GetTemplatePhraseMaster(templatePhraseRequest)
            .done(function (response) {
            if (response.Success) {
                me.updateViewModel(response.Payload);
                for (i = 0; i < 5; i++) {
                    me.addPhraseDetail();
                }
                me.fieldsOnLoad = JSON.stringify(me.getTemplatePhrase());
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    TemplatePhraseController.prototype.updateViewModel = function (master) {
        var me = this;
        me.viewModel.TemplatePhrase.Details([]);
        me.viewModel.TemplatePhrase.ID(master.ID);
        me.viewModel.TemplatePhrase.PhraseName(master.PhraseName);
        me.viewModel.TemplatePhrase.IsActive(master.IsActive);
        me.viewModel.TemplatePhrase.AdditionalTextLabel1(master.AdditionalTextLabel1);
        me.viewModel.TemplatePhrase.AdditionalTextLabel2(master.AdditionalTextLabel2);
        me.viewModel.TemplatePhrase.AdditionalNumberLabel1(master.AdditionalNumberLabel1);
        me.viewModel.TemplatePhrase.AdditionalNumberLabel2(master.AdditionalNumberLabel2);
        _.forEach(master.Details, function (detail) {
            var templatePhraseDetail = {
                ID: ko.observable(detail.ID),
                Phrase: ko.observable(detail.Phrase),
                SortOrder: ko.observable(detail.SortOrder),
                IsActive: ko.observable(detail.IsActive),
                AdditionalTextValue1: ko.observable(detail.AdditionalTextValue1),
                AdditionalTextValue2: ko.observable(detail.AdditionalTextValue2),
                AdditionalNumberValue1: ko.observable(detail.AdditionalNumberValue1),
                AdditionalNumberValue2: ko.observable(detail.AdditionalNumberValue2),
            };
            me.viewModel.TemplatePhrase.Details.push(templatePhraseDetail);
        });
    };
    TemplatePhraseController.prototype.togglePhraseStatus = function () {
        var me = this;
        var deferred = $.Deferred();
        var newIsActive = !this.viewModel.TemplatePhrase.IsActive();
        var waitContainer = UI.showWaitIndicator(me.container);
        var fieldsChanged = me.haveFieldsChanged();
        templatePhraseData.ChangeTemplatePhraseStatus(me.viewModel.TemplatePhrase.ID(), newIsActive)
            .done(function (response) {
            if (response.Success) {
                me.viewModel.TemplatePhrase.IsActive(newIsActive);
                if (!fieldsChanged) {
                    me.fieldsOnLoad = JSON.stringify(me.getTemplatePhrase());
                }
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve(true);
        });
        return deferred.promise();
    };
    TemplatePhraseController.prototype.isValid = function () {
        var isValid = true;
        var templatePhrase = this.viewModel.TemplatePhrase;
        isValid = UI.setRequiredString(templatePhrase.PhraseName, templatePhrase.IsPhraseNameMissing) ? isValid : false;
        return isValid;
    };
    TemplatePhraseController.prototype.addPhraseDetail = function () {
        var me = this;
        var templatePhraseDetail = {
            ID: ko.observable(0),
            Phrase: ko.observable(""),
            SortOrder: ko.observable(0),
            IsActive: ko.observable(true),
            IsPhraseDetailMissing: ko.observable(false),
            AdditionalTextValue1: ko.observable(""),
            AdditionalTextValue2: ko.observable(""),
            AdditionalNumberValue1: ko.observable(),
            AdditionalNumberValue2: ko.observable(),
        };
        me.viewModel.TemplatePhrase.Details.push(templatePhraseDetail);
    };
    TemplatePhraseController.prototype.deletePhrase = function (detail) {
        detail.IsActive(false);
    };
    TemplatePhraseController.prototype.undoDeletePhrase = function (detail) {
        detail.IsActive(true);
    };
    TemplatePhraseController.prototype.getTemplatePhrase = function () {
        var me = this;
        var templatePhrase = {
            ID: me.viewModel.TemplatePhrase.ID(),
            PhraseName: me.viewModel.TemplatePhrase.PhraseName(),
            IsActive: me.viewModel.TemplatePhrase.IsActive(),
            AdditionalTextLabel1: me.viewModel.TemplatePhrase.AdditionalTextLabel1(),
            AdditionalTextLabel2: me.viewModel.TemplatePhrase.AdditionalTextLabel2(),
            AdditionalNumberLabel1: me.viewModel.TemplatePhrase.AdditionalNumberLabel1(),
            AdditionalNumberLabel2: me.viewModel.TemplatePhrase.AdditionalNumberLabel2(),
            Details: [],
        };
        _.forEach(me.viewModel.TemplatePhrase.Details(), function (detail) {
            var templatePhraseDetail = {
                ID: detail.ID(),
                Phrase: detail.Phrase(),
                SortOrder: detail.SortOrder(),
                IsActive: detail.IsActive(),
                AdditionalTextValue1: detail.AdditionalTextValue1(),
                AdditionalTextValue2: detail.AdditionalTextValue2(),
                AdditionalNumberValue1: detail.AdditionalNumberValue1(),
                AdditionalNumberValue2: detail.AdditionalNumberValue2(),
            };
            templatePhrase.Details.push(templatePhraseDetail);
        });
        return templatePhrase;
    };
    TemplatePhraseController.prototype.updateURL = function (newID, PhraseName) {
        var app = Global.app();
        var routeChange = {
            appRouterID: this.appRouterID([]),
            url: "/TemplatePhrase/" + newID,
            title: this.title(),
            subTitle: PhraseName,
            newAppRouterID: this.appRouterID([newID]),
        };
        app.events().trigger(EventUtil.EVENT_ROUTECHANGE, routeChange);
    };
    return TemplatePhraseController;
}());
exports.TemplatePhraseController = TemplatePhraseController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(80);
var ko = __webpack_require__(4);
var Global = __webpack_require__(2);
var Data = __webpack_require__(905);
var UI = __webpack_require__(3);
var StateValues;
(function (StateValues) {
    StateValues[StateValues["Hidden"] = 0] = "Hidden";
    StateValues[StateValues["UploadFile"] = 1] = "UploadFile";
    StateValues[StateValues["Validate"] = 2] = "Validate";
    StateValues[StateValues["ImportFinished"] = 3] = "ImportFinished";
})(StateValues || (StateValues = {}));
var TemplatePhraseImportControl = (function () {
    function TemplatePhraseImportControl(onCancel, onImportFinished) {
        var _this = this;
        this.onCancel = onCancel;
        this.onImportFinished = onImportFinished;
        this.viewModel = {
            State: ko.observable(StateValues.Hidden),
            FileIsUploaded: ko.observable(false),
            AppendToExistingPhrases: ko.observable(true),
            ValidPhrases: ko.observableArray(),
            InvalidPhrases: ko.observableArray(),
            ImportedPhrases: ko.observableArray(),
            NotImportedPhrases: ko.observableArray(),
            GeneralErrors: ko.observableArray(),
            BackToUploadFile: this.backToFileUpload.bind(this),
            numberOfValidPhrases: function () {
                var validPhrases = this.ValidPhrases();
                if (validPhrases) {
                    return validPhrases.length;
                }
                else {
                    return 0;
                }
            },
            hasValidPhrases: function () {
                return this.numberOfValidPhrases() > 0;
            },
            numberOfInvalidPhrases: function () {
                var invalidPhrases = this.InvalidPhrases();
                if (invalidPhrases) {
                    return invalidPhrases.length;
                }
                else {
                    return 0;
                }
            },
            hasInvalidPhrases: function () {
                return this.numberOfInvalidPhrases() > 0;
            },
            numberOfGeneralErrors: function () {
                var generalErrors = this.GeneralErrors();
                if (generalErrors) {
                    return generalErrors.length;
                }
                else {
                    return 0;
                }
            },
            hasGeneralErrors: function () {
                return this.numberOfGeneralErrors() > 0;
            },
            numberOfImportedPhrases: function () {
                var importedPhrases = this.ImportedPhrases();
                if (importedPhrases) {
                    return importedPhrases.length;
                }
                else {
                    return 0;
                }
            },
            isImported: function () {
                return this.numberOfImportedPhrases() > 0;
            },
            numberOfNotImportedPhrases: function () {
                var notImportedPhrases = this.NotImportedPhrases();
                if (notImportedPhrases) {
                    return notImportedPhrases.length;
                }
                else {
                    return 0;
                }
            },
            isNotImported: function () {
                return this.numberOfNotImportedPhrases() > 0;
            },
            onCancel: function () {
                if (_this.onCancel) {
                    _this.viewModel.State(StateValues.Hidden);
                    _this.viewModel.FileIsUploaded(false);
                    _this.reset();
                    _this.onCancel();
                }
            },
            onValidateFile: function () {
                _this.validateFile();
                _this.viewModel.State(StateValues.Validate);
            },
            onImportFile: function () {
                if (_this.viewModel.AppendToExistingPhrases()) {
                    UI.showConfirmDialog("Are you sure you want to add " + _this.viewModel.numberOfValidPhrases() + " phrase details to the template?\n                    This action can not be stopped once it has started.", function () { return _this.importFile(); });
                }
                else {
                    UI.showConfirmDialog("Are you sure you want to delete all current phrase details and replace them with\n                    " + _this.viewModel.numberOfValidPhrases() + " phrase details? This action can not be stopped once it has started.", function () { return _this.importFile(); });
                }
            },
            onImportFinished: function () {
                if (_this.onImportFinished) {
                    _this.viewModel.State(StateValues.Hidden);
                    _this.reset();
                    _this.onImportFinished();
                }
            },
            isStateHidden: function () { return _this.viewModel.State() === StateValues.Hidden; },
            isStateUploadFile: function () { return _this.viewModel.State() === StateValues.UploadFile; },
            isStateValidate: function () { return _this.viewModel.State() === StateValues.Validate; },
            isStateImportFinished: function () { return _this.viewModel.State() === StateValues.ImportFinished; },
        };
    }
    TemplatePhraseImportControl.prototype.isUploadInProcess = function () {
        return this.viewModel.FileIsUploaded() && !this.viewModel.isStateImportFinished();
    };
    TemplatePhraseImportControl.prototype.render = function (container) {
        var _this = this;
        var app = Global.app();
        var deferred = $.Deferred();
        this.container = container;
        app.templates().render("templatephraseimportcontrol", "template_phrase_import_control", this.container).done(function () {
            ko.applyBindings(_this.viewModel, container[0]);
            _this.createUploadFileControl();
            deferred.resolve();
        });
        return deferred.promise();
    };
    TemplatePhraseImportControl.prototype.load = function (param) {
        if (param != null && param > 0) {
            this.templatePhraseID = param;
        }
        else {
            this.templatePhraseID = 0;
        }
        this.uploadSessionID = this.setUploadSessionID();
        var deferred = $.Deferred();
        this.viewModel.State(StateValues.UploadFile);
        return deferred.promise();
    };
    TemplatePhraseImportControl.prototype.validateFile = function () {
        var _this = this;
        var request = this.buildRequest();
        Data.ValidateFile(request).done(function (response) {
            if (response.Success) {
                _this.viewModel.ValidPhrases.push.apply(_this.viewModel.ValidPhrases, response.Payload.ValidPhrases);
                _this.viewModel.InvalidPhrases.push.apply(_this.viewModel.InvalidPhrases, response.Payload.InvalidPhrases);
                _this.viewModel.GeneralErrors.push.apply(_this.viewModel.GeneralErrors, response.Payload.ErrorMessages);
            }
            else {
                _this.viewModel.GeneralErrors.push.apply(_this.viewModel.GeneralErrors, response.ErrorMessages);
                _this.viewModel.GeneralErrors.push.apply(_this.viewModel.GeneralErrors, response.Payload.ErrorMessages);
            }
            _this.viewModel.State(StateValues.Validate);
        });
    };
    TemplatePhraseImportControl.prototype.importFile = function () {
        var _this = this;
        var request = this.buildRequest();
        Data.Import(request).done(function (response) {
            if (response.Success) {
                _this.viewModel.ValidPhrases.push.apply(_this.viewModel.ValidPhrases, response.Payload.ValidPhrases);
                _this.viewModel.InvalidPhrases.push.apply(_this.viewModel.InvalidPhrases, response.Payload.InvalidPhrases);
                _this.viewModel.GeneralErrors.push.apply(_this.viewModel.GeneralErrors, response.Payload.ErrorMessages);
            }
            else {
                _this.viewModel.GeneralErrors.push.apply(_this.viewModel.GeneralErrors, response.ErrorMessages);
                _this.viewModel.GeneralErrors.push.apply(_this.viewModel.GeneralErrors, response.Payload.ErrorMessages);
            }
            _this.viewModel.ImportedPhrases.push.apply(_this.viewModel.ImportedPhrases, response.Payload.ValidPhrases);
            _this.viewModel.NotImportedPhrases.push.apply(_this.viewModel.NotImportedPhrases, response.Payload.InvalidPhrases);
        });
        this.viewModel.State(StateValues.ImportFinished);
    };
    TemplatePhraseImportControl.prototype.setUploadSessionID = function () {
        return this.uploadSessionID = (new Date()).getTime();
    };
    TemplatePhraseImportControl.prototype.clearUploadedFileList = function () {
        this.uploadControl.clearAllFiles();
    };
    TemplatePhraseImportControl.prototype.buildRequest = function () {
        var request = {
            AppendToExistingPhrases: this.viewModel.AppendToExistingPhrases(),
            TemplatePhraseID: this.templatePhraseID,
            UploadSessionID: this.uploadSessionID,
        };
        return request;
    };
    TemplatePhraseImportControl.prototype.createUploadFileControl = function () {
        var _this = this;
        this.uploadControl = this.container.find("input[data-id='uploadFileControl']").kendoUpload({
            async: {
                saveUrl: "save",
                autoUpload: true,
            },
            multiple: false,
            validation: {
                allowedExtensions: [".csv", ".xls", ".xlsx"],
            },
            upload: function (e) {
                if (e.sender.options.async) {
                    e.sender.options.async.saveUrl = Global.app().webServiceBaseURL + ("/api/FileUploadApi/Import/" + _this.setUploadSessionID());
                }
            },
            success: function (e) {
                _this.viewModel.FileIsUploaded(true);
            },
        }).data("kendoUpload");
    };
    TemplatePhraseImportControl.prototype.backToFileUpload = function () {
        this.reset();
        this.viewModel.State(StateValues.UploadFile);
    };
    TemplatePhraseImportControl.prototype.reset = function () {
        this.clearUploadedFileList();
        this.viewModel.GeneralErrors([]);
        this.viewModel.ValidPhrases([]);
        this.viewModel.InvalidPhrases([]);
        this.viewModel.NotImportedPhrases([]);
        this.viewModel.ImportedPhrases([]);
        this.uploadSessionID = this.setUploadSessionID();
        this.viewModel.AppendToExistingPhrases(true);
        this.viewModel.FileIsUploaded(false);
    };
    return TemplatePhraseImportControl;
}());
exports.TemplatePhraseImportControl = TemplatePhraseImportControl;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function ValidateFile(request) {
    return Util.callWebService("/api/TemplatePhraseDetail/Validate", "POST", request);
}
exports.ValidateFile = ValidateFile;
function Import(request) {
    return Util.callWebService("/api/TemplatePhraseDetail/Import", "POST", request);
}
exports.Import = Import;


/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function GetTemplatePhraseMaster(request) {
    return Util.callWebService("/api/TemplatePhrase/GetTemplatePhrase", "POST", request);
}
exports.GetTemplatePhraseMaster = GetTemplatePhraseMaster;
function SaveTemplatePhrase(templatePhrase) {
    return Util.callWebService("/api/TemplatePhrase/SaveTemplatePhrase", "POST", templatePhrase);
}
exports.SaveTemplatePhrase = SaveTemplatePhrase;
function ChangeTemplatePhraseStatus(templatePhraseID, isActive) {
    return Util.callWebService("/api/TemplatePhrase/ChangeTemplatePhraseStatus", "POST", {
        ID: templatePhraseID,
        IsActive: isActive,
    });
}
exports.ChangeTemplatePhraseStatus = ChangeTemplatePhraseStatus;


/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var data_1 = __webpack_require__(23);
var Global = __webpack_require__(2);
var GridUtil = __webpack_require__(27);
var UI = __webpack_require__(3);
var TemplatePhrasesController = (function () {
    function TemplatePhrasesController() {
    }
    TemplatePhrasesController.prototype.render = function (container) {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        me.gridContainer = container.find("div[data-id='grid']");
        me.dataSource = new kendo.data.DataSource({
            pageSize: 100,
        });
        me.grid = me.gridContainer.kendoGrid({
            dataSource: me.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                { title: "Name", field: "PhraseName", template: kendo.template($("#template_templatephrases_phrasename").html()) },
                {
                    title: "Last Modified", field: "DateTimeModified",
                    template: kendo.template($("#template_templatephrases_lastmodifieddate").html()),
                },
                { title: "Modified By", field: "ModifedByFullName" },
            ],
            excel: {
                fileName: "TemplatePhrases.xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");
        me.gridFilterControl = new GridUtil.GridFilterControl(container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showExportToExcel: true,
            showFilters: true,
            showRefresh: true,
            filters: [
                { name: Constants.PHRASE_FILTER_SHOWACTIVE, checked: true },
                { name: Constants.PHRASE_FILTER_SHOWINACTIVE, checked: false },
            ],
            grid: me.grid,
        });
        me.gridContainer.on("click", "a[data-id='link']", function (e) {
            var path = $(this).attr("href");
            e.preventDefault();
            app.router().navigate(_.defaultTo(path, ""), true);
            return false;
        });
        deferred.resolve();
        return deferred.promise();
    };
    TemplatePhrasesController.prototype.load = function (params) {
        var app = Global.app();
        var me = this;
        var dataSource;
        var deferred = $.Deferred();
        dataSource = data_1.createWebServiceDataSource("/api/TemplatePhrases", {
            id: "ID",
            fields: {
                ID: { type: "long" },
                PhraseName: { type: "string" },
                DateTimeModified: { type: "date" },
                IsActive: { type: "boolean" },
                ModifedByFullName: { type: "string" },
            },
        }, function (data) {
            me.setDataFilter(data);
        }, function (status) {
            if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                app.pageManager().closeCurrentPage();
            }
        });
        me.grid.setDataSource(dataSource);
        deferred.resolve();
        return deferred.promise();
    };
    TemplatePhrasesController.prototype.add = function () {
        Global.app().router().navigate("/TemplatePhrase", true);
    };
    TemplatePhrasesController.prototype.haveFieldsChanged = function () {
        return false;
    };
    TemplatePhrasesController.prototype.height = function (height) {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    };
    TemplatePhrasesController.prototype.refresh = function () {
        this.grid.dataSource.read();
    };
    TemplatePhrasesController.prototype.appRouterID = function (params) {
        return "TemplatePhrases";
    };
    TemplatePhrasesController.prototype.title = function () {
        return "Template Phrases";
    };
    TemplatePhrasesController.prototype.subTitle = function () {
        return "";
    };
    TemplatePhrasesController.prototype.setDataFilter = function (data) {
        if (this.gridFilterControl != null) {
            this.gridFilterControl.setDataFilter(data);
        }
    };
    return TemplatePhrasesController;
}());
exports.TemplatePhrasesController = TemplatePhrasesController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var data_1 = __webpack_require__(23);
var Global = __webpack_require__(2);
var GridUtil = __webpack_require__(27);
var UI = __webpack_require__(3);
var TemplateData = __webpack_require__(84);
var TemplatesController = (function () {
    function TemplatesController() {
    }
    TemplatesController.prototype.render = function (container) {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        me.gridContainer = container.find("div[data-id='grid']");
        me.dataSource = new kendo.data.DataSource({
            pageSize: 100,
        });
        me.gridContainer.on("click", "a[data-id='copyLink']", function (e) {
            var ID = $(this).attr("href");
            e.preventDefault();
            UI.showConfirmDialog("Are you sure you want to copy this template?", function () {
                TemplateData.CopyTemplate(ID)
                    .done(function (response) {
                    if (response.Success) {
                        UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                        me.refresh();
                        deferred.resolve();
                    }
                    else {
                        UI.showErrorMessage(response.ErrorMessages);
                        deferred.reject();
                    }
                })
                    .fail(function () {
                    deferred.reject();
                });
            });
        });
        me.grid = me.gridContainer.kendoGrid({
            dataSource: me.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                { title: "ID", field: "ID" },
                { title: "Name", field: "TemplateName", template: kendo.template($("#template_templates_templatename").html()) },
                { title: "Target Type", field: "TargetTemplateName" },
                { title: "Copy Template", template: "<a href=\"#: ID #\" title=\"Open Template\" data-id=\"copyLink\">Copy Template</a>" },
                {
                    title: "Last Modified", field: "DateTimeModified",
                    template: kendo.template($("#template_templates_lastmodifieddate").html()),
                },
                { title: "Modified By", field: "ModifedByFullName" },
            ],
            excel: {
                fileName: "Templates.xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");
        me.grid.hideColumn(0);
        me.gridFilterControl = new GridUtil.GridFilterControl(container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showExportToExcel: true,
            showFilters: true,
            showRefresh: true,
            filters: [
                { name: Constants.PHRASE_FILTER_SHOWACTIVE, checked: true },
                { name: Constants.PHRASE_FILTER_SHOWINACTIVE, checked: false },
            ],
            grid: me.grid,
        });
        me.gridContainer.on("click", "a[data-id='link']", function (e) {
            var path = $(this).attr("href");
            e.preventDefault();
            app.router().navigate(_.defaultTo(path, ""), true);
            return false;
        });
        deferred.resolve();
        return deferred.promise();
    };
    TemplatesController.prototype.load = function (params) {
        var app = Global.app();
        var me = this;
        var dataSource;
        var deferred = $.Deferred();
        dataSource = data_1.createWebServiceDataSource("/api/Templates", {
            id: "ID",
            fields: {
                ID: { type: "long" },
                TemplateName: { type: "string" },
                TargetTemplateName: { type: "string" },
                DateTimeModified: { type: "date" },
                IsActive: { type: "boolean" },
                ModifedByFullName: { type: "string" },
            },
        }, function (data) {
            me.setDataFilter(data);
        }, function (status) {
            if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                app.pageManager().closeCurrentPage();
            }
        });
        me.grid.setDataSource(dataSource);
        deferred.resolve();
        return deferred.promise();
    };
    TemplatesController.prototype.add = function () {
        Global.app().router().navigate("/Template", true);
    };
    TemplatesController.prototype.haveFieldsChanged = function () {
        return false;
    };
    TemplatesController.prototype.height = function (height) {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    };
    TemplatesController.prototype.refresh = function () {
        this.grid.dataSource.read();
    };
    TemplatesController.prototype.appRouterID = function (params) {
        return "Templates";
    };
    TemplatesController.prototype.title = function () {
        return Constants.LABEL_APPOINTMENT + " Templates";
    };
    TemplatesController.prototype.subTitle = function () {
        return "";
    };
    TemplatesController.prototype.setDataFilter = function (data) {
        data.IncludeActive = true;
        data.IncludeInactive = false;
        if (this.gridFilterControl != null) {
            this.gridFilterControl.setDataFilter(data);
        }
    };
    return TemplatesController;
}());
exports.TemplatesController = TemplatesController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var EventUtil = __webpack_require__(26);
var Global = __webpack_require__(2);
var UI = __webpack_require__(3);
var Util = __webpack_require__(8);
var UserData = __webpack_require__(91);
var UserController = (function () {
    function UserController() {
        this.fieldsOnLoad = {};
        var me = this;
        this.viewModel = {
            ID: ko.observable(0),
            CustomerID: ko.observable(0),
            UserName: ko.observable().extend({ required: true }),
            Email: ko.observable(),
            FirstName: ko.observable().extend({ required: true }),
            LastName: ko.observable().extend({ required: true }),
            IsActive: ko.observable(true),
            UserCustomerIsActive: ko.observable(true),
            TimeZoneID: ko.observable(0),
            IsTimeZoneIDMissing: ko.observable(false),
            Roles: ko.observableArray(),
            ShowPassword: ko.observable(false),
            TimeZones: ko.observableArray(),
            MinimumPasswordLength: ko.observable(0),
            PasswordComplexityRequirements: ko.observable(""),
            ResetPasswordOnNextLogin: ko.observable(true),
            Errors: ko.observable(false),
            passwordVisible: function (user) {
                user.ShowPassword(!user.ShowPassword());
            },
            inactivateUser: function (user) {
                UI.showConfirmDialog("Are you sure you want to make user inactive?", function () { me.toggleUserStatus(); });
            },
            activateUser: function (user) {
                UI.showConfirmDialog("Are you sure you want to make user active?", function () { me.toggleUserStatus(); });
            },
        };
        this.viewModel.Password = ko.observable("").extend({
            required: {
                message: "Please enter a password",
                params: true,
                onlyIf: me.viewModel.ShowPassword,
            },
        });
        this.viewModel.ConfirmPassword = ko.observable("").extend({
            required: {
                message: "Please confirm password",
                params: true,
                onlyIf: me.viewModel.ShowPassword,
            },
        });
        this.viewModel.errors = ko.validation.group(this.viewModel, { deep: true });
    }
    UserController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    UserController.prototype.load = function (params) {
        if (params != null && params.length === 1) {
            this.userID = params[0];
        }
        else {
            this.userID = 0;
        }
        this.loadPasswordRequirements();
        return this.loadRecord(this.userID);
    };
    UserController.prototype.haveFieldsChanged = function () {
        var fieldValues = ko.toJSON(this.viewModel);
        return fieldValues !== this.fieldsOnLoad;
    };
    UserController.prototype.appRouterID = function (params) {
        var appRouterID = "User";
        if (params != null && params.length === 1) {
            appRouterID += params[0];
        }
        return appRouterID;
    };
    UserController.prototype.save = function () {
        var me = this;
        var app = Global.app();
        var waitContainer;
        var deferred = $.Deferred();
        if (this.isValid()) {
            waitContainer = UI.showWaitIndicator(me.container);
            UserData.SaveUser(ko.toJS(this.viewModel))
                .done(function (response) {
                if (response.Success) {
                    if (me.viewModel.ID() <= 0) {
                        me.viewModel.ID(response.Payload.ID);
                        me.updateURL(response.Payload.ID, me.viewModel.UserName());
                    }
                    else {
                        app.pageManager().refreshCurrentPageTitle();
                    }
                    me.loadRecord(response.Payload.ID);
                    UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                    deferred.resolve();
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                    deferred.reject();
                }
            })
                .fail(function () {
                deferred.reject();
            })
                .always(function () {
                UI.hideWaitIndicator(me.container, waitContainer);
            });
        }
        else {
            deferred.reject();
        }
        return deferred.promise();
    };
    UserController.prototype.title = function () {
        return "User";
    };
    UserController.prototype.subTitle = function () {
        if (this.viewModel != null && this.userID != null) {
            return this.viewModel.UserName();
        }
        else {
            return "New";
        }
    };
    UserController.prototype.updateURL = function (newID, UserName) {
        var app = Global.app();
        var routeChange = {
            appRouterID: this.appRouterID([]),
            url: "/User/" + newID,
            title: this.title(),
            subTitle: UserName,
            newAppRouterID: this.appRouterID([newID]),
        };
        app.events().trigger(EventUtil.EVENT_ROUTECHANGE, routeChange);
    };
    UserController.prototype.loadRecord = function (userID) {
        var me = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        var userRequest = {
            UserID: userID,
        };
        UserData.GetUser(userRequest)
            .done(function (response) {
            if (response.Success) {
                me.viewModel.Roles([]);
                me.viewModel.TimeZones([]);
                me.viewModel.ID(response.Payload.ID);
                me.viewModel.CustomerID(response.Payload.CustomerID);
                if (!Util.isNullOrEmpty(response.Payload.UserName)) {
                    me.viewModel.UserName(response.Payload.UserName);
                }
                if (!Util.isNullOrEmpty(response.Payload.FirstName)) {
                    me.viewModel.FirstName(response.Payload.FirstName);
                }
                if (!Util.isNullOrEmpty(response.Payload.LastName)) {
                    me.viewModel.LastName(response.Payload.LastName);
                }
                me.viewModel.Email(response.Payload.Email);
                if (me.viewModel.ID() === 0) {
                    me.viewModel.ShowPassword(true);
                }
                me.viewModel.IsActive(response.Payload.IsActive);
                me.viewModel.UserCustomerIsActive(response.Payload.UserCustomerIsActive);
                $(response.Payload.Roles).each(function (index, roles) {
                    me.viewModel.Roles.push(me.Roles(roles));
                });
                _.forEach(response.Payload.TimeZones, function (timezone) {
                    me.viewModel.TimeZones.push(timezone);
                });
                me.viewModel.TimeZoneID(response.Payload.TimeZoneID);
                me.viewModel.ResetPasswordOnNextLogin(response.Payload.ResetPasswordOnNextLogin);
                me.fieldsOnLoad = ko.toJSON(me.viewModel);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    UserController.prototype.isValid = function () {
        var user = this.viewModel;
        var isValid = true;
        if (this.viewModel.errors().length > 0) {
            this.viewModel.errors.showAllMessages();
            UI.showErrorMessage([Constants.PHRASE_INVALIDFIELDSONSAVE]);
            return false;
        }
        if (user.ShowPassword() && (user.Password() !== user.ConfirmPassword())) {
            UI.showErrorMessage(["Passwords do not match"]);
            user.Errors(true);
            return false;
        }
        isValid = UI.setRequiredNumber(user.TimeZoneID, user.IsTimeZoneIDMissing) ? isValid : false;
        return isValid;
    };
    UserController.prototype.Roles = function (roles) {
        return {
            ID: ko.observable(roles ? roles.ID : 0),
            RoleName: ko.observable(roles ? roles.RoleName : ""),
            IsUserInRole: ko.observable(roles ? roles.IsUserInRole : false),
        };
    };
    UserController.prototype.toggleUserStatus = function () {
        var me = this;
        var newIsActive = !this.viewModel.UserCustomerIsActive();
        var waitContainer = UI.showWaitIndicator(me.container);
        UserData.ChangeUserStatus(this.viewModel.ID(), newIsActive)
            .done(function (response) {
            if (response.Success) {
                me.viewModel.UserCustomerIsActive(newIsActive);
                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(me.container, waitContainer);
        });
    };
    UserController.prototype.loadPasswordRequirements = function () {
        var me = this;
        UserData.GetPasswordRequirements()
            .done(function (response) {
            if (response.Success) {
                me.viewModel.MinimumPasswordLength(response.Payload.MinimumPasswordLength);
                me.viewModel.PasswordComplexityRequirements(response.Payload.PasswordComplexityRequirements);
            }
        });
    };
    return UserController;
}());
exports.UserController = UserController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function GetPasswordRequirements() {
    return Util.callWebService("/api/User/PasswordRequirements", "GET");
}
exports.GetPasswordRequirements = GetPasswordRequirements;
function GetUser(request) {
    return Util.callWebService("/api/User/GetUser", "POST", request);
}
exports.GetUser = GetUser;
function SaveUser(user) {
    return Util.callWebService("/api/User/SaveUser", "POST", user);
}
exports.SaveUser = SaveUser;
function ChangeUserStatus(userID, isActive) {
    return Util.callWebService("/api/User/ChangeUserStatus", "POST", {
        ID: userID,
        UserCustomerIsActive: isActive,
    });
}
exports.ChangeUserStatus = ChangeUserStatus;
function ChangePassword(request) {
    return Util.callWebService("/api/User/ChangePassword", "POST", request);
}
exports.ChangePassword = ChangePassword;


/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var Constants = __webpack_require__(5);
var UI = __webpack_require__(3);
var UserProfileData = __webpack_require__(911);
var ko = __webpack_require__(4);
var USERPROFILE_MISSING_TIMEZONEID = "Please select a Time Zone.";
var UserProfileController = (function () {
    function UserProfileController() {
        this.fieldsOnLoad = "";
        this.viewModel = {
            TimeZoneID: ko.observable(),
            LanguageID: ko.observable(),
            TimeZones: ko.observableArray(),
            Languages: ko.observableArray([]),
        };
    }
    UserProfileController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, container[0]);
        deferred.resolve();
        return deferred.promise();
    };
    UserProfileController.prototype.load = function () {
        return this.loadRecord();
    };
    UserProfileController.prototype.haveFieldsChanged = function () {
        var fieldValues = JSON.stringify(this.createUserProfileMaster());
        return fieldValues !== this.fieldsOnLoad;
    };
    UserProfileController.prototype.appRouterID = function (params) {
        return "UserProfile";
    };
    UserProfileController.prototype.save = function () {
        var _this = this;
        var waitContainer;
        var deferred = $.Deferred();
        if (this.isValid()) {
            waitContainer = UI.showWaitIndicator(this.container);
            UserProfileData.SaveUserProfileMaster(this.createUserProfileMaster())
                .done(function (response) {
                if (response.Success) {
                    UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                    _this.fieldsOnLoad = JSON.stringify(_this.createUserProfileMaster());
                    deferred.resolve();
                }
                else {
                    UI.showErrorMessage(response.ErrorMessages);
                    deferred.reject();
                }
            })
                .fail(function () {
                deferred.reject();
            })
                .always(function () {
                UI.hideWaitIndicator(_this.container, waitContainer);
            });
        }
        else {
            deferred.reject();
        }
        return deferred.promise();
    };
    UserProfileController.prototype.title = function () {
        return "Your Profile";
    };
    UserProfileController.prototype.subTitle = function () {
        return "";
    };
    UserProfileController.prototype.loadRecord = function () {
        var _this = this;
        var deferred = $.Deferred();
        var waitContainer = UI.showWaitIndicator(this.container);
        var me = this;
        UserProfileData.GetUserProfileMaster()
            .done(function (response) {
            if (response.Success) {
                me.updateViewModel(response.Payload);
            }
            else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
            .always(function () {
            UI.hideWaitIndicator(_this.container, waitContainer);
            deferred.resolve();
        });
        return deferred.promise();
    };
    UserProfileController.prototype.isValid = function () {
        var isValid = true;
        if (this.viewModel.TimeZoneID() == null) {
            UI.showErrorMessage([USERPROFILE_MISSING_TIMEZONEID]);
            isValid = false;
        }
        return isValid;
    };
    UserProfileController.prototype.updateViewModel = function (userProfileMaster) {
        this.viewModel.TimeZones(userProfileMaster.TimeZones);
        this.viewModel.Languages(userProfileMaster.Languages || []);
        this.viewModel.TimeZoneID(userProfileMaster.TimeZoneID);
        this.viewModel.LanguageID(userProfileMaster.LanguageID);
        this.fieldsOnLoad = JSON.stringify(this.createUserProfileMaster());
    };
    UserProfileController.prototype.createUserProfileMaster = function () {
        var UserProfileMaster = {
            TimeZoneID: this.viewModel.TimeZoneID(),
            LanguageID: this.viewModel.LanguageID(),
            TimeZones: this.viewModel.TimeZones(),
            Languages: this.viewModel.Languages(),
        };
        return UserProfileMaster;
    };
    return UserProfileController;
}());
exports.UserProfileController = UserProfileController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util = __webpack_require__(8);
function GetUserProfileMaster() {
    return Util.callWebService("/api/UserProfile/GetUserProfileMaster", "GET");
}
exports.GetUserProfileMaster = GetUserProfileMaster;
function SaveUserProfileMaster(userProfileMaster) {
    return Util.callWebService("/api/UserProfile/SaveUserProfileMaster", "POST", userProfileMaster);
}
exports.SaveUserProfileMaster = SaveUserProfileMaster;


/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(9);
var Constants = __webpack_require__(5);
var data_1 = __webpack_require__(23);
var Global = __webpack_require__(2);
var GridUtil = __webpack_require__(27);
var UI = __webpack_require__(3);
var UsersController = (function () {
    function UsersController() {
        var app = Global.app();
        var customerSettings = app.userSession ? app.userSession.CustomerSettings : [];
        this.dateFormat = UI.GetCustomerSetting(customerSettings, Constants.SETTING_KEY_DATEFORMAT, Constants.DEFAULT_DATE_FORMAT);
    }
    UsersController.prototype.render = function (container) {
        var me = this;
        var app = Global.app();
        var deferred = $.Deferred();
        me.gridContainer = container.find("div[data-id='grid']");
        me.dataSource = new kendo.data.DataSource({
            pageSize: 100,
        });
        me.grid = me.gridContainer.kendoGrid({
            dataSource: me.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                { title: "Login Name", field: "UserName", template: kendo.template($("#template_users_username").html()) },
                { title: "User Name", field: "FullName" },
                { title: "Email", field: "Email" },
                {
                    title: "Created Date",
                    field: "DateTimeCreated",
                    template: "#= DateTimeCreated === null ? \" \" : kendo.toString(DateTimeCreated, \"" + UI.getKendoDateFormat(me.dateFormat) + "\")#",
                    width: "220px",
                    filterable: {
                        ui: function (element) {
                            element.kendoDatePicker({
                                format: UI.getKendoDateFormat(me.dateFormat),
                            });
                        },
                    },
                },
            ],
            excel: {
                fileName: "Users.xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");
        me.gridFilterControl = new GridUtil.GridFilterControl(container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showExportToExcel: true,
            showFilters: true,
            showRefresh: true,
            filters: [
                { name: Constants.PHRASE_FILTER_SHOWACTIVE, checked: true },
                { name: Constants.PHRASE_FILTER_SHOWINACTIVE, checked: false },
            ],
            grid: me.grid,
        });
        me.gridContainer.on("click", "a[data-id='link']", function (e) {
            var path = $(this).attr("href");
            e.preventDefault();
            app.router().navigate(_.defaultTo(path, ""), true);
            return false;
        });
        deferred.resolve();
        return deferred.promise();
    };
    UsersController.prototype.load = function (params) {
        var app = Global.app();
        var me = this;
        var dataSource;
        var deferred = $.Deferred();
        dataSource = data_1.createWebServiceDataSource("/api/Users", {
            id: "ID",
            fields: {
                ID: { type: "long" },
                UserName: { type: "string" },
                FullName: { type: "string" },
                Email: { type: "string" },
                DateTimeCreated: { type: "date" },
                IsActive: { type: "boolean" },
            },
        }, function (data) {
            me.setDataFilter(data);
        }, function (status) {
            if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                app.pageManager().closeCurrentPage();
            }
        });
        me.grid.setDataSource(dataSource);
        deferred.resolve();
        return deferred.promise();
    };
    UsersController.prototype.add = function () {
        Global.app().router().navigate("/User", true);
    };
    UsersController.prototype.haveFieldsChanged = function () {
        return false;
    };
    UsersController.prototype.height = function (height) {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    };
    UsersController.prototype.refresh = function () {
        this.grid.dataSource.read();
    };
    UsersController.prototype.appRouterID = function (params) {
        return "Users";
    };
    UsersController.prototype.title = function () {
        return "Users";
    };
    UsersController.prototype.subTitle = function () {
        return "";
    };
    UsersController.prototype.setDataFilter = function (data) {
        data.IncludeActive = true;
        data.IncludeInactive = false;
        if (this.gridFilterControl != null) {
            this.gridFilterControl.setDataFilter(data);
        }
    };
    return UsersController;
}());
exports.UsersController = UsersController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var reportViewer_1 = __webpack_require__(399);
var UI = __webpack_require__(3);
var Util = __webpack_require__(8);
var ViewReportController = (function () {
    function ViewReportController() {
        this.viewModel = {
            appointmentID: ko.observable(),
        };
        this.reportViewer = new reportViewer_1.ReportViewer();
    }
    ViewReportController.prototype.render = function (container) {
        var deferred = $.Deferred();
        this.container = container;
        ko.applyBindings(this.viewModel, this.container[0]);
        this.reportViewer.render(this.container.find(".reportContainer"))
            .then(function () {
            deferred.resolve();
        });
        return deferred.promise();
    };
    ViewReportController.prototype.load = function (params) {
        var deferred = $.Deferred();
        if (params && params.length === 1) {
            this.viewModel.appointmentID(params[0]);
            var reportParameters = {};
            for (var _i = 0, _a = Util.getURLParameters(); _i < _a.length; _i++) {
                var p = _a[_i];
                if (p.Key === "appointmentID" || p.Key === "taskID") {
                    reportParameters.appointmentID = p.Value;
                    reportParameters.taskID = p.Value;
                }
                else {
                    reportParameters[p.Key] = p.Value;
                }
            }
            this.reportViewer.loadReport(params[0], reportParameters);
        }
        else {
            UI.showErrorMessage(["No report specified."]);
        }
        return deferred.promise();
    };
    ViewReportController.prototype.appRouterID = function (params) {
        var taskID = 0;
        if (params && params.length > 0) {
            taskID = params[0];
        }
        var routerID = "ViewReport" + taskID;
        for (var _i = 0, _a = Util.getURLParameters(); _i < _a.length; _i++) {
            var p = _a[_i];
            routerID += "" + p.Key + p.Value;
        }
        return routerID;
    };
    ViewReportController.prototype.title = function () {
        return "View Report";
    };
    ViewReportController.prototype.subTitle = function () {
        return "";
    };
    ViewReportController.prototype.haveFieldsChanged = function () {
        return false;
    };
    return ViewReportController;
}());
exports.ViewReportController = ViewReportController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 919:
/***/ (function(module, exports) {

module.exports = "/templates/telerikreportviewer.html";

/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {﻿/*
* TelerikReporting v11.2.17.913 (http://www.telerik.com/products/reporting.aspx)
* Copyright 2017 Telerik AD. All rights reserved.
*
* Telerik Reporting commercial licenses may be obtained at
* http://www.telerik.com/purchase/license-agreement/reporting.aspx
* If you do not own a commercial license, this file shall be governed by the trial license terms.
*/

// NOTE: This file has been modified to load properly with webpack.
// Two instances of "window.jQuery" were replaced with "jQuery" in IFFE initilizations.

(function(trv, $, window, document, undefined) {
    "use strict";
    var stringFormatRegExp = /{(\w+?)}/g;
    var specialKeys = {
        DELETE: 46,
        BACKSPACE: 8,
        TAB: 9,
        ESC: 27,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        END: 35,
        HOME: 36
    };
    function getCheckSpecialKeyFn() {
        var userAgent = window.navigator.userAgent.toLowerCase();
        if (userAgent.indexOf("firefox") > -1) {
            var specialKeysArray = Object.keys(specialKeys);
            var specialKeysLength = specialKeysArray.length;
            return function(keyCode) {
                for (var i = 0; i < specialKeysLength; i++) {
                    if (specialKeys[specialKeysArray[i]] == keyCode) {
                        return true;
                    }
                }
            };
        }
        return function(keyCode) {
            return false;
        };
    }
    var utils = trv.utils = {
        trim: function(s, charlist) {
            return this.rtrim(this.ltrim(s, charlist), charlist);
        },
        replaceAll: function(str, find, replace) {
            return str.replace(new RegExp(find, "g"), replace);
        },
        ltrim: function(s, charlist) {
            if (charlist === undefined) {
                charlist = "s";
            }
            return s.replace(new RegExp("^[" + charlist + "]+"), "");
        },
        rtrim: function(s, charlist) {
            if (charlist === undefined) {
                charlist = "s";
            }
            return s.replace(new RegExp("[" + charlist + "]+$"), "");
        },
        stringFormat: function(template, data) {
            var isArray = Array.isArray(data);
            return template.replace(stringFormatRegExp, function($0, $1) {
                return data[isArray ? parseInt($1) : $1];
            });
        },
        escapeHtml: function(str) {
            return $("<div>").text(str).html();
        },
        isSpecialKey: getCheckSpecialKeyFn(),
        tryParseInt: function(value) {
            if (/^(\-|\+)?([0-9]+)$/.test(value)) {
                return Number(value);
            }
            return NaN;
        },
        tryParseFloat: function(value) {
            if (/^(\-|\+)?([0-9]+(\.[0-9]+)?)$/.test(value)) {
                return Number(value);
            }
            return NaN;
        },
        parseToLocalDate: function(date) {
            if (date instanceof Date) return date;
            var isUtc = /Z|[\+\-]\d\d:?\d\d/i.test(date);
            if (!isUtc) {
                date += "Z";
            }
            return new Date(date);
        },
        adjustTimezone: function(date) {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
        },
        unadjustTimezone: function(date) {
            return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
        },
        areEqual: function(v1, v2) {
            if (v1 instanceof Date && v2 instanceof Date) {
                if (v1.getTime() !== v2.getTime()) {
                    return false;
                }
            } else if (v1 !== v2) {
                return false;
            }
            return true;
        },
        reportSourcesAreEqual: function(rs1, rs2) {
            if (rs1 && rs2 && rs1.report === rs2.report) {
                var params1 = [], params2 = [];
                if (rs1.parameters) params1 = Object.getOwnPropertyNames(rs1.parameters);
                if (rs2.parameters) params2 = Object.getOwnPropertyNames(rs2.parameters);
                if (params1.length === params2.length) {
                    for (var i = params1.length - 1; i >= 0; i--) {
                        var p = params1[i];
                        var v1 = rs1.parameters[p];
                        var v2 = rs2.parameters[p];
                        if (Array.isArray(v1)) {
                            if (!Array.isArray(v2)) return false;
                            if (!utils.areEqualArrays(v1, v2)) {
                                return false;
                            }
                        } else if (!utils.areEqual(v1, v2)) {
                            return false;
                        }
                    }
                    return true;
                }
            }
            return false;
        },
        areEqualArrays: function(array1, array2) {
            if (array1 == null) {
                if (array2 != null) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (array2 == null) {
                    return false;
                }
            }
            if (array1.length !== array2.length) {
                return false;
            }
            for (var j = array1.length - 1; j >= 0; j--) {
                if (!utils.areEqual(array1[j], array2[j])) {
                    return false;
                }
            }
            return true;
        },
        isSvgSupported: function isSvgSupported() {
            var matches = /Version\/(\d+.\d+.\d+) Safari/.exec(navigator.userAgent);
            if (matches && matches.length > 1) {
                var version = parseFloat(matches[1]);
                return version >= 6;
            }
            return true;
        },
        isInvalidClientException: function(xhr) {
            if (!xhr) return false;
            if (!xhr.responseText) return false;
            var json = utils.parseJSON(xhr.responseText);
            if (!json) return false;
            if (!json.exceptionType) return false;
            return json.exceptionType === "Telerik.Reporting.Services.Engine.InvalidClientException";
        },
        parseJSON: function(json) {
            try {
                return JSON.parse(json, function(key, value) {
                    if (key && value) {
                        var firstChar = key.charAt(0);
                        if (firstChar == firstChar.toUpperCase()) {
                            var newPropertyName = firstChar.toLowerCase() + key.slice(1);
                            this[newPropertyName] = value;
                        }
                    }
                    return value;
                });
            } catch (e) {
                return null;
            }
        },
        extend: function() {
            var src, copy, name, options, target, i = 0, length = arguments.length;
            target = length > 1 ? arguments[i++] || {} : {};
            for (;i < length; i++) {
                if ((options = arguments[i]) != null) {
                    for (name in options) {
                        src = target[name];
                        copy = options[name];
                        if (target === copy) {
                            continue;
                        }
                        if (copy !== undefined) {
                            target[name] = copy;
                        }
                    }
                }
            }
            return target;
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (utils.isArray(obj)) {
                length = obj.length;
                for (;i < length; i++) {
                    if (callback.call(obj[i], i, obj[i]) === false) {
                        break;
                    }
                }
            } else {
                for (i in obj) {
                    if (callback.call(obj[i], i, obj[i]) === false) {
                        break;
                    }
                }
            }
            return obj;
        },
        selector: function() {
            return document.querySelectorAll(arguments[0]);
        },
        isArray: function(obj) {
            if (Array.isArray(obj)) return true;
            var length = !!obj && "length" in obj && obj.length;
            if (typeof length === "number") {
                return true;
            }
            return false;
        },
        loadScript: function(src, done) {
            var js = document.createElement("script");
            js.src = src;
            js.onload = function() {
                done();
            };
            js.onerror = function() {
                done(new Error("Failed to load script " + src));
            };
            document.head.appendChild(js);
        },
        filterUniqueLastOccurance: function(array) {
            function onlyLastUnique(value, index, self) {
                return self.lastIndexOf(value) === index;
            }
            return array.filter(onlyLastUnique);
        },
        logError: function(error) {
            var console = window.console;
            if (console && console.error) {
                console.error(error);
            }
        }
    };
    trv.domUtils = function() {
        function toPixels(value) {
            return parseInt(value, 10) || 0;
        }
        return {
            getMargins: function(dom) {
                var $target = $(dom);
                return {
                    left: toPixels($target.css("marginLeft")),
                    right: toPixels($target.css("marginRight")),
                    top: toPixels($target.css("marginTop")),
                    bottom: toPixels($target.css("marginBottom"))
                };
            },
            getPadding: function(dom) {
                var $target = $(dom);
                return {
                    left: toPixels($target.css("paddingLeft")),
                    right: toPixels($target.css("paddingRight")),
                    top: toPixels($target.css("paddingTop")),
                    bottom: toPixels($target.css("paddingBottom"))
                };
            },
            getBorderWidth: function(dom) {
                var $target = $(dom);
                return {
                    left: toPixels($target.css("borderLeftWidth")),
                    right: toPixels($target.css("borderRightWidth")),
                    top: toPixels($target.css("borderTopWidth")),
                    bottom: toPixels($target.css("borderBottomWidth"))
                };
            },
            scale: function(dom, scaleX, scaleY, originX, originY) {
                scaleX = scaleX || 1;
                scaleY = scaleY || 1;
                originX = originX || 0;
                originY = originY || 0;
                var scale = utils.stringFormat("scale({0}, {1})", [ scaleX, scaleY ]), origin = utils.stringFormat("{0} {1}", [ originX, originY ]);
                $(dom).css("transform", scale).css("-moz-transform", scale).css("-ms-transform", scale).css("-webkit-transform", scale).css("-o-transform", scale).css("-moz-transform-origin", origin).css("-webkit-transform-origin", origin).css("-o-transform-origin", origin).css("-ms-transform-origin", origin).css("transform-origin", origin);
            }
        };
    }();
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv) {
    "use strict";
    var sr = {
        controllerNotInitialized: "Controller is not initialized.",
        noReportInstance: "No report instance.",
        missingTemplate: "!obsolete resource!",
        noReport: "No report.",
        noReportDocument: "No report document.",
        missingOrInvalidParameter: "Missing or invalid parameter value. Please input valid data for all parameters.",
        invalidParameter: "Please input a valid value.",
        invalidDateTimeValue: "Please input a valid date.",
        parameterIsEmpty: "Parameter value cannot be empty.",
        cannotValidateType: "Cannot validate parameter of type {type}.",
        loadingFormats: "Loading...",
        loadingReport: "Loading report...",
        preparingDownload: "Preparing document to download. Please wait...",
        preparingPrint: "Preparing document to print. Please wait...",
        errorLoadingTemplates: "Error loading the report viewer's templates. (Template = {0}).",
        loadingReportPagesInProgress: "{0} pages loaded so far ...",
        loadedReportPagesComplete: "Done. Total {0} pages loaded.",
        noPageToDisplay: "No page to display.",
        errorDeletingReportInstance: "Error deleting report instance: {0}.",
        errorRegisteringViewer: "Error registering the viewer with the service.",
        noServiceClient: "No serviceClient has been specified for this controller.",
        errorRegisteringClientInstance: "Error registering client instance.",
        errorCreatingReportInstance: "Error creating report instance (Report = {0}).",
        errorCreatingReportDocument: "Error creating report document (Report = {0}; Format = {1}).",
        unableToGetReportParameters: "Unable to get report parameters.",
        errorObtainingAuthenticationToken: "Error obtaining authentication token.",
        clientExpired: "Click 'Refresh' to restore client session.",
        ariaLabelPageNumberSelector: "Page number selector. Showing page {0} of {1}.",
        ariaLabelPageNumberEditor: "Page number editor.",
        ariaLabelExpandable: "Expandable",
        ariaLabelParameter: "parameter",
        ariaLabelErrorMessage: "Error message",
        ariaLabelParameterInfo: "Contains {0} options.",
        ariaLabelMultiSelect: "Multiselect",
        ariaLabelMultiValue: "Multivalue",
        ariaLabelSingleValue: "Single value",
        ariaLabelParameterDateTime: "Datetime",
        ariaLabelParameterString: "String",
        ariaLabelParameterNumerical: "Numerical",
        ariaLabelParameterBoolean: "Boolean"
    };
    trv.sr = trv.utils.extend(sr, trv.sr);
})(window.telerikReportViewer = window.telerikReportViewer || {});

(function(trv, window, document, undefined) {
    "use strict";
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReportViewer.utils";
    }
    function IEHelper() {
        function getPdfPlugin() {
            var classIds = [ "AcroPDF.PDF.1", "PDF.PdfCtrl.6", "PDF.PdfCtrl.5" ];
            var plugin = null;
            utils.each(classIds, function(index, classId) {
                try {
                    plugin = new ActiveXObject(classId);
                    if (plugin) {
                        return false;
                    }
                } catch (ex) {}
            });
            return plugin;
        }
        return {
            hasPdfPlugin: function() {
                return getPdfPlugin() !== null;
            }
        };
    }
    function FirefoxHelper() {
        function hasPdfPlugin() {
            var matches = /Firefox[\/\s](\d+\.\d+)/.exec(navigator.userAgent);
            if (null !== matches && matches.length > 1) {
                var version = parseFloat(matches[1]);
                if (version >= 19) {
                    return false;
                }
            }
            var pdfPlugins = navigator.mimeTypes["application/pdf"];
            var pdfPlugin = pdfPlugins !== null ? pdfPlugins.enabledPlugin : null;
            if (pdfPlugin) {
                var description = pdfPlugin.description;
                return description.indexOf("Adobe") !== -1 && (description.indexOf("Version") === -1 || parseFloat(description.split("Version")[1]) >= 6);
            }
            return false;
        }
        return {
            hasPdfPlugin: function() {
                return hasPdfPlugin();
            }
        };
    }
    function ChromeHelper() {
        function hasPdfPlugin() {
            var navPlugins = navigator.plugins;
            var found = false;
            utils.each(navPlugins, function(key, value) {
                if (navPlugins[key].name === "Chrome PDF Viewer" || navPlugins[key].name === "Adobe Acrobat") {
                    found = true;
                    return false;
                }
            });
            return found;
        }
        return {
            hasPdfPlugin: function() {
                return hasPdfPlugin();
            }
        };
    }
    function SafariHelper() {
        function hasPdfPlugin() {
            var navPlugins = navigator.plugins;
            var found = false;
            utils.each(navPlugins, function(key, value) {
                if (navPlugins[key].name === "WebKit built-in PDF" || navPlugins[key].name === "Adobe Acrobat") {
                    found = true;
                    return false;
                }
            });
            return found;
        }
        return {
            hasPdfPlugin: function() {
                return hasPdfPlugin();
            }
        };
    }
    function OtherBrowserHelper() {
        return {
            hasPdfPlugin: function() {
                return false;
            }
        };
    }
    function selectBrowserHelper() {
        if (window.navigator) {
            var userAgent = window.navigator.userAgent.toLowerCase();
            if (userAgent.indexOf("msie") > -1 || userAgent.indexOf("mozilla") > -1 && userAgent.indexOf("trident") > -1) return IEHelper(); else if (userAgent.indexOf("firefox") > -1) return FirefoxHelper(); else if (userAgent.indexOf("chrome") > -1) return ChromeHelper(); else if (userAgent.indexOf("safari") > -1) return SafariHelper(); else return OtherBrowserHelper();
        }
        return null;
    }
    var helper = selectBrowserHelper();
    var hasPdfPlugin = helper ? helper.hasPdfPlugin() : false;
    trv.printManager = function() {
        var iframe;
        function printDesktop(src) {
            if (!iframe) {
                iframe = document.createElement("IFRAME");
                iframe.style.display = "none";
            }
            iframe.src = src;
            document.body.appendChild(iframe);
        }
        function printMobile(src) {
            window.open(src, "_self");
        }
        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        var printFunc = isMobile ? printMobile : printDesktop;
        return {
            print: function(src) {
                printFunc(src);
            },
            getDirectPrintState: function() {
                return hasPdfPlugin;
            }
        };
    }();
})(window.telerikReportViewer = window.telerikReportViewer || {}, window, document);

(function(trv, $, undefined) {
    "use strict";
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReporting.utils";
    }
    var JSON_MIME_TYPE = "application/json", JSON_CONTENT_TYPE = "application/json; charset=UTF-8", URLENCODED_CONTENT_TYPE = "application/x-www-form-urlencoded; charset=UTF-8", HTTP_GET = "GET", HTTP_POST = "POST", HTTP_PUT = "PUT", HTTP_DELETE = "DELETE";
    var defaultOptions = {};
    trv.ServiceClient = function(options) {
        options = utils.extend({}, defaultOptions, options);
        var baseUrl = utils.rtrim(options.serviceUrl || options.baseUrl, "\\/"), loginPromise;
        var _ajax = $ajax;
        function validateClientID(clientID) {
            if (!clientID) throw "Invalid cliendID";
        }
        function urlFromTemplate(template, args) {
            args = utils.extend({}, {
                baseUrl: baseUrl
            }, args);
            return utils.stringFormat(template, args);
        }
        function getHeaderSettings(authorizationToken) {
            return authorizationToken ? {
                headers: {
                    Authorization: "Bearer " + authorizationToken
                }
            } : {};
        }
        function login() {
            if (!loginPromise) {
                var loginInfo = options.loginInfo;
                if (loginInfo && loginInfo.url && (loginInfo.username || loginInfo.password)) {
                    loginPromise = _ajax({
                        url: loginInfo.url,
                        type: HTTP_POST,
                        data: {
                            grant_type: "password",
                            username: loginInfo.username,
                            password: loginInfo.password
                        },
                        dataType: "json",
                        contentType: URLENCODED_CONTENT_TYPE
                    }).then(function(result) {
                        return result.access_token;
                    });
                } else {
                    loginPromise = Promise.resolve();
                }
            }
            return loginPromise;
        }
        function $ajax(ajaxSettings) {
            return new Promise(function(resolve, reject) {
                $.ajax(ajaxSettings).done(function(data) {
                    return resolve(data);
                }).fail(function(xhr, status, error) {
                    reject(toXhrErrorData(xhr, status, error));
                });
            });
        }
        function toXhrErrorData(xhr, status, error) {
            return {
                xhr: xhr,
                status: status,
                error: error
            };
        }
        return {
            _urlFromTemplate: urlFromTemplate,
            registerClient: function(settings) {
                return login().then(function(authorizationToken) {
                    var ajaxSettings = utils.extend(getHeaderSettings(authorizationToken), settings, {
                        type: HTTP_POST,
                        url: urlFromTemplate("{baseUrl}/clients"),
                        dataType: "json",
                        data: JSON.stringify({
                            timeStamp: Date.now()
                        })
                    });
                    return _ajax(ajaxSettings);
                }).then(function(clientData) {
                    return clientData.clientId;
                });
            },
            unregisterClient: function(clientID, settings) {
                validateClientID(clientID);
                return login().then(function(authorizationToken) {
                    var ajaxSettings = utils.extend(getHeaderSettings(authorizationToken), settings, {
                        type: HTTP_DELETE,
                        url: urlFromTemplate("{baseUrl}/clients/{clientID}", {
                            clientID: clientID
                        })
                    });
                    return _ajax(ajaxSettings);
                });
            },
            getParameters: function(clientID, report, parameterValues, settings) {
                validateClientID(clientID);
                return login().then(function(authorizationToken) {
                    var ajaxSettings = utils.extend(getHeaderSettings(authorizationToken), settings, {
                        type: HTTP_POST,
                        url: urlFromTemplate("{baseUrl}/clients/{clientID}/parameters", {
                            clientID: clientID
                        }),
                        contentType: JSON_CONTENT_TYPE,
                        dataType: "json",
                        data: JSON.stringify({
                            report: report,
                            parameterValues: parameterValues
                        })
                    });
                    return _ajax(ajaxSettings);
                });
            },
            createReportInstance: function(clientID, report, parameterValues, settings) {
                validateClientID(clientID);
                return login().then(function(authorizationToken) {
                    var ajaxSettings = utils.extend(getHeaderSettings(authorizationToken), settings, {
                        type: HTTP_POST,
                        url: urlFromTemplate("{baseUrl}/clients/{clientID}/instances", {
                            clientID: clientID
                        }),
                        contentType: JSON_CONTENT_TYPE,
                        dataType: "json",
                        data: JSON.stringify({
                            report: report,
                            parameterValues: parameterValues
                        })
                    });
                    return _ajax(ajaxSettings);
                }).then(function(instanceData) {
                    return instanceData.instanceId;
                });
            },
            deleteReportInstance: function(clientID, instanceID, settings) {
                validateClientID(clientID);
                return login().then(function(authorizationToken) {
                    var ajaxSettings = utils.extend(getHeaderSettings(authorizationToken), settings, {
                        type: HTTP_DELETE,
                        url: urlFromTemplate("{baseUrl}/clients/{clientID}/instances/{instanceID}", {
                            clientID: clientID,
                            instanceID: instanceID
                        })
                    });
                    return _ajax(ajaxSettings);
                });
            },
            createReportDocument: function(clientID, instanceID, format, deviceInfo, useCache, baseDocumentID, actionID, settings) {
                validateClientID(clientID);
                return login().then(function(authorizationToken) {
                    deviceInfo = deviceInfo || {};
                    deviceInfo["BasePath"] = baseUrl;
                    var ajaxSettings = utils.extend(getHeaderSettings(authorizationToken), settings, {
                        type: HTTP_POST,
                        url: urlFromTemplate("{baseUrl}/clients/{clientID}/instances/{instanceID}/documents", {
                            clientID: clientID,
                            instanceID: instanceID
                        }),
                        contentType: JSON_CONTENT_TYPE,
                        dataType: "json",
                        data: JSON.stringify({
                            format: format,
                            deviceInfo: deviceInfo,
                            useCache: useCache,
                            baseDocumentID: baseDocumentID,
                            actionID: actionID
                        })
                    });
                    return _ajax(ajaxSettings);
                }).then(function(documentData) {
                    return documentData.documentId;
                });
            },
            deleteReportDocument: function(clientID, instanceID, documentID, settings) {
                validateClientID(clientID);
                return login().then(function(authorizationToken) {
                    var ajaxSettings = utils.extend(getHeaderSettings(authorizationToken), settings, {
                        type: HTTP_DELETE,
                        url: urlFromTemplate("{baseUrl}/clients/{clientID}/instances/{instanceID}/documents/{documentID}", {
                            clientID: clientID,
                            instanceID: instanceID,
                            documentID: documentID
                        })
                    });
                    return _ajax(ajaxSettings);
                });
            },
            getDocumentInfo: function(clientID, instanceID, documentID, settings) {
                validateClientID(clientID);
                return login().then(function(authorizationToken) {
                    var ajaxSettings = utils.extend(getHeaderSettings(authorizationToken), settings, {
                        type: HTTP_GET,
                        url: urlFromTemplate("{baseUrl}/clients/{clientID}/instances/{instanceID}/documents/{documentID}/info", {
                            clientID: clientID,
                            instanceID: instanceID,
                            documentID: documentID
                        }),
                        dataType: "json"
                    });
                    return _ajax(ajaxSettings);
                });
            },
            getPage: function(clientID, instanceID, documentID, pageNumber, settings) {
                validateClientID(clientID);
                return login().then(function(authorizationToken) {
                    var ajaxSettings = utils.extend(getHeaderSettings(authorizationToken), settings, {
                        type: HTTP_GET,
                        url: urlFromTemplate("{baseUrl}/clients/{clientID}/instances/{instanceID}/documents/{documentID}/pages/{pageNumber}", {
                            clientID: clientID,
                            instanceID: instanceID,
                            documentID: documentID,
                            pageNumber: pageNumber
                        }),
                        dataType: "json"
                    });
                    return _ajax(ajaxSettings);
                });
            },
            get: function(url) {
                var ajaxSettings = {
                    type: HTTP_GET,
                    url: url
                };
                return _ajax(ajaxSettings);
            },
            formatDocumentUrl: function(clientID, instanceID, documentID, queryString) {
                var url = urlFromTemplate("{baseUrl}/clients/{clientID}/instances/{instanceID}/documents/{documentID}", {
                    clientID: clientID,
                    instanceID: instanceID,
                    documentID: documentID
                });
                if (queryString) {
                    url += "?" + queryString;
                }
                return url;
            },
            getDocumentFormats: function(settings) {
                var ajaxSettings = utils.extend({}, settings, {
                    type: HTTP_GET,
                    url: urlFromTemplate("{baseUrl}/formats"),
                    dataType: "json"
                });
                return _ajax(ajaxSettings);
            },
            setAccessToken: function(accessToken) {
                loginPromise = Promise.resolve(accessToken);
            },
            login: login
        };
    };
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery);

(function(trv, window, document, undefined) {
    "use strict";
    var sr = trv.sr;
    if (!sr) {
        throw "Missing telerikReportViewer.sr";
    }
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReportViewer.utils";
    }
    var printManager = trv.printManager;
    if (!printManager) {
        throw "Missing telerikReportViewer.printManager";
    }
    trv.ViewModes = {
        INTERACTIVE: "INTERACTIVE",
        PRINT_PREVIEW: "PRINT_PREVIEW"
    };
    trv.PrintModes = {
        AUTO_SELECT: "AUTO_SELECT",
        FORCE_PDF_PLUGIN: "FORCE_PDF_PLUGIN",
        FORCE_PDF_FILE: "FORCE_PDF_FILE"
    };
    var defaultOptions = {
        pagePollIntervalMs: 500,
        documentInfoPollIntervalMs: 2e3
    };
    function ReportViewerController(options) {
        var controller = {}, clientId, reportInstanceId, reportDocumentId, registerClientPromise, registerInstancePromise, documentFormatsPromise, report, parameterValues, currentPageNumber, pageCount, viewMode = trv.ViewModes.INTERACTIVE, loader, printMode = trv.PrintModes.AUTO_SELECT, bookmarkNodes, clientHasExpired = false, parameterValidators = trv.parameterValidators, events = new Events();
        clearReportState();
        options = utils.extend({}, defaultOptions, options);
        if (options.settings.printMode) {
            printMode = options.settings.printMode();
        }
        var client = options.serviceClient;
        if (!client) {
            throw sr.noServiceClient;
        }
        clientId = options.settings.clientId();
        function setClientId(id) {
            clientId = id;
            options.settings.clientId(clientId);
        }
        function clearClientId() {
            clientId = null;
            registerClientPromise = null;
            options.settings.clientId(null);
        }
        function getFormat() {
            if (viewMode === trv.ViewModes.PRINT_PREVIEW) {
                return "HTML5";
            }
            return "HTML5Interactive";
        }
        function handleRequestError(xhrData, localizedMessage) {
            if (utils.isInvalidClientException(xhrData.xhr)) {
                onClientExpired();
            }
            raiseError(formatXhrError(xhrData.xhr, xhrData.status, xhrData.error, localizedMessage));
            throw "Error shown. Throwing promises chain stop error.";
        }
        function initializeClientAsync() {
            if (!registerClientPromise) {
                registerClientPromise = client.registerClient().catch(function(xhrErrorData) {
                    handleRequestError(xhrErrorData, sr.errorRegisteringViewer);
                }).then(function(clientId) {
                    setClientId(clientId);
                }).catch(clearClientId);
            }
            return registerClientPromise;
        }
        function registerInstanceAsync() {
            if (!registerInstancePromise) {
                registerInstancePromise = createReportInstanceAsync(report, parameterValues).then(function(instanceId) {
                    reportInstanceId = instanceId;
                });
                registerInstancePromise.catch(function(errorMessage) {
                    registerInstancePromise = null;
                });
            }
            return registerInstancePromise;
        }
        function clearReportState() {
            reportDocumentId = null;
            reportInstanceId = null;
            registerInstancePromise = null;
            currentPageNumber = pageCount = 0;
        }
        function formatError(args) {
            var len = args.length;
            if (len == 1) {
                return args[0];
            }
            if (len > 1) {
                return utils.stringFormat(args[0], Array.prototype.slice.call(args, 1));
            }
            return "";
        }
        function raiseError() {
            var error = formatError(arguments);
            controller.error(error);
        }
        function createReportInstanceAsync(report, parameterValues) {
            throwIfNotInitialized();
            return client.createReportInstance(clientId, report, parameterValues).catch(function(xhrErrorData) {
                handleRequestError(xhrErrorData, utils.stringFormat(sr.errorCreatingReportInstance, [ utils.escapeHtml(report) ]));
            });
        }
        function registerDocumentAsync(format, deviceInfo, useCache, baseDocumentId, actionId) {
            throwIfNotInitialized();
            throwIfNoReportInstance();
            return client.createReportDocument(clientId, reportInstanceId, format, deviceInfo, useCache, baseDocumentId, actionId).catch(function(xhrErrorData) {
                handleRequestError(xhrErrorData, utils.stringFormat(sr.errorCreatingReportDocument, [ utils.escapeHtml(report), utils.escapeHtml(format) ]));
            });
        }
        function getDocumentInfoRecursive(clientId, instanceId, documentId, options) {
            if (instanceId == reportInstanceId) {
                return client.getDocumentInfo(clientId, instanceId, documentId).catch(handleRequestError).then(function(info) {
                    if (info && info.documentReady) {
                        return info;
                    } else {
                        info["promise"] = new Promise(function(resolve, reject) {
                            window.setTimeout(resolve, options.documentInfoPollIntervalMs);
                        }).then(function() {
                            return getDocumentInfoRecursive(clientId, instanceId, documentId, options);
                        });
                        return info;
                    }
                });
            } else {
                return Promise.reject();
            }
        }
        function ReportLoader(reportHost, useCache, baseDocumentId, actionId) {
            var loaderOptions = {};
            function onReportDocumentRegistered(id) {
                if (reportHost) {
                    reportDocumentId = id;
                    onBeginLoadReport();
                    getReportDocumentReady();
                }
            }
            function onBeforeLoadReport() {
                loaderOptions.documentInfoPollIntervalMs = options.pagePollIntervalMs;
                if (reportHost) {
                    reportHost.beforeLoadReport();
                }
            }
            function onBeginLoadReport() {
                if (reportHost) {
                    reportHost.beginLoadReport();
                }
            }
            function onReportLoadComplete(info) {
                if (reportHost) {
                    reportHost.onReportLoadComplete(info);
                }
            }
            function onReportLoadProgress(info) {
                if (reportHost) {
                    pageCount = info.pageCount;
                    reportHost.reportLoadProgress(info);
                }
            }
            function getReportDocumentReady() {
                throwIfNotInitialized();
                throwIfNoReportInstance();
                throwIfNoReportDocument();
                progressReportDocumentReady(getDocumentInfoRecursive(clientId, reportInstanceId, reportDocumentId, loaderOptions));
            }
            function progressReportDocumentReady(getDocumentReadyPromise) {
                getDocumentReadyPromise.then(function(info) {
                    if (info.documentReady) {
                        onReportLoadComplete(info);
                    } else {
                        onReportLoadProgress(info);
                        progressReportDocumentReady(info.promise);
                    }
                });
            }
            function onError() {
                if (reportHost) {
                    reportHost.raiseError.apply(this, arguments);
                }
            }
            function getPageAsync(pageNo) {
                return new Promise(function(resolve, reject) {
                    var fn = function() {
                        client.getPage(clientId, reportInstanceId, reportDocumentId, pageNo).catch(handleRequestError).then(function(pageInfo) {
                            if (pageInfo.pageReady) {
                                resolve(pageInfo);
                            } else {
                                window.setTimeout(fn, options.pagePollIntervalMs);
                            }
                        });
                    };
                    fn();
                });
            }
            function onBeginLoadPage(pageNo) {
                if (reportHost) {
                    reportHost.beginLoadPage(pageNo);
                }
            }
            var loadPromise;
            function loadAsync() {
                if (!loadPromise) {
                    onBeforeLoadReport();
                    var format = getFormat();
                    var deviceInfo = createPreviewDeviceInfo();
                    loadPromise = initializeClientAsync().then(registerInstanceAsync).then(function() {
                        return registerDocumentAsync(format, deviceInfo, useCache, baseDocumentId, actionId);
                    }).then(onReportDocumentRegistered);
                }
                return loadPromise;
            }
            function createPreviewDeviceInfo() {
                var deviceInfo = createDeviceInfo();
                deviceInfo.ContentOnly = true;
                deviceInfo.UseSVG = utils.isSvgSupported();
                return deviceInfo;
            }
            return {
                beginLoad: function() {
                    loadAsync();
                },
                beginGetPage: function(pageNo) {
                    throwIfNotInitialized();
                    loadAsync().then(function() {
                        onBeginLoadPage(pageNo);
                        return getPageAsync(pageNo);
                    }).then(function(pageInfo) {
                        loaderOptions.documentInfoPollIntervalMs = options.documentInfoPollIntervalMs;
                        if (reportHost) {
                            reportHost.pageReady(pageInfo);
                        }
                    });
                },
                dispose: function() {
                    reportHost = null;
                }
            };
        }
        function createDeviceInfo() {
            var enableAcc = options.settings.enableAccessibility();
            var deviceInfo = {
                enableAccessibility: enableAcc
            };
            if (enableAcc) {
                deviceInfo.contentTabIndex = options.settings.contentTabIndex;
            }
            return deviceInfo;
        }
        function resolveErrorByExceptionType(exceptionType) {
            switch (exceptionType) {
              case "Telerik.Reporting.Services.Engine.InvalidParameterException":
                return sr.missingOrInvalidParameter;

              default:
                return "";
            }
        }
        function formatXhrError(xhr, status, error, localizedMessage) {
            var parsedXhr = utils.parseJSON(xhr.responseText);
            var result = "";
            if (parsedXhr) {
                var errorMessage = resolveErrorByExceptionType(parsedXhr.exceptionType || parsedXhr.error);
                if (errorMessage) {
                    return errorMessage;
                }
                result = parsedXhr.message;
                var exceptionMessage = parsedXhr.exceptionMessage || parsedXhr.error_description;
                if (exceptionMessage) {
                    if (result) {
                        result += "<br/>" + exceptionMessage;
                    } else {
                        result = exceptionMessage;
                    }
                }
            } else {
                result = xhr.responseText;
            }
            if (localizedMessage || error) {
                if (result) {
                    result = "<br/>" + result;
                }
                result = (localizedMessage ? localizedMessage : error) + result;
            }
            if (utils.isInvalidClientException(xhr)) {
                result += "<br />" + sr.clientExpired;
            }
            return result;
        }
        function getReportPage(pageNo) {
            if (loader) {
                loader.beginGetPage(pageNo);
            }
        }
        function loadReportAsync(ignoreCache, baseDocumentId, actionId) {
            if (!report) {
                raiseError(sr.noReport);
                return;
            }
            if (loader) {
                loader.dispose();
                loader = null;
            }
            clearReportState();
            loader = new ReportLoader(controller, !ignoreCache, baseDocumentId, actionId);
            loader.beginLoad();
        }
        function onExportStarted() {
            controller.exportStarted();
        }
        function onExportDocumentReady(args) {
            controller.exportReady(args);
        }
        function onPrintStarted() {
            controller.printStarted();
        }
        function onPrintDocumentReady(args) {
            controller.printReady(args);
        }
        function printReport() {
            throwIfNoReport();
            onPrintStarted();
            var canUsePlugin = getCanUsePlugin(window.navigator.userAgent.toLowerCase());
            var contentDisposition = canUsePlugin ? "inline" : "attachment";
            var queryString = "response-content-disposition=" + contentDisposition;
            exportAsync("PDF", {
                ImmediatePrint: true
            }).then(function(info) {
                var url = client.formatDocumentUrl(info.clientId, info.instanceId, info.documentId, queryString);
                onPrintDocumentReady({
                    url: url
                });
                printManager.print(url);
            });
        }
        function getCanUsePlugin(browser) {
            if(browser.indexOf("chrome") > -1)
            {
                return false;
            }
            switch (printMode) {
              case trv.PrintModes.FORCE_PDF_FILE:
              case false:
                return false;

              case trv.PrintModes.FORCE_PDF_PLUGIN:
              case true:
                return true;

              default:
                return printManager.getDirectPrintState();
            }
        }
        function exportReport(format, deviceInfo) {
            throwIfNoReport();
            onExportStarted();
            if (!deviceInfo) {
                deviceInfo = createDeviceInfo();
            }
            var queryString = "response-content-disposition=attachment";
            exportAsync(format, deviceInfo).then(function(info) {
                var url = client.formatDocumentUrl(info.clientId, info.instanceId, info.documentId, queryString);
                onExportDocumentReady({
                    url: url
                });
                window.open(url, "_self");
            });
        }
        function exportAsync(format, deviceInfo) {
            throwIfNoReport();
            return initializeClientAsync().then(registerInstanceAsync).then(function() {
                return registerDocumentAsync(format, deviceInfo, true, reportDocumentId);
            }).then(function(documentId) {
                return waitReportDocumentReady(clientId, reportInstanceId, documentId, options);
            });
        }
        function waitReportDocumentReady(clientId, reportInstanceId, documentId, options) {
            return new Promise(function(resolve, reject) {
                var fn = function(promise) {
                    promise.then(function(info) {
                        if (info.documentReady) {
                            resolve({
                                clientId: clientId,
                                instanceId: reportInstanceId,
                                documentId: documentId
                            });
                        } else {
                            fn(info.promise);
                        }
                    });
                };
                fn(getDocumentInfoRecursive(clientId, reportInstanceId, documentId, options));
            });
        }
        function execServerAction(actionId) {
            throwIfNoReport();
            throwIfNoReportInstance();
            throwIfNoReportDocument();
            onServerActionStarted();
            controller.refreshReportCore(false, reportDocumentId, actionId);
        }
        function throwIfNotInitialized() {
            if (!clientId) {
                throw sr.controllerNotInitialized;
            }
        }
        function throwIfNoReportInstance() {
            if (!reportInstanceId) {
                throw sr.noReportInstance;
            }
        }
        function throwIfNoReportDocument() {
            if (!reportDocumentId) {
                throw sr.noReportDocument;
            }
        }
        function throwIfNoReport() {
            if (!report) {
                throw sr.noReport;
            }
        }
        function getEventHandlerFromArguments(args) {
            var arg0;
            if (args && args.length) {
                arg0 = args[0];
            }
            if (typeof arg0 == "function") {
                return arg0;
            }
            return null;
        }
        function eventFactory(event, args) {
            var h = getEventHandlerFromArguments(args);
            if (h) {
                events.on(event, h);
            } else {
                events.trigger(event, args);
            }
            return controller;
        }
        function Events() {
            var events = {};
            function resolveEvent(eventName) {
                var event = events[eventName];
                if (!event) {
                    events[eventName] = event = new Event(eventName);
                }
                return event;
            }
            return {
                on: function(eventName, handler) {
                    resolveEvent(eventName).on(handler);
                },
                trigger: function(eventName, args) {
                    resolveEvent(eventName).trigger(args);
                }
            };
            function Event(eventName) {
                var callbacks = [];
                var event = {
                    on: function(callback) {
                        callbacks.push(callback);
                    },
                    trigger: function(args) {
                        var a = [].slice.call(args);
                        a.unshift(eventName);
                        for (var i = 0; i < callbacks.length; i++) {
                            callbacks[i].apply(controller, a);
                        }
                    }
                };
                return event;
            }
        }
        function loadParametersAsync(report, paramValues) {
            return initializeClientAsync().then(function() {
                return client.getParameters(clientId, report, paramValues || parameterValues || {}).catch(function(xhrErrorData) {
                    handleRequestError(xhrErrorData, sr.unableToGetReportParameters);
                });
            });
        }
        function getDocumentFormatsAsync() {
            if (!documentFormatsPromise) {
                documentFormatsPromise = client.getDocumentFormats().catch(handleRequestError);
            }
            return documentFormatsPromise;
        }
        function getPageForBookmark(nodes, id) {
            if (nodes) {
                for (var i = 0, len = nodes.length; i < len; i++) {
                    var node = nodes[i];
                    if (node.id == id) {
                        return node.page;
                    } else {
                        var page = getPageForBookmark(node.items, id);
                        if (page) {
                            return page;
                        }
                    }
                }
            }
            return null;
        }
        function fixDataContractJsonSerializer(arr) {
            var dict = {};
            if (Array.isArray(arr)) {
                arr.forEach(function(pair) {
                    dict[pair.Key] = pair.Value;
                });
            }
            return dict;
        }
        function changeReportSource(rs) {
            if (options.settings.reportSource) {
                options.settings.reportSource(rs);
            }
            controller.reportSourceChanged();
        }
        function changePageNumber(pageNr) {
            options.settings.pageNumber(pageNr);
            controller.currentPageChanged();
        }
        var actionHandlers = {
            sorting: function(action) {
                execServerAction(action.Id);
            },
            toggleVisibility: function(action) {
                execServerAction(action.Id);
            },
            navigateToReport: function(action) {
                var args = action.Value;
                onServerActionStarted();
                controller.reportSource({
                    report: args.Report,
                    parameters: fixDataContractJsonSerializer(args.ParameterValues)
                });
                controller.refreshReport(false);
            },
            navigateToUrl: function(action) {
                var args = action.Value;
                window.open(args.Url, args.Target);
            },
            navigateToBookmark: function(action) {
                var id = action.Value, page = getPageForBookmark(bookmarkNodes, id);
                controller.navigateToPage(page, id);
            },
            customAction: function(action) {}
        };
        function onInteractiveActionExecuting(cancelArgs) {
            controller.interactiveActionExecuting(cancelArgs);
        }
        function executeReportAction(cancelArgs) {
            var action = cancelArgs.action;
            var handler = actionHandlers[action.Type];
            if (typeof handler === "function") {
                window.setTimeout(function() {
                    onInteractiveActionExecuting(cancelArgs);
                    if (!cancelArgs.cancel) {
                        handler(action);
                    }
                }, 0);
            }
        }
        function onServerActionStarted() {
            controller.serverActionStarted();
        }
        function onReportActionEnter(args) {
            controller.interactiveActionEnter({
                action: args.action,
                element: args.element
            });
        }
        function onReportActionLeave(args) {
            controller.interactiveActionLeave({
                action: args.action,
                element: args.element
            });
        }
        function clientExpired() {
            return eventFactory(controller.Events.CLIENT_EXPIRED, arguments);
        }
        function onClientExpired() {
            clientHasExpired = true;
            controller.clientExpired();
        }
        function onReportToolTipOpening(args) {
            controller.toolTipOpening(args);
        }
        controller.Events = {
            ERROR: "trv.ERROR",
            EXPORT_STARTED: "trv.EXPORT_STARTED",
            EXPORT_DOCUMENT_READY: "trv.EXPORT_DOCUMENT_READY",
            PRINT_STARTED: "trv.PRINT_STARTED",
            PRINT_DOCUMENT_READY: "trv.PRINT_DOCUMENT_READY",
            BEFORE_LOAD_PARAMETERS: "trv.BEFORE_LOAD_PARAMETERS",
            ON_LOADED_REPORT_CHANGE: "trv.ON_LOADED_REPORT_CHANGE",
            BEFORE_LOAD_REPORT: "trv.BEFORE_LOAD_REPORT",
            BEGIN_LOAD_REPORT: "trv.BEGIN_LOAD_REPORT",
            REPORT_LOAD_COMPLETE: "trv.REPORT_LOAD_COMPLETE",
            REPORT_LOAD_PROGRESS: "trv.REPORT_LOAD_PROGRESS",
            REPORT_LOAD_FAIL: "trv.REPORT_LOAD_FAIL",
            BEGIN_LOAD_PAGE: "trv.BEGIN_LOAD_PAGE",
            PAGE_READY: "trv.PAGE_READY",
            VIEW_MODE_CHANGED: "trv.VIEW_MODE_CHANGED",
            PRINT_MODE_CHANGED: "trv.PRINT_MODE_CHANGED",
            REPORT_SOURCE_CHANGED: "trv.REPORT_SOURCE_CHANGED",
            NAVIGATE_TO_PAGE: "trv.NAVIGATE_TO_PAGE",
            CURRENT_PAGE_CHANGED: "trv.CURRENT_PAGE_CHANGED",
            GET_DOCUMENT_MAP_STATE: "trv.GET_DOCUMENT_MAP_STATE",
            SET_DOCUMENT_MAP_VISIBLE: "trv.SET_DOCUMENT_MAP_VISIBLE",
            GET_PARAMETER_AREA_STATE: "trv.GET_PARAMETER_AREA_STATE",
            SET_PARAMETER_AREA_VISIBLE: "trv.SET_PARAMETER_AREA_VISIBLE",
            PAGE_SCALE: "trv.PAGE_SCALE",
            GET_PAGE_SCALE: "trv.GET_PAGE_SCALE",
            SERVER_ACTION_STARTED: "trv.SERVER_ACTION_STARTED",
            TOGGLE_SIDE_MENU: "trv.TOGGLE_SIDE_MENU",
            UPDATE_UI: "trv.UPDATE_UI",
            CSS_LOADED: "trv.CSS_LOADED",
            RELOAD_PARAMETERS: "trv.RELOAD_PARAMETERS",
            INTERACTIVE_ACTION_EXECUTING: "trv.INTERACTIVE_ACTION_EXECUTING",
            INTERACTIVE_ACTION_ENTER: "trv.INTERACTIVE_ACTION_ENTER",
            INTERACTIVE_ACTION_LEAVE: "trv.INTERACTIVE_ACTION_LEAVE",
            UPDATE_UI_INTERNAL: "trv.UPDATE_UI_INTERNAL",
            CLIENT_EXPIRED: "trv.CLIENT_EXPIRED",
            TOOLTIP_OPENING: "trv.TOOLTIP_OPENING",
            PAGE_NUMBER: "trv.PAGE_NUMBER",
            PAGE_COUNT: "trv.PAGE_COUNT"
        };
        utils.extend(controller, {
            reportSource: function(rs) {
                if (null === rs) {
                    report = parameterValues = null;
                    clearReportState();
                    changeReportSource(rs);
                    return this;
                } else if (rs) {
                    report = rs.report;
                    parameterValues = rs.parameters;
                    changeReportSource(rs);
                    return this;
                } else {
                    if (report === null) {
                        return null;
                    }
                    return {
                        report: report,
                        parameters: utils.extend({}, parameterValues)
                    };
                }
            },
            reportDocumentIdExposed: function() {
                return reportDocumentId;
            },
            setParameters: function(paramValues) {
                parameterValues = paramValues;
            },
            pageCount: function() {
                return pageCount;
            },
            currentPageNumber: function(pageNo) {
                if (pageNo === undefined) return currentPageNumber;
                var num = utils.tryParseInt(pageNo);
                if (num != currentPageNumber) {
                    currentPageNumber = num;
                    changePageNumber(num);
                }
                return this;
            },
            viewMode: function(vm) {
                var vmode = controller.setViewMode(vm);
                if (typeof vmode === "string") {
                    return vmode;
                }
                if (report) {
                    controller.refreshReportCore(false, reportDocumentId);
                }
                return controller;
            },
            setViewMode: function(vm) {
                if (!vm) {
                    return viewMode;
                }
                if (viewMode != vm) {
                    viewMode = vm;
                    controller.viewModeChanged(vm);
                }
                return controller;
            },
            printMode: function(pm) {
                if (!pm) {
                    return printMode;
                }
                if (printMode != pm) {
                    printMode = pm;
                    controller.printModeChanged(pm);
                }
                return controller;
            },
            previewReport: function(ignoreCache, baseDocumentId, actionId) {
                controller.onLoadedReportChange();
                controller.refreshReportCore(ignoreCache, baseDocumentId, actionId);
            },
            refreshReportCore: function(ignoreCache, baseDocumentId, actionId) {
                loadReportAsync(ignoreCache, baseDocumentId, actionId);
            },
            refreshReport: function(ignoreCache, baseDocumentId, actionId) {
                controller.onLoadedReportChange();
                if (clientHasExpired) {
                    clientHasExpired = false;
                    clearClientId();
                }
                if (!report) {
                    raiseError(sr.noReport);
                    return;
                }
                var loadParametersPromise = controller.loadParameters(null);
                loadParametersPromise.then(function(parameters) {
                    var parameterValues = {};
                    var hasError = false;
                    utils.each(parameters || [], function() {
                        try {
                            parameterValues[this.id] = parameterValidators.validate(this, this.value);
                        } catch (e) {
                            hasError = true;
                            return;
                        }
                    });
                    if (hasError) {
                        raiseError(sr.missingOrInvalidParameter);
                    } else {
                        controller.setParameters(parameterValues);
                        controller.refreshReportCore(ignoreCache, baseDocumentId, actionId);
                    }
                });
                controller.reloadParameters(loadParametersPromise);
            },
            exportReport: function(format, deviceInfo) {
                exportReport(format, deviceInfo);
            },
            printReport: function() {
                printReport();
            },
            getReportPage: function(pageNumber) {
                getReportPage(pageNumber);
            },
            executeReportAction: function(cancelArgs) {
                executeReportAction(cancelArgs);
            },
            reportActionEnter: function(args) {
                onReportActionEnter(args);
            },
            reportActionLeave: function(args) {
                onReportActionLeave(args);
            },
            reportToolTipOpening: function(args) {
                onReportToolTipOpening(args);
            },
            loadParameters: function(paramValues) {
                if (report === null) {
                    return {};
                }
                controller.beforeLoadParameters(paramValues == null);
                return loadParametersAsync(report, paramValues);
            },
            getDocumentFormats: function() {
                return getDocumentFormatsAsync();
            },
            setAuthenticationToken: function(token) {
                client.setAccessToken(token);
            },
            clientId: function() {
                return clientId;
            },
            onReportLoadComplete: function(info) {
                pageCount = info.pageCount;
                bookmarkNodes = info.bookmarkNodes;
                controller.reportLoadComplete(info);
            },
            raiseError: raiseError,
            on: events.on,
            error: function() {
                return eventFactory(controller.Events.ERROR, arguments);
            },
            reloadParameters: function() {
                return eventFactory(controller.Events.RELOAD_PARAMETERS, arguments);
            },
            exportStarted: function() {
                return eventFactory(controller.Events.EXPORT_STARTED, arguments);
            },
            exportReady: function() {
                return eventFactory(controller.Events.EXPORT_DOCUMENT_READY, arguments);
            },
            printStarted: function() {
                return eventFactory(controller.Events.PRINT_STARTED, arguments);
            },
            printReady: function() {
                return eventFactory(controller.Events.PRINT_DOCUMENT_READY, arguments);
            },
            beforeLoadParameters: function() {
                return eventFactory(controller.Events.BEFORE_LOAD_PARAMETERS, arguments);
            },
            onLoadedReportChange: function() {
                return eventFactory(controller.Events.ON_LOADED_REPORT_CHANGE, arguments);
            },
            beforeLoadReport: function() {
                return eventFactory(controller.Events.BEFORE_LOAD_REPORT, arguments);
            },
            beginLoadReport: function() {
                return eventFactory(controller.Events.BEGIN_LOAD_REPORT, arguments);
            },
            reportLoadComplete: function() {
                return eventFactory(controller.Events.REPORT_LOAD_COMPLETE, arguments);
            },
            reportLoadProgress: function() {
                return eventFactory(controller.Events.REPORT_LOAD_PROGRESS, arguments);
            },
            reportLoadFail: function() {
                return eventFactory(controller.Events.REPORT_LOAD_FAIL, arguments);
            },
            beginLoadPage: function() {
                return eventFactory(controller.Events.BEGIN_LOAD_PAGE, arguments);
            },
            pageReady: function() {
                return eventFactory(controller.Events.PAGE_READY, arguments);
            },
            viewModeChanged: function() {
                return eventFactory(controller.Events.VIEW_MODE_CHANGED, arguments);
            },
            printModeChanged: function() {
                return eventFactory(controller.Events.PRINT_MODE_CHANGED, arguments);
            },
            reportSourceChanged: function() {
                return eventFactory(controller.Events.REPORT_SOURCE_CHANGED, arguments);
            },
            navigateToPage: function() {
                return eventFactory(controller.Events.NAVIGATE_TO_PAGE, arguments);
            },
            currentPageChanged: function() {
                return eventFactory(controller.Events.CURRENT_PAGE_CHANGED, arguments);
            },
            getDocumentMapState: function() {
                return eventFactory(controller.Events.GET_DOCUMENT_MAP_STATE, arguments);
            },
            setDocumentMapVisible: function() {
                return eventFactory(controller.Events.SET_DOCUMENT_MAP_VISIBLE, arguments);
            },
            getParametersAreaState: function() {
                return eventFactory(controller.Events.GET_PARAMETER_AREA_STATE, arguments);
            },
            setParametersAreaVisible: function() {
                return eventFactory(controller.Events.SET_PARAMETER_AREA_VISIBLE, arguments);
            },
            scale: function() {
                return eventFactory(controller.Events.PAGE_SCALE, arguments);
            },
            getScale: function() {
                return eventFactory(controller.Events.GET_PAGE_SCALE, arguments);
            },
            serverActionStarted: function() {
                return eventFactory(controller.Events.SERVER_ACTION_STARTED, arguments);
            },
            cssLoaded: function() {
                return eventFactory(controller.Events.CSS_LOADED, arguments);
            },
            interactiveActionExecuting: function() {
                return eventFactory(controller.Events.INTERACTIVE_ACTION_EXECUTING, arguments);
            },
            interactiveActionEnter: function() {
                return eventFactory(controller.Events.INTERACTIVE_ACTION_ENTER, arguments);
            },
            interactiveActionLeave: function() {
                return eventFactory(controller.Events.INTERACTIVE_ACTION_LEAVE, arguments);
            },
            updateUI: function() {
                return eventFactory(controller.Events.UPDATE_UI, arguments);
            },
            updateUIInternal: function() {
                return eventFactory(controller.Events.UPDATE_UI_INTERNAL, arguments);
            },
            toolTipOpening: function() {
                return eventFactory(controller.Events.TOOLTIP_OPENING, arguments);
            },
            pageNumberChange: function() {
                return eventFactory(controller.Events.PAGE_NUMBER, arguments);
            },
            pageCountChange: function() {
                return eventFactory(controller.Events.PAGE_COUNT, arguments);
            },
            clientExpired: clientExpired
        });
        return controller;
    }
    trv.ReportViewerController = ReportViewerController;
})(window.telerikReportViewer = window.telerikReportViewer || {}, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    trv.touchBehavior = function(dom, options) {
        var startDistance, ignoreTouch;
        init(dom);
        function init(element) {
            if (typeof $.fn.kendoTouch === "function") {
                $(element).find(".trv-page-wrapper").mousedown(function() {
                    ignoreTouch = true;
                }).mouseup(function() {
                    ignoreTouch = false;
                }).kendoTouch({
                    multiTouch: true,
                    enableSwipe: true,
                    swipe: function(e) {
                        if (!ignoreTouch) {
                            onSwipe(e);
                        }
                    },
                    gesturestart: function(e) {
                        if (!ignoreTouch) {
                            onGestureStart(e);
                        }
                    },
                    gestureend: function(e) {
                        if (!ignoreTouch) {
                            onGestureEnd(e);
                        }
                    },
                    gesturechange: function(e) {
                        if (!ignoreTouch) {
                            onGestureChange(e);
                        }
                    },
                    doubletap: function(e) {
                        if (!ignoreTouch) {
                            onDoubleTap(e);
                        }
                    },
                    touchstart: function(e) {
                        if (!ignoreTouch) {
                            fire("touchstart");
                        }
                    }
                });
            }
        }
        function onDoubleTap(e) {
            fire("doubletap", e);
        }
        function onGestureStart(e) {
            startDistance = kendo.touchDelta(e.touches[0], e.touches[1]).distance;
        }
        function onGestureEnd(e) {}
        function onGestureChange(e) {
            var current = kendo.touchDelta(e.touches[0], e.touches[1]).distance;
            onPinch({
                distance: current,
                lastDistance: startDistance
            });
            startDistance = current;
        }
        function onSwipe(e) {
            fire("swipe", e);
        }
        function onPinch(e) {
            fire("pinch", e);
        }
        function fire(func, args) {
            var handler = options[func];
            if (typeof handler === "function") {
                handler(args);
            }
        }
    };
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    var sr = trv.sr;
    if (!sr) {
        throw "Missing telerikReportViewer.sr";
    }
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReportViewer.utils";
    }
    var domUtils = trv.domUtils;
    var touchBehavior = trv.touchBehavior;
    if (!touchBehavior) {
        throw "Missing telerikReportViewer.touch";
    }
    var defaultOptions = {};
    var scaleModes = trv.ScaleModes = {
        FIT_PAGE_WIDTH: "FIT_PAGE_WIDTH",
        FIT_PAGE: "FIT_PAGE",
        SPECIFIC: "SPECIFIC"
    };
    function PagesArea(placeholder, options, otherOptions) {
        options = $.extend({}, defaultOptions, options, otherOptions);
        var controller = options.controller;
        if (!controller) throw "No controller (telerikReportViewer.reportViewerController) has been specified.";
        var $placeholder = $(placeholder), $pageContainer = $placeholder.find(".trv-page-container"), pageContainer = $pageContainer[0], $pageWrapper = $placeholder.find(".trv-page-wrapper"), pageWrapper = $pageWrapper[0], $errorMessage = $placeholder.find(".trv-error-message"), actions, pendingBookmark, pageScaleMode = scaleModes.SPECIFIC, pageScale = 1, minPageScale = .1, maxPageScale = 8, documentReady = true, navigateToPageOnDocReady, navigateToBookmarkOnDocReady, isNewReportSource, showErrorTimeoutId;
        $(window).on("resize", function(event, args) {
            if (shouldAutosizePage()) {
                updatePageDimensions();
            }
        });
        enableTouch($placeholder);
        function clearPendingTimeoutIds() {
            if (showErrorTimeoutId) {
                window.clearTimeout(showErrorTimeoutId);
            }
        }
        function invalidateCurrentlyLoadedPage() {
            var page = findPage(navigateToPageOnDocReady);
            if (page) {
                pageNo(page, -1);
            }
        }
        function navigateWhenPageAvailable(pageNumber, pageCount) {
            if (pageNumber && pageNumber <= pageCount) {
                navigateToPage(pageNumber, navigateToBookmarkOnDocReady);
            }
        }
        function navigateOnLoadComplete(pageNumber, pageCount) {
            if (pageNumber) {
                var pageNumber = Math.min(pageNumber, pageCount);
                navigateToPage(pageNumber, navigateToBookmarkOnDocReady);
            }
        }
        function clearPage() {
            clear(isNewReportSource);
            isNewReportSource = false;
        }
        controller.reportSourceChanged(function() {
            isNewReportSource = true;
            navigateToPageOnDocReady = null;
            navigateToBookmarkOnDocReady = null;
            documentReady = false;
        }).beforeLoadParameters(function(event, initial) {
            if (initial) {
                showError(sr.loadingReport);
            }
        }).beforeLoadReport(function() {
            documentReady = false;
            if (!navigateToPageOnDocReady) navigateToPageOnDocReady = 1;
            clearPendingTimeoutIds();
            clear();
            disablePagesArea(true);
            showError(sr.loadingReport);
        }).beginLoadReport(function(event, args) {
            documentReady = true;
            invalidateCurrentlyLoadedPage();
        }).reportLoadProgress(function(event, args) {
            navigateWhenPageAvailable(navigateToPageOnDocReady, args.pageCount);
            showError(utils.stringFormat(sr.loadingReportPagesInProgress, [ args.pageCount ]));
        }).reportLoadComplete(function(event, args) {
            if (0 === args.pageCount) {
                clearPage();
                showError(sr.noPageToDisplay);
            } else {
                navigateOnLoadComplete(navigateToPageOnDocReady, args.pageCount);
                showError(utils.stringFormat(sr.loadedReportPagesComplete, [ args.pageCount ]));
                showErrorTimeoutId = window.setTimeout(showError, 2e3);
                enableInteractivity();
            }
        }).navigateToPage(function(event, pageNumber, bookmark) {
            navigateToPage(pageNumber, bookmark);
        }).pageReady(function(event, page) {
            setPageContent(page);
            disablePagesArea(false);
        }).error(function(event, error) {
            disablePagesArea(false);
            clearPage();
            showError(error);
        }).exportStarted(function(event, args) {
            showError(sr.preparingDownload);
        }).exportReady(function(event, args) {
            showError();
        }).printStarted(function(event, args) {
            showError(sr.preparingPrint);
        }).printReady(function(event, args) {
            showError();
        }).scale(function(event, args) {
            setPageScale(args);
        }).getScale(function(event, args) {
            var page = getCurrentPage();
            var scale = $(page).data("pageScale") || pageScale;
            args.scale = scale;
            args.scaleMode = pageScaleMode;
        }).setDocumentMapVisible(function() {
            if (shouldAutosizePage()) {
                updatePageDimensions();
            }
        }).setParametersAreaVisible(function() {
            if (shouldAutosizePage()) {
                updatePageDimensions();
            }
        }).serverActionStarted(function() {
            disablePagesArea(true);
            showError(sr.loadingReport);
        });
        function enableTouch(dom) {
            var allowSwipeLeft, allowSwipeRight;
            touchBehavior(dom, {
                swipe: function(e) {
                    var pageNumber = controller.currentPageNumber();
                    if (allowSwipeLeft && e.direction == "left") {
                        if (pageNumber < controller.pageCount()) {
                            controller.navigateToPage(pageNumber + 1);
                        }
                    } else if (allowSwipeRight && e.direction == "right") {
                        if (pageNumber > 1) {
                            controller.navigateToPage(pageNumber - 1);
                        }
                    }
                },
                pinch: function(e) {
                    var page = getCurrentPage();
                    var scale = $(page).data("pageScale") || pageScale;
                    var f = e.distance / e.lastDistance;
                    setPageScale({
                        scale: scale * f,
                        scaleMode: trv.ScaleModes.SPECIFIC
                    });
                },
                doubletap: function(e) {
                    options.commands.toggleZoomMode.exec();
                },
                touchstart: function(e) {
                    var el = pageWrapper;
                    allowSwipeRight = 0 == el.scrollLeft;
                    allowSwipeLeft = el.scrollWidth - el.offsetWidth == el.scrollLeft;
                }
            });
        }
        function shouldAutosizePage() {
            return -1 != [ scaleModes.FIT_PAGE, scaleModes.FIT_PAGE_WIDTH ].indexOf(pageScaleMode);
        }
        function updatePageDimensions() {
            for (var i = 0, children = pageContainer.childNodes, len = children.length; i < len; i++) {
                setPageDimensions(children[i], pageScaleMode, pageScale);
            }
        }
        function setPageScale(options) {
            pageScaleMode = options.scaleMode || pageScaleMode;
            var scale = pageScale;
            if ("scale" in options) {
                scale = options.scale;
            }
            pageScale = Math.max(minPageScale, Math.min(maxPageScale, scale));
            updatePageDimensions();
        }
        function clear(clearPageWrapper) {
            disableInteractivity();
            pendingBookmark = undefined;
            if (clearPageWrapper) {
                $pageWrapper.empty();
            }
            showError();
        }
        function getCurrentPage() {
            return findPage(controller.currentPageNumber());
        }
        function findPage(pageNumber) {
            var page;
            utils.each($pageContainer.children(), function(index, page1) {
                if (pageNo(page1) == pageNumber) {
                    page = page1;
                }
                return !page;
            });
            return page;
        }
        function navigateToPage(pageNumber, bookmark) {
            if (documentReady) {
                navigateToPageCore(pageNumber, bookmark);
            } else {
                navigateToPageOnDocumentReady(pageNumber, bookmark);
            }
        }
        function navigateToPageOnDocumentReady(pageNumber, bookmark) {
            navigateToPageOnDocReady = pageNumber;
            navigateToBookmarkOnDocReady = bookmark;
        }
        function navigateToPageCore(pageNumber, bookmark) {
            var page = findPage(pageNumber);
            if (page) {
                if (bookmark) {
                    navigateToBookmark(bookmark);
                }
            } else {
                pendingBookmark = bookmark;
                beginLoadPage(pageNumber);
            }
        }
        function navigateToBookmark(bookmark) {
            if (bookmark) {
                var el = $pageContainer.find("[data-bookmark-id=" + bookmark + "]")[0];
                if (el) {
                    if (options.enableAccessibility) {
                        var $nextFocusable = findNextFocusableElement($(el));
                        if ($nextFocusable) {
                            $nextFocusable.focus();
                        }
                    }
                    var container = $pageContainer[0], offsetTop = 0, offsetLeft = 0;
                    while (el && el != container) {
                        if ($(el).is(".trv-page-wrapper")) {
                            var scale = $(el).data("pageScale");
                            if (typeof scale === "number") {
                                offsetTop *= scale;
                                offsetLeft *= scale;
                            }
                        }
                        offsetTop += el.offsetTop;
                        offsetLeft += el.offsetLeft;
                        el = el.offsetParent;
                    }
                    container.scrollTop = offsetTop;
                    container.scrollLeft = offsetLeft;
                }
            }
        }
        function findNextFocusableElement(element) {
            if (!element || element.length == 0) {
                return null;
            }
            var num = utils.tryParseInt(element.attr("tabindex"));
            if (num != NaN && num > -1) {
                return element;
            }
            return findNextFocusableElement(element.next());
        }
        function disablePagesArea(disable) {
            (disable ? $.fn.addClass : $.fn.removeClass).call($placeholder, "loading");
        }
        function showError(error) {
            $errorMessage.html(error);
            (error ? $.fn.addClass : $.fn.removeClass).call($placeholder, "error");
        }
        function pageNo(page, no) {
            var $page = page.$ ? page : $(page), dataKey = "pageNumber";
            if (no === undefined) {
                return $page.data(dataKey);
            }
            $page.data(dataKey, no);
            return page;
        }
        function beginLoadPage(pageNumber) {
            disablePagesArea(true);
            window.setTimeout(controller.getReportPage.bind(controller, pageNumber), 1);
            navigateToPageOnDocReady = null;
        }
        function setPageDimensions(page, scaleMode, scale) {
            var $target = $(page), $page = $target.find("div.trv-report-page"), $pageContent = $target.find("div.sheet"), pageContent = $pageContent[0];
            if (!pageContent) return;
            var pageWidth, pageHeight, box = $target.data("box");
            if (!box) {
                var margins = domUtils.getMargins($target), borders = domUtils.getBorderWidth($page), padding = domUtils.getPadding($page);
                box = {
                    padLeft: margins.left + borders.left + padding.left,
                    padRight: margins.right + borders.right + padding.right,
                    padTop: margins.top + borders.top + padding.top,
                    padBottom: margins.bottom + borders.bottom + padding.bottom
                };
                $target.data("box", box);
            }
            if ($target.data("pageWidth") === undefined) {
                pageWidth = pageContent.offsetWidth;
                pageHeight = pageContent.offsetHeight;
                $target.data("pageWidth", pageWidth);
                $target.data("pageHeight", pageHeight);
            } else {
                pageWidth = $target.data("pageWidth");
                pageHeight = $target.data("pageHeight");
            }
            var scrollBarV = pageHeight > pageWidth && scaleMode == scaleModes.FIT_PAGE_WIDTH ? 20 : 0, scaleW = (pageContainer.clientWidth - scrollBarV - box.padLeft - box.padRight) / pageWidth, scaleH = (pageContainer.clientHeight - 1 - box.padTop - box.padBottom) / pageHeight;
            if (scaleMode == scaleModes.FIT_PAGE_WIDTH) {
                scale = scaleW;
            } else if (!scale || scaleMode == scaleModes.FIT_PAGE) {
                scale = Math.min(scaleW, scaleH);
            }
            $target.data("pageScale", scale);
            domUtils.scale($pageContent, scale, scale);
            $page.css("height", scale * pageHeight).css("width", scale * pageWidth);
        }
        function enableInteractivity() {
            $pageContainer.on("click", "[data-reporting-action]", onInteractiveItemClick);
            $pageContainer.on("mouseenter", "[data-reporting-action]", onInteractiveItemEnter);
            $pageContainer.on("mouseleave", "[data-reporting-action]", onInteractiveItemLeave);
            $pageContainer.on("mouseenter", "[data-tooltip-title],[data-tooltip-text]", onToolTipItemEnter);
            $pageContainer.on("mouseleave", "[data-tooltip-title],[data-tooltip-text]", onToolTipItemLeave);
        }
        function disableInteractivity() {
            $pageContainer.off("click", "[data-reporting-action]", onInteractiveItemClick);
            $pageContainer.off("mouseenter", "[data-reporting-action]", onInteractiveItemEnter);
            $pageContainer.off("mouseleave", "[data-reporting-action]", onInteractiveItemLeave);
            $pageContainer.off("mouseenter", "[data-tooltip-title],[data-tooltip-text]", onToolTipItemEnter);
            $pageContainer.off("mouseleave", "[data-tooltip-title],[data-tooltip-text]", onToolTipItemLeave);
        }
        function onInteractiveItemClick(args) {
            var $t = $(this);
            var actionId = $t.attr("data-reporting-action");
            var a = getAction(actionId);
            if (a) {
                navigateToPageOnDocReady = controller.currentPageNumber();
                controller.executeReportAction({
                    element: args.currentTarget,
                    action: a,
                    cancel: false
                });
            }
        }
        function onInteractiveItemEnter(args) {
            var $t = $(this);
            var actionId = $t.attr("data-reporting-action");
            var a = getAction(actionId);
            if (a !== null && args.currentTarget === this) {
                controller.reportActionEnter({
                    element: args.currentTarget,
                    action: a
                });
            }
        }
        function onInteractiveItemLeave(args) {
            var $t = $(this);
            var actionId = $t.attr("data-reporting-action");
            var a = getAction(actionId);
            if (a !== null && args.currentTarget === this) {
                controller.reportActionLeave({
                    element: args.currentTarget,
                    action: a
                });
            }
        }
        function getAction(actionId) {
            if (actions) {
                var action;
                utils.each(actions, function() {
                    if (this.Id == actionId) {
                        action = this;
                    }
                    return action === undefined;
                });
                return action;
            }
            return null;
        }
        function onToolTipItemEnter(args) {
            var $t = $(this);
            var title = $t.attr("data-tooltip-title");
            var text = $t.attr("data-tooltip-text");
            if (!title && !text) {
                return;
            }
            var toolTipArgs = {
                element: args.currentTarget,
                toolTip: {
                    title: title || "",
                    text: text || ""
                },
                cancel: false
            };
            controller.reportToolTipOpening(toolTipArgs);
            if (toolTipArgs.cancel) {
                return;
            }
            var content = applyToolTipTemplate(toolTipArgs);
            var viewportElement = args.currentTarget.viewportElement;
            var ktt = getToolTip($t, content);
            ktt.show($t);
            if (viewportElement && viewportElement.nodeName === "svg") {
                positionToolTip(ktt, args);
            }
        }
        function applyToolTipTemplate(toolTipArgs) {
            var toolTipTemplate = options.templates["trv-pages-area-kendo-tooltip"];
            var $container = $(toolTipTemplate);
            var $titleSpan = $container.find(".trv-pages-area-kendo-tooltip-title");
            var $textSpan = $container.find(".trv-pages-area-kendo-tooltip-text");
            $titleSpan.text(toolTipArgs.toolTip.title);
            $textSpan.text(toolTipArgs.toolTip.text);
            return $container.clone().wrap("<p>").parent().html();
        }
        function positionToolTip(toolTip, e) {
            var x = e.pageX;
            var y = e.pageY;
            toolTip.popup.element.parent().css({
                left: x + 10,
                top: y + 5
            });
        }
        function getToolTip(target, toolTipContent) {
            var ktt = target.data("kendoTooltip");
            if (!ktt) {
                ktt = target.kendoTooltip({
                    content: toolTipContent,
                    autohide: true,
                    callout: false
                }).data("kendoTooltip");
            }
            return ktt;
        }
        function onToolTipItemLeave(args) {
            var $t = $(this);
            var toolTip = $t.data("kendoTooltip");
            if (toolTip) {
                toolTip.hide();
            }
        }
        function updatePageStyle(page) {
            var styleId = "trv-" + controller.clientId() + "-styles";
            $("#" + styleId).remove();
            var pageStyles = $("<style id=" + styleId + "></style>");
            pageStyles.append(page.pageStyles);
            pageStyles.appendTo("head");
        }
        function setPageContent(page) {
            actions = JSON.parse(page.pageActions);
            updatePageStyle(page);
            var wrapper = $($.parseHTML(page.pageContent)), $pageContent = wrapper.find("div.sheet"), $page = $('<div class="trv-report-page"></div>');
            $pageContent.css("margin", 0);
            $page.append($pageContent).append($('<div class="trv-page-overlay"></div>'));
            var pageNumber = page.pageNumber;
            var $target = $pageWrapper.empty().removeData().data("pageNumber", pageNumber).append($page);
            controller.currentPageNumber(pageNumber);
            if (controller.viewMode() == trv.ViewModes.INTERACTIVE) {
                $placeholder.removeClass("printpreview");
                $placeholder.addClass("interactive");
            } else {
                $placeholder.removeClass("interactive");
                $placeholder.addClass("printpreview");
            }
            setPageDimensions($target, pageScaleMode, pageScale);
            $pageContainer.scrollTop(0);
            $pageContainer.scrollLeft(0);
            navigateToBookmark(pendingBookmark);
        }
    }
    var pluginName = "telerik_ReportViewer_PagesArea";
    $.fn[pluginName] = function(options, otherOptions) {
        return utils.each(this, function() {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new PagesArea(this, options, otherOptions));
            }
        });
    };
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    var defaultOptions = {};
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReportViewer.utils";
    }
    function DocumentMapArea(placeholder, options, otherOptions) {
        options = $.extend({}, defaultOptions, options, otherOptions);
        var controller = options.controller;
        if (!controller) {
            throw "No controller (telerikReporting.reportViewerController) has been specified.";
        }
        var $placeholder = $(placeholder), $documentMap;
        var documentMapVisible = options.documentMapVisible !== false;
        var enableAccessibility = options.enableAccessibility;
        init();
        function init() {
            $documentMap = $('<div id="documentMap"></div>');
            $documentMap.appendTo(placeholder);
            attach();
        }
        function onTreeViewSelectionChanged(e) {
            var documentMapNode = this.dataItem(e.node), page = documentMapNode.page, id = documentMapNode.id;
            controller.navigateToPage(page, id);
        }
        function onTreeViewNodeExpand(e) {
            if (enableAccessibility) {
                window.setTimeout(function() {
                    setNodeAccessibilityAttributes(e.node);
                }, 100);
            }
        }
        function setNodeAccessibilityAttributes(node) {
            var $items = $(node).find("li");
            utils.each($items, function() {
                var $li = $(this);
                $li.attr("aria-label", $li[0].innerText);
            });
        }
        function clearDocumentMap() {
            displayDocumentMap([]);
        }
        function displayDocumentMap(documentMap) {
            var hasDocumentMap = documentMap && !$.isEmptyObject(documentMap);
            var $treeView = $documentMap.data("kendoTreeView");
            if (!$treeView) {
                $documentMap.kendoTreeView({
                    dataTextField: "text",
                    select: onTreeViewSelectionChanged
                });
                $treeView = $documentMap.data("kendoTreeView");
            }
            $treeView.setDataSource(documentMap);
            setAccessibilityAttributes($treeView);
            showDocumentMap(hasDocumentMap);
        }
        function setAccessibilityAttributes(treeView) {
            if (enableAccessibility) {
                treeView.bind("expand", onTreeViewNodeExpand);
                treeView.element.attr("aria-label", "Document map area");
                var listItems = treeView.element.find("ul");
                utils.each(listItems, function() {
                    setNodeAccessibilityAttributes(this);
                });
            }
        }
        function isVisible() {
            var args = {};
            controller.getDocumentMapState(args);
            return args.visible;
        }
        function beginLoad() {
            $placeholder.addClass("loading");
        }
        function endLoad() {
            $placeholder.removeClass("loading");
        }
        var currentReport = null;
        var documentMapNecessary = false;
        function showDocumentMap(show) {
            (show ? $.fn.removeClass : $.fn.addClass).call($placeholder, "hidden");
        }
        function attach() {
            controller.beginLoadReport(function() {
                beginLoad();
                var r = controller.reportSource().report;
                var clearMapItems = currentReport !== r || !isVisible();
                currentReport = r;
                if (clearMapItems) {
                    clearDocumentMap();
                }
            }).reportLoadComplete(function(event, args) {
                if (args.documentMapAvailable) {
                    documentMapNecessary = true;
                    displayDocumentMap(args.documentMapNodes);
                    controller.setDocumentMapVisible({
                        enabled: true,
                        visible: documentMapVisible
                    });
                } else {
                    documentMapNecessary = false;
                    showDocumentMap(false);
                }
                endLoad();
            }).error(function(event, error) {
                endLoad();
                clearDocumentMap();
            }).getDocumentMapState(function(event, args) {
                args.enabled = documentMapNecessary;
                args.visible = documentMapVisible;
            }).setDocumentMapVisible(function(event, args) {
                documentMapVisible = args.visible;
                showDocumentMap(args.visible && documentMapNecessary);
            });
        }
    }
    var pluginName = "telerik_ReportViewer_DocumentMapArea";
    $.fn[pluginName] = function(options, otherOptions) {
        return utils.each(this, function() {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new DocumentMapArea(this, options, otherOptions));
            }
        });
    };
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    trv.ParameterTypes = {
        INTEGER: "System.Int64",
        FLOAT: "System.Double",
        STRING: "System.String",
        DATETIME: "System.DateTime",
        BOOLEAN: "System.Boolean"
    };
    trv.parameterEditorsMatch = {
        MultiSelect: function(parameter) {
            return Boolean(parameter.availableValues) && parameter.multivalue;
        },
        SingleSelect: function(parameter) {
            return Boolean(parameter.availableValues) && !parameter.multivalue;
        },
        MultiValue: function(parameter) {
            return Boolean(parameter.multivalue);
        },
        DateTime: function(parameter) {
            return parameter.type === trv.ParameterTypes.DATETIME;
        },
        String: function(parameter) {
            return parameter.type === trv.ParameterTypes.STRING;
        },
        Number: function(parameter) {
            switch (parameter.type) {
              case trv.ParameterTypes.INTEGER:
              case trv.ParameterTypes.FLOAT:
                return true;

              default:
                return false;
            }
        },
        Boolean: function(parameter) {
            return parameter.type === trv.ParameterTypes.BOOLEAN;
        },
        Default: function(parameter) {
            return true;
        }
    };
    var sr = trv.sr, utils = trv.utils;
    var multivalueUtils = function() {
        var lineSeparator = "\n";
        return {
            formatValue: function(value) {
                var text = "";
                if (value) {
                    [].concat(value).forEach(function(val) {
                        if (text.length > 0) {
                            text += lineSeparator;
                        }
                        text += val;
                    });
                }
                return text;
            },
            parseValues: function(text) {
                return ("" + text).split(lineSeparator);
            }
        };
    }();
    function integerInputBehavior(input) {
        function isValid(newValue) {
            return /^(\-|\+)?([0-9]*)$/.test(newValue);
        }
        function onKeyPress(event) {
            if (utils.isSpecialKey(event.keyCode)) {
                return true;
            }
            return isValid($(input).val() + String.fromCharCode(event.charCode));
        }
        function onPaste(event) {}
        function attach(input) {
            $(input).on("keypress", onKeyPress).on("paste", onPaste);
        }
        function detach(input) {
            $(input).off("keypress", onKeyPress).off("paste", onPaste);
        }
        attach(input);
        return {
            dispose: function() {
                detach(input);
            }
        };
    }
    function floatInputBehavior(input) {
        function isValid(newValue) {
            return /^(\-|\+)?([0-9]*(\.[0-9]*)?)$/.test(newValue);
        }
        function onKeyPress(event) {
            if (utils.isSpecialKey(event.keyCode)) {
                return true;
            }
            return isValid($(input).val() + String.fromCharCode(event.charCode));
        }
        function onPaste(event) {}
        function attach(input) {
            $(input).on("keypress", onKeyPress).on("paste", onPaste);
        }
        function detach(input) {
            $(input).off("keypress", onKeyPress).off("paste", onPaste);
        }
        attach(input);
        return {
            dispose: function() {
                detach(input);
            }
        };
    }
    function applyClass(apply, cssClass, item) {
        var fn = apply ? $.fn.addClass : $.fn.removeClass;
        fn.call(item, cssClass);
    }
    function enableItem(item, enable) {
        applyClass(!enable, "k-state-disabled", item);
    }
    function selectItem(item, select) {
        applyClass(select, "k-state-selected", item);
        item.attr("aria-selected", select);
    }
    function addAccessibilityAttributes(editor, type, caption, additionalInfo, error) {
        if (!additionalInfo) {
            additionalInfo = "";
        }
        var label = utils.stringFormat("{0}. {1} {2}. {3}", [ caption, type, sr.ariaLabelParameter, additionalInfo ]);
        editor.attr("aria-label", label);
        setAccessibilityErrorAttributes(editor, error);
    }
    var containerTabIndex;
    var editorsIndex = 0;
    function setEditorTabIndex(editor) {
        if (!containerTabIndex) {
            var $container = $("div.trv-parameters-area-content");
            if ($container.length > 0) {
                var tabIndexAttr = $container.attr("tabIndex");
                if (tabIndexAttr) {
                    containerTabIndex = utils.tryParseInt(tabIndexAttr);
                }
            }
            if (!containerTabIndex || isNaN(containerTabIndex)) {
                containerTabIndex = 300;
            }
        }
        editor.attr("tabindex", containerTabIndex + ++editorsIndex);
    }
    function setAccessibilityErrorAttributes(editor, error) {
        var errToken = utils.stringFormat(" {0}:", [ sr.ariaLabelErrorMessage ]);
        var label = editor.attr("aria-label");
        if (!label) {
            return;
        }
        var errIdx = label.indexOf(errToken);
        if (errIdx > -1) {
            label = label.substring(0, errIdx);
        }
        if (error && error != "") {
            editor.attr("aria-required", true);
            editor.attr("aria-invalid", true);
            label += errToken + error;
        } else {
            editor.removeAttr("aria-invalid");
        }
        editor.attr("aria-label", label);
    }
    trv.parameterEditors = [ {
        match: trv.parameterEditorsMatch.MultiSelect,
        createEditor: function(placeholder, options) {
            var $placeholder = $(placeholder);
            var enabled = true;
            $placeholder.html(options.templates["trv-parameter-editor-available-values-multiselect"]);
            var $list = $placeholder.find(".list"), $selectAll = $placeholder.find(".select-all"), $selectNone = $placeholder.find(".select-none"), listView, parameter, updateTimeout, valueChangeCallback = options.parameterChanged, initialized;
            $selectAll.click(function(e) {
                e.preventDefault();
                if (!enabled) return;
                setSelectedItems(parameter.availableValues.map(function(av) {
                    return av.value;
                }));
            });
            $selectNone.click(function(e) {
                e.preventDefault();
                if (!enabled) return;
                setSelectedItems([]);
            });
            function onSelectionChanged(selection) {
                if (initialized) {
                    applyAriaSelected(selection);
                    notifyParameterChanged(selection);
                }
                var noSelection = selection.length == 0;
                (noSelection ? $.fn.show : $.fn.hide).call($selectAll);
                (!noSelection ? $.fn.show : $.fn.hide).call($selectNone);
            }
            function applyAriaSelected(selection) {
                var children = listView.element.children();
                utils.each(children, function() {
                    var $item = $(this);
                    var isSelected = selection.filter($item).length > 0;
                    $item.attr("aria-selected", isSelected);
                });
            }
            function notifyParameterChanged(selection) {
                var availableValues = parameter.availableValues, values = $.map(selection, function(item) {
                    return availableValues[$(item).index()].value;
                });
                clearPendingChange();
                var immediateUpdate = !parameter.autoRefresh && !parameter.childParameters;
                updateTimeout = window.setTimeout(function() {
                    if (!utils.areEqualArrays(parameter.value, values)) {
                        valueChangeCallback(parameter, values);
                    }
                    updateTimeout = null;
                }, immediateUpdate ? 0 : 1e3);
            }
            function clearPendingChange() {
                if (updateTimeout) {
                    window.clearTimeout(updateTimeout);
                }
            }
            function getSelectedItems() {
                return $(listView.element).find(".k-state-selected");
            }
            function onItemClick() {
                if (!enabled) return;
                $(this).toggleClass("k-state-selected");
                onSelectionChanged(getSelectedItems());
            }
            function onKeydown(event) {
                if (!enabled) return;
                if (event.which != 32) {
                    return;
                }
                var focused = $(listView.element).find(".k-state-focused");
                if (focused.length > 0) {
                    focused.toggleClass("k-state-selected");
                    onSelectionChanged(getSelectedItems());
                }
            }
            function init() {
                setEditorTabIndex($list);
                setSelectedItems(parameter.value);
                var element = $(listView.element);
                element.on("click", ".listviewitem", onItemClick);
                element.on("keydown", onKeydown);
                initialized = true;
            }
            function clear() {
                initialized = false;
                if (listView) {
                    $(listView.element).off("click", ".listviewitem", onItemClick);
                    $(listView.element).off("keydown", onKeydown);
                }
            }
            function setSelectedItems(items) {
                setSelectedItemsCore(items);
                onSelectionChanged(getSelectedItems());
            }
            function setSelectedItemsCore(items) {
                if (!Array.isArray(items)) {
                    items = [ items ];
                }
                var children = listView.element.children();
                utils.each(parameter.availableValues, function(i, av) {
                    var selected = false;
                    utils.each(items, function(j, v) {
                        var availableValue = av.value;
                        if (v instanceof Date) {
                            availableValue = utils.parseToLocalDate(av.value);
                        }
                        selected = utils.areEqual(v, availableValue);
                        return !selected;
                    });
                    selectItem($(children[i]), selected);
                });
            }
            return {
                beginEdit: function(param) {
                    clear();
                    parameter = param;
                    $list.kendoListView({
                        template: '<div class="listviewitem">${name}</div>',
                        dataSource: {
                            data: parameter.availableValues
                        },
                        selectable: false,
                        navigatable: true
                    });
                    listView = $list.data("kendoListView");
                    init();
                },
                enable: function(enable) {
                    enabled = enable;
                    enableItem($list, enabled);
                },
                clearPendingChange: clearPendingChange,
                addAccessibility: function(param) {
                    var info = utils.stringFormat(sr.ariaLabelParameterInfo, [ param.availableValues.length ]);
                    addAccessibilityAttributes($list, sr.ariaLabelMultiSelect, param.text, info, param.Error);
                    $list.attr("aria-multiselectable", "true");
                    var items = $list.find(".listviewitem");
                    utils.each(items, function() {
                        $(this).attr("aria-label", this.innerText);
                    });
                },
                setAccessibilityErrorState: function(param) {
                    setAccessibilityErrorAttributes($list, param.Error);
                }
            };
        }
    }, {
        match: trv.parameterEditorsMatch.SingleSelect,
        createEditor: function(placeholder, options) {
            var $placeholder = $(placeholder);
            var enabled = true;
            $placeholder.html(options.templates["trv-parameter-editor-available-values"]);
            var $list = $placeholder.find(".list"), $selectNone = $placeholder.find(".select-none"), listView, parameter, valueChangeCallback = options.parameterChanged;
            if ($selectNone) {
                $selectNone.click(function(e) {
                    e.preventDefault();
                    listView.clearSelection();
                });
            }
            function onSelectionChanged(selection) {
                notifyParameterChanged(selection);
            }
            function notifyParameterChanged(selection) {
                var availableValues = parameter.availableValues, values = $.map(selection, function(item) {
                    return availableValues[$(item).index()].value;
                });
                if (Array.isArray(values)) {
                    values = values[0];
                }
                valueChangeCallback(parameter, values);
            }
            function getSelectedItems() {
                return listView.select();
            }
            function onChange() {
                onSelectionChanged(getSelectedItems());
            }
            function init() {
                setEditorTabIndex($list);
                setSelectedItems(parameter.value);
                listView.bind("change", onChange);
            }
            function reset() {
                if (listView) {
                    listView.unbind("change", onChange);
                }
            }
            function setSelectedItems(value) {
                var items = listView.element.children();
                utils.each(parameter.availableValues, function(i, av) {
                    var availableValue = av.value;
                    if (value instanceof Date) {
                        availableValue = utils.parseToLocalDate(av.value);
                    }
                    if (utils.areEqual(value, availableValue)) {
                        listView.select(items[i]);
                        return false;
                    }
                    return true;
                });
            }
            return {
                beginEdit: function(param) {
                    reset();
                    parameter = param;
                    if ($selectNone && !param.allowNull) {
                        $selectNone.hide();
                    }
                    $list.kendoListView({
                        template: '<div class="listviewitem">${name}</div>',
                        dataSource: {
                            data: parameter.availableValues
                        },
                        selectable: true,
                        navigatable: true
                    });
                    listView = $list.data("kendoListView");
                    init($list);
                },
                enable: function(enable) {
                    enabled = enable;
                    enableItem($list, enabled);
                    if (enabled) {
                        listView.bind("change", onChange);
                        $list.addClass("k-selectable");
                    } else {
                        listView.unbind("change", onChange);
                        $list.removeClass("k-selectable");
                    }
                },
                addAccessibility: function(param) {
                    var info = utils.stringFormat(sr.ariaLabelParameterInfo, [ param.availableValues.length ]);
                    addAccessibilityAttributes($list, sr.ariaLabelSingleValue, param.text, info, param.Error);
                    var items = $list.find(".listviewitem");
                    utils.each(items, function() {
                        $(this).attr("aria-label", this.innerText);
                    });
                },
                setAccessibilityErrorState: function(param) {
                    setAccessibilityErrorAttributes($list, param.Error);
                }
            };
        }
    }, {
        match: trv.parameterEditorsMatch.MultiValue,
        createEditor: function(placeholder, options) {
            var $placeholder = $(placeholder), parameter;
            $placeholder.html(options.templates["trv-parameter-editor-multivalue"]);
            var $textArea = $placeholder.find("textarea").on("change", function() {
                if (options.parameterChanged) {
                    options.parameterChanged(parameter, multivalueUtils.parseValues(this.value));
                }
            });
            function setValue(value) {
                parameter.value = value;
                $textArea.val(multivalueUtils.formatValue(value));
            }
            return {
                beginEdit: function(param) {
                    parameter = param;
                    setValue(param.value);
                    setEditorTabIndex($textArea);
                },
                enable: function(enable) {
                    enableItem($textArea, enable);
                    $textArea.prop("disabled", !enable);
                },
                addAccessibility: function(param) {
                    addAccessibilityAttributes($textArea, sr.ariaLabelMultiValue, param.text, null, param.Error);
                },
                setAccessibilityErrorState: function(param) {
                    setAccessibilityErrorAttributes($textArea, param.Error);
                }
            };
        }
    }, {
        match: trv.parameterEditorsMatch.DateTime,
        createEditor: function(placeholder, options) {
            var $placeholder = $(placeholder), parameter;
            $placeholder.html(options.templates["trv-parameter-editor-datetime"]);
            var $dateTimePicker = $placeholder.find("input[type=datetime]").kendoDatePicker({
                change: function() {
                    var handler = options.parameterChanged;
                    if (handler) {
                        var dtv = this.value();
                        if (null !== dtv) {
                            dtv = utils.adjustTimezone(dtv);
                        }
                        handler(parameter, dtv);
                    }
                }
            });
            var dateTimePicker = $dateTimePicker.data("kendoDatePicker");
            function setValue(value) {
                parameter.value = value;
                var dt = null;
                try {
                    if (value) {
                        dt = utils.unadjustTimezone(value);
                    }
                } catch (e) {
                    dt = null;
                }
                dateTimePicker.value(dt);
            }
            return {
                beginEdit: function(param) {
                    parameter = param;
                    setValue(param.value);
                    setEditorTabIndex($dateTimePicker);
                },
                enable: function(enable) {
                    dateTimePicker.enable(enable);
                    enableItem($dateTimePicker, enable);
                },
                addAccessibility: function(param) {
                    addAccessibilityAttributes($dateTimePicker, sr.ariaLabelParameterDateTime, param.text, null, param.Error);
                    $dateTimePicker.attr("aria-live", "assertive");
                },
                setAccessibilityErrorState: function(param) {
                    setAccessibilityErrorAttributes($dateTimePicker, param.Error);
                }
            };
        }
    }, {
        match: trv.parameterEditorsMatch.String,
        createEditor: function(placeholder, options) {
            var $placeholder = $(placeholder), parameter;
            $placeholder.html(options.templates["trv-parameter-editor-text"]);
            var $input = $placeholder.find('input[type="text"]').change(function() {
                if (options.parameterChanged) {
                    options.parameterChanged(parameter, $input.val());
                }
            });
            function setValue(value) {
                parameter.value = value;
                $input.val(value);
            }
            return {
                beginEdit: function(param) {
                    parameter = param;
                    setValue(param.value);
                    setEditorTabIndex($input);
                },
                enable: function(enabled) {
                    $input.prop("disabled", !enabled);
                    enableItem($input, enabled);
                },
                addAccessibility: function(param) {
                    addAccessibilityAttributes($input, sr.ariaLabelParameterString, param.text, null, param.Error);
                    $input.attr("aria-live", "assertive");
                },
                setAccessibilityErrorState: function(param) {
                    setAccessibilityErrorAttributes($input, param.Error);
                }
            };
        }
    }, {
        match: trv.parameterEditorsMatch.Number,
        createEditor: function(placeholder, options) {
            var $placeholder = $(placeholder), parameter, inputBehavior;
            $placeholder.html(options.templates["trv-parameter-editor-number"]);
            var $input = $placeholder.find("input[type=number]").on("change", function() {
                if (options.parameterChanged) {
                    options.parameterChanged(parameter, $input.val());
                }
            });
            function setValue(value) {
                parameter.value = value;
                $input.val(value);
            }
            return {
                beginEdit: function(param) {
                    if (inputBehavior) {
                        inputBehavior.dispose();
                    }
                    parameter = param;
                    $input.val(parameter.value);
                    if (parameter.type === trv.ParameterTypes.INTEGER) {
                        inputBehavior = integerInputBehavior($input);
                    } else {
                        inputBehavior = floatInputBehavior($input);
                    }
                    setEditorTabIndex($input);
                },
                enable: function(enable) {
                    $input.prop("disabled", !enable);
                    enableItem($input, enable);
                },
                addAccessibility: function(param) {
                    addAccessibilityAttributes($input, sr.ariaLabelParameterNumerical, param.text, null, param.Error);
                    $input.attr("aria-live", "assertive");
                },
                setAccessibilityErrorState: function(param) {
                    setAccessibilityErrorAttributes($input, param.Error);
                }
            };
        }
    }, {
        match: trv.parameterEditorsMatch.Boolean,
        createEditor: function(placeholder, options) {
            var $placeholder = $(placeholder), parameter;
            $placeholder.html(options.templates["trv-parameter-editor-boolean"]);
            var $input = $placeholder.find("input[type=checkbox]").on("change", function() {
                if (options.parameterChanged) {
                    options.parameterChanged(parameter, this.checked);
                }
            });
            function setValue(value) {
                parameter.value = value;
                $input[0].checked = value === true;
            }
            return {
                beginEdit: function(param) {
                    parameter = param;
                    setValue(param.value);
                    setEditorTabIndex($input);
                },
                enable: function(enable) {
                    enableItem($input, enable);
                    $input.attr("disabled", !enable);
                },
                addAccessibility: function(param) {
                    addAccessibilityAttributes($input, sr.ariaLabelParameterBoolean, param.text, null, param.Error);
                    $input.attr("aria-live", "assertive");
                },
                setAccessibilityErrorState: function(param) {
                    setAccessibilityErrorAttributes($input, param.Error);
                }
            };
        }
    }, {
        match: trv.parameterEditorsMatch.Default,
        createEditor: function(placeholder, options) {
            var $placeholder = $(placeholder);
            $placeholder.html('<div class="trv-parameter-editor-generic"></div>');
            return {
                beginEdit: function(parameter) {
                    $placeholder.find(".trv-parameter-editor-generic").html(parameter.Error ? "(error)" : parameter.value);
                },
                enable: function(enable) {}
            };
        }
    } ];
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    var sr = trv.sr, utils = trv.utils;
    trv.parameterValidators = function() {
        var validators = {};
        function validateParameter(parameter, value, validatorFunc, compareFunc) {
            var values = [].concat(value).map(function(value1) {
                return checkAvailbaleValues(parameter, validatorFunc(value1), compareFunc);
            });
            if (parameter.multivalue) {
                if ((value == null || value.length == 0) && !parameter.allowNull) {
                    throw sr.invalidParameter;
                }
                return values;
            }
            return values[0];
        }
        function isNull(parameter, value) {
            return parameter.allowNull && -1 != [ null, "", undefined ].indexOf(value);
        }
        function checkAvailbaleValues(parameter, value, compareFunc) {
            if (parameter.availableValues) {
                var found = false;
                utils.each(parameter.availableValues, function(i, av) {
                    found = compareFunc(value, av.value);
                    return !found;
                });
                if (!found) {
                    if (parameter.allowNull && !value) {
                        return value;
                    }
                    throw sr.invalidParameter;
                }
            }
            return value;
        }
        validators[trv.ParameterTypes.STRING] = {
            validate: function(parameter, value) {
                return validateParameter(parameter, value, function(value) {
                    if (!value) {
                        if (parameter.allowNull) {
                            return null;
                        }
                        if (parameter.allowBlank) {
                            return "";
                        }
                        throw sr.parameterIsEmpty;
                    }
                    return value;
                }, function(s1, s2) {
                    return s1 == s2;
                });
            }
        };
        validators[trv.ParameterTypes.FLOAT] = {
            validate: function(parameter, value) {
                return validateParameter(parameter, value, function(value) {
                    var num = utils.tryParseFloat(value);
                    if (isNaN(num)) {
                        if (isNull(parameter, value)) {
                            return null;
                        }
                        throw sr.parameterIsEmpty;
                    }
                    return num;
                }, function(f1, f2) {
                    return utils.tryParseFloat(f1) == utils.tryParseFloat(f2);
                });
            }
        };
        validators[trv.ParameterTypes.INTEGER] = {
            validate: function(parameter, value) {
                return validateParameter(parameter, value, function(value) {
                    var num = utils.tryParseInt(value);
                    if (isNaN(num)) {
                        if (isNull(parameter, value)) {
                            return null;
                        }
                        throw sr.parameterIsEmpty;
                    }
                    return num;
                }, function(n1, n2) {
                    return utils.tryParseInt(n1) == utils.tryParseFloat(n2);
                });
            }
        };
        validators[trv.ParameterTypes.DATETIME] = {
            validate: function(parameter, value) {
                return validateParameter(parameter, value, function(value) {
                    if (parameter.allowNull && (value === null || value === "" || value === undefined)) {
                        return null;
                    }
                    if (!isNaN(Date.parse(value))) {
                        return utils.parseToLocalDate(value);
                    }
                    throw sr.invalidDateTimeValue;
                }, function(d1, d2) {
                    d1 = utils.parseToLocalDate(d1);
                    d2 = utils.parseToLocalDate(d2);
                    return d1.getTime() == d2.getTime();
                });
            }
        };
        validators[trv.ParameterTypes.BOOLEAN] = {
            validate: function(parameter, value) {
                return validateParameter(parameter, value, function(value) {
                    if (-1 != [ "true", "false" ].indexOf(("" + value).toLowerCase())) {
                        return Boolean(value);
                    }
                    if (isNull(parameter, value)) {
                        return null;
                    }
                    throw sr.parameterIsEmpty;
                }, function(b1, b2) {
                    return Boolean(b1) == Boolean(b2);
                });
            }
        };
        return {
            validate: function(parameter, value) {
                var v = validators[parameter.type];
                if (!v) {
                    throw utils.stringFormat(sr.cannotValidateType, parameter);
                }
                return v.validate(parameter, value);
            }
        };
    }();
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    var sr = trv.sr, utils = trv.utils, parameterValidators = trv.parameterValidators;
    var defaultOptions = {};
    var Events = {
        PARAMETERS_READY: "pa.parametersReady",
        ERROR: "pa.Error"
    };
    function ParametersArea(placeholder, options, otherOptions) {
        options = $.extend({}, defaultOptions, options, otherOptions);
        var parametersArea = {};
        var $parametersArea = $(parametersArea);
        var editors = {};
        var controller = options.controller;
        if (!controller) {
            throw "No controller (telerikReporting.reportViewerController) has been specified.";
        }
        var parameterEditors = [].concat(options.parameterEditors, trv.parameterEditors);
        var recentParameterValues, parameters, initialParameterValues = undefined;
        var $placeholder = $(placeholder), $content = $placeholder.find(".trv-parameters-area-content"), $errorMessage = $placeholder.find(".trv-error-message"), $previewButton = $placeholder.find(".trv-parameters-area-preview-button"), noParametersContent = $placeholder.html();
        $previewButton.on("click", function(e) {
            e.preventDefault();
            if (allParametersValid()) {
                applyParameters();
            }
        });
        var parameterContainerTemplate = options.templates["trv-parameter"];
        var parametersAreaVisible = options.parametersAreaVisible !== false;
        var enableAccessibility = options.enableAccessibility;
        function createParameterContainer() {
            return $(parameterContainerTemplate);
        }
        function createParameterUI(parameter) {
            var $container = createParameterContainer(), $editorPlaceholder = $container.find(".trv-parameter-value"), $title = $container.find(".trv-parameter-title"), $error = $container.find(".trv-parameter-error"), $errorMessage = $container.find(".trv-parameter-error-message"), $useDefaultValueCheckbox = $container.find(".trv-parameter-use-default input"), editorFactory = selectParameterEditorFactory(parameter);
            var parameterText = parameter.text;
            var isHiddenParameter = !parameter.isVisible;
            if (isHiddenParameter) {
                parameterText += "<br />[<b>hidden</b>]";
            }
            $title.html(parameterText).attr("title", parameterText);
            $errorMessage.html(parameter.Error);
            (parameter.Error ? $.fn.show : $.fn.hide).call($error);
            var editor = editorFactory.createEditor($editorPlaceholder, {
                templates: options.templates,
                parameterChanged: function(parameter, newValue) {
                    try {
                        newValue = parameterValidators.validate(parameter, newValue);
                        $error.hide();
                        onParameterChanged(parameter, newValue);
                    } catch (error) {
                        parameter.Error = error;
                        parameter.value = [];
                        $errorMessage.html(error);
                        $error.show();
                        enablePreviewButton(false);
                    } finally {
                        setAccessibilityErrorState(parameter);
                    }
                }
            });
            editors[parameter.id] = editor;
            editor.beginEdit(parameter);
            if (enableAccessibility && !isHiddenParameter) {
                editor.addAccessibility(parameter);
            }
            if ($useDefaultValueCheckbox.length > 0) {
                $useDefaultValueCheckbox.on("click", function() {
                    var useDefaultValue = $(this).is(":checked");
                    if (useDefaultValue) {
                        delete recentParameterValues[parameter.id];
                        delete initialParameterValues[parameter.id];
                        invalidateChildParameters(parameter);
                        updateParameters(onLoadParametersSuccess);
                    } else {
                        recentParameterValues[parameter.id] = parameter.value;
                        initialParameterValues[parameter.id] = parameter.value;
                    }
                    editor.enable(!useDefaultValue);
                    raiseParametersReady();
                });
                var hasInitialValues = initialParameterValues != null;
                if (hasInitialValues) {
                    if (!(parameter.id in initialParameterValues)) {
                        $useDefaultValueCheckbox.prop("checked", true);
                        editor.enable(false);
                    }
                } else if (isHiddenParameter) {
                    $useDefaultValueCheckbox.prop("checked", true);
                    editor.enable(false);
                }
            }
            return $container;
        }
        function setAccessibilityErrorState(parameter) {
            var editor = editors[parameter.id];
            if (!editor || !enableAccessibility) {
                return;
            }
            editor.setAccessibilityErrorState(parameter);
        }
        function enablePreviewButton(enabled) {
            if (enabled) {
                $previewButton.prop("disabled", false);
                $previewButton.removeClass("k-state-disabled");
            } else {
                $previewButton.prop("disabled", true);
                $previewButton.addClass("k-state-disabled");
            }
        }
        function selectParameterEditorFactory(parameter) {
            var factory;
            utils.each(parameterEditors, function() {
                if (this && this.match(parameter)) {
                    factory = this;
                }
                return !factory;
            });
            return factory;
        }
        function showError(error) {
            $errorMessage.html(error);
            (error ? $.fn.addClass : $.fn.removeClass).call($placeholder, "error");
        }
        function showPreviewButton() {
            (allParametersAutoRefresh(parameters) ? $.fn.removeClass : $.fn.addClass).call($placeholder, "preview");
        }
        function allParametersAutoRefresh() {
            var allAuto = true;
            utils.each(parameters, function() {
                return allAuto = !this.isVisible || this.autoRefresh;
            });
            return allAuto;
        }
        function allParametersValid() {
            var allValid = true;
            utils.each(parameters, function() {
                return allValid = !this.Error;
            });
            return allValid;
        }
        function fill(newParameters) {
            recentParameterValues = {};
            parameters = newParameters || [];
            editors = {};
            var $parameterContainer, $tempContainer = $("<div></div>");
            utils.each(parameters, function() {
                try {
                    this.value = parameterValidators.validate(this, this.value);
                } catch (e) {
                    this.Error = this.Error || e;
                }
                var hasError = Boolean(this.Error), hasValue = !hasError;
                if (hasValue) {
                    recentParameterValues[this.id] = this.value;
                } else {
                    this.Error = sr.invalidParameter;
                }
                if (this.isVisible || options.showHiddenParameters) {
                    if ($parameterContainer = createParameterUI(this)) {
                        $tempContainer.append($parameterContainer);
                    }
                }
            });
            if (initialParameterValues !== undefined) {
                if (null == initialParameterValues) {
                    initialParameterValues = {};
                    utils.each(parameters, function() {
                        if (this.isVisible) {
                            initialParameterValues[this.id] = this.value;
                        } else {
                            delete recentParameterValues[this.id];
                        }
                    });
                } else {
                    utils.each(parameters, function() {
                        if (!(this.id in initialParameterValues)) {
                            delete recentParameterValues[this.id];
                        }
                    });
                }
            }
            $content.empty();
            if (parameters.length > 0) {
                $content.append($tempContainer.children());
                if (enableAccessibility) {
                    $content.attr("aria-label", "Parameters area. Contains " + parameters.length + " parameters.");
                }
            } else {
                $content.append(noParametersContent);
            }
            showPreviewButton(parameters);
            var allValid = allParametersValid();
            enablePreviewButton(allValid);
        }
        function applyParameters() {
            controller.setParameters($.extend({}, recentParameterValues));
            controller.previewReport(false);
        }
        function allParametersValidForAutoRefresh() {
            var triggerAutoUpdate = true;
            for (var i = parameters.length - 1; triggerAutoUpdate && i >= 0; i--) {
                var p = parameters[i];
                triggerAutoUpdate = p.id in recentParameterValues && (Boolean(p.autoRefresh) || !p.isVisible);
            }
            return triggerAutoUpdate;
        }
        function raiseParametersReady() {
            parametersArea.parametersReady(recentParameterValues);
        }
        function tryRefreshReport() {
            raiseParametersReady();
            if (allParametersValidForAutoRefresh()) {
                applyParameters();
            }
        }
        function invalidateChildParameters(parameter) {
            if (parameter.childParameters) {
                utils.each(parameter.childParameters, function(index, parameterId) {
                    var childParameter = getParameterById(parameterId);
                    if (childParameter) {
                        invalidateChildParameters(childParameter);
                    }
                    delete recentParameterValues[parameterId];
                    resetPendingParameterChange(parameterId);
                });
            }
        }
        function resetPendingParameterChange(parameterId) {
            if (editors) {
                var editor = editors[parameterId];
                if (editor && typeof editor.clearPendingChange === "function") {
                    editor.clearPendingChange();
                }
            }
        }
        function onParameterChanged(parameter, newValue) {
            delete parameter["Error"];
            parameter.value = newValue;
            recentParameterValues[parameter.id] = newValue;
            if (initialParameterValues !== undefined) {
                if (parameter.id in initialParameterValues) {
                    recentParameterValues[parameter.id] = newValue;
                }
            } else {
                recentParameterValues[parameter.id] = newValue;
            }
            invalidateChildParameters(parameter);
            if (parameter.childParameters) {
                updateParameters(tryRefreshReport);
            } else {
                var allValid = allParametersValid();
                enablePreviewButton(allValid);
                if (allValid) {
                    tryRefreshReport();
                }
            }
        }
        function getParameterById(parameterId) {
            if (parameters) {
                for (var i = 0; i < parameters.length; i++) {
                    var p = parameters[i];
                    if (p.id === parameterId) {
                        return p;
                    }
                }
            }
            return null;
        }
        function setParametersAreaVisibility(visible) {
            controller.setParametersAreaVisible({
                visible: visible
            });
        }
        function hasVisibleParameters(params) {
            if (!params || null === params) {
                return false;
            }
            var result = false;
            utils.each(params, function() {
                result = this.isVisible;
                return !result;
            });
            return result;
        }
        var loadingCount = 0;
        function beginLoad() {
            loadingCount++;
            $placeholder.addClass("loading");
        }
        function endLoad() {
            if (loadingCount > 0) {
                if (0 == --loadingCount) {
                    $placeholder.removeClass("loading");
                }
            }
        }
        function onLoadParametersComplete(params, successAction) {
            var showParamsArea = hasVisibleParameters(params) && parametersAreaVisible;
            if (!showParamsArea) {
                showParametersArea(false);
            }
            fill(params);
            showError("");
            if (showParamsArea) {
                showParametersArea(true);
            }
            controller.updateUIInternal();
            if (typeof successAction === "function") {
                successAction();
            }
            endLoad();
        }
        function updateParameters(successAction) {
            acceptParameters(controller.loadParameters(recentParameterValues), successAction);
        }
        function acceptParameters(controllerLoadParametersPromise, successAction) {
            beginLoad();
            controllerLoadParametersPromise.then(function(parameters) {
                onLoadParametersComplete(parameters, successAction);
            }).catch(function(error) {
                endLoad();
                clear();
                if (!$placeholder.hasClass("hidden")) {
                    showError(error);
                }
                parametersArea.error(error);
            });
        }
        function getEventHandlerFromArguments(args) {
            var arg0;
            if (args && args.length) {
                arg0 = args[0];
            }
            if (typeof arg0 == "function") {
                return arg0;
            }
            return null;
        }
        function eventFactory(event, args) {
            var h = getEventHandlerFromArguments(args);
            if (h) {
                $parametersArea.on(event, h);
            } else {
                $parametersArea.trigger(event, args);
            }
            return controller;
        }
        function onLoadParametersSuccess() {
            if (initialParameterValues === null) {
                initialParameterValues = $.extend({}, recentParameterValues);
            }
            raiseParametersReady();
        }
        function showParametersArea(show) {
            (show ? $.fn.removeClass : $.fn.addClass).call($placeholder, "hidden");
        }
        function onReloadParameters(event, controllerLoadParametersPromise) {
            showError();
            $content.empty();
            acceptParameters(controllerLoadParametersPromise, onLoadParametersSuccess);
        }
        controller.reloadParameters(onReloadParameters).getParametersAreaState(function(event, args) {
            var parametersAreaNecessary = false;
            if (parameters) {
                parametersAreaNecessary = hasVisibleParameters(parameters);
            }
            args.enabled = parametersAreaNecessary;
            args.visible = parametersAreaVisible;
        }).setParametersAreaVisible(function(event, args) {
            parametersAreaVisible = args.visible;
            showParametersArea(args.visible && hasVisibleParameters(parameters));
        }).beforeLoadReport(function() {
            loadingCount = 0;
            beginLoad();
        }).error(endLoad).pageReady(function() {
            endLoad();
        });
        function clear() {
            fill([]);
        }
        $.extend(parametersArea, {
            allParametersValid: function() {
                return allParametersValid();
            },
            clear: function() {
                clear();
            },
            error: function() {
                return eventFactory(Events.ERROR, arguments);
            },
            parametersReady: function() {
                return eventFactory(Events.PARAMETERS_READY, arguments);
            },
            setParameters: function(parameterValues) {
                initialParameterValues = null === parameterValues ? null : $.extend({}, parameterValues);
            }
        });
        return parametersArea;
    }
    var pluginName = "telerik_ReportViewer_ParametersArea";
    $.fn[pluginName] = function(options, otherOptions) {
        return utils.each(this, function() {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new ParametersArea(this, options, otherOptions));
            }
        });
    };
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReporting.utils";
    }
    function uiController(options) {
        var stateFlags = {
            ExportInProgress: 1 << 0,
            PrintInProgress: 1 << 1
        };
        function getState(flags) {
            return (state & flags) != 0;
        }
        function setState(flags, value) {
            if (value) {
                state |= flags;
            } else {
                state &= ~flags;
            }
        }
        var controller = options.controller, historyManager = options.history, state = 0, refreshUI, commands = options.commands;
        if (!controller) {
            throw "No controller (telerikReporting.ReportViewerController) has been specified.";
        }
        function getDocumentMapState() {
            var args = {};
            controller.getDocumentMapState(args);
            return args;
        }
        function getParametersAreaState() {
            var args = {};
            controller.getParametersAreaState(args);
            return args;
        }
        function updateUI() {
            if (!refreshUI) {
                refreshUI = true;
                window.setTimeout(function() {
                    try {
                        updateUICore();
                    } finally {
                        refreshUI = false;
                    }
                }, 10);
            }
        }
        function updateUICore() {
            var rs = controller.reportSource();
            var pageCount = controller.pageCount();
            var currentPageNumber = controller.currentPageNumber();
            var hasReport = rs && rs.report;
            var hasPages = hasReport && pageCount > 0;
            var nextPage = hasPages && currentPageNumber < pageCount;
            var prevPage = hasPages && currentPageNumber > 1;
            var hasPage = hasPages && currentPageNumber;
            var documentMapState = getDocumentMapState();
            var parametersAreaState = getParametersAreaState();
            commands.goToFirstPage.enabled(prevPage);
            commands.goToPrevPage.enabled(prevPage);
            commands.goToLastPage.enabled(nextPage);
            commands.goToNextPage.enabled(nextPage);
            commands.goToPage.enabled(hasPages);
            commands.print.enabled(hasPages && !getState(stateFlags.PrintInProgress));
            commands.export.enabled(hasPages && !getState(stateFlags.ExportInProgress));
            commands.refresh.enabled(hasReport);
            commands.historyBack.enabled(historyManager && historyManager.canMoveBack());
            commands.historyForward.enabled(historyManager && historyManager.canMoveForward());
            commands.toggleDocumentMap.enabled(hasReport && documentMapState.enabled).checked(documentMapState.enabled && documentMapState.visible);
            commands.toggleParametersArea.enabled(hasReport && parametersAreaState.enabled).checked(parametersAreaState.enabled && parametersAreaState.visible);
            commands.togglePrintPreview.enabled(hasPages).checked(controller.viewMode() == trv.ViewModes.PRINT_PREVIEW);
            commands.zoom.enabled(hasPage);
            commands.zoomIn.enabled(hasPage);
            commands.zoomOut.enabled(hasPage);
            commands.toggleZoomMode.enabled(hasPage);
            controller.updateUI(null);
            try {
                controller.pageNumberChange(currentPageNumber);
                controller.pageCountChange(pageCount);
            } finally {}
        }
        function getScaleMode() {
            var args = {};
            controller.getScale(args);
            return args.scaleMode;
        }
        controller.scale(function(event, args) {
            commands.toggleZoomMode.checked(args.scaleMode == trv.ScaleModes.FIT_PAGE);
        });
        controller.currentPageChanged(updateUI);
        controller.beforeLoadReport(updateUI);
        controller.reportLoadProgress(updateUI);
        controller.reportLoadComplete(updateUI);
        controller.reportSourceChanged(updateUI);
        controller.viewModeChanged(updateUI);
        controller.setParametersAreaVisible(updateUI);
        controller.setDocumentMapVisible(updateUI);
        controller.exportStarted(function() {
            setState(stateFlags.ExportInProgress, true);
            updateUI();
        });
        controller.exportReady(function() {
            setState(stateFlags.ExportInProgress, false);
            updateUI();
        });
        controller.printStarted(function() {
            setState(stateFlags.PrintInProgress, true);
            updateUI();
        });
        controller.printReady(function() {
            setState(stateFlags.PrintInProgress, false);
            updateUI();
        });
        controller.error(function() {
            setState(stateFlags.ExportInProgress, false);
            setState(stateFlags.PrintInProgress, false);
            updateUI();
        });
        controller.updateUIInternal(updateUI);
        updateUI();
    }
    trv.uiController = uiController;
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, window, document, undefined) {
    "use strict";
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReporting.utils";
    }
    trv.HistoryManager = function(options) {
        var controller = options.controller;
        var clientHasExpired = false;
        if (!controller) {
            throw "No controller (telerikReporting.reportViewerController) has been specified.";
        }
        var settings = options.settings, history = settings.history() || {
            records: [],
            position: -1
        };
        controller.onLoadedReportChange(function() {
            clientHasExpired = false;
            addToHistory(true);
        }).currentPageChanged(function() {
            updatePageInfo();
        }).reportLoadComplete(function(event, args) {
            addToHistory(false);
        }).clientExpired(function() {
            clientHasExpired = true;
            var records = history.records;
            for (var i = 0; i < records.length; i++) {
                records[i].reportDocumentId = null;
            }
        });
        function getCurrentRecord() {
            var records = history.records;
            if (records.length > 0) {
                return records[history.position];
            }
            return null;
        }
        function pushRecord(rec) {
            var records = history.records, position = history.position;
            records = Array.prototype.slice.call(records, 0, position + 1);
            records.push(rec);
            history.records = records;
            history.position = records.length - 1;
            saveSettings();
        }
        function saveSettings() {
            settings.history(history);
        }
        function updatePageInfo() {
            var currentRecord = getCurrentRecord();
            if (currentRecord) {
                currentRecord.pageNumber = controller.currentPageNumber();
                currentRecord.viewMode = controller.viewMode();
                currentRecord.reportDocumentId = controller.reportDocumentIdExposed();
                saveSettings();
            }
        }
        function addToHistory(temp) {
            removeTempRecordsFromHistory();
            var currentRecord = getCurrentRecord();
            var rs = controller.reportSource();
            if (!currentRecord || !utils.reportSourcesAreEqual(currentRecord.reportSource, rs)) {
                pushRecord({
                    reportSource: rs,
                    pageNumber: 1,
                    temp: temp
                });
            }
        }
        function exec(currentRecord) {
            controller.setViewMode(currentRecord.viewMode);
            controller.reportSource(currentRecord.reportSource);
            controller.refreshReport(false, currentRecord.reportDocumentId);
            controller.navigateToPage(currentRecord.pageNumber);
        }
        function canMove(step) {
            var position = history.position, length = history.records.length, newPos = position + step;
            return 0 <= newPos && newPos < length;
        }
        function move(step) {
            var position = history.position, length = history.records.length, newPos = position + step;
            if (newPos < 0) {
                newPos = 0;
            } else if (newPos >= length) {
                newPos = length - 1;
            }
            if (newPos != position) {
                history.position = newPos;
                saveSettings();
                exec(getCurrentRecord());
            }
        }
        function removeTempRecordsFromHistory() {
            var lastIndex = history.records.length - 1;
            while (lastIndex >= 0) {
                if (history.records[lastIndex].temp === true) {
                    history.records.splice(lastIndex, 1);
                    if (history.position >= lastIndex) {
                        history.position--;
                    }
                } else {
                    break;
                }
                lastIndex--;
            }
        }
        return {
            back: function() {
                move(-1);
            },
            forward: function() {
                move(+1);
            },
            canMoveBack: function() {
                return canMove(-1);
            },
            canMoveForward: function() {
                return canMove(1);
            },
            loadCurrent: function() {
                var rec = getCurrentRecord();
                if (rec) {
                    exec(rec);
                }
                return Boolean(rec);
            }
        };
    };
})(window.telerikReportViewer = window.telerikReportViewer || {}, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReporting.utils";
    }
    var scaleTransitionMap = {};
    scaleTransitionMap[trv.ScaleModes.FIT_PAGE] = {
        scaleMode: trv.ScaleModes.FIT_PAGE_WIDTH
    };
    scaleTransitionMap[trv.ScaleModes.FIT_PAGE_WIDTH] = {
        scaleMode: trv.ScaleModes.SPECIFIC,
        scale: 1
    };
    scaleTransitionMap[trv.ScaleModes.SPECIFIC] = {
        scaleMode: trv.ScaleModes.FIT_PAGE
    };
    var scaleValues = [ .1, .25, .5, .75, 1, 1.5, 2, 4, 8 ];
    function CommandSet(options) {
        var controller = options.controller;
        if (!controller) {
            throw "No options.controller.";
        }
        var historyManager = options.history;
        if (!historyManager) {
            throw "No options.history.";
        }
        function getDocumentMapVisible() {
            var args = {};
            controller.getDocumentMapState(args);
            return Boolean(args.visible);
        }
        function getParametersAreaVisible() {
            var args = {};
            controller.getParametersAreaState(args);
            return Boolean(args.visible);
        }
        return {
            historyBack: new command(function() {
                historyManager.back();
            }),
            historyForward: new command(function() {
                historyManager.forward();
            }),
            goToPrevPage: new command(function() {
                controller.navigateToPage(controller.currentPageNumber() - 1);
            }),
            goToNextPage: new command(function() {
                controller.navigateToPage(controller.currentPageNumber() + 1);
            }),
            goToFirstPage: new command(function() {
                controller.navigateToPage(1);
            }),
            goToLastPage: new command(function() {
                controller.navigateToPage(controller.pageCount());
            }),
            goToPage: new command(function(pageNumber) {
                if (!isNaN(pageNumber)) {
                    var pageCount = controller.pageCount();
                    if (pageNumber > pageCount) {
                        pageNumber = pageCount;
                    } else if (pageNumber < 1) {
                        pageNumber = 1;
                    }
                    controller.navigateToPage(pageNumber);
                    return pageNumber;
                }
            }),
            refresh: new command(function() {
                controller.refreshReport(true);
            }),
            "export": new command(function(format) {
                if (format) {
                    controller.exportReport(format);
                }
            }),
            print: new command(function() {
                controller.printReport();
            }),
            togglePrintPreview: new command(function() {
                controller.viewMode(controller.viewMode() == trv.ViewModes.PRINT_PREVIEW ? trv.ViewModes.INTERACTIVE : trv.ViewModes.PRINT_PREVIEW);
            }),
            toggleDocumentMap: new command(function() {
                controller.setDocumentMapVisible({
                    visible: !getDocumentMapVisible()
                });
            }),
            toggleParametersArea: new command(function() {
                controller.setParametersAreaVisible({
                    visible: !getParametersAreaVisible()
                });
            }),
            zoom: new command(function(scale) {
                controller.scale({
                    scale: 1
                });
            }),
            zoomIn: new command(function() {
                zoom(1);
            }),
            zoomOut: new command(function() {
                zoom(-1);
            }),
            toggleSideMenu: new command(function() {
                $(controller).trigger(controller.Events.TOGGLE_SIDE_MENU);
            }),
            toggleZoomMode: new command(function() {
                var args = {};
                controller.getScale(args);
                controller.scale(scaleTransitionMap[args.scaleMode]);
            })
        };
        function zoom(step) {
            var args = {};
            controller.getScale(args);
            args.scale = getZoomScale(args.scale, step);
            args.scaleMode = trv.ScaleModes.SPECIFIC;
            controller.scale(args);
        }
        function getZoomScale(scale, steps) {
            var pos = -1, length = scaleValues.length;
            for (var i = 0; i < length; i++) {
                var value = scaleValues[i];
                if (scale < value) {
                    pos = i - .5;
                    break;
                }
                if (scale == value) {
                    pos = i;
                    break;
                }
            }
            pos = pos + steps;
            if (steps >= 0) {
                pos = Math.round(pos - .49);
            } else {
                pos = Math.round(pos + .49);
            }
            if (pos < 0) {
                pos = 0;
            } else if (pos > length - 1) {
                pos = length - 1;
            }
            return scaleValues[pos];
        }
    }
    trv.CommandSet = CommandSet;
    function command(execCallback) {
        var enabledState = true;
        var checkedState = false;
        var cmd = {
            enabled: function(state) {
                if (arguments.length == 0) {
                    return enabledState;
                }
                var newState = Boolean(state);
                enabledState = newState;
                $(this).trigger("enabledChanged");
                return cmd;
            },
            checked: function(state) {
                if (arguments.length == 0) {
                    return checkedState;
                }
                var newState = Boolean(state);
                checkedState = newState;
                $(this).trigger("checkedChanged");
                return cmd;
            },
            exec: execCallback
        };
        return cmd;
    }
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    var sr = trv.sr;
    if (!sr) {
        throw "Missing telerikReportViewer.sr";
    }
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReporting.utils";
    }
    var lastSelectedMenuItem, lastSelectedSubmenuItem;
    function MainMenu(dom, options, otherOptions) {
        options = $.extend({}, options, otherOptions);
        var menu = $(dom).data("kendoMenu"), childrenL1 = dom.childNodes, controller = options.controller, enableAccessibility = options.enableAccessibility, DEFAULT_TABINDEX = 1;
        if (!menu) {
            init();
        }
        controller.reportLoadComplete(function(e, args) {
            if (enableAccessibility) {} else {
                if (menu && menu._oldHoverItem) {
                    menu._oldHoverItem.toggleClass("k-state-focused");
                }
            }
        });
        function init() {
            menu = $(dom).kendoMenu().data("kendoMenu"), menu.bind("open", onSubmenuOpen);
            menu.bind("activate", onSubmenuActivate);
            menu.bind("deactivate", onSubmenuDeactivate);
            menu.element.off("keydown", onMenuKeyDown);
            menu.element.on("keydown", onMenuKeyDown);
            if (options.enableAccessibility) {
                setTabIndexes();
            }
        }
        function setTabIndexes() {
            var $menus = $.find('[data-role="telerik_ReportViewer_MainMenu"]');
            utils.each($menus, function() {
                var $menuArea = $(this);
                var listItems = $menuArea.find("li");
                var menuTabIndex = 0;
                var tabIndexAttr = $menuArea.attr("tabIndex");
                if (tabIndexAttr) {
                    menuTabIndex = utils.tryParseInt(tabIndexAttr);
                    if (!menuTabIndex || isNaN(menuTabIndex)) {
                        menuTabIndex = 0;
                    }
                }
                setMenuItemsTabIndexes(listItems, menuTabIndex);
                var pager = listItems.find('input[data-role="telerik_ReportViewer_PageNumberInput"]');
                if (pager.length > 0) {
                    pager.attr("tabindex", menuTabIndex);
                }
            });
        }
        function setMenuItemsTabIndexes(listItems, menuTabIndex) {
            utils.each(listItems, function() {
                var $item = $(this);
                $item.attr("tabindex", menuTabIndex);
                $item.focus(function() {
                    $item.addClass("k-state-focused");
                });
                $item.blur(function() {
                    $item.removeClass("k-state-focused");
                });
                var anchor = $item.children("a");
                if (anchor.length > 0) {
                    var $anchor = $(anchor);
                    $anchor.attr("tabindex", -1);
                    $item.attr("title", $anchor.attr("title"));
                }
                $item.off("keydown");
                $item.on("keydown", function(event) {
                    if (event.which == kendo.keys.ENTER) {
                        clickOnMenuItem($item);
                        lastSelectedMenuItem = $item;
                    }
                });
            });
        }
        function onSubmenuOpen(e) {
            var $item = $(e.item);
            if ($item.children("ul[data-command-list=export-format-list]").length > 0) {
                menu.unbind("open", onSubmenuOpen);
                menu.append({
                    text: sr.loadingFormats,
                    spriteCssClass: "k-icon k-loading"
                }, $item);
                controller.getDocumentFormats().then(fillFormats).then(function() {
                    menu.open($item);
                });
            }
        }
        function fillFormats(formats) {
            utils.each($(dom).find("ul[data-command-list=export-format-list]"), function() {
                var $list = $(this), $parent = $list.parents("li");
                menu.remove($list.children("li"));
                var tabIndex = enableAccessibility ? $parent.attr("tabindex") : -1;
                if (!tabIndex) {
                    tabIndex = 1;
                }
                utils.each(formats, function() {
                    var format = this;
                    var ariaLabel = enableAccessibility ? utils.stringFormat('aria-label="{localizedName}" ', format) : " ";
                    var li = "<li " + ariaLabel + utils.stringFormat('tabindex="' + tabIndex + '"><a tabindex="-1" href="#" data-command="telerik_ReportViewer_export" data-command-parameter="{name}"><span>{localizedName}</span></a></li>', format);
                    menu.append(li, $parent);
                });
                if (enableAccessibility) {
                    setInternalListAccessibilityKeyEvents($parent.find("li"));
                }
            });
        }
        function setInternalListAccessibilityKeyEvents(listItems) {
            utils.each(listItems, function() {
                var $item = $(this);
                $item.off("keydown");
                $item.on("keydown", function(event) {
                    switch (event.which) {
                      case kendo.keys.ENTER:
                        clickOnMenuItem($item);
                        break;

                      case kendo.keys.UP:
                        var $prev = $item.prev();
                        if ($prev.length > 0) {
                            $prev.focus();
                        } else {
                            $item.parents("li").focus();
                        }
                        break;

                      case kendo.keys.DOWN:
                        var $next = $item.next();
                        if ($next.length > 0) {
                            $next.focus();
                        } else {
                            $item.parent().children("li").first().focus();
                        }
                        break;
                    }
                });
            });
        }
        function clickOnMenuItem(item) {
            if (item && item.length > 0) {
                var anchor = item.children("a");
                if (anchor.length > 0) {
                    anchor.click();
                }
            }
        }
        function onSubmenuActivate(e) {
            var $item = $(e.item);
            focusOnFirstSubmenuItem($item);
        }
        function onSubmenuDeactivate(e) {
            lastSelectedSubmenuItem = undefined;
        }
        function focusOnFirstSubmenuItem(parentItem) {
            if (lastSelectedMenuItem && lastSelectedMenuItem.is(parentItem)) {
                window.setTimeout(function() {
                    var li = parentItem.find("li");
                    if (li.length > 0) {
                        li[0].focus();
                    }
                }, 100);
            }
        }
        function onMenuKeyDown(e) {
            switch (e.which) {
              case kendo.keys.ENTER:
                if (!enableAccessibility) {
                    var $item = getFocusedItem();
                    if ($item.length > 0) {
                        if (isItemExportContainer($item) && lastSelectedSubmenuItem) {
                            $item = lastSelectedSubmenuItem;
                        }
                        clickOnMenuItem($item);
                    }
                }
                break;

              case kendo.keys.RIGHT:
                enableAccessibility ? focusNextItemAccessibilitySelection() : focusNextItemNativeMenuSelection();
                break;

              case kendo.keys.LEFT:
                enableAccessibility ? focusPreviousItemAccessibilitySelection() : focusPreviousItemNativeMenuSelection();
                break;

              case kendo.keys.DOWN:
              case kendo.keys.UP:
                if (!enableAccessibility) {
                    lastSelectedSubmenuItem = getKendoFocusedNestedItem();
                }
            }
        }
        function getFocusedItem() {
            var $item;
            var focusedItem = document.activeElement;
            if (focusedItem && focusedItem.localName == "li") {
                var items = $(childrenL1).filter("li.k-item");
                for (var i = 0; i < items.length; i++) {
                    var listItem = items[i];
                    if (focusedItem === listItem) {
                        $item = $(listItem);
                        break;
                    }
                }
            } else {
                $item = menu.element.children("li.k-item.k-state-focused");
                if ($item.length == 0) {
                    $item = menu.element.children("li.k-item").first();
                }
            }
            return $item;
        }
        function focusNextItemAccessibilitySelection() {
            var $item = getFocusedItem();
            if (!$item || !$item.length > 0) {
                return;
            }
            var $next = $item.next();
            if (!$next.length > 0) {
                $next = $(childrenL1).filter("li.k-item").first();
            }
            $next.focus();
        }
        var lastKendoFocusedItem;
        function focusNextItemNativeMenuSelection() {
            var allItems = menu.element.children("li.k-item");
            var $focused = allItems.filter(".k-state-focused");
            if (kendo.version >= "2017.3.913") {
                lastKendoFocusedItem = $focused;
                return;
            }
            if ($focused.hasClass("k-state-disabled")) {
                if (!lastKendoFocusedItem || $focused.is(lastKendoFocusedItem)) {
                    var $next = $focused.next();
                    if (!$next.length > 0) {
                        $next = allItems.first();
                    }
                    $focused.toggleClass("k-state-focused");
                    $next.toggleClass("k-state-focused");
                    lastKendoFocusedItem = $next;
                    menu._oldHoverItem = $next;
                } else {
                    lastKendoFocusedItem = $focused;
                }
            } else {
                menu._oldHoverItem = $focused;
                lastKendoFocusedItem = $focused;
            }
        }
        function focusPreviousItemAccessibilitySelection() {
            var $item = getFocusedItem();
            if (!$item || !$item.length > 0) {
                return;
            }
            var $prev = $item.prev();
            if (!$prev.length > 0) {
                $prev = $(childrenL1).filter("li.k-item").last();
            }
            $prev.focus();
        }
        function focusPreviousItemNativeMenuSelection() {
            var $focused = menu.element.children("li.k-item.k-state-focused");
            lastKendoFocusedItem = $focused;
        }
        function getKendoFocusedNestedItem() {
            var $focused = menu.element.find('li.k-item.k-state-focused [data-command="telerik_ReportViewer_export"]');
            if ($focused.length == 1) {
                return $focused.parent("li");
            }
            return undefined;
        }
        function isItemExportContainer(item) {
            if (item.length == 0) {
                return;
            }
            var id = item.attr("id");
            return id == "main-menu-export-command" || id == "side-menu-export-command";
        }
    }
    var pluginName = "telerik_ReportViewer_MainMenu";
    $.fn[pluginName] = function(options, otherOptions) {
        return utils.each(this, function() {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new MainMenu(this, options, otherOptions));
            }
        });
    };
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    var sr = trv.sr;
    if (!sr) {
        throw "Missing telerikReportViewer.sr";
    }
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReporting.utils";
    }
    var loadingFormats, panelBar;
    function SideMenu(dom, options, otherOptions) {
        options = $.extend({}, options, otherOptions);
        var enableAccessibility = options.enableAccessibility, lastSelectedMenuItem, DEFAULT_TABINDEX = 3;
        var controller = options.controller;
        if (!controller) {
            throw "No controller (telerikReporting.ReportViewerController) has been specified.";
        }
        init(dom);
        function init(root) {
            var $root = $(root);
            panelBar = $root.children("ul").kendoPanelBar().data("kendoPanelBar");
            panelBar.bind("expand", onSubmenuOpen);
            panelBar.element.off("keydown", onPanelKeyDown);
            panelBar.element.on("keydown", onPanelKeyDown);
            setTabIndexes($root);
            enableCloseOnClick($root);
            $root.click(function(e) {
                if (e.target == root) {
                    $(options.controller).trigger(options.controller.Events.TOGGLE_SIDE_MENU);
                }
            });
        }
        $(controller).on(controller.Events.TOGGLE_SIDE_MENU, function() {
            setSideMenuVisibility();
            if (enableAccessibility) {
                panelBar.element.focus();
            }
        });
        function setSideMenuVisibility() {
            var $root = panelBar.element.parent();
            var hidden = $root.position().left < 0 || !$root.is(":visible");
            if (hidden) {
                $root.show();
            } else {
                window.setTimeout(function() {
                    $root.hide();
                }, 500);
            }
        }
        function onSubmenuOpen(e) {
            var $item = $(e.item);
            if ($item.children("ul[data-command-list=export-format-list]").length > 0) {
                panelBar.unbind("expand", onSubmenuOpen);
                panelBar.append({
                    text: sr.loadingFormats,
                    spriteCssClass: "k-icon k-loading"
                }, $item);
                options.controller.getDocumentFormats().then(fillFormats).then(function() {
                    panelBar.expand($item);
                });
            }
        }
        function fillFormats(formats) {
            utils.each($(dom).find("ul[data-command-list=export-format-list]"), function() {
                var $list = $(this), $parent = $list.parents("li");
                panelBar.remove($list.children("li"));
                var tabIndex = $parent.attr("tabindex");
                if (!tabIndex) {
                    tabIndex = DEFAULT_TABINDEX;
                }
                utils.each(formats, function(i) {
                    var format = this;
                    var ariaLabel = enableAccessibility ? utils.stringFormat('aria-label="{localizedName}" ', format) : " ";
                    var li = "<li " + ariaLabel + utils.stringFormat('tabindex="' + tabIndex + '"><a tabindex="-1" href="#" data-command="telerik_ReportViewer_export" data-command-parameter="{name}"><span>{localizedName}</span></a></li>', format);
                    panelBar.append(li, $parent);
                });
                setListItemsTabIndex($parent.find("li"), tabIndex);
                enableCloseOnClick($parent);
            });
        }
        function focusOnFirstSubmenuItem(parentItem) {
            if (lastSelectedMenuItem && lastSelectedMenuItem.is(parentItem)) {
                window.setTimeout(function() {
                    var li = parentItem.find("li");
                    if (li.length > 0) {
                        li[0].focus();
                    }
                }, 100);
            }
        }
        function enableCloseOnClick(root) {
            utils.each(root.find("li"), function() {
                var isLeaf = $(this).children("ul").length == 0;
                if (isLeaf) {
                    $(this).children("a").click(function() {
                        $(options.controller).trigger(options.controller.Events.TOGGLE_SIDE_MENU);
                    });
                }
            });
        }
        function setTabIndexes(root) {
            if (!root) {
                return;
            }
            var $list = root.children("ul");
            var parentTabIndex = root.attr("tabindex");
            var listIndex = parentTabIndex ? parentTabIndex : DEFAULT_TABINDEX;
            setListItemsTabIndex($list, listIndex);
        }
        function setListItemsTabIndex(list, tabIndex) {
            list.attr("tabindex", tabIndex);
            var items = list.find("li");
            utils.each(items, function() {
                var $item = $(this);
                $item.attr("tabindex", tabIndex);
                var anchor = $item.children("a");
                if (anchor.length > 0) {
                    var $anchor = $(anchor);
                    $anchor.attr("tabindex", -1);
                }
                $item.focus(function() {
                    var anchor = $item.children("a");
                    if (anchor.length > 0) {
                        anchor.addClass("k-state-focused");
                    }
                });
                $item.blur(function() {
                    var anchor = $item.children("a");
                    if (anchor.length > 0) {
                        anchor.removeClass("k-state-focused");
                    }
                });
                $item.off("keydown", onItemKeyDown);
                $item.on("keydown", onItemKeyDown);
            });
        }
        function onPanelKeyDown(e) {
            if (e.which == kendo.keys.ENTER) {
                var $item;
                var isSelectedFocusedItem = false;
                var focusedItem = document.activeElement;
                if (focusedItem && focusedItem.localName == "li") {
                    var items = panelBar.element.find("li.k-item");
                    for (var i = 0; i < items.length; i++) {
                        var listItem = items[i];
                        if (focusedItem === listItem) {
                            $item = $(listItem);
                            isSelectedFocusedItem = true;
                            break;
                        }
                    }
                } else {
                    $item = panelBar.select();
                }
                if (!$item || !$item.length > 0) {
                    return;
                }
                handleItemSelect($item, isSelectedFocusedItem);
            }
        }
        function onItemKeyDown(e) {
            if (e.which == kendo.keys.ENTER) {
                handleItemSelect($(e.target), false);
            }
        }
        function handleItemSelect(item, handleExpandCollapse) {
            if (!item.length > 0) {
                return;
            }
            lastSelectedMenuItem = item;
            var isLeaf = item.children("ul").length == 0;
            if (!isLeaf) {
                if (handleExpandCollapse) {
                    if (item.hasClass("k-state-active")) {
                        panelBar.collapse(item);
                    } else {
                        panelBar.expand(item);
                    }
                }
            } else {
                var $anchor = item.find("a");
                if ($anchor.length > 0) {
                    $anchor[0].click();
                }
            }
        }
    }
    var pluginName = "telerik_ReportViewer_SideMenu";
    $.fn[pluginName] = function(options, otherOptions) {
        return utils.each(this, function() {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new SideMenu(this, options, otherOptions));
            }
        });
    };
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReportViewer.utils";
    }
    trv.binder = {
        bind: function($element) {
            var args = Array.prototype.slice.call(arguments, 1);
            attachCommands($element, args);
            var result = utils.selector('[data-role^="telerik_ReportViewer_"]');
            utils.each(result, function() {
                var $this = $(this), f = $.fn[$this.attr("data-role")];
                if (typeof f === "function") {
                    f.apply($this, args);
                }
            });
        }
    };
    function attachCommands($element, args) {
        var commands = args[0].commands, viewerOptions = args[1], elementSelector = '[data-command^="telerik_ReportViewer_"]', customElementSelector = "[data-target-report-viewer]" + elementSelector;
        $element.on("click", elementSelector, commandHandler);
        if (!trv.GlobalSettings.CommandHandlerAttached) {
            $(document.body).on("click", customElementSelector, customCommandHandler);
            trv.GlobalSettings.CommandHandlerAttached = true;
        }
        utils.each(commands, function(key, command) {
            attachCommand(key, command, viewerOptions, $element);
        });
        function commandHandler(e) {
            var prefixedDataCommand = $(this).attr("data-command");
            if (prefixedDataCommand) {
                var dataCommand = prefixedDataCommand.substring("telerik_ReportViewer_".length), cmd = commands[dataCommand];
                if (cmd.enabled()) {
                    cmd.exec($(this).attr("data-command-parameter"));
                }
                e.preventDefault();
            }
        }
        function customCommandHandler(e) {
            var $this = $(this), prefixedDataCommand = $this.attr("data-command"), reportViewerTarget = $this.attr("data-target-report-viewer");
            if (prefixedDataCommand && reportViewerTarget) {
                var dataCommand = prefixedDataCommand.substring("telerik_ReportViewer_".length), reportViewer = $(reportViewerTarget).data("telerik_ReportViewer"), cmd = reportViewer.commands[dataCommand];
                if (cmd.enabled()) {
                    cmd.exec($(this).attr("data-command-parameter"));
                }
                e.preventDefault();
            }
        }
    }
    function attachCommand(dataCommand, cmd, viewerOptions, $element) {
        if (cmd) {
            var elementSelector = '[data-command="telerik_ReportViewer_' + dataCommand + '"]', customElementSelector = '[data-target-report-viewer="' + viewerOptions.selector + '"]' + elementSelector, $defaultElement = $element.find(elementSelector), $customElement = $(customElementSelector);
            $(cmd).on("enabledChanged", function(e) {
                (cmd.enabled() ? $.fn.removeClass : $.fn.addClass).call($defaultElement.parent("li"), "k-state-disabled");
                (cmd.enabled() ? $.fn.removeClass : $.fn.addClass).call($customElement, viewerOptions.disabledButtonClass);
            }).on("checkedChanged", function(e) {
                (cmd.checked() ? $.fn.addClass : $.fn.removeClass).call($defaultElement.parent("li"), "k-state-selected");
                (cmd.checked() ? $.fn.addClass : $.fn.removeClass).call($customElement, viewerOptions.checkedButtonClass);
            });
        }
    }
    function LinkButton(dom, options) {
        var cmd, $element = $(dom), dataCommand = $element.attr("data-command");
        if (dataCommand) {
            cmd = options.commands[dataCommand];
        }
        if (cmd) {
            $element.click(function(e) {
                if (cmd.enabled()) {
                    cmd.exec($(this).attr("data-command-parameter"));
                } else {
                    e.preventDefault();
                }
            });
            $(cmd).on("enabledChanged", function(e) {
                (cmd.enabled() ? $.fn.removeClass : $.fn.addClass).call($element, "disabled");
            }).on("checkedChanged", function(e) {
                (cmd.checked() ? $.fn.addClass : $.fn.removeClass).call($element, "checked");
            });
        }
    }
    var linkButton_pluginName = "telerik_ReportViewer_LinkButton";
    $.fn[linkButton_pluginName] = function(options) {
        return utils.each(this, function() {
            if (!$.data(this, linkButton_pluginName)) {
                $.data(this, linkButton_pluginName, new LinkButton(this, options));
            }
        });
    };
    function PageNumberInput(dom, options) {
        var $element = $(dom), cmd = options.commands["goToPage"];
        function setPageNumber(value) {
            $element.val(value);
        }
        options.controller.pageNumberChange(function(e, value) {
            setPageNumber(value);
        });
        $element.change(function() {
            var val = $(this).val();
            var num = utils.tryParseInt(val);
            if (num != NaN) {
                var result = cmd.exec(num);
                setPageNumber(result);
            }
        });
        $element.keydown(function(e) {
            if (e.which == 13) {
                $(this).change();
                return e.preventDefault();
            }
        });
        function validateValue(value) {
            return /^([0-9]+)$/.test(value);
        }
        $element.keypress(function(event) {
            if (utils.isSpecialKey(event.keyCode)) {
                return true;
            }
            var newValue = $element.val() + String.fromCharCode(event.charCode);
            return validateValue(newValue);
        }).on("paste", function(event) {});
    }
    var pageNumberInput_pluginName = "telerik_ReportViewer_PageNumberInput";
    $.fn[pageNumberInput_pluginName] = function(options) {
        return utils.each(this, function() {
            if (!$.data(this, pageNumberInput_pluginName)) {
                $.data(this, pageNumberInput_pluginName, new PageNumberInput(this, options));
            }
        });
    };
    function PageCountLabel(dom, options) {
        var $element = $(dom);
        options.controller.pageCountChange(function(e, value) {
            $element.html(value);
        });
    }
    var pageCountLabel_pluginName = "telerik_ReportViewer_PageCountLabel";
    $.fn[pageCountLabel_pluginName] = function(options) {
        return utils.each(this, function() {
            if (!$.data(this, pageCountLabel_pluginName)) {
                $.data(this, pageCountLabel_pluginName, new PageCountLabel(this, options));
            }
        });
    };
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, window, document, undefined) {
    "use strict";
    trv.PerspectiveManager = function(dom, controller) {
        var smallMenu = dom.querySelectorAll ? dom.querySelectorAll(".trv-menu-small")[0] : false, perspectives = {
            small: {
                documentMapVisible: false,
                parametersAreaVisible: false,
                onDocumentMapVisibleChanged: function(e, args) {
                    if (args.visible) {
                        controller.setParametersAreaVisible({
                            visible: false
                        });
                    }
                },
                onParameterAreaVisibleChanged: function(e, args) {
                    if (args.visible) {
                        controller.setDocumentMapVisible({
                            visible: false
                        });
                    }
                },
                onBeforeLoadReport: function() {
                    controller.setParametersAreaVisible({
                        visible: false
                    });
                    controller.setDocumentMapVisible({
                        visible: false
                    });
                },
                onNavigateToPage: function() {
                    controller.setParametersAreaVisible({
                        visible: false
                    });
                    controller.setDocumentMapVisible({
                        visible: false
                    });
                }
            },
            large: {
                documentMapVisible: true,
                parametersAreaVisible: true
            }
        }, currentPerspective;
        function init() {
            currentPerspective = getPerspective();
            initStateFromController(perspectives["large"]);
        }
        function setPerspective(beforeApplyState) {
            var perspective = getPerspective();
            if (perspective !== currentPerspective) {
                var oldState = perspectives[currentPerspective];
                var newState = perspectives[perspective];
                currentPerspective = perspective;
                if (beforeApplyState) {
                    beforeApplyState.call(undefined, oldState, newState);
                }
                applyState(newState);
            }
        }
        function onDocumentMapVisibleChanged(e, args) {
            dispatch("onDocumentMapVisibleChanged", arguments);
        }
        function onParameterAreaVisibleChanged(e, args) {
            dispatch("onParameterAreaVisibleChanged", arguments);
        }
        function onBeforeLoadReport() {
            dispatch("onBeforeLoadReport", arguments);
        }
        function onNavigateToPage() {
            dispatch("onNavigateToPage", arguments);
        }
        function onReportLoadComplete() {
            dispatch("onReportLoadComplete", arguments);
        }
        function onWindowResize() {
            setPerspective(function(oldState, newState) {
                initStateFromController(oldState);
            });
        }
        function onCssLoaded() {
            setPerspective(null);
        }
        function dispatch(func, args) {
            var activePerspective = perspectives[currentPerspective];
            var handler = activePerspective[func];
            if (typeof handler === "function") {
                handler.apply(activePerspective, args);
            }
        }
        function attach() {
            window.addEventListener("resize", onWindowResize);
            controller.setDocumentMapVisible(onDocumentMapVisibleChanged);
            controller.setParametersAreaVisible(onParameterAreaVisibleChanged);
            controller.beforeLoadReport(onBeforeLoadReport);
            controller.navigateToPage(onNavigateToPage);
            controller.reportLoadComplete(onReportLoadComplete);
            controller.cssLoaded(onCssLoaded);
        }
        function getPerspective() {
            return smallMenu && getComputedStyle(smallMenu)["display"] != "none" ? "small" : "large";
        }
        function initStateFromController(state) {
            state.documentMapVisible = documentMapVisible();
            state.parametersAreaVisible = parametersAreaVisible();
        }
        function applyState(state) {
            documentMapVisible(state.documentMapVisible);
            parametersAreaVisible(state.parametersAreaVisible);
        }
        function documentMapVisible() {
            if (arguments.length == 0) {
                var args1 = {};
                controller.getDocumentMapState(args1);
                return args1.visible;
            }
            controller.setDocumentMapVisible({
                visible: Boolean(arguments[0])
            });
            return this;
        }
        function parametersAreaVisible() {
            if (arguments.length == 0) {
                var args1 = {};
                controller.getParametersAreaState(args1);
                return args1.visible;
            }
            controller.setParametersAreaVisible({
                visible: Boolean(arguments[0])
            });
            return this;
        }
        init();
        return {
            attach: attach
        };
    };
})(window.telerikReportViewer = window.telerikReportViewer || {}, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    var sr = trv.sr;
    if (!sr) {
        throw "Missing telerikReportViewer.sr";
    }
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReportViewer.utils";
    }
    var defaultOptions = {};
    function accessibility(options) {
        var controller, pageInitialized = false, areas, lastArea, keyMap = {
            CONFIRM_KEY: 13,
            CONTENT_AREA_KEY: 67,
            DOCUMENT_MAP_AREA_KEY: 68,
            MENU_AREA_KEY: 77,
            PARAMETERS_AREA_KEY: 80
        };
        options = $.extend({}, defaultOptions, options);
        controller = options.controller;
        if (!controller) {
            throw "No controller (telerikReporting.ReportViewerController) has been specified.";
        }
        controller.reportLoadComplete(onReportLoadComplete).pageReady(function(event, page) {
            initPage(page);
            pageInitialized = true;
        }).error(function(e, message) {
            focusOnErrorMessage();
            window.setTimeout(setAccessibilityUI, 500);
        }).updateUI(function(e) {
            if (pageInitialized) {
                setPageSelector();
                decorateMenuItems();
            }
        });
        function onReportLoadComplete(e, args) {
            setAccessibilityUI();
            var content = findContentArea();
            if (content.length > 0) {
                content.focus();
            }
        }
        function setAccessibilityUI() {
            if (!areas) {
                initAreas();
                $(document.body).off("keydown", processKeyDown);
                $(document.body).on("keydown", processKeyDown);
            }
        }
        function focusOnErrorMessage() {
            var selectorChain = [ "div.trv-pages-area", "div.trv-error-message" ];
            var $errMsg = findElement(selectorChain);
            if ($errMsg.length == 0) {
                return;
            }
            $errMsg.attr("tabIndex", 0);
            $errMsg.focus();
        }
        function initPage(page) {
            if (!page) {
                return;
            }
            setAccessibilityUI();
            var area = areas[keyMap.CONTENT_AREA_KEY];
            setContentAreaKeyDown(area);
        }
        function setPageSelector() {
            var $pagers = $(".trv-report-pager");
            if ($pagers.length > 0) {
                var pageNumber = controller.currentPageNumber();
                var pageCount = controller.pageCount();
                utils.each($pagers, function() {
                    var $pager = $(this);
                    $pager.attr("aria-label", utils.stringFormat(sr.ariaLabelPageNumberSelector, [ pageNumber, pageCount ]));
                    var $pageInputs = $pager.find("input[data-role=telerik_ReportViewer_PageNumberInput]");
                    if ($pageInputs.length > 0) {
                        utils.each($pageInputs, function() {
                            var $this = $(this);
                            $this.attr("aria-label", sr.ariaLabelPageNumberEditor);
                            $this.attr("min", "1");
                            $this.attr("max", "" + pageCount);
                        });
                    }
                });
            }
        }
        function initAreas() {
            areas = {};
            areas[keyMap.DOCUMENT_MAP_AREA_KEY] = findDocumentMapArea();
            areas[keyMap.MENU_AREA_KEY] = findMenuArea();
            areas[keyMap.CONTENT_AREA_KEY] = findContentArea();
            var parametersArea = findParametersArea();
            if (parametersArea) {
                areas[keyMap.PARAMETERS_AREA_KEY] = parametersArea;
                setParameterEditorsKeyDown(parametersArea);
            }
        }
        function findContentArea() {
            return findElement([ "div[data-role=telerik_ReportViewer_PagesArea]" ]);
        }
        function findDocumentMapArea() {
            return findElement([ "div[data-role=telerik_ReportViewer_DocumentMapArea]", "div[data-role=treeview]" ]);
        }
        function findMenuArea() {
            return findElement("ul[data-role=telerik_ReportViewer_MainMenu]");
        }
        function findParametersArea() {
            return findElement([ "div[data-role=telerik_ReportViewer_ParametersArea]", "div.trv-parameters-area-content" ]);
        }
        function findElement(selectorChain) {
            if (selectorChain.constructor != Array) {
                selectorChain = [ selectorChain ];
            }
            var $area = $(selectorChain[0]);
            for (var i = 1; i < selectorChain.length; i++) {
                $area = $area.find(selectorChain[i]);
            }
            return $area;
        }
        function processKeyDown(event) {
            if (!areas) {
                return;
            }
            if (!(event.altKey && event.ctrlKey)) {
                return;
            }
            var currentArea = areas[event.which];
            if (!currentArea) {
                return;
            }
            if (!IsAreaContainerVisible(currentArea.parent())) {
                return;
            }
            var className = "k-state-focused";
            if (lastArea) {
                lastArea.removeClass(className);
            }
            currentArea.addClass(className);
            currentArea.focus();
            lastArea = currentArea;
            event.preventDefault();
        }
        function setParameterEditorsKeyDown(parametersAreaContent) {
            if (parametersAreaContent.length == 0) {
                return;
            }
            var $paramsArea = parametersAreaContent.parent("div[data-role=telerik_ReportViewer_ParametersArea]");
            if (!IsAreaContainerVisible($paramsArea)) {
                return;
            }
            utils.each(parametersAreaContent.children(), function() {
                $(this).keydown(function(event) {
                    if (event.which == keyMap.CONFIRM_KEY) {
                        var paramsButton = $paramsArea.find("button.trv-parameters-area-preview-button");
                        paramsButton.focus();
                        event.preventDefault();
                    }
                });
            });
        }
        function IsAreaContainerVisible(container) {
            return container && !container.hasClass("hidden");
        }
        function setContentAreaKeyDown(contentArea) {
            if (!contentArea) {
                return;
            }
            var actions = contentArea.find("div [data-reporting-action]");
            if (!actions.length > 0) {
                return;
            }
            utils.each(actions, function() {
                var $action = $(this);
                $action.keydown(function(event) {
                    if (event.which == keyMap.CONFIRM_KEY) {
                        $action.click();
                    }
                });
            });
        }
        function decorateMenuItems() {
            var menuAreas = areas[keyMap.MENU_AREA_KEY];
            if (!menuAreas) {
                return;
            }
            utils.each(menuAreas, function() {
                var $menu = $(this);
                var menuItems = $menu.children("li.k-item");
                utils.each(menuItems, function() {
                    var $menuItem = $(this);
                    if (!$menuItem.hasClass("trv-report-pager")) {
                        var expandable = $menuItem.find("ul").length > 0 ? utils.stringFormat(". {0}", [ sr.ariaLabelExpandable ]) : "";
                        var selected = $menuItem.hasClass("k-state-selected") ? ". Selected" : "";
                        var label = $menuItem.attr("title") + expandable + selected;
                        $menuItem.attr("aria-label", label);
                        if ($menuItem.hasClass("k-state-disabled")) {
                            $menuItem.attr("aria-disabled", "true");
                        } else {
                            $menuItem.removeAttr("aria-disabled");
                        }
                    }
                });
            });
        }
        function setKeyMap(keyMapValues) {
            keyMap = keyMapValues;
            areas = undefined;
            setAccessibilityUI();
        }
        function getKeyMap() {
            return keyMap;
        }
        return {
            getKeyMap: getKeyMap,
            setKeyMap: setKeyMap
        };
    }
    trv.accessibility = accessibility;
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

(function(trv, $, window, document, undefined) {
    "use strict";
    if (!$) {
        alert("jQuery is not loaded. Make sure that jQuery is included.");
    }
    if (!trv.GlobalSettings) {
        trv.GlobalSettings = {};
    }
    var utils = trv.utils;
    if (!utils) {
        throw "Missing telerikReportViewer.utils";
    }
    var sr = trv.sr;
    if (!sr) {
        throw "Missing telerikReportViewer.sr";
    }
    if (!trv.ServiceClient) {
        throw "Missing telerikReportViewer.ServiceClient";
    }
    if (!trv.ReportViewerController) {
        throw "Missing telerikReportViewer.ReportViewerController";
    }
    if (!trv.HistoryManager) {
        throw "Missing telerikReportViewer.HistoryManager";
    }
    var binder = trv.binder;
    if (!binder) {
        throw "Missing telerikReportViewer.Binder";
    }
    if (!trv.CommandSet) {
        throw "Missing telerikReportViewer.commandSet";
    }
    if (!trv.uiController) {
        throw "Missing telerikReportViewer.uiController";
    }
    trv.Events = {
        EXPORT_BEGIN: "EXPORT_BEGIN",
        EXPORT_END: "EXPORT_END",
        PRINT_BEGIN: "PRINT_BEGIN",
        PRINT_END: "PRINT_END",
        RENDERING_BEGIN: "RENDERING_BEGIN",
        RENDERING_END: "RENDERING_END",
        PAGE_READY: "PAGE_READY",
        ERROR: "ERROR",
        UPDATE_UI: "UPDATE_UI",
        INTERACTIVE_ACTION_EXECUTING: "INTERACTIVE_ACTION_EXECUTING",
        INTERACTIVE_ACTION_ENTER: "INTERACTIVE_ACTION_ENTER",
        INTERACTIVE_ACTION_LEAVE: "INTERACTIVE_ACTION_LEAVE",
        VIEWER_TOOLTIP_OPENING: "VIEWER_TOOLTIP_OPENING"
    };
    var templateCache = function() {
        var cache = {};
        return {
            load: function(url, serviceUrl, client) {
                var p = cache[url];
                if (!p) {
                    cache[url] = p = client.get(url).then(function(html) {
                        var templates = {};
                        var styleSheets = [];
                        var scripts = [];
                        var baseUri = utils.rtrim(serviceUrl, "\\/") + "/";
                        html = utils.replaceAll(html, "{service}/", baseUri);
                        html = utils.replaceAll(html, "{service}", baseUri);
                        var viewerTemplate = $("<div></div>").html(html);
                        utils.each(viewerTemplate.find("template"), function(index, e) {
                            var $e = $(e);
                            templates[$e.attr("id")] = utils.trim($e.html(), "\n 	");
                        });
                        utils.each(viewerTemplate.find("link"), function(index, e) {
                            styleSheets.push(utils.trim(e.outerHTML, "\n 	"));
                        });
                        styleSheets = utils.filterUniqueLastOccurance(styleSheets);
                        utils.each(viewerTemplate.find("script"), function(index, e) {
                            scripts.push(utils.trim(e.innerHTML, "\n 	"));
                        });
                        return {
                            templates: templates,
                            styleSheets: styleSheets,
                            scripts: scripts
                        };
                    });
                }
                return p;
            }
        };
    }();
    function MemStorage() {
        var data = {};
        return {
            getItem: function(key) {
                return data[key];
            },
            setItem: function(key, value) {
                data[key] = value;
            },
            removeItem: function(key) {
                delete data[key];
            }
        };
    }
    function ReportViewerSettings(id, storage, defaultSettings) {
        var _this = {};
        function getItem(key) {
            var value = storage.getItem(formatKey(key));
            return value != null ? value : defaultSettings[key];
        }
        function stateItem(prop, args) {
            var stateKey = "state";
            var value = getItem(stateKey);
            var currentState = typeof value == "string" ? JSON.parse(value) : {};
            if (args.length) {
                if (currentState) {
                    currentState[prop] = args[0];
                }
                setItem(stateKey, JSON.stringify(currentState));
                return _this;
            } else {
                return currentState[prop];
            }
        }
        function setItem(key, value) {
            var formattedKey = formatKey(key);
            storage.setItem(formattedKey, value);
            if (storage instanceof window.Storage) {
                var oldValue = storage.getItem(formattedKey);
                var storageEvent = document.createEvent("StorageEvent");
                storageEvent.initStorageEvent("telerikReportingStorage", false, false, formattedKey, oldValue, value, null, storage);
                window.dispatchEvent(storageEvent);
            }
        }
        function formatKey(key) {
            return id + "_" + key;
        }
        function value(key, args) {
            if (args.length) {
                setItem(key, args[0]);
                return _this;
            } else {
                return getItem(key);
            }
        }
        function valueFloat(key, args) {
            if (args.length) {
                setItem(key, args[0]);
                return _this;
            } else {
                return parseFloat(getItem(key));
            }
        }
        function valueObject(key, args) {
            if (args.length) {
                setItem(key, JSON.stringify(args[0]));
                return _this;
            } else {
                var value = getItem(key);
                return typeof value == "string" ? JSON.parse(value) : null;
            }
        }
        utils.extend(_this, {
            viewMode: function() {
                return stateItem("viewMode", arguments);
            },
            printMode: function() {
                return stateItem("printMode", arguments);
            },
            scale: function() {
                return stateItem("scale", arguments);
            },
            scaleMode: function() {
                return stateItem("scaleMode", arguments);
            },
            documentMapVisible: function() {
                return stateItem("documentMapVisible", arguments);
            },
            parametersAreaVisible: function() {
                return stateItem("parametersAreaVisible", arguments);
            },
            history: function() {
                return valueObject("history", arguments);
            },
            clientId: function() {
                return value("clientId", arguments);
            },
            reportSource: function() {
                return stateItem("reportSource", arguments);
            },
            pageNumber: function() {
                return stateItem("pageNumber", arguments);
            },
            enableAccessibility: function() {
                return value("enableAccessibility", arguments);
            }
        });
        return _this;
    }
    function getDefaultOptions(serviceUrl) {
        return {
            id: null,
            serviceUrl: null,
            templateUrl: utils.rtrim(serviceUrl, "\\/") + "/resources/templates/telerikReportViewerTemplate-html",
            reportSource: null,
            reportServer: null,
            authenticationToken: null,
            scale: 1,
            scaleMode: trv.ScaleModes.FIT_PAGE,
            viewMode: trv.ViewModes.INTERACTIVE,
            persistSession: false,
            parameterEditors: [],
            disabledButtonClass: null,
            checkedButtonClass: null,
            parametersAreaVisible: true,
            documentMapVisible: true,
            enableAccessibility: false
        };
    }
    function ReportViewer(dom, options) {
        if (!window.kendo) {
            alert("Kendo is not loaded. Make sure that Kendo is included.");
        }
        var $placeholder = $(dom), templates = {}, scripts = {}, persistanceKey = options.id || "#" + $placeholder.attr("id"), accessibility;
        if (!validateOptions(options)) {
            return;
        }
        var svcApiUrl = options.serviceUrl;
        if (options.reportServer) {
            var reportServerUrl = utils.rtrim(options.reportServer.url, "\\/");
            svcApiUrl = reportServerUrl + "/api/reports";
        }
        options = utils.extend({}, getDefaultOptions(svcApiUrl), options);
        var settings = new ReportViewerSettings(persistanceKey, options.persistSession ? window.sessionStorage : new MemStorage(), {
            scale: options.scale,
            scaleMode: options.scaleMode,
            printMode: options.printMode ? options.printMode : options.directPrint,
            enableAccessibility: options.enableAccessibility
        });
        var serviceClientOptions = {};
        if (options.reportServer) {
            var reportServerUrl = utils.rtrim(options.reportServer.url, "\\/");
            serviceClientOptions.serviceUrl = reportServerUrl + "/api/reports";
            serviceClientOptions.loginInfo = {
                url: reportServerUrl + "/Token",
                username: options.reportServer.username,
                password: options.reportServer.password
            };
        } else {
            serviceClientOptions.serviceUrl = options.serviceUrl;
        }
        var client = new trv.ServiceClient(serviceClientOptions);
        var controller = options.controller;
        if (!controller) {
            controller = new trv.ReportViewerController({
                serviceClient: client,
                settings: settings
            });
            if (options.authenticationToken) {
                controller.setAuthenticationToken(options.authenticationToken);
            }
        }
        var history = new trv.HistoryManager({
            controller: controller,
            settings: settings
        });
        var commands = new trv.CommandSet({
            controller: controller,
            history: history
        });
        new trv.uiController({
            controller: controller,
            history: history,
            commands: commands
        });
        var viewer = {
            refreshReport: function(ignoreCache) {
                if (arguments.length === 0) {
                    ignoreCache = true;
                }
                controller.refreshReport(ignoreCache);
                return viewer;
            },
            reportSource: function(rs) {
                if (rs || rs === null) {
                    controller.reportSource(rs);
                    controller.refreshReport(false);
                    return viewer;
                }
                return controller.reportSource();
            },
            viewMode: function(vm) {
                if (vm) {
                    controller.viewMode(vm);
                    return viewer;
                }
                return controller.viewMode();
            },
            printMode: function(pm) {
                if (pm) {
                    controller.printMode(pm);
                    return viewer;
                }
                return controller.printMode();
            },
            scale: function(scale) {
                if (scale) {
                    controller.scale(scale);
                    return viewer;
                }
                scale = {};
                controller.getScale(scale);
                return scale;
            },
            currentPage: function() {
                return controller.currentPageNumber();
            },
            pageCount: function() {
                return controller.pageCount();
            },
            authenticationToken: function(token) {
                if (token) {
                    controller.setAuthenticationToken(token);
                }
                return viewer;
            },
            bind: function(eventName, eventHandler) {
                eventBinder(eventName, eventHandler, true);
            },
            unbind: function(eventName, eventHandler) {
                eventBinder(eventName, eventHandler, false);
            },
            accessibilityKeyMap: function(keyMap) {
                if (accessibility) {
                    if (keyMap) {
                        accessibility.setKeyMap(keyMap);
                        return viewer;
                    }
                    return accessibility.getKeyMap();
                }
                return undefined;
            },
            commands: commands
        };
        function validateOptions(options) {
            if (!options) {
                $placeholder.html("The report viewer configuration options are not initialized.");
                return false;
            }
            if (options.reportServer) {
                if (!options.reportServer.url) {
                    $placeholder.html("The report server URL is not specified.");
                    return false;
                }
            } else {
                if (!options.serviceUrl) {
                    $placeholder.html("The serviceUrl is not specified.");
                    return false;
                }
            }
            return true;
        }
        function eventBinder(eventName, eventHandler, bind) {
            if (typeof eventHandler == "function") {
                if (bind) {
                    $(viewer).on(eventName, {
                        sender: viewer
                    }, eventHandler);
                } else {
                    $(viewer).off(eventName, eventHandler);
                }
            } else if (!eventHandler && !bind) {
                $(viewer).off(eventName);
            }
        }
        function attachEvents() {
            var viewerEventsMapping = {
                EXPORT_BEGIN: controller.Events.EXPORT_STARTED,
                EXPORT_END: controller.Events.EXPORT_DOCUMENT_READY,
                PRINT_BEGIN: controller.Events.PRINT_STARTED,
                PRINT_END: controller.Events.PRINT_DOCUMENT_READY,
                RENDERING_BEGIN: controller.Events.BEFORE_LOAD_REPORT,
                RENDERING_END: controller.Events.REPORT_LOAD_COMPLETE,
                PAGE_READY: controller.Events.PAGE_READY,
                ERROR: controller.Events.ERROR,
                UPDATE_UI: controller.Events.UPDATE_UI,
                INTERACTIVE_ACTION_EXECUTING: controller.Events.INTERACTIVE_ACTION_EXECUTING,
                INTERACTIVE_ACTION_ENTER: controller.Events.INTERACTIVE_ACTION_ENTER,
                INTERACTIVE_ACTION_LEAVE: controller.Events.INTERACTIVE_ACTION_LEAVE,
                VIEWER_TOOLTIP_OPENING: controller.Events.TOOLTIP_OPENING
            }, $viewer = $(viewer);
            for (var eventName in viewerEventsMapping) {
                var controllerEventName = viewerEventsMapping[eventName];
                controller.on(controllerEventName, function($viewer, eventName) {
                    return function(e, args) {
                        $viewer.trigger({
                            type: eventName,
                            data: e.data
                        }, args);
                    };
                }($viewer, eventName));
            }
        }
        function attachEventHandlers() {
            eventBinder(trv.Events.EXPORT_BEGIN, options.exportBegin, true);
            eventBinder(trv.Events.EXPORT_END, options.exportEnd, true);
            eventBinder(trv.Events.PRINT_BEGIN, options.printBegin, true);
            eventBinder(trv.Events.PRINT_END, options.printEnd, true);
            eventBinder(trv.Events.RENDERING_BEGIN, options.renderingBegin, true);
            eventBinder(trv.Events.RENDERING_END, options.renderingEnd, true);
            eventBinder(trv.Events.PAGE_READY, options.pageReady, true);
            eventBinder(trv.Events.ERROR, options.error, true);
            eventBinder(trv.Events.UPDATE_UI, options.updateUi, true);
            eventBinder(trv.Events.INTERACTIVE_ACTION_EXECUTING, options.interactiveActionExecuting, true);
            eventBinder(trv.Events.INTERACTIVE_ACTION_ENTER, options.interactiveActionEnter, true);
            eventBinder(trv.Events.INTERACTIVE_ACTION_LEAVE, options.interactiveActionLeave, true);
            eventBinder(trv.Events.VIEWER_TOOLTIP_OPENING, options.viewerToolTipOpening, true);
            $(controller).on(controller.Events.TOGGLE_SIDE_MENU, function() {
                window.setTimeout(function() {
                    $placeholder.toggleClass("trv-side-menu-visible");
                }, 1);
            });
        }
        function init() {
            $placeholder.html(templates["trv-report-viewer"]);
            binder.bind($placeholder, {
                controller: controller,
                commands: commands,
                templates: templates
            }, options);
            new trv.PerspectiveManager(dom, controller).attach();
            attachEvents();
            attachEventHandlers();
            initFromStorage();
            initAccessibility(options);
        }
        function initFromStorage() {
            var vm = settings.viewMode();
            var pm = settings.printMode();
            var s = settings.scale();
            var sm = settings.scaleMode();
            var dm = settings.documentMapVisible();
            var pa = settings.parametersAreaVisible();
            controller.viewMode(vm ? vm : options.viewMode);
            controller.printMode(pm ? pm : options.printMode);
            controller.scale({
                scale: s ? s : options.scale,
                scaleMode: sm ? sm : options.scaleMode
            });
            controller.setDocumentMapVisible({
                visible: dm ? dm : options.documentMapVisible
            });
            controller.setParametersAreaVisible({
                visible: pa ? pa : options.parametersAreaVisible
            });
            controller.printModeChanged(function() {
                settings.printMode(controller.printMode());
            });
            controller.viewModeChanged(function() {
                settings.viewMode(controller.viewMode());
            });
            controller.scale(function() {
                var args = {};
                controller.getScale(args);
                settings.scale(args.scale);
                settings.scaleMode(args.scaleMode);
            });
            controller.setDocumentMapVisible(function() {
                var args = {};
                controller.getDocumentMapState(args);
                settings.documentMapVisible(args.visible);
            });
            controller.setParametersAreaVisible(function() {
                var args = {};
                controller.getParametersAreaState(args);
                settings.parametersAreaVisible(args.visible);
            });
        }
        function initAccessibility(options) {
            if (options.enableAccessibility) {
                accessibility = new trv.accessibility({
                    controller: controller,
                    templates: templates
                });
                settings.contentTabIndex = getTemplateContentTabIndex();
            }
        }
        function getTemplateContentTabIndex() {
            var pageAreaSelector = "div.trv-pages-area";
            try {
                var pagesArea$ = $placeholder.find(pageAreaSelector);
                if (pagesArea$.length == 0) {
                    throw "Selector " + pageAreaSelector + " did not return a result.";
                }
                return parseInt(pagesArea$.attr("tabindex"));
            } catch (e) {
                if (console) console.log(e);
                return 0;
            }
        }
        function start() {
            var pendingRefresh = false;
            init();
            controller.reportLoadComplete(function() {
                if (options.documentMapVisible === false) {
                    controller.setDocumentMapVisible({
                        visible: false
                    });
                }
            });
            var rs = settings.reportSource();
            if (rs !== undefined) {
                controller.reportSource(rs);
                var pageNumber = settings.pageNumber();
                if (pageNumber !== undefined) {
                    controller.navigateToPage(pageNumber);
                }
                pendingRefresh = true;
            } else {
                if (options.viewMode) {
                    controller.viewMode(options.viewMode);
                }
                if (options.reportSource) {
                    controller.reportSource(options.reportSource);
                    pendingRefresh = true;
                }
            }
            for (var i = 0; i < scripts.length; i++) {
                try {
                    eval(scripts[i]);
                } catch (e) {
                    if (console) console.log(e);
                }
            }
            if (typeof options.ready === "function") {
                options.ready.call(viewer);
            }
            if (pendingRefresh) {
                controller.refreshReport(false);
            }
        }
        function loadStyleSheets(styleSheets) {
            if (!styleSheets) return Promise.resolve();
            var $head = $("head");
            var currentStyleLinks = $head.find("link").map(function(i, e) {
                return e.outerHTML;
            }).toArray();
            var promises = [];
            utils.each(styleSheets, function(i, e) {
                if (-1 == currentStyleLinks.indexOf(e)) {
                    promises.push(new Promise(function(resolve, reject) {
                        var $link = $(e);
                        $link.on("load", resolve);
                        $link.on("onerror", function() {
                            utils.logError("error loading stylesheet " + e);
                            resolve();
                        });
                        $head.append($link);
                    }));
                }
            });
            return Promise.all(promises).then(controller.cssLoaded);
        }
        function browserSupportsAllFeatures() {
            return window.Promise;
        }
        function main(err) {
            if (err) {
                utils.logError(err);
            } else {
                templateCache.load(options.templateUrl, svcApiUrl, client).catch(function() {
                    $placeholder.html(utils.stringFormat(sr.errorLoadingTemplates, [ utils.escapeHtml(options.templateUrl) ]));
                    return Promise.reject();
                }).then(function(result) {
                    templates = result.templates;
                    scripts = result.scripts;
                    return loadStyleSheets(result.styleSheets);
                }).then(start);
            }
        }
        if (browserSupportsAllFeatures()) {
            main();
        } else {
            utils.loadScript("https://cdn.polyfill.io/v2/polyfill.min.js?features=Promise", main);
        }
        return viewer;
    }
    var pluginName = "telerik_ReportViewer";
    jQuery.fn[pluginName] = function(options) {
        if (this.selector && !options.selector) {
            options.selector = this.selector;
        }
        return utils.each(this, function() {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new ReportViewer(this, options));
            }
        });
    };
    trv.ReportViewer = ReportViewer;
})(window.telerikReportViewer = window.telerikReportViewer || {}, jQuery, window, document);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __webpack_require__(4);
var reportViewer_1 = __webpack_require__(399);
var ReportData = __webpack_require__(81);
var ViewReportsController = (function () {
    function ViewReportsController() {
        this.viewModel = {
            reports: ko.observableArray(),
        };
        this.reportViewer = new reportViewer_1.ReportViewer();
    }
    ViewReportsController.prototype.render = function (container) {
        var deferred = $.Deferred();
        var me = this;
        this.container = container;
        me.treeView = $(me.container).find(".reportsTree").kendoTreeView({
            change: function (e) {
                var dataItem = me.treeView.dataItem(me.treeView.select());
                if (dataItem && dataItem.report) {
                    me.reportViewer.loadReport(dataItem.report.ID);
                }
            },
        }).data("kendoTreeView");
        $(".reportsTree").on("click", ".k-in", function (e) {
            me.treeView.toggle($(e.target).closest(".k-item"));
        });
        ko.applyBindings(this.viewModel, container[0]);
        this.reportViewer.render(this.container.find(".reportContainer"));
        deferred.resolve();
        return deferred.promise();
    };
    ViewReportsController.prototype.load = function (params) {
        var deferred = $.Deferred();
        this.loadReports(deferred);
        return deferred.promise();
    };
    ViewReportsController.prototype.refresh = function () {
        this.loadReports();
    };
    ViewReportsController.prototype.appRouterID = function (params) {
        return "View Reports";
    };
    ViewReportsController.prototype.title = function () {
        return "View Reports";
    };
    ViewReportsController.prototype.subTitle = function () {
        return "";
    };
    ViewReportsController.prototype.haveFieldsChanged = function () {
        return false;
    };
    ViewReportsController.prototype.loadReports = function (deferred) {
        var _this = this;
        ReportData.GetAllReports().then(function (response) {
            var runnableReports = response.Payload.filter(function (report) {
                return (report.FileKey !== null && report.IsActive === true);
            });
            _this.viewModel.reports(runnableReports);
            _this.treeDataSource = ReportData.CreateReportTreeDataSource(runnableReports);
            _this.treeView.setDataSource(_this.treeDataSource);
            if (deferred) {
                deferred.resolve();
            }
        });
    };
    return ViewReportsController;
}());
exports.ViewReportsController = ViewReportsController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(9);
var TabScrollerControl = (function () {
    function TabScrollerControl(container) {
        this.scrollBarWidths = 40;
        var me = this;
        this.container = container;
        this.container.find(".tab-scroller-scroller-right").click(function () {
            me.container.find(".tab-scroller-scroller-left").fadeIn("slow");
            me.container.find(".tab-scroller-scroller-right").fadeOut("slow");
            me.container.find(".tab-scroller-list").animate({ left: "+=" + me.widthOfHidden() + "px" }, "slow");
        });
        this.container.find(".tab-scroller-scroller-left").click(function () {
            me.container.find(".tab-scroller-scroller-right").fadeIn("slow");
            me.container.find(".tab-scroller-scroller-left").fadeOut("slow");
            me.container.find(".tab-scroller-list").animate({ left: "-=" + me.getLeftPosition() + "px" }, "slow");
        });
    }
    TabScrollerControl.prototype.reset = function () {
        this.container.find(".tab-scroller-scroller-left").hide();
        this.container.find(".tab-scroller-scroller-right").hide();
        this.container.find(".tab-scroller-list").css("left", 0);
    };
    TabScrollerControl.prototype.resize = function () {
        var outerWidth = _.defaultTo(this.container.find(".tab-scroller-wrapper").outerWidth(), 0);
        if (outerWidth < this.widthOfList()) {
            this.container.find(".tab-scroller-scroller-right").show();
        }
        else {
            this.container.find(".tab-scroller-scroller-right").hide();
        }
        if (this.getLeftPosition() < 0) {
            this.container.find(".tab-scroller-scroller-left").show();
        }
        else {
            this.container.find(".tab-scroller-item").animate({ left: "-=" + this.getLeftPosition() + "px" }, "slow");
            this.container.find(".tab-scroller-scroller-left").hide();
        }
    };
    TabScrollerControl.prototype.scrollRight = function () {
        if (!this.container.find(".tab-scroller-scroller-right").is(":hidden")) {
            this.container.find(".tab-scroller-scroller-left").fadeIn("slow");
            this.container.find(".tab-scroller-scroller-right").fadeOut("slow");
            this.container.find(".tab-scroller-list").animate({ left: "+=" + this.widthOfHidden() + "px" }, "slow");
        }
    };
    TabScrollerControl.prototype.widthOfList = function () {
        var itemsWidth = 0;
        this.container.find(".tab-scroller-list li").each(function () {
            itemsWidth += _.defaultTo($(this).outerWidth(), 0);
        });
        return itemsWidth;
    };
    TabScrollerControl.prototype.widthOfHidden = function () {
        var outerWidth = _.defaultTo(this.container.find(".tab-scroller-wrapper").outerWidth(), 0);
        return outerWidth - this.widthOfList() - this.getLeftPosition() - this.scrollBarWidths;
    };
    TabScrollerControl.prototype.getLeftPosition = function () {
        return this.container.find(".tab-scroller-list").position().left;
    };
    return TabScrollerControl;
}());
exports.TabScrollerControl = TabScrollerControl;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SAMLLoginManager = (function () {
    function SAMLLoginManager(config) {
        this.config = config;
    }
    SAMLLoginManager.prototype.login = function () {
        window.location.replace(this.config.loginPageURL);
    };
    SAMLLoginManager.prototype.logout = function () {
        window.location.replace(this.config.logoutPageURL);
    };
    SAMLLoginManager.prototype.isCurrentPageSAMLLogin = function () {
        if (window.location.pathname && window.location.pathname.indexOf("SAMLLogin") >= 0) {
            return true;
        }
        else {
            return false;
        }
    };
    return SAMLLoginManager;
}());
exports.SAMLLoginManager = SAMLLoginManager;


/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var templateLoader_1 = __webpack_require__(925);
var Templates = (function () {
    function Templates() {
        this.templates = [];
    }
    Templates.prototype.render = function (templateFileName, templateName, container) {
        var template = null;
        var max;
        var i;
        max = this.templates.length;
        for (i = 0; i < max; i++) {
            if (this.templates[i].templateFileName === templateFileName) {
                template = this.templates[i];
                break;
            }
        }
        if (template === null) {
            template = new templateLoader_1.TemplateLoader(templateFileName);
            this.templates.push(template);
        }
        return template.render(templateName, container);
    };
    return Templates;
}());
exports.Templates = Templates;


/***/ }),

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var TemplateLoader = (function () {
    function TemplateLoader(templateFileName) {
        this.templateFileName = templateFileName;
    }
    TemplateLoader.prototype.render = function (templateName, container) {
        var deferred = $.Deferred();
        var onLoad;
        if (container != null) {
            onLoad = function () {
                container.html($("#" + templateName).html());
                deferred.resolve();
            };
        }
        else {
            onLoad = function () {
                deferred.resolve();
            };
        }
        this.loadTemplate(templateName, onLoad);
        return deferred.promise();
    };
    TemplateLoader.prototype.loadTemplate = function (templateName, onSuccess) {
        if (this.templateIsLoaded === null) {
            this.templateIsLoaded = this.isTemplateLoaded(templateName);
        }
        if (this.templateIsLoaded) {
            onSuccess();
        }
        else {
            var me_1 = this;
            var date = new Date();
            var url = "/templates/" + this.templateFileName + ".html?t=" + date.getTime();
            $.get(url, function (data) {
                $("body").append(data);
                me_1.templateIsLoaded = true;
                onSuccess();
            });
        }
    };
    TemplateLoader.prototype.isTemplateLoaded = function (templateName) {
        return $("#" + templateName).length > 0;
    };
    return TemplateLoader;
}());
exports.TemplateLoader = TemplateLoader;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(282);
__webpack_require__(927);
__webpack_require__(22);
__webpack_require__(386);
__webpack_require__(98);
var L = __webpack_require__(139);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
var _ = __webpack_require__(9);
var inputmask = __webpack_require__(928);
var ko = __webpack_require__(4);
var Constants = __webpack_require__(5);
var mapUtil_1 = __webpack_require__(377);
var UI = __webpack_require__(3);
var util_1 = __webpack_require__(8);
function registerKnockoutBindingHandlers() {
    ko.bindingHandlers.enterkey = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var callback = valueAccessor();
            $(element).keypress(function (event) {
                var keyCode = (event.which ? event.which : event.keyCode);
                if (keyCode === 13) {
                    callback.call(null, bindingContext.$data);
                    return false;
                }
                return true;
            });
        },
    };
    ko.bindingHandlers.inputmask = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var el = $(element);
            var boundValue = valueAccessor();
            el.val(boundValue.value());
            inputmask(boundValue.maskFormat).mask(el);
            var mask = el[0].inputmask;
            el.on("focusout change", function () {
                if (mask.isComplete()) {
                    boundValue.value(mask.unmaskedvalue());
                }
                else {
                    boundValue.value(null);
                }
            });
            $(element).attr("placeholder", boundValue.maskFormat);
        },
    };
    ko.bindingHandlers.singleCheckboxAnswer = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var selected = valueAccessor().value();
            if (util_1.isNullOrSpace(selected)) {
                valueAccessor().value(Constants.SINGLECHECKBOX_ANSWER_FALSE);
            }
            var el = $(element);
            el.on("change", function () {
                if (valueAccessor().value() === "true") {
                    valueAccessor().value(Constants.SINGLECHECKBOX_ANSWER_FALSE);
                    valueAccessor().checked(false);
                }
                else {
                    valueAccessor().value(Constants.SINGLECHECKBOX_ANSWER_TRUE);
                    valueAccessor().checked(true);
                }
            });
        },
    };
    ko.bindingHandlers.colorpicker = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var el = $(element);
            var boundValue = valueAccessor();
            el.kendoColorPicker({
                value: boundValue.value(),
                buttons: true,
                select: function (e) {
                    boundValue.value(e.value);
                },
            });
        },
    };
    ko.bindingHandlers.combobox = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var el = $(element);
            var boundValue = valueAccessor();
            el.kendoComboBox({
                value: boundValue.value(),
                dataSource: boundValue.dataSource(),
                dataTextField: boundValue.dataTextField,
                dataValueField: boundValue.dataValueField,
                filter: "contains",
                select: function (e) {
                    if (e.dataItem) {
                        boundValue.value(e.dataItem[boundValue.dataValueField]);
                    }
                },
                change: function (e) {
                    if (!el.val()) {
                        boundValue.value("");
                    }
                },
            });
        },
    };
    ko.bindingHandlers.date = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            $(element).kendoDatePicker({
                format: UI.getKendoDateFormat(valueAccessor().dateFormat),
            });
            $(element).attr("placeholder", valueAccessor().dateFormat);
        },
    };
    ko.bindingHandlers.datetime = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            $(element).kendoDateTimePicker({
                format: UI.getKendoDateFormat(valueAccessor().dateFormat) + " " + UI.getKendoTimeFormat(valueAccessor().timeFormat),
                timeFormat: UI.getKendoTimeFormat(valueAccessor().timeFormat),
            });
            $(element).attr("placeholder", valueAccessor().dateFormat + " " + Constants.TIME_PLACEHOLDER);
        },
    };
    ko.bindingHandlers.time = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            $(element).kendoTimePicker({
                format: UI.getKendoTimeFormat(valueAccessor().timeFormat),
            });
            $(element).attr("placeholder", Constants.TIME_PLACEHOLDER);
        },
    };
    ko.bindingHandlers.numeric = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            $(element).kendoNumericTextBox({
                format: UI.getKendoNumericFormat(valueAccessor().numberFormat, valueAccessor().numberOfDecimals),
                restrictDecimals: true,
                decimals: valueAccessor().numberOfDecimals,
                min: valueAccessor().min === "" ? null : valueAccessor().min,
                max: valueAccessor().max === "" ? null : valueAccessor().max,
            });
            $(element).attr("placeholder", Constants.NUMERIC_PLACEHOLDER);
            var control = $(element).data("kendoNumericTextBox");
            if (!valueAccessor().readonly) {
                control.readonly(false);
            }
            else {
                control.readonly(true);
            }
        },
    };
    ko.bindingHandlers.formItemMap = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            updateMap(valueAccessor, element);
        },
        update: function (element, valueAccessor, viewModel) {
            updateMap(valueAccessor, element);
        },
    };
    function updateMap(valueAccessor, element) {
        var lat = parseFloat(valueAccessor().latitude());
        var long = parseFloat(valueAccessor().longitude());
        var map;
        var tiles = mapUtil_1.getMapTileLayer();
        $(element).empty();
        $(element).html("<div class='map'></div>");
        map = L.map($(element).find("div")[0], { layers: [tiles] });
        var iconHtml = "<i class=\"fa fa-map-marker fa-3x\"></i>";
        valueAccessor().latitude(isNaN(lat) ? null : lat);
        valueAccessor().longitude(isNaN(long) ? null : long);
        valueAccessor().validLat(validateLatLong(valueAccessor().latitude(), true));
        valueAccessor().validLong(validateLatLong(valueAccessor().longitude(), false));
        if (!_.isNaN(lat) && !_.isNaN(long) && valueAccessor().validLat() && valueAccessor().validLong()) {
            map.setView([lat, long], 10);
            var marker_1 = L.marker(L.latLng(lat, long), {
                title: "current location",
                icon: new L.DivIcon({ html: iconHtml, className: "map-icon", iconSize: [30, 35] }),
                draggable: true,
            });
            marker_1.on("dragend", function (event) {
                UI.showConfirmDialog(" Are you sure you want to move the location?", function () {
                    var location = marker_1.getLatLng();
                    valueAccessor().latitude(location.lat);
                    valueAccessor().longitude(location.lng);
                }, function () {
                    marker_1.setLatLng(L.latLng(lat, long));
                });
            });
            marker_1.addTo(map);
            setTimeout(function () {
                map.invalidateSize();
            }, 100);
            valueAccessor().hasValue(true);
            valueAccessor().latLongMissing(false);
        }
    }
    function validateLatLong(latLong, isLatitude) {
        var valid = true;
        if (!_.isNaN(latLong) && !_.isNull(latLong)) {
            if (isLatitude) {
                valid = (latLong >= -90 && latLong <= 90) ? valid : false;
            }
            else {
                valid = (latLong >= -180 && latLong <= 180) ? valid : false;
            }
        }
        return valid;
    }
    ko.bindingHandlers.slider = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var minVal = parseFloat(valueAccessor().min);
            var maxVal = parseFloat(valueAccessor().max);
            var defaultValue = parseFloat(valueAccessor().defaultValue);
            var selectVal = parseFloat(valueAccessor().value()) ? valueAccessor().value() : defaultValue;
            var interval = parseFloat(valueAccessor().interval);
            valueAccessor().value(selectVal);
            $(element).kendoSlider({
                value: selectVal,
                min: minVal,
                max: maxVal,
                smallStep: interval,
                largeStep: interval,
                change: function (e) {
                    valueAccessor().value(e.value);
                },
                slide: function (e) {
                    valueAccessor().value(e.value);
                },
            });
            var slider = $(element).data("kendoSlider");
            slider.enable(!valueAccessor().readOnly);
        },
    };
    ko.bindingHandlers.templateSlider = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            $(element).kendoSlider({
                value: valueAccessor().value,
                min: valueAccessor().min,
                max: valueAccessor().mix,
                tickPlacement: "none",
                tooltip: {
                    enabled: false,
                },
            });
        },
    };
}
exports.registerKnockoutBindingHandlers = registerKnockoutBindingHandlers;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 933:
/***/ (function(module, exports) {

module.exports = "//web.config";

/***/ })

},[402]);


// WEBPACK FOOTER //
// app.5cc9.js